import React from "react";

import { Link, Fab, FabButtons, Icon } from "framework7-react";

export const PrimaryLogo = (props) => (
  <svg width={props.size} style={props.style} viewBox="0 0 264 61">
    <g
      id="primaryBlack"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="logo">
        <path
          d="M26.4707639,31.7181044 C27.7015439,31.9607434 28.7372092,32.7872449 29.2468465,33.9335271 C29.5954796,34.6593046 29.6708478,35.4864222 29.4591352,36.2632592 C29.3883723,36.5299808 29.3938156,36.6823932 29.7149703,36.7585994 C30.5864126,36.9185237 31.3582493,37.4190053 31.8598009,38.1493707 C32.3613525,38.8797361 32.5512966,39.779811 32.3876302,40.6505583 C32.3386405,40.9880429 32.458393,41.0751357 32.7251147,41.1622284 C33.9302329,41.5249104 34.8715901,42.4702411 35.2291929,43.6768762 C35.5867956,44.8835113 35.3125314,46.189108 34.4996302,47.1498575 C32.8666405,49.1203318 31.1084548,51.0309299 29.2958362,52.8544351 C27.0128748,55.1343245 24.0708376,56.6386672 20.885939,57.1546414 C16.5639594,57.9167033 12.5576912,57.1546414 9.01954675,54.4765382 C6.0202889,52.179466 4.41451564,49.0441257 3.81030943,45.3807853 C3.59045479,44.1761911 3.4919825,42.9525817 3.51637127,41.7283316 C3.5602642,39.3041743 2.83624617,36.928252 1.44791758,34.9405375 C0.930144658,34.221387 0.507508476,33.4383208 0.190515471,32.6108054 C-0.184395186,31.500923 0.0125517324,30.2775276 0.716840359,29.3413788 C1.42112899,28.4052301 2.54201929,27.8769409 3.71233004,27.9295681 C4.63742397,28.0088102 5.50307091,28.4184467 6.15092808,29.0835475 C7.38161232,30.2832196 8.42725185,31.659061 9.25360862,33.1660219 C9.3407014,33.3075477 9.42779419,33.4545168 9.52577357,33.5905993 C10.2388458,34.6357127 10.9464747,34.7935684 12.0786809,34.2111354 C13.4584224,33.4443145 14.738207,32.5100718 15.8889903,31.4296095 C19.3182688,28.4303516 22.4971555,25.1752587 25.6270526,21.8711761 C26.8084822,20.4812635 28.8238079,20.1538307 30.3844961,21.0982276 C31.3723769,21.6900241 32.0363724,22.7001059 32.1879443,23.8416652 C32.3395162,24.9832244 31.9621099,26.1315796 31.1628878,26.9606609 C29.7421867,28.4249083 28.2888259,29.8510527 26.8463516,31.3153002 L26.4707639,31.7181044 Z M30.1449909,49.5721257 L29.6877538,49.3924968 C28.3026278,48.8913048 27.3611145,47.5986092 27.309032,46.1265173 C27.309032,45.6747235 27.1892794,45.4352183 26.7157124,45.4461049 C26.6385638,45.4433548 26.5619265,45.4324067 26.4870938,45.4134451 C24.6036452,45.0123471 23.3465773,43.2287337 23.6021453,41.3200841 C23.651135,41.0043728 23.5531556,40.8791769 23.2537741,40.8138573 C21.9271175,40.5088648 20.8715423,39.5060995 20.4989209,38.1968281 C20.1262996,36.8875567 20.4956778,35.4792468 21.4629287,34.5214034 C24.2172381,31.7453208 26.9878774,28.9910115 29.74763,26.2258155 C29.9263544,26.0539183 30.0953588,25.8721932 30.2538569,25.6814856 C30.9757948,24.7695794 30.8535528,23.4512838 29.9762486,22.687671 C28.9801249,21.8385163 27.7009496,21.941939 26.7102691,22.9761659 C25.1317123,24.6091556 23.5858154,26.2421454 21.9745988,27.8751351 C19.5360008,30.29196 17.0756295,32.7087848 14.2614439,34.6738158 C13.4628484,35.2110053 12.6042493,35.6530926 11.7030932,35.9910942 C11.2894025,36.1543932 11.2458561,36.2795891 11.3111757,36.6551767 C11.5834639,38.0567827 11.2941418,39.5092579 10.5055674,40.699548 C10.3161281,41.0752766 9.85801373,41.2263569 9.48222718,41.0370326 C9.12077004,40.8239043 8.98535054,40.3677544 9.17195913,39.9919191 C9.26993851,39.752414 9.41146429,39.5292387 9.52033028,39.2951768 C10.1997196,37.9915283 9.99790136,36.4030237 9.01410345,35.3106818 C8.41466511,34.5742273 7.86892945,33.7956444 7.3811137,32.9809498 C6.69514131,31.8835055 5.8597435,30.8868906 4.89896927,30.019795 C4.29155879,29.4149384 3.35761815,29.2840536 2.60734031,29.6986404 C1.68197945,30.2429703 1.24651551,31.0540219 1.57311346,32.0065992 C1.87641819,32.7424703 2.26169528,33.4418121 2.72164959,34.0913828 C3.65169232,35.401081 4.31562365,36.8805937 4.675794,38.4460221 C4.86999517,39.7747653 4.97546579,41.1149696 4.99150535,42.4577336 C5.0648414,44.8052417 5.60517445,47.1146104 6.58094872,49.250971 C7.56074257,51.3901876 11.0281241,53.1755897 13.7116706,51.1180226 C14.4309946,50.5248164 15.0909253,49.8630627 15.682145,49.142105 C16.1339388,48.6304349 16.5585161,48.4562493 16.9613203,48.7665174 C17.3641244,49.0767855 17.3260213,49.5068061 16.901444,50.0565793 C16.629279,50.4049505 16.3571141,50.7696515 16.0577326,51.0908062 C14.8112171,52.3863114 13.4014026,53.398765 11.5289077,53.562064 C11.2349695,53.562064 10.9464747,53.6328269 10.5981035,53.6763733 C16.2754646,57.5901054 25.1861453,56.2782703 30.1449909,49.5721257 Z M24.1192587,39.4421459 C24.4388877,39.3239759 24.7468496,39.1763728 25.0391763,39.0012387 C25.6387151,38.5503322 26.214652,38.0688707 26.7647021,37.5587644 C27.1490677,37.2474693 27.4848091,36.8805389 27.7608258,36.4701045 C28.3322618,35.534703 28.0771031,34.3161413 27.1783928,33.6885787 C26.3912435,33.0746532 25.287439,33.0746532 24.5002896,33.6885787 C23.7545576,34.3635478 23.0578153,35.0983931 22.377403,35.8658983 C21.7923374,36.4529649 21.6658517,37.3561172 22.0671349,38.0813211 C22.4276039,38.8960208 23.2285019,39.4271202 24.1192587,39.4421459 Z M31.0268054,40.1334449 L30.9124961,40.0735686 C30.938877,39.3660991 30.5250021,38.7160337 29.8728259,38.4405788 C29.2260488,38.1094072 28.4432719,38.2018781 27.891465,38.6746407 C27.2219392,39.2189706 26.5796299,39.7633005 25.9101041,40.3076305 C25.4249554,40.6784575 25.1354487,41.2503267 25.1237893,41.8608559 C25.1121299,42.4713852 25.3795913,43.0538909 25.8502278,43.4429708 C26.5469701,44.0362904 27.6410733,44.1342698 28.16363,43.6171564 C28.9365785,42.8550945 29.7149703,42.0930326 30.4334857,41.281981 C30.6799977,40.926346 30.8794285,40.5402918 31.0268054,40.1334449 Z M31.5711353,42.5448264 C31.4336414,42.5793244 31.3042085,42.6403428 31.1901043,42.7244553 C30.547795,43.3395481 29.910929,43.9600842 29.3012795,44.6132801 C28.7468018,45.1995579 28.6204456,46.07098 28.9855682,46.7905998 C29.3261634,47.5534493 30.082512,48.0456086 30.9179394,48.0480019 C31.2927613,48.0175905 31.6513221,47.8817149 31.9521662,47.6560844 C32.4385398,47.2140266 32.8864994,46.7314685 33.2912178,46.2136101 C33.8744589,45.5871289 34.016803,44.6683621 33.6504756,43.8947646 C33.2975718,43.0627996 32.4747077,42.5285841 31.5711353,42.5448264 Z"
          id="Shape"
          fill="#161616"
          fillRule="nonzero"
        ></path>
        <path
          d="M1.56767017,14.4737325 C1.7399782,14.5471562 1.90120184,14.6442568 2.04668049,14.7622274 C4.50705173,17.2008254 6.95835079,19.6448668 9.40057769,22.0943514 C9.56879723,22.2341508 9.67389245,22.4355987 9.69231081,22.6535492 C9.71072917,22.8714998 9.64093047,23.0877274 9.49855708,23.2537741 C9.33797203,23.4115809 9.11833435,23.4944324 8.89353221,23.482001 C8.66873007,23.4695695 8.45956697,23.3630055 8.31736116,23.1884545 C5.89509302,20.7716297 3.47826818,18.3602482 1.08865984,15.9270934 C0.894375867,15.7011595 0.777957005,15.4187006 0.756618587,15.1214851 C0.718515492,14.7458975 1.08865984,14.4791758 1.56767017,14.4737325 Z"
          id="Path"
          fill="#161616"
          fillRule="nonzero"
        ></path>
        <path
          d="M14.3866397,13.9892789 C14.4282695,14.4134799 14.1408168,14.7998917 13.7225572,14.88198 C13.3415263,14.9309697 13.0203717,14.6805779 12.8897325,14.1852377 C12.6175675,13.1346809 12.3454026,12.0786809 12.1004541,11.0281241 C11.5488664,8.82903128 11.0045365,6.63356727 10.4674643,4.44173214 C10.4168089,4.24998776 10.3929943,4.05214384 10.3967014,3.85385582 C10.3867211,3.52757962 10.6191425,3.24402552 10.9410314,3.18977332 C11.2621269,3.0828469 11.6125249,3.23235007 11.7575262,3.53814447 C11.8255213,3.67407406 11.8802089,3.81626191 11.9208252,3.96272181 C12.7336912,7.19604152 13.5429284,10.4293612 14.3485367,13.662681 C14.3594233,13.7987634 14.3757531,13.9348459 14.3866397,13.9892789 Z"
          id="Path"
          fill="#161616"
          fillRule="nonzero"
        ></path>
        <path
          d="M23.5204958,13.5483717 C23.5204958,11.8609489 23.5204958,10.1735262 23.5204958,8.49154673 C23.5213687,8.19335513 23.629576,7.9054464 23.8253205,7.68049515 C24.0081691,7.53084059 24.2559623,7.48769592 24.4786315,7.56674349 C24.7013007,7.64579105 24.8664234,7.83552085 24.9139804,8.06696939 C24.9504875,8.23125092 24.9651296,8.39963574 24.9575268,8.56775292 C24.9575268,11.9099386 24.9575268,15.2503099 24.9575268,18.5888667 C24.9575268,19.1331966 24.6690319,19.503341 24.2117948,19.5088427 C23.7545576,19.5142276 23.4497329,19.1386399 23.4497329,18.5562069 C23.4497329,16.8832996 23.4497329,15.2140212 23.4497329,13.5483717 L23.5204958,13.5483717 Z"
          id="Path"
          fill="#161616"
          fillRule="nonzero"
        ></path>
        <path
          d="M13.8695263,20.6845369 C14.0872583,20.6845369 14.1797944,20.6518771 14.2668872,20.6518771 C15.2303511,20.6518771 15.9434233,20.3143926 16.2047017,19.3073822 C16.2613683,19.1685171 16.3344664,19.0369405 16.4224336,18.9154647 C16.629279,19.3345987 16.8143512,19.6938565 16.9667636,20.0585575 C17.0459652,20.3123164 17.2780031,20.4874394 17.5437533,20.4940214 C17.9628873,20.5266812 18.3820213,20.6192173 18.9317946,20.7063101 C18.5834234,21.0492379 18.3112585,21.3431761 18.0173203,21.6044545 C17.7491259,21.7939031 17.6364065,22.1364818 17.739712,22.4481658 C17.8376914,22.8291968 17.8649079,23.2265576 17.9356708,23.6837948 C17.5274234,23.4660628 17.1681656,23.2973205 16.847011,23.0959184 C16.5954096,22.9072174 16.2494577,22.9072174 15.9978563,23.0959184 C15.682145,23.2973205 15.3337738,23.4497329 14.8656501,23.6892381 C14.9472996,23.2102277 14.990846,22.8564133 15.0724954,22.5080421 C15.1897011,22.1524033 15.0617341,21.7618835 14.7567841,21.5445782 C14.4682892,21.3214029 14.2178975,21.0329081 13.8695263,20.6845369 Z"
          id="Path"
          fill="#161616"
          fillRule="nonzero"
        ></path>
        <path
          d="M6.11282499,8.79637148 C6.6571549,9.66185605 7.3484539,9.74894884 8.19760857,9.43323749 C7.62058386,10.0834286 7.65408447,11.0716969 8.27381476,11.6813201 C7.48277163,11.3488532 6.57028801,11.699439 6.20536107,12.4760417 C6.24614076,12.0471257 6.10797103,11.6204101 5.82352523,11.2968014 C5.53907943,10.9731928 5.13361403,10.781425 4.7030105,10.7668458 C5.10179751,10.5844342 5.46922357,10.3400959 5.79167033,10.042887 C5.96745725,9.64818866 6.07600564,9.2268737 6.11282499,8.79637148 L6.11282499,8.79637148 Z"
          id="Path"
          fill="#161616"
          fillRule="nonzero"
        ></path>
        <path
          d="M17.9628873,7.77303124 C18.5702888,8.35924305 19.5328055,8.35924305 20.140207,7.77303124 C20.0102957,8.18448281 19.9549926,8.61584671 19.976908,9.04676325 C20.0748874,9.38969109 20.4559183,9.65096946 20.7879596,10.0320004 C19.8734853,9.98845401 19.1549698,10.2116293 18.8991348,11.2240829 C18.7753783,10.3734978 17.9938335,9.77826561 17.1409491,9.88503132 C17.8812378,9.3461447 18.3003719,8.73649519 17.9628873,7.77303124 Z"
          id="Path"
          fill="#161616"
          fillRule="nonzero"
        ></path>
        <line
          x1="71.8515492"
          y1="0"
          x2="71.8515492"
          y2="60.9649509"
          id="Path"
          stroke="#161616"
          strokeWidth="1.20000005"
        ></line>
        <path
          d="M97.9412822,32.3549704 C97.8604711,33.0779158 97.8204901,33.8048428 97.8215297,34.53229 C97.8215297,41.390847 100.684705,43.938311 104.195633,43.938311 C106.642111,43.9845734 109.076657,43.5861932 111.380788,42.7625584 L111.505984,43.0347234 C109.165254,43.8880164 106.686521,44.2996006 104.195633,44.2485791 C99.2966637,44.2485791 95.0726636,41.663012 95.0726636,34.53229 C95.0726636,28.000331 99.1932411,24.342434 104.522231,24.342434 C108.435963,24.342434 112.512994,26.5197536 112.349695,32.3331972 L97.9412822,32.3549704 Z M97.9793853,32.0447023 L109.606272,32.0447023 C109.524623,26.672166 107.064252,24.6744752 104.522231,24.6744752 C101.332458,24.6744752 98.665241,27.3416918 97.9793853,32.0447023 Z"
          id="Shape"
          fill="#161616"
          fillRule="nonzero"
        ></path>
        <path
          d="M127.204459,41.3309707 L127.204459,40.7866408 C126.39885,42.1964553 124.86384,44.2703523 120.868458,44.2703523 C116.143675,44.2703523 115.338066,41.3745171 115.093118,39.8068469 C114.690314,37.1777334 115.637448,35.2181457 122.844376,34.750022 C124.293329,34.6374342 125.748314,34.6247031 127.199015,34.7119189 L127.199015,28.1799599 C127.199015,28.1799599 127.645366,24.652702 122.958685,24.652702 C120.670597,24.7340532 118.421147,25.2668176 116.339633,26.2203722 L116.181778,25.9482072 C118.449531,24.8230424 120.955687,24.2627989 123.486685,24.3152175 C129.338232,24.3152175 130.018644,26.8191351 130.018644,28.1527434 L130.018644,41.3309707 C130.018644,43.883878 131.874809,43.8022285 131.874809,43.8022285 L133.126768,43.8022285 L133.126768,44.1179399 L131.874809,44.1179399 C126.964953,44.1179399 127.204459,41.3309707 127.204459,41.3309707 Z M127.204459,39.7633005 L127.204459,35.022187 C125.740486,34.8958984 124.267838,34.9086565 122.806273,35.0602901 C118.52784,35.5338571 117.678685,36.9436716 117.907304,39.8068469 C118.065159,41.7228883 118.669366,43.9600842 121.499881,43.9600842 C124.580788,43.9600842 127.084706,41.3309707 127.204459,39.7633005 L127.204459,39.7633005 Z"
          id="Shape"
          fill="#161616"
          fillRule="nonzero"
        ></path>
        <path
          d="M147.143264,25.8883309 C146.299552,25.2623515 143.997037,24.6363721 142.059222,24.6744752 C138.869449,24.7125783 137.944088,26.672166 137.944088,28.16363 C137.944088,33.3402075 149.375016,31.6527848 149.375016,38.8270531 C149.375016,43.0945997 144.857078,44.2703523 141.547552,44.2703523 C139.914562,44.2703523 137.10582,43.9981873 135.369407,42.5067233 L135.614356,42.2726615 C136.703016,43.2905584 139.206933,43.9600842 141.101201,43.9600842 C144.209325,43.9600842 146.59349,42.1583522 146.59349,39.3332799 C146.59349,33.1007023 135.162562,34.8643313 135.162562,28.7134032 C135.162562,24.7561247 139.887346,24.3587639 141.944913,24.3587639 C144.568583,24.3587639 146.386645,24.9847433 147.355552,25.6107227 L147.143264,25.8883309 Z"
          id="Path"
          fill="#161616"
          fillRule="nonzero"
        ></path>
        <path
          d="M152.836955,24.4948463 L155.678357,24.4948463 L161.932707,40.8247439 L168.110852,28.3976919 C168.110852,28.3976919 169.400914,26.0080835 167.947553,24.7180216 L168.197945,24.4948463 C168.197945,24.4948463 169.771058,25.5181866 168.519099,28.4140217 L160.746068,44.1179399 L157.354893,51.1343525 C155.945078,54.1880434 154.208666,54.1499403 152.189202,53.6382702 L152.189202,53.344332 C154.812872,54.0465176 156.064831,53.1864763 156.995635,51.1670123 L160.38681,44.1505997 L160.343264,44.1505997 L152.836955,24.4948463 Z"
          id="Path"
          fill="#161616"
          fillRule="nonzero"
        ></path>
        <path
          d="M186.013863,28.4793413 C185.170152,25.7576917 183.292213,24.6690319 181.452378,24.6690319 C177.740048,24.6744752 174.729904,28.3051558 174.729904,34.5540632 C174.729904,41.4126202 177.598523,43.9600842 181.10945,43.9600842 C183.293514,44.0026126 185.463591,43.6026665 187.488997,42.7843316 L187.60875,43.0564966 C185.549028,43.904379 183.33636,44.3176327 181.10945,44.2703523 C176.183265,44.2703523 171.986481,41.6847852 171.986481,34.5540632 C171.986481,28.0221042 176.107059,24.3642072 181.430605,24.3642072 C184.299224,24.3642072 187.287595,25.5780629 188.577657,28.4793413 L186.013863,28.4793413 Z"
          id="Path"
          fill="#161616"
          fillRule="nonzero"
        ></path>
        <path
          d="M204.907555,41.3309707 L204.907555,29.0236713 C204.907555,27.3416918 204.706152,24.6690319 201.151678,24.6690319 C197.597204,24.6690319 194.652379,28.3976919 194.652379,30.1994239 L194.652379,44.1179399 L191.827307,44.1179399 L191.827307,14.7567841 L194.652379,14.7567841 L194.652379,28.9855682 C195.381781,27.1076299 197.880255,24.3642072 201.184338,24.3642072 C207.035885,24.3642072 207.716297,26.9116712 207.716297,29.0672176 L207.716297,41.3309707 C207.716297,43.883878 209.572462,43.8022285 209.572462,43.8022285 L210.824421,43.8022285 L210.824421,44.1179399 L208.36405,44.1179399 C204.668049,44.1179399 204.907555,41.3309707 204.907555,41.3309707 Z"
          id="Path"
          fill="#161616"
          fillRule="nonzero"
        ></path>
        <path
          d="M225.85337,41.3309707 L225.85337,40.7866408 C225.047762,42.1964553 223.512751,44.2703523 219.51737,44.2703523 C214.792586,44.2703523 213.986978,41.3745171 213.747472,39.8068469 C213.339225,37.1777334 214.291802,35.2181457 221.493287,34.750022 C222.942241,34.6374342 224.397225,34.6247031 225.847927,34.7119189 L225.847927,28.1799599 C225.847927,28.1799599 226.294277,24.652702 221.61304,24.652702 C219.329027,24.7431807 217.085294,25.2833045 215.010318,26.2421454 L214.852462,25.9699804 C217.120576,24.8458361 219.626479,24.2856492 222.15737,24.3369907 C228.008916,24.3369907 228.689329,26.8409083 228.689329,28.1745166 L228.689329,41.3309707 C228.689329,43.883878 230.550937,43.8022285 230.550937,43.8022285 L231.797453,43.8022285 L231.797453,44.1179399 L230.550937,44.1179399 C225.613865,44.1179399 225.85337,41.3309707 225.85337,41.3309707 Z M225.85337,39.7633005 L225.85337,35.022187 C224.389397,34.8958984 222.916749,34.9086565 221.455184,35.0602901 C217.176751,35.5338571 216.327596,36.9436716 216.556215,39.8068469 C216.71407,41.7228883 217.32372,43.9600842 220.148792,43.9600842 C223.2297,43.9600842 225.733617,41.3309707 225.85337,39.7633005 L225.85337,39.7633005 Z"
          id="Shape"
          fill="#161616"
          fillRule="nonzero"
        ></path>
        <path
          d="M249.629701,28.9474651 L242.526195,44.1179399 L242.123391,44.1179399 L234.606195,24.4948463 L237.431267,24.4948463 L243.609412,40.7213212 L249.422855,28.4575681 L247.936835,24.4948463 L250.761907,24.4948463 L256.923722,40.7430944 L262.780711,28.4357949 C262.780711,28.4357949 264.070773,26.0461866 262.617412,24.7561247 L262.856918,24.5166195 C262.856918,24.5166195 264.435474,25.5399598 263.183516,28.4357949 L255.835062,44.1179399 L255.432258,44.1179399 L249.629701,28.9474651 Z"
          id="Path"
          fill="#161616"
          fillRule="nonzero"
        ></path>
      </g>
    </g>
  </svg>
);

export const AgentSvg = (props) => (
  <svg width={props.size} style={props.style} viewBox="0 0 920.29689 567.13633">
    <path
      d="M1050.23779,538.70137H409.64889a9.92188,9.92188,0,0,1-9.91066-9.91066V176.34249a9.92187,9.92187,0,0,1,9.91066-9.91065h640.5889a9.92187,9.92187,0,0,1,9.91066,9.91065V528.79071A9.92188,9.92188,0,0,1,1050.23779,538.70137Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#e6e6e6"
    />
    <path
      d="M1036.72325,525.18683H423.16343a9.92186,9.92186,0,0,1-9.91066-9.91065V189.857a9.92187,9.92187,0,0,1,9.91066-9.91066h613.55982a9.92187,9.92187,0,0,1,9.91066,9.91066V515.27618A9.92186,9.92186,0,0,1,1036.72325,525.18683Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#fff"
    />
    <path
      d="M594.85176,380.73573H479.42023a4.81528,4.81528,0,0,1-4.80963-4.80962V255.7089a4.81529,4.81529,0,0,1,4.80963-4.80963H594.85176a4.81529,4.81529,0,0,1,4.80963,4.80963V375.92611A4.81529,4.81529,0,0,1,594.85176,380.73573ZM479.42023,252.82312a2.88893,2.88893,0,0,0-2.88578,2.88578V375.92611a2.88892,2.88892,0,0,0,2.88578,2.88577H594.85176a2.88893,2.88893,0,0,0,2.88578-2.88577V255.7089a2.88894,2.88894,0,0,0-2.88578-2.88578Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#3f3d56"
    />
    <path
      d="M787.65911,380.73573H672.22757a4.81529,4.81529,0,0,1-4.80963-4.80962V255.7089a4.81529,4.81529,0,0,1,4.80963-4.80963H787.65911a4.81529,4.81529,0,0,1,4.80963,4.80963V375.92611A4.81529,4.81529,0,0,1,787.65911,380.73573ZM672.22757,252.82312a2.88893,2.88893,0,0,0-2.88577,2.88578V375.92611a2.88892,2.88892,0,0,0,2.88577,2.88577H787.65911a2.88892,2.88892,0,0,0,2.88577-2.88577V255.7089a2.88893,2.88893,0,0,0-2.88577-2.88578Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#3f3d56"
    />
    <path
      d="M980.46645,380.73573H865.03492a4.81529,4.81529,0,0,1-4.80963-4.80962V255.7089a4.81529,4.81529,0,0,1,4.80963-4.80963H980.46645a4.81529,4.81529,0,0,1,4.80963,4.80963V375.92611A4.81528,4.81528,0,0,1,980.46645,380.73573ZM865.03492,252.82312a2.88894,2.88894,0,0,0-2.88578,2.88578V375.92611a2.88893,2.88893,0,0,0,2.88578,2.88577H980.46645a2.88892,2.88892,0,0,0,2.88578-2.88577V255.7089a2.88893,2.88893,0,0,0-2.88578-2.88578Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#3f3d56"
    />
    <path
      d="M514.846,454.23394a3.26532,3.26532,0,1,0,0-6.53063H485.54652a3.26531,3.26531,0,0,0,0,6.53063Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#e6e6e6"
    />
    <path
      d="M588.72546,434.99542a3.26531,3.26531,0,1,0,0-6.53062H485.54652a3.26531,3.26531,0,0,0,0,6.53062Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#e6e6e6"
    />
    <path
      d="M707.65336,454.23394a3.26532,3.26532,0,0,0,0-6.53063H678.35387a3.26531,3.26531,0,0,0,0,6.53063Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#e6e6e6"
    />
    <path
      d="M781.53281,434.99542a3.26531,3.26531,0,0,0,0-6.53062H678.35387a3.26531,3.26531,0,0,0,0,6.53062Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#e6e6e6"
    />
    <path
      d="M900.46071,454.23394a3.26532,3.26532,0,0,0,0-6.53063H871.16122a3.26532,3.26532,0,1,0,0,6.53063Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#e6e6e6"
    />
    <path
      d="M974.34016,434.99542a3.26531,3.26531,0,0,0,0-6.53062H871.16122a3.26531,3.26531,0,1,0,0,6.53062Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#e6e6e6"
    />
    <path
      d="M588.72546,416.07508a3.26532,3.26532,0,1,0,0-6.53063H485.54652a3.26531,3.26531,0,0,0,0,6.53063Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#fed448"
    />
    <path
      d="M781.53281,416.07508a3.26532,3.26532,0,0,0,0-6.53063H678.35387a3.26531,3.26531,0,0,0,0,6.53063Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#fed448"
    />
    <path
      d="M974.34016,416.07508a3.26531,3.26531,0,0,0,0-6.53063H871.16122a3.26532,3.26532,0,1,0,0,6.53063Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#fed448"
    />
    <path
      d="M570.2556,357.43737a3.26531,3.26531,0,0,0,0-6.53062H504.01639a3.26531,3.26531,0,1,0,0,6.53062Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#e6e6e6"
    />
    <path
      d="M570.2556,338.19886a3.26531,3.26531,0,0,0,0-6.53062H504.01639a3.26531,3.26531,0,1,0,0,6.53062Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#e6e6e6"
    />
    <circle cx="397.28444" cy="128.48808" r="20.72228" fill="#fed448" />
    <path
      d="M763.063,357.43737a3.26531,3.26531,0,0,0,0-6.53062H696.82373a3.26531,3.26531,0,0,0,0,6.53062Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#e6e6e6"
    />
    <path
      d="M763.063,338.19886a3.26531,3.26531,0,0,0,0-6.53062H696.82373a3.26531,3.26531,0,0,0,0,6.53062Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#e6e6e6"
    />
    <circle cx="590.09179" cy="128.48808" r="20.72228" fill="#fed448" />
    <path
      d="M955.87029,357.43737a3.26531,3.26531,0,1,0,0-6.53062H889.63108a3.26531,3.26531,0,0,0,0,6.53062Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#e6e6e6"
    />
    <path
      d="M955.87029,338.19886a3.26531,3.26531,0,1,0,0-6.53062H889.63108a3.26531,3.26531,0,0,0,0,6.53062Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#e6e6e6"
    />
    <circle cx="782.89913" cy="128.48808" r="20.72228" fill="#fed448" />
    <polygon
      points="153.95 481.518 165.052 487.573 157.987 510.786 146.886 511.795 140.83 498.675 153.95 481.518"
      fill="#ffb9b9"
    />
    <polygon
      points="119.636 527.943 119.636 539.044 102.479 538.035 102.718 528.892 119.636 527.943"
      fill="#ffb9b9"
    />
    <polygon
      points="157.987 348.297 151.932 423.991 132.756 535.007 102.479 530.97 112.571 443.166 108.534 362.427 157.987 348.297"
      fill="#2f2e41"
    />
    <path
      d="M217.09913,458.21145l72.66561,1.00922,8.07394,55.50842-49.453,23.21264-12.11093,44.40674,61.5639,65.60083-24.22186,30.27735s-34.31432-46.42523-59.54543-72.66559-13.12018-105.97064-13.12018-105.97064Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#2f2e41"
    />
    <circle cx="120.64505" cy="126.26344" r="22.20337" fill="#ffb9b9" />
    <path
      d="M268.57057,307.834v22.20337L253.4319,354.25918s-23.21262-17.15714-18.1664-21.19412,6.05547-35.32355,6.05547-35.32355Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#ffb9b9"
    />
    <polygon
      points="128.719 159.569 143.858 177.735 137.802 303.89 90.368 302.881 82.294 192.874 92.386 164.615 99.309 155.196 111.562 173.698 128.719 159.569"
      fill="#fff"
    />
    <path
      d="M292.79248,391.60125l11.10168,42.38828-11.10168,42.38824,18.16639,24.22186,16.14791-76.70257s-12.111-62.57309-13.1202-69.63785-3.02772-8.074-3.02772-8.074l-8.074,1.00925Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#2f2e41"
    />
    <polygon
      points="72.202 241.317 65.137 254.438 63.118 276.641 67.155 301.872 53.026 325.085 38.897 261.502 54.035 179.753 60.091 179.753 72.202 241.317"
      fill="#2f2e41"
    />
    <path
      d="M297.83867,646.94009s14.12936,4.037,19.17564,5.0462-3.02773,20.18488-3.02773,20.18488-5.0462,26.24035-6.05546,31.28656-8.074,22.20343-17.15717,24.22186-3.02772-35.32355-3.02772-35.32355-4.037-12.1109-4.037-16.14789,6.05546-2.01849,6.05546-2.01849C305.91259,672.17117,297.83867,646.94009,297.83867,646.94009Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#2f2e41"
    />
    <path
      d="M264.53355,724.65182c-1.00925,6.05548,1.00926,6.05548-15.13867,8.074S237.284,721.62411,237.284,721.62411a84.80035,84.80035,0,0,1,4.037-18.16638c3.02774-8.074,19.17564,2.01849,19.17564,2.01849S265.5428,718.59634,264.53355,724.65182Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#2f2e41"
    />
    <path
      d="M241.29467,298.44634l-.526,8.97562s-6.5124-14.72672-7.52165-29.86536,16.14792-18.16638,26.24036-19.17563S286.737,264.43642,286.737,272.5104s-18.1664,6.05548-25.23111,4.037-10.09244,15.13867-10.09244,15.13867l-4.037,1.00925Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#2f2e41"
    />
    <polygon
      points="134.676 166.716 128.719 159.569 111.562 173.698 128.719 185.809 134.676 166.716"
      fill="#fff"
    />
    <polygon
      points="92.386 164.615 99.451 155.532 111.562 173.698 96.423 184.8 92.386 164.615"
      fill="#fff"
    />
    <path
      d="M295.82019,405.73064l-4.037,38.35129,8.07393,23.21265,5.04622,22.20337s-.00006,21.19415-20.18489,22.20337-37.342-63.5824-37.342-63.5824-3.02773,14.12939-5.04622,22.20337-36.3328,40.36981-36.3328,40.36981-8.07394-1.00928-15.13866-17.15716,14.12942-31.28656,14.12942-31.28656l6.05549-21.19416-2.01849-26.24035L194.8957,346.18523l41.88364-21.69876-4.5416,58.03156,15.13866,45.416,22.708-100.4198,7.56933,5.55085,32.29583,13.12018Z"
      transform="translate(-139.85155 -166.43184)"
      fill="#2f2e41"
    />
    <polygon
      points="257.738 567.136 0 567.136 0 565.03 258.12 565.03 257.738 567.136"
      fill="#3f3d56"
    />
  </svg>
);

export const FoodSvg = (props) => (
  <svg width={props.size} style={props.style} viewBox="0 0 373 204">
    <g
      id="foodSvg"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="02---Onboarding" transform="translate(-34.000000, -584.000000)">
        <g id="food" transform="translate(34.000000, 584.000000)">
          <path
            d="M255.867988,174.049409 C290.583619,173.635244 325.29807,173.872736 360.011341,174.761887 C362.997572,174.838418 366.096332,174.936711 368.733458,175.736569 C371.370584,176.536428 373.400061,178.252296 372.678546,179.900733 C359.127624,180.306171 345.562713,180.431446 331.983812,180.276558 C329.026667,181.741537 325.78011,183.948051 327.597495,185.923749 C328.855058,187.29086 331.959264,187.697858 334.673926,187.701061 C339.590676,187.706865 344.527202,186.890625 349.371199,187.369519 C354.215196,187.848414 359.048648,190.425203 357.629661,193.10028 C356.552091,195.131708 352.46399,196.137311 348.743643,196.316877 C345.023296,196.496444 341.213909,196.123047 337.577406,196.604101 C334.121619,197.061242 331.127573,198.249103 327.893332,199.078306 C322.791527,200.386317 317.136065,200.790468 311.571832,201.134274 C268.846222,203.774227 225.766305,203.75328 182.788884,203.72937 C165.389832,203.719686 147.754453,203.693036 130.95297,201.124085 C121.375782,199.659728 112.198311,197.385732 102.500292,196.205792 C90.9161329,194.796373 78.9437151,194.987683 67.097241,195.029925 C46.3003644,195.104081 25.5210255,194.69874 4.75922412,193.813902 C3.21421048,193.748017 1.31774623,193.524873 0.900789922,192.676927 C0.41418848,191.687338 2.38901684,190.915155 4.05829636,190.520251 C13.517126,188.305863 23.134927,186.854899 32.8209547,186.18105 C37.7263833,185.832181 42.7813029,185.65459 47.2930165,184.506123 C51.8047302,183.357657 55.746328,180.949172 55.7039709,178.140001 C55.6910506,177.283059 55.3335318,176.366329 56.0406515,175.609401 C56.9796146,174.604293 59.2898515,174.3737 61.2830908,174.264121 C83.3793476,173.049349 105.596026,172.54225 127.792558,172.746022 C135.600433,172.817703 143.440484,172.976396 151.193067,172.444479 C157.545307,172.008644 163.767148,171.113817 170.027479,170.362575 C178.43068,169.354183 215.001202,164.130335 220.335999,168.369 C224.329532,171.541989 216.084548,172.226617 226.795459,173.521394 C236.121564,174.648771 246.409052,174.162257 255.867988,174.049409 Z"
            id="Path"
            fill="#F2F2F2"
            fillRule="nonzero"
          ></path>
          <path
            d="M120.169809,160.501559 C120.169809,160.501559 107.277722,185.724183 118.249711,185.724183 C129.221701,185.724183 267.468777,186.266605 271.308973,179.215119 C273.999464,174.274758 272.516049,156.687402 271.386654,146.599369 C270.931272,142.528303 267.337117,139.519081 263.200934,139.745839 C233.301899,141.377524 121.60417,147.424506 122.089907,146.669814 C123.049955,145.178153 122.364208,145.584969 122.364208,145.584969 C122.364208,145.584969 117.97541,159.416718 120.169809,160.501559 Z"
            id="Path"
            fill="#3F3D56"
            fillRule="nonzero"
          ></path>
          <path
            d="M271.391483,146.594056 C270.937623,142.526131 267.355537,139.519238 263.233251,139.745831 C233.434683,141.376275 122.112183,147.418578 122.59627,146.66445 C123.553094,145.17394 122.869647,145.580442 122.869647,145.580442 C122.869647,145.580442 121.893333,148.665936 121.093822,152.035397 C121.207152,152.024281 121.29185,152.130041 120.92276,152.773862 C120.889923,152.919155 120.857575,153.064482 120.825719,153.209841 C125.284401,153.646549 232.207351,147.842734 261.319603,146.24987 C265.44189,146.023277 269.023976,149.03017 269.477835,153.098095 C270.314734,160.592663 271.346097,172.228177 270.718381,179.733826 C270.960452,179.603464 271.165356,179.414564 271.314058,179.184676 C273.995519,174.248126 272.5171,156.674323 271.391483,146.594056 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.1"
          ></path>
          <path
            d="M136.017763,122.12191 C134.593213,121.684352 132.79027,121.1193 132.952763,120.197881 C133.039094,119.708318 133.692713,119.326386 134.166302,118.915922 C135.079202,118.12472 135.325363,117.010278 134.344781,116.246122 C133.364199,115.481967 131.002321,115.379787 130.137204,116.188421 C129.692169,116.604396 129.718983,117.126086 129.489224,117.595913 C128.772419,119.061642 125.872197,119.705212 123.408452,120.274655 C120.944706,120.844099 118.188167,121.903554 118.419786,123.419926 C118.672446,125.074083 122.473175,126.541514 120.943917,127.951971 C120.389368,128.463438 119.222832,128.748828 118.974606,129.333919 C118.799954,129.74558 119.150775,130.16422 119.491328,130.54026 L121.911622,133.212752 C122.874577,134.276046 123.866779,135.433034 123.544264,136.616617 C122.905001,138.962626 117.70898,139.860133 113.590534,139.596531 C112.082352,139.499999 110.309719,139.367855 109.273338,140.003032 C108.474636,140.492537 108.475995,141.254987 108.74147,141.907599 C109.424745,143.587265 111.610585,145.041911 114.408033,145.678619 C111.272647,146.298602 110.041282,148.911805 112.206032,150.351702 C110.967241,150.778848 109.62796,150.817325 108.36679,150.461999 C107.296127,151.449884 107.925554,152.805601 109.283465,153.669811 C110.641377,154.534021 112.565101,155.020241 114.427811,155.481898 L112.684588,157.115561 C113.946116,158.103002 116.670347,157.754931 118.507445,157.130812 C120.344543,156.506694 122.337991,155.668688 124.396292,155.995251 C126.326694,156.301519 127.786806,157.59204 129.752369,157.371059 C131.275625,157.199806 132.000498,156.218687 132.475076,155.371848 L134.492496,151.771927 C137.364229,152.222237 140.383666,150.250034 139.230385,148.677285 C142.443917,149.023172 145.606992,146.931557 144.55206,145.158273 C146.263466,146.48123 147.468436,148.018096 148.057957,149.629824 C148.321363,150.349975 148.481697,151.11142 149.199175,151.721666 C150.149955,152.430563 151.376807,152.653013 152.515129,152.322906 C151.92914,153.461874 151.454497,154.790358 152.658719,155.756738 C153.86294,156.723117 157.337894,156.449048 157.184486,155.264883 C159.020843,156.055807 161.07866,156.799114 163.373674,156.858119 C165.668687,156.917124 168.180336,156.041749 168.389287,154.730903 C171.62356,155.80001 175.007121,156.34586 178.412758,156.347931 C178.702476,155.470695 180.725617,155.187029 182.238231,155.401423 C183.750844,155.615816 185.153951,156.130927 186.712151,156.131807 C188.270352,156.132688 189.946083,155.192766 189.148335,154.425852 C192.429466,155.11381 195.797642,155.284167 199.131206,154.930767 C202.275793,154.596187 205.255948,153.80095 208.440256,153.629449 C211.67043,153.432325 214.904603,153.944277 217.916934,155.129558 C218.960856,155.568252 220.258368,156.120442 221.405225,155.77632 C222.055745,155.581127 222.371958,155.159649 222.813874,154.82362 C224.715898,153.37736 228.605151,153.654693 231.605839,154.223301 C234.606528,154.79191 238.096998,155.47645 240.726163,154.471466 C241.718218,154.092255 242.449194,153.506284 243.50442,153.187949 C247.284667,152.047523 251.809291,154.969646 255.821604,154.128888 C257.128193,153.855087 258.188321,153.200026 259.572387,153.119223 C262.027371,152.975898 263.649711,154.643555 266.03667,155.002265 C268.513375,155.374442 271.198224,153.864027 270.5941,152.438367 C272.974559,152.491318 275.34805,152.160678 277.62387,151.459082 L276.499527,149.430843 C279.301217,149.385611 281.362264,147.372621 280.064168,145.94931 C282.873766,145.413014 285.095346,143.969695 285.67283,142.305464 C286.250315,140.641232 285.16126,138.820773 282.923378,137.709475 C281.602597,137.053594 279.868083,136.592364 279.113088,135.689178 C278.569384,135.038753 278.648624,134.282093 278.437164,133.571167 C277.97432,132.015101 275.968216,130.64117 273.376795,130.105449 C272.251292,129.872777 271.019711,129.784363 270.00065,129.425075 C268.981589,129.065787 268.245548,128.287504 268.833672,127.69047 C269.14495,127.374488 269.744479,127.1884 270.132128,126.90149 C271.703988,125.738125 269.008819,124.265689 266.70796,123.612567 L272.202431,123.43245 L273.382241,118.071002 C271.208355,119.843051 265.569313,119.470341 264.156669,117.461241 C265.921679,118.041723 268.288921,117.299461 269.15188,116.243429 C270.014838,115.187397 269.802733,113.959273 269.572394,112.800706 C269.528083,112.2153 269.180426,111.696173 268.656655,111.433311 C268.118868,111.176568 267.262067,111.06939 267.085647,110.681274 C266.905641,110.285253 267.601336,109.935074 267.704549,109.530141 C267.902682,108.752797 266.11985,108.410202 264.915948,108.034273 C262.075432,107.147295 260.699966,104.65473 257.468101,104.735756 C254.26133,104.816152 253.365038,107.270035 253.362841,109.109182 C253.360645,110.94833 252.27545,113.407787 249.066147,113.374243 C247.784603,113.360846 246.667238,112.899023 245.644004,112.456725 L236.452443,108.483602 C235.237974,107.917303 233.974462,107.463302 232.677635,107.127249 C230.823662,106.693615 228.775454,106.642394 226.774535,106.596821 L213.916531,106.303968 C213.261632,106.252419 212.602732,106.309203 211.966226,106.472046 C211.290818,106.698217 210.962603,107.143536 210.555772,107.526393 C208.765414,109.211255 204.555908,109.87115 201.517917,108.943209 C200.712455,108.69718 199.990697,108.358011 199.13717,108.172625 C196.448704,107.588676 193.627572,108.669044 190.834276,109.059354 C186.2552,109.699195 180.564933,108.597904 177.263811,110.525472 C176.163255,111.168103 175.579408,112.046791 174.55952,112.731723 C173.539632,113.416655 171.699291,113.881095 170.413032,113.363917 C170.574602,114.620822 170.721729,115.932421 169.872767,117.095074 C169.023804,118.257727 166.846397,119.206591 164.707136,118.913418 C163.571811,118.612619 163.661313,117.656204 164.198266,117.008912 C164.735219,116.361621 165.558762,115.700265 165.291062,115.00018 C165.025484,114.305658 163.810081,113.901713 162.901313,113.41757 C161.992545,112.933427 161.386386,112.015843 162.351613,111.569018 C161.701182,110.731181 159.363372,110.83334 158.334987,111.535952 C157.306602,112.238565 157.203887,113.228025 157.091761,114.142757 C156.979636,115.057489 156.73524,116.059511 155.543692,116.67168 C153.513084,117.714944 149.614712,117.173681 148.26801,118.532601 C147.840213,118.964284 147.814971,119.485025 147.570207,119.961215 C146.477693,122.086715 141.761225,122.637134 137.905959,122.810582 C137.824716,123.252836 137.806664,123.704425 137.852345,124.151776 C139.171064,123.579704 136.973542,122.415479 136.017763,122.12191 Z"
            id="Path"
            fill="#61AB43"
            fillRule="nonzero"
          ></path>
          <path
            d="M269.739869,120.215903 C269.986929,121.273836 270.214374,122.395297 269.288913,123.359604 C269.151544,123.498851 268.996158,123.624389 268.825719,123.733826 C270.070618,123.699066 271.315529,123.664326 272.560452,123.629606 C272.982232,121.997656 273.403988,120.365729 273.825719,118.733826 C272.859882,119.404175 271.256171,119.737408 269.601266,119.768528 C269.660293,119.914542 269.706619,120.064073 269.739869,120.215903 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.1"
          ></path>
          <path
            d="M270.825719,125.645697 C270.697771,124.947987 269.58513,124.239909 268.339619,123.733826 C267.243185,124.272343 265.996108,124.385515 264.825719,124.052713 C265.734793,125.386581 268.519392,125.970859 270.825719,125.645697 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.1"
          ></path>
          <path
            d="M272.376016,129.733826 C272.346097,129.871564 272.316209,130.00928 272.286353,130.146976 C270.466144,130.207458 268.645933,130.267964 266.825719,130.328495 C269.112429,130.986691 271.790997,132.470623 270.228799,133.643057 C269.843537,133.932219 269.247705,134.119769 268.938341,134.43821 C268.353853,135.039895 269.085347,135.82427 270.098134,136.186344 C271.110921,136.548417 272.334885,136.637521 273.453476,136.872006 C276.028928,137.411917 278.022679,138.796552 278.482675,140.364769 C278.692836,141.081245 278.614087,141.843805 279.154442,142.499301 C279.904791,143.409536 281.628603,143.874379 282.941252,144.535367 C283.067702,144.599047 283.189362,144.665677 283.308348,144.733826 C284.494991,144.051735 285.348016,143.172047 285.673773,142.220085 C286.2477,140.542856 285.165346,138.7082 282.941252,137.588232 C281.628603,136.927241 279.904791,136.462402 279.154442,135.552167 C278.614087,134.896671 278.692836,134.13411 278.482675,133.417634 C278.022679,131.849414 276.028935,130.464779 273.453476,129.924868 C273.10149,129.851089 272.738985,129.79188 272.376016,129.733826 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.1"
          ></path>
          <path
            d="M111.539117,154.733826 C111.993921,153.852819 113.15576,153.070395 114.825719,152.77064 C113.230208,152.469186 111.727035,151.852344 110.422607,150.96378 C109.739802,150.982029 109.057983,150.904468 108.401139,150.733826 C107.262512,151.687455 107.931886,152.99616 109.375982,153.830406 C110.057008,154.205251 110.782725,154.508342 111.539117,154.733826 L111.539117,154.733826 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.1"
          ></path>
          <path
            d="M121.42252,127.644228 C122.203064,127.353812 123.00271,127.116934 123.815837,126.93526 C126.273545,126.371736 129.1667,125.734835 129.881764,124.284306 C130.110975,123.819369 130.084203,123.303066 130.528171,122.891427 C131.391171,122.091156 133.747295,122.192297 134.725466,122.948506 C135.703638,123.704715 135.45811,124.807631 134.5474,125.59062 C134.074999,125.99683 133.422963,126.374803 133.336826,126.859302 C133.174741,127.77116 134.973257,128.330348 136.394329,128.763357 C137.063249,128.977404 137.689496,129.305814 138.244919,129.733826 C138.256775,129.637097 138.268593,129.540613 138.277949,129.444923 C142.123802,129.273264 146.828757,128.728572 147.918602,126.625112 C148.162761,126.153871 148.187934,125.638518 148.614689,125.211319 C149.958097,123.866508 153.846953,124.402136 155.872613,123.3697 C157.061211,122.763878 157.305034,121.772267 157.416879,120.866995 C157.528723,119.961724 157.631174,118.982568 158.657087,118.287243 C159.682939,117.591919 162.015057,117.490815 162.66386,118.319966 C161.701006,118.76215 162.305697,119.670226 163.212244,120.14934 C164.118792,120.628454 165.3312,121.028207 165.596137,121.715535 C165.863206,122.408361 165.041659,123.062851 164.506028,123.703452 C163.970397,124.344053 163.881097,125.290513 165.013623,125.588182 C167.147698,125.878318 169.31976,124.939302 170.166645,123.788696 C171.01353,122.638089 170.866792,121.340118 170.705573,120.096261 C171.988699,120.608061 173.82454,120.148441 174.841929,119.4706 C175.859317,118.792759 176.441735,117.923209 177.539636,117.287254 C180.832677,115.379662 186.509043,116.469538 191.076919,115.836347 C193.863392,115.450068 196.677634,114.380896 199.359527,114.958805 C200.210938,115.142255 200.930945,115.47792 201.734429,115.72139 C204.76503,116.639719 208.964219,115.986659 210.750216,114.319269 C211.156059,113.940401 211.483458,113.499698 212.157203,113.275876 C212.792157,113.114715 213.449452,113.058519 214.102755,113.109538 C218.378293,113.206135 222.65383,113.302739 226.929367,113.39935 C228.925359,113.44445 230.968569,113.495136 232.818028,113.924282 C234.111684,114.256852 235.372108,114.706141 236.583611,115.266557 C239.639982,116.577184 242.696353,117.887824 245.752726,119.198478 C246.773446,119.636182 247.888064,120.093228 249.166496,120.106477 C252.367971,120.139673 253.450489,117.705726 253.452687,115.885644 C253.454885,114.065563 254.348978,111.637148 257.547892,111.557582 C260.771866,111.47741 262.144005,113.944118 264.977559,114.821888 C266.178513,115.193918 267.957016,115.53296 267.759339,116.302247 C267.667608,116.659248 267.108402,116.973345 267.114095,117.314732 C267.911962,117.127958 268.637864,116.714219 269.203157,116.124039 C270.063993,115.078961 269.85243,113.863568 269.622623,112.717029 C269.578425,112.137691 269.231611,111.623945 268.709112,111.363818 C268.172639,111.109734 267.317941,111.003692 267.141936,110.61957 C266.962404,110.227668 267.656392,109.881114 267.759346,109.480391 C267.957022,108.711104 266.17852,108.372066 264.977566,108.000036 C262.144012,107.122265 260.771883,104.655547 257.547898,104.735736 C254.348988,104.815292 253.454892,107.243721 253.452694,109.063792 C253.450496,110.883863 252.367978,113.31781 249.166503,113.284621 C247.88807,113.271372 246.773452,112.814327 245.752733,112.376626 C242.69636,111.065979 239.639989,109.755337 236.583618,108.444701 C235.372113,107.884289 234.111689,107.434998 232.818035,107.10242 C230.968576,106.67328 228.925366,106.622598 226.929374,106.577498 C222.653837,106.480887 218.3783,106.384281 214.102762,106.287682 C213.449459,106.236667 212.792165,106.292861 212.15721,106.454013 C211.483452,106.677842 211.156066,107.118534 210.750222,107.497417 C208.964226,109.1648 204.765037,109.817863 201.734436,108.899537 C200.930925,108.656071 200.210948,108.320399 199.359534,108.136949 C196.677641,107.559043 193.863399,108.628212 191.076925,109.014491 C186.50905,109.647682 180.832684,108.557807 177.539642,110.465402 C176.441742,111.101353 175.859328,111.97093 174.841935,112.648748 C173.824543,113.326565 171.988703,113.786201 170.70558,113.274409 C170.866799,114.518265 171.013568,115.81625 170.166652,116.96684 C169.319737,118.11743 167.147705,119.056466 165.01363,118.76633 C163.881114,118.468661 163.9704,117.522156 164.506035,116.881599 C165.041669,116.241042 165.863213,115.586508 165.596144,114.893682 C165.331207,114.206364 164.118768,113.806608 163.212251,113.327488 C162.305735,112.848367 161.701013,111.940304 162.663867,111.498117 C162.015063,110.668966 159.682946,110.770069 158.657094,111.465394 C157.63118,112.160718 157.528761,113.139912 157.416886,114.045146 C157.30501,114.95038 157.061218,115.942025 155.87262,116.547848 C153.84696,117.58029 149.958121,117.044659 148.614696,118.389466 C148.187941,118.816672 148.162768,119.332022 147.918609,119.803262 C146.828764,121.906719 142.123808,122.451412 138.277956,122.62307 C138.2686,122.718761 138.256782,122.815245 138.244926,122.911977 C137.689504,122.483963 137.063257,122.155551 136.394336,121.941505 C134.973264,121.508512 133.174747,120.949308 133.336833,120.037453 C133.42297,119.552964 134.075006,119.174991 134.547407,118.768771 C135.45812,117.985779 135.703645,116.882903 134.725473,116.126657 C133.747302,115.37041 131.391181,115.269307 130.528178,116.069574 C130.08421,116.481217 130.110982,116.997513 129.881771,117.462456 C129.166707,118.912986 126.273552,119.549883 123.815844,120.113407 C121.358136,120.676931 118.608319,121.725413 118.839345,123.226081 C119.08741,124.836947 122.759026,126.268852 121.42252,127.644228 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.1"
          ></path>
          <path
            d="M114.642059,145.845946 C113.965672,145.975894 113.319395,146.239411 112.738072,146.622288 C113.106573,146.639115 113.473474,146.664233 113.825878,146.687688 C117.937734,146.961178 123.125469,146.029968 123.76373,143.595855 C124.085741,142.367839 123.09511,141.1674 122.133704,140.064155 C121.74724,139.620712 121.3608,139.177269 120.974384,138.733826 C118.962592,139.445857 116.213599,139.694287 113.825878,139.535468 C112.32012,139.435301 110.550262,139.298191 109.515542,139.957221 C108.718124,140.465112 108.719491,141.256176 108.98455,141.93331 C109.666702,143.676066 111.849077,145.185346 114.642059,145.845946 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.1"
          ></path>
          <ellipse
            id="Oval"
            fill="#EA565C"
            fillRule="nonzero"
            cx="198.825719"
            cy="107.733826"
            rx="41"
            ry="27"
          ></ellipse>
          <path
            d="M184.085506,105.536472 C184.085506,105.536472 165.323278,107.398246 170.84158,99.6851825 C176.359882,91.9721193 183.257759,89.3124406 186.568742,91.4401802 C189.879726,93.5679198 191.2593,99.4192129 190.70747,99.4192129 C190.155639,99.4192129 182.154101,94.8977608 179.394948,98.3553415 C176.635796,101.812922 184.085506,105.536472 184.085506,105.536472 Z"
            id="Path"
            fill="#FFFFFF"
            fillRule="nonzero"
            opacity="0.2"
          ></path>
          <path
            d="M200.602625,106.733826 C200.602625,106.733826 216.269488,117.307767 206.765188,119.742064 C197.260887,122.17636 190.151299,119.817185 189.065019,116.050647 C187.97874,112.284108 190.918677,106.873267 191.342047,107.226633 C191.765416,107.579999 194.814669,116.202289 199.2942,115.293829 C203.77373,114.385369 200.602625,106.733826 200.602625,106.733826 Z"
            id="Path"
            fill="#FFFFFF"
            fillRule="nonzero"
            opacity="0.2"
          ></path>
          <path
            d="M203.825719,100.049024 C203.825719,100.049024 205.026791,81.50983 211.873219,88.1828929 C218.719647,94.8559558 220.262708,102.008221 217.582741,104.861516 C214.902774,107.714812 208.797688,108.058133 208.88802,107.522196 C208.978352,106.986259 214.831404,99.9851015 211.809044,96.7165225 C208.786683,93.4479435 203.825719,100.049024 203.825719,100.049024 Z"
            id="Path"
            fill="#FFFFFF"
            fillRule="nonzero"
            opacity="0.2"
          ></path>
          <ellipse
            id="Oval"
            fill="#EA565C"
            fillRule="nonzero"
            cx="148.825719"
            cy="105.733826"
            rx="41"
            ry="27"
          ></ellipse>
          <path
            d="M135.085507,103.536472 C135.085507,103.536472 116.323278,105.398246 121.84158,97.6851818 C127.359882,89.9721178 134.257762,87.3124388 137.568742,89.440182 C140.879722,91.5679252 142.2593,97.4192123 141.70747,97.4192123 C141.155639,97.4192123 133.154101,92.897763 130.394949,96.355344 C127.635796,99.812925 135.085507,103.536472 135.085507,103.536472 Z"
            id="Path"
            fill="#FFFFFF"
            fillRule="nonzero"
            opacity="0.2"
          ></path>
          <path
            d="M150.602628,104.733826 C150.602628,104.733826 166.269485,115.307771 156.765189,117.742064 C147.260893,120.176357 140.151299,117.817189 139.065019,114.050647 C137.97874,110.284105 140.918677,104.873267 141.34205,105.226633 C141.765423,105.579999 144.814668,114.202293 149.294202,113.293833 C153.773736,112.385373 150.602628,104.733826 150.602628,104.733826 Z"
            id="Path"
            fill="#FFFFFF"
            fillRule="nonzero"
            opacity="0.2"
          ></path>
          <path
            d="M154.825719,98.049022 C154.825719,98.049022 156.026791,79.5098325 162.873219,86.1828917 C169.719647,92.8559509 171.262708,100.008216 168.582741,102.861515 C165.902774,105.714813 159.797692,106.058131 159.888037,105.522197 C159.978383,104.986263 165.831418,97.9850999 162.809057,94.716521 C159.786697,91.4479421 154.825719,98.049022 154.825719,98.049022 Z"
            id="Path"
            fill="#FFFFFF"
            fillRule="nonzero"
            opacity="0.2"
          ></path>
          <path
            d="M170.141297,82.7338262 C179.019719,87.6753309 184.662693,95.0748623 184.662693,103.34656 C184.662693,118.224175 166.413524,130.284888 143.901996,130.284888 C136.188445,130.284888 128.975712,128.868431 122.825719,126.408232 C129.916184,130.354646 139.069494,132.733826 149.065019,132.733826 C171.57655,132.733826 189.825719,120.673114 189.825719,105.795498 C189.825719,96.0156867 181.939626,87.4535325 170.141297,82.7338262 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.1"
          ></path>
          <path
            d="M220.141297,84.7338262 C229.019719,89.6753343 234.662696,97.0748623 234.662696,105.34656 C234.662696,120.224175 216.413527,132.284888 193.901996,132.284888 C186.188445,132.284888 178.975712,130.868431 172.825719,128.408232 C179.916184,132.354646 189.069497,134.733826 199.065023,134.733826 C221.576536,134.733826 239.825719,122.673114 239.825719,107.795498 C239.825719,98.0156867 231.939643,89.4535359 220.141297,84.7338262 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.1"
          ></path>
          <path
            d="M123.598763,100.857421 C123.598763,100.857421 158.858485,62.8294424 245.231141,78.5366509 C313.509378,90.9533193 257.441383,112.32445 230.953212,120.7337 C223.268256,123.172475 215.307227,124.617526 207.261151,125.034177 C177.378603,126.585603 102.214845,127.972472 123.598763,100.857421 Z"
            id="Path"
            fill="#714B4F"
            fillRule="nonzero"
          ></path>
          <path
            d="M230.954037,111.375022 C223.26887,113.830682 215.307619,115.285733 207.26132,115.705259 C183.052632,116.970784 129.129006,118.126656 120.89051,104.004831 C110.487569,126.830519 179.050748,125.504161 207.26132,124.02943 C215.307616,123.609901 223.268863,122.154849 230.954027,119.699189 C250.369949,113.492696 285.676279,100.274131 276.258842,88.7338262 C269.918043,97.7904034 245.794607,106.631081 230.954037,111.375022 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.1"
          ></path>
          <line
            x1="198.825719"
            y1="78.7338262"
            x2="208.825719"
            y2="97.7338262"
            id="Path"
            stroke="#000000"
            strokeWidth="2"
            opacity="0.1"
          ></line>
          <line
            x1="169.825719"
            y1="85.7338262"
            x2="177.825719"
            y2="101.733826"
            id="Path"
            stroke="#000000"
            strokeWidth="2"
            opacity="0.1"
          ></line>
          <line
            x1="216.825719"
            y1="78.7338262"
            x2="229.825719"
            y2="97.7338262"
            id="Path"
            stroke="#000000"
            strokeWidth="2"
            opacity="0.1"
          ></line>
          <line
            x1="169.825719"
            y1="102.733826"
            x2="255.825719"
            y2="91.7338262"
            id="Path"
            stroke="#000000"
            strokeWidth="2"
            opacity="0.1"
          ></line>
          <line
            x1="252.825719"
            y1="82.7338262"
            x2="258.825719"
            y2="90.7338262"
            id="Path"
            stroke="#000000"
            strokeWidth="2"
            opacity="0.1"
          ></line>
          <line
            x1="152.825719"
            y1="91.7338262"
            x2="156.825719"
            y2="99.7338262"
            id="Path"
            stroke="#000000"
            strokeWidth="2"
            opacity="0.1"
          ></line>
          <path
            d="M165.88323,66.2269514 C165.88323,66.2269514 244.648759,65.8715829 245.371379,65.1608492 C246.093998,64.4501155 262.714246,64.0735895 265.966033,68.69336 C269.217819,73.3131306 270.301751,75.4453281 265.966033,76.1560652 C261.630315,76.8668023 118.91296,149.717004 118.91296,149.717004 C118.91296,149.717004 110.964145,150.427738 114.938554,142.609668 C118.912964,134.791597 165.88323,66.2269514 165.88323,66.2269514 Z"
            id="Path"
            fill="#F6C964"
            fillRule="nonzero"
          ></path>
          <path
            d="M198.825719,98.772288 C198.825719,101.671783 184.722688,108.733826 167.325719,108.733826 C149.928751,108.733826 135.825719,101.671783 135.825719,98.772288 C135.825719,95.8727931 149.928751,94.7338262 167.325729,94.7338262 C184.722708,94.7338262 198.825719,95.8727931 198.825719,98.772288 Z"
            id="Path"
            fill="#61AB43"
            fillRule="nonzero"
          ></path>
          <ellipse
            id="Oval"
            fill="#61AB43"
            fillRule="nonzero"
            cx="167.325719"
            cy="98.2338262"
            rx="31.5"
            ry="5.5"
          ></ellipse>
          <path
            d="M236.825719,93.772288 C236.825719,96.671783 222.722688,103.733826 205.325719,103.733826 C187.928751,103.733826 173.825719,96.671783 173.825719,93.772288 C173.825719,90.8727931 187.928747,89.7338262 205.325719,89.7338262 C222.722691,89.7338262 236.825719,90.8727931 236.825719,93.772288 Z"
            id="Path"
            fill="#61AB43"
            fillRule="nonzero"
          ></path>
          <ellipse
            id="Oval"
            fill="#61AB43"
            fillRule="nonzero"
            cx="205.325719"
            cy="93.2338262"
            rx="31.5"
            ry="5.5"
          ></ellipse>
          <path
            d="M274.825719,88.772289 C274.825719,91.6717813 260.722688,98.7338262 243.325719,98.7338262 C225.928751,98.7338262 211.825719,91.6717813 211.825719,88.772289 C211.825719,85.8727968 225.928747,84.7338262 243.325719,84.7338262 C260.722691,84.7338262 274.825719,85.8727934 274.825719,88.772289 Z"
            id="Path"
            fill="#61AB43"
            fillRule="nonzero"
          ></path>
          <ellipse
            id="Oval"
            fill="#61AB43"
            fillRule="nonzero"
            cx="243.325719"
            cy="89.2338262"
            rx="31.5"
            ry="5.5"
          ></ellipse>
          <path
            d="M127.084375,90.2662839 C127.084375,90.2662839 114.059906,88.1370386 120.723589,77.4908088 C127.387273,66.8445789 129.628595,54.9103073 132.53648,52.244033 C135.78747,49.2631611 202.888236,-3.00025944 255.162993,54.8321293 C260.701106,61.0320799 265.203026,68.0916561 268.493982,75.7367963 C269.126316,77.1821678 269.823489,78.4793869 270.504991,79.16377 C272.625253,81.2930153 274.44262,87.3765767 270.504991,90.4183556 C266.567362,93.4601346 150.558712,105.323093 127.084375,90.2662839 Z"
            id="Path"
            fill="#3F3D56"
            fillRule="nonzero"
          ></path>
          <path
            d="M187.825719,46.7338262 C187.089596,47.3480824 186.221745,47.6952224 185.325719,47.7338262 C183.945007,47.7338262 182.825719,47.2861108 182.825719,46.7338262 C182.825719,46.1815455 183.945007,45.7338262 185.325719,45.7338262 C186.221745,45.7724306 187.089597,46.1195719 187.825719,46.7338262 Z"
            id="Path"
            fill="#F2F2F2"
            fillRule="nonzero"
          ></path>
          <path
            d="M165.825719,40.7338262 C165.089596,41.3480817 164.221745,41.6952223 163.325719,41.7338262 C161.945007,41.7338262 160.825719,41.2861099 160.825719,40.7338262 C160.825719,40.1815426 161.945007,39.7338262 163.325719,39.7338262 C164.221745,39.7724302 165.089596,40.1195708 165.825719,40.7338262 L165.825719,40.7338262 Z"
            id="Path"
            fill="#F2F2F2"
            fillRule="nonzero"
          ></path>
          <path
            d="M224.825719,48.524423 C223.931921,48.7863636 222.9762,48.8029105 222.072596,48.5720894 C220.69567,48.1703014 219.695849,47.4975287 219.839439,47.0694128 C219.98303,46.6412969 221.21564,46.6199553 222.592562,47.0217433 C223.476092,47.3124149 224.251312,47.834056 224.825719,48.524423 L224.825719,48.524423 Z"
            id="Path"
            fill="#F2F2F2"
            fillRule="nonzero"
          ></path>
          <path
            d="M184.825719,33.524422 C183.931921,33.7863627 182.9762,33.8029107 182.072596,33.5720915 C180.69567,33.1703006 179.695849,32.497528 179.839439,32.0694123 C179.98303,31.6412965 181.21564,31.6199549 182.592562,32.0217458 C183.476093,32.3124156 184.251312,32.8340556 184.825719,33.524422 L184.825719,33.524422 Z"
            id="Path"
            fill="#F2F2F2"
            fillRule="nonzero"
          ></path>
          <path
            d="M228.825719,38.524423 C227.931921,38.7863636 226.9762,38.8029105 226.072596,38.5720894 C224.695669,38.1703014 223.695851,37.4975287 223.839439,37.0694128 C223.983026,36.6412969 225.215636,36.6199553 226.592562,37.0217433 C227.476092,37.3124149 228.251311,37.834056 228.825719,38.524423 L228.825719,38.524423 Z"
            id="Path"
            fill="#F2F2F2"
            fillRule="nonzero"
          ></path>
          <path
            d="M219.825719,37.7338262 C219.089596,38.3480814 218.221744,38.695222 217.325719,38.7338262 C215.945006,38.7338262 214.825719,38.2861099 214.825719,37.7338262 C214.825719,37.1815426 215.945006,36.7338262 217.325719,36.7338262 C218.221744,36.7724305 219.089596,37.1195711 219.825719,37.7338262 Z"
            id="Path"
            fill="#F2F2F2"
            fillRule="nonzero"
          ></path>
          <path
            d="M193.825719,32.7338262 C193.089597,33.3480817 192.221746,33.6952223 191.325719,33.7338262 C189.945009,33.7338262 188.825719,33.2861137 188.825719,32.7338262 C188.825719,32.1815388 189.945009,31.7338262 191.325719,31.7338262 C192.221746,31.7724302 193.089597,32.1195708 193.825719,32.7338262 L193.825719,32.7338262 Z"
            id="Path"
            fill="#F2F2F2"
            fillRule="nonzero"
          ></path>
          <path
            d="M213.825719,32.7338262 C213.089597,33.3480817 212.221746,33.6952223 211.325719,33.7338262 C209.945009,33.7338262 208.825719,33.2861137 208.825719,32.7338262 C208.825719,32.1815388 209.945009,31.7338262 211.325719,31.7338262 C212.221746,31.7724302 213.089597,32.1195708 213.825719,32.7338262 L213.825719,32.7338262 Z"
            id="Path"
            fill="#F2F2F2"
            fillRule="nonzero"
          ></path>
          <path
            d="M205.825719,44.7338262 C205.089596,45.3480817 204.221745,45.6952223 203.325719,45.7338262 C201.945007,45.7338262 200.825719,45.2861137 200.825719,44.7338262 C200.825719,44.1815388 201.945007,43.7338262 203.325719,43.7338262 C204.221745,43.7724302 205.089596,44.1195708 205.825719,44.7338262 L205.825719,44.7338262 Z"
            id="Path"
            fill="#F2F2F2"
            fillRule="nonzero"
          ></path>
          <path
            d="M184.825719,42.7338262 C185.044479,41.7203219 185.521874,40.7979299 186.20094,40.0767116 C187.281965,39.0083604 188.418941,38.4658449 188.740449,38.8649733 C189.061957,39.2641016 188.446253,40.453733 187.365229,41.5220879 C186.641215,42.1875064 185.759649,42.6081499 184.825719,42.7338262 Z"
            id="Path"
            fill="#F2F2F2"
            fillRule="nonzero"
          ></path>
          <path
            d="M170.825719,38.7338262 C171.044477,37.7203213 171.521872,36.7979292 172.20094,36.0767132 C173.281961,35.0083574 174.418941,34.4658451 174.740449,34.8649738 C175.061957,35.2641025 174.446253,36.4537348 173.365229,37.5220869 C172.641216,38.1875075 171.759649,38.6081516 170.825719,38.7338262 Z"
            id="Path"
            fill="#F2F2F2"
            fillRule="nonzero"
          ></path>
          <path
            d="M146.825719,55.7338262 C147.044479,54.720322 147.521873,53.7979303 148.200939,53.0767132 C149.281962,52.0083574 150.418938,51.4658451 150.740449,51.8649738 C151.06196,52.2641025 150.446249,53.4537311 149.365229,54.5220869 C148.641216,55.1875075 147.759649,55.6081514 146.825719,55.7338262 Z"
            id="Path"
            fill="#F2F2F2"
            fillRule="nonzero"
          ></path>
          <path
            d="M199.825719,37.7338262 C200.044477,36.7203213 200.521872,35.7979292 201.20094,35.0767132 C202.281961,34.0083574 203.418937,33.4658451 203.740448,33.8649738 C204.061959,34.2641025 203.446252,35.4537348 202.365228,36.5220869 C201.641215,37.187507 200.759649,37.608151 199.825719,37.7338262 Z"
            id="Path"
            fill="#F2F2F2"
            fillRule="nonzero"
          ></path>
          <path
            d="M193.825719,47.7338262 C194.044477,46.7203213 194.521872,45.7979292 195.20094,45.0767132 C196.281965,44.0083574 197.418941,43.4658451 197.740449,43.8649738 C198.061957,44.2641025 197.446253,45.4537348 196.365229,46.5220869 C195.641216,47.1875075 194.759649,47.6081516 193.825719,47.7338262 L193.825719,47.7338262 Z"
            id="Path"
            fill="#F2F2F2"
            fillRule="nonzero"
          ></path>
          <path
            d="M294.597928,166.733826 C294.597928,166.733826 290.403478,168.007451 288.306253,170.554697 C288.306253,170.554697 284.531248,172.25286 282.224299,171.828318 C279.917349,171.403776 275.722903,175.649185 279.078461,176.92281 C282.43402,178.196434 302.986831,181.59276 303.406273,180.531408 C303.825719,179.470056 303.825719,168.644262 303.825719,168.644262 L294.597928,166.733826 Z"
            id="Path"
            fill="#575A89"
            fillRule="nonzero"
          ></path>
          <path
            d="M327.845481,164.733826 C327.845481,164.733826 323.944591,166.697556 322.315149,169.546272 C322.315149,169.546272 318.897078,171.852942 316.562554,171.833627 C314.228031,171.814313 310.826468,176.682031 314.332378,177.351267 C317.838289,178.020504 338.571918,177.815456 338.805077,176.7064 C339.038237,175.597344 337.219252,165.018519 337.219252,165.018519 L327.845481,164.733826 Z"
            id="Path"
            fill="#575A89"
            fillRule="nonzero"
          ></path>
          <circle
            id="Oval"
            fill="#FFB9B9"
            fillRule="nonzero"
            cx="301.325719"
            cy="15.2338262"
            r="9.5"
          ></circle>
          <path
            d="M309.437019,16.7338262 C309.437019,16.7338262 310.467458,23.8628576 312.322235,24.7015684 C313.612701,25.3478612 314.795026,26.1969818 315.825719,27.2176973 L310.673538,29.7338262 L300.57526,29.1047914 C300.57526,29.1047914 301.399611,24.491889 299.956999,22.1854395 C298.514388,19.87899 309.437019,16.7338262 309.437019,16.7338262 Z"
            id="Path"
            fill="#FFB9B9"
            fillRule="nonzero"
          ></path>
          <path
            d="M328.790319,49.7338262 C328.790319,49.7338262 333.369969,62.0525076 328.790319,73.9536059 C324.21067,85.8547042 322.219522,87.7338262 322.219522,87.7338262 L320.825719,72.0744873 L322.428405,70.5498463 C322.428405,70.5498463 323.398908,65.7990346 322.610103,62.9862101 C321.821298,60.1733855 323.015987,51.404155 323.015987,51.404155 L328.790319,49.7338262 Z"
            id="Path"
            fill="#FFB9B9"
            fillRule="nonzero"
          ></path>
          <path
            d="M292.301325,76.4411895 C292.301325,76.4411895 286.244625,90.1894599 286.871183,96.8552877 C287.497741,103.521115 292.301325,131.642577 292.301325,131.642577 C292.301325,131.642577 291.674771,167.888016 293.554437,167.888016 C295.434104,167.888016 304.414725,171.220929 304.414725,168.929552 C304.414725,166.638175 306.294392,111.645094 306.294392,111.645094 C306.294392,111.645094 316.945826,135.808719 317.990084,137.683481 C319.034343,139.558242 325.717597,168.929548 328.014968,168.929548 C330.312338,168.929548 337.413293,166.846477 336.786739,165.388327 C336.160184,163.930177 329.059226,131.434268 325.091043,123.10198 C321.12286,114.769693 321.958264,83.3153264 321.958264,83.3153264 L315.275013,68.7338262 L292.301325,76.4411895 Z"
            id="Path"
            fill="#3F3D56"
            fillRule="nonzero"
          ></path>
          <path
            d="M299.139141,10.5592369 C299.139141,10.5592369 293.21137,10.1398268 292.787946,8.67189354 C292.364521,7.20396024 291.517705,5.94573368 291.941118,5.94573368 C292.364532,5.94573368 292.576237,4.89721038 292.576237,4.89721038 C292.576237,4.89721038 292.999651,4.68750711 293.211359,4.89721038 C293.423068,5.10691366 293.634773,3.42928055 293.634773,3.42928055 C293.634773,3.42928055 293.846478,2.80016726 294.058183,3.21957727 C294.269888,3.63898728 294.269892,3.42928055 294.481597,2.80016726 C294.693302,2.17105398 295.751838,1.75164397 295.751838,1.75164397 C295.751838,1.75164397 299.774259,1.96134724 300.409382,1.12253069 C301.044504,0.283714134 308.242523,0.912823951 309.724465,1.96134724 C311.206408,3.00987054 317.769315,6.78455716 316.710783,9.93012704 C315.65225,13.0756969 311.841534,19.99595 311.841534,21.0444732 C311.841534,22.0929965 310.359591,21.8832933 309.936174,20.83477 C309.512757,19.7862467 306.125458,18.5280167 306.125458,17.8989103 C306.125458,17.2698039 304.220098,11.3980673 303.161572,11.8174738 C302.103047,12.2368804 300.832799,15.5921604 300.409389,14.9630472 C299.985978,14.3339339 299.139141,10.5592369 299.139141,10.5592369 Z"
            id="Path"
            fill="#3F3D56"
            fillRule="nonzero"
          ></path>
          <path
            d="M327.825719,39.2221984 C327.825719,39.2221984 319.355938,26.6640668 316.876983,26.0361502 C314.398028,25.4082336 308.820359,23.7338262 308.820359,23.7338262 C308.820359,23.7338262 303.242696,24.5710334 301.59007,25.408244 C299.937444,26.2454546 293.740025,27.710568 293.533446,30.2221964 C293.326867,32.7338262 295.186086,56.8035936 294.153186,59.1059175 C293.120285,61.4082415 289.608423,83.3849907 291.26107,82.9663854 C292.913717,82.5477801 291.674231,77.1059319 298.904533,76.8966171 C306.134836,76.6873024 310.059858,72.2919657 312.745402,77.5245233 C315.430946,82.757081 323.074406,86.7338262 323.074406,86.7338262 C323.266517,85.0464254 323.542306,83.3698869 323.900727,81.7105695 C324.520467,78.7803427 322.248084,71.6640594 322.248084,71.6640594 C322.248084,71.6640594 322.454666,55.1291758 323.280984,53.2454536 C324.107302,51.3617315 327.825719,39.2221984 327.825719,39.2221984 Z"
            id="Path"
            fill="#FED448"
            fillRule="nonzero"
          ></path>
          <path
            d="M324.367849,38.7338262 L327.493257,39.1447858 C327.493257,39.1447858 327.284897,43.2543751 328.118341,44.4872505 C328.951784,45.7201259 330.410305,52.0899912 329.576862,52.2954727 C328.743418,52.5009542 321.242441,53.7338262 321.242441,53.7338262 L320.825719,44.2817724 L324.367849,38.7338262 Z"
            id="Path"
            fill="#FED448"
            fillRule="nonzero"
          ></path>
          <path
            d="M290.886953,45.7338262 C290.886953,45.7338262 288.783344,59.2981626 287.73154,60.9676187 C286.679735,62.6370748 281.420713,86.0094738 281.420713,86.0094738 C281.420713,86.0094738 272.772718,97.9398009 276.979939,97.7311202 C281.18716,97.5224395 285.627931,86.8442036 285.627931,86.8442036 C285.627931,86.8442036 298.670306,63.2631238 298.670306,60.7589414 C298.670306,58.254759 301.825719,45.7338262 301.825719,45.7338262 L290.886953,45.7338262 Z"
            id="Path"
            fill="#FFB9B9"
            fillRule="nonzero"
          ></path>
          <path
            d="M296.523235,27.7338262 L292.749047,29.1560459 C292.749047,29.1560459 287.926469,45.8163648 288.974855,47.2385878 C290.023241,48.6608107 302.603874,46.6290646 302.81355,46.0195381 C303.023226,45.4100116 300.507092,27.7338262 296.523235,27.7338262 Z"
            id="Path"
            fill="#FED448"
            fillRule="nonzero"
          ></path>
          <path
            d="M34.8257191,140.733826 C34.8257191,161.184998 47.3491559,177.733826 62.8257191,177.733826"
            id="Path"
            fill="#46455B"
            fillRule="nonzero"
          ></path>
          <path
            d="M62.8257191,177.733826 C62.8257191,157.282656 77.1382218,140.733826 94.8257191,140.733826"
            id="Path"
            fill="#FED448"
            fillRule="nonzero"
          ></path>
          <path
            d="M44.8257191,142.733826 C44.8257191,162.079534 52.8765021,177.733826 62.8257191,177.733826"
            id="Path"
            fill="#FED448"
            fillRule="nonzero"
          ></path>
          <path
            d="M62.8257191,177.733826 C62.8257191,151.75531 79.3745472,130.733826 99.8257191,130.733826"
            id="Path"
            fill="#46455B"
            fillRule="nonzero"
          ></path>
          <path
            d="M56.8257191,178.021644 C56.8257191,178.021644 60.8569,177.891241 62.0717954,176.982618 C63.2866908,176.073995 68.2727677,174.989046 68.5741542,176.446281 C68.8755408,177.903515 74.6322666,183.693903 70.0810836,183.732459 C65.5299005,183.771014 59.50616,182.987885 58.2935848,182.212116 C57.0810095,181.436347 56.8257191,178.021644 56.8257191,178.021644 Z"
            id="Path"
            fill="#A8A8A8"
            fillRule="nonzero"
          ></path>
          <path
            d="M70.1632334,182.289039 C65.6117321,182.322768 59.5875739,181.637931 58.3749311,180.959534 C57.451438,180.442902 57.0834336,178.5891 56.9603048,177.733826 C56.8750325,177.737192 56.8257191,177.738644 56.8257191,177.738644 C56.8257191,177.738644 57.0810617,180.724731 58.2937046,181.403124 C59.5063475,182.081518 65.5305263,182.766358 70.0820103,182.732629 C71.3958477,182.7229 71.849671,182.293598 71.824753,181.657766 C71.6422289,182.041921 71.1411616,182.281797 70.1632334,182.289039 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.2"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const MealSvg = (props) => (
  <svg
    width="20px"
    height="20px"
    style={{ ...props.style, enableBackground: "new 0 0 510.919 510.919" }}
    version="1.1"
    id="IconsRepoEditor"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 510.919 510.919"
    fill="#000000"
    stroke="#000000"
    strokeWidth="12"
  >
    <g id="IconsRepo_bgCarrier"></g>{" "}
    <path d="M327.528,438.483h-16.004c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16.004c4.142,0,7.5-3.358,7.5-7.5 S331.67,438.483,327.528,438.483z"></path>{" "}
    <path d="M506.52,219.108c-2.918-2.988-6.982-4.702-11.15-4.702h-6.206c-5.548-14.372-14.763-26.99-26.903-36.729 c-12.89-10.341-28.234-16.743-44.567-18.628c-19.564-25.534-50.02-40.675-82.163-40.675c-1.882,0-3.688,0.084-5.479,0.203 c-6.067-4.388-12.504-8.228-19.2-11.481c-1.377-11.658-11.315-20.732-23.337-20.732c-4.359,0-8.442,1.197-11.946,3.273 c-4.133-6.757-11.581-11.276-20.065-11.276s-15.932,4.519-20.065,11.276c-3.503-2.076-7.586-3.273-11.946-3.273 c-12.022,0-21.959,9.074-23.336,20.732c-6.697,3.254-13.134,7.094-19.201,11.482c-1.792-0.119-3.598-0.203-5.479-0.203 c-17.687,0-34.858,4.593-49.99,12.971L67.664,36.201c-0.049-0.082-0.101-0.162-0.153-0.241 c-7.148-10.812-21.761-13.792-32.571-6.644c-10.812,7.148-13.792,21.759-6.644,32.571c0.044,0.066,0.089,0.132,0.135,0.197 l66.87,94.455c-0.674,0.826-1.338,1.661-1.988,2.51c-16.333,1.886-31.678,8.288-44.567,18.628 c-12.14,9.739-21.355,22.357-26.903,36.729h-6.291c-4.212,0-8.162,1.663-11.121,4.683c-2.941,3.002-4.514,6.955-4.429,11.131 c2.192,106.873,46.41,183.467,127.959,221.85v1.915c0,17.374,14.135,31.508,31.508,31.508h192.065 c17.374,0,31.508-14.135,31.508-31.508v-2.286c40.324-19.147,72.016-49.108,94.24-89.115 c20.835-37.506,32.464-83.271,33.63-132.349C511.014,226.064,509.453,222.112,506.52,219.108z M287.514,101.363 c4.69,0,8.506,3.815,8.506,8.505s-3.816,8.505-8.506,8.505s-8.505-3.815-8.505-8.505S282.824,101.363,287.514,101.363z M255.503,93.361c4.69,0,8.505,3.815,8.505,8.505s-3.815,8.505-8.505,8.505s-8.505-3.815-8.505-8.505 S250.813,93.361,255.503,93.361z M223.493,101.363c4.69,0,8.505,3.815,8.505,8.505s-3.815,8.505-8.505,8.505 s-8.505-3.815-8.505-8.505S218.803,101.363,223.493,101.363z M43.213,41.829c3.878-2.565,9.108-1.526,11.718,2.303l57.982,95.409 c-2.444,1.857-4.811,3.824-7.091,5.9L40.754,53.529C38.239,49.626,39.329,44.397,43.213,41.829z M97.919,173.674 c2.217-0.167,4.245-1.31,5.537-3.119c16.634-23.282,43.558-37.182,72.02-37.182c2.318,0,4.685,0.173,7.106,0.366 c1.837,0.146,3.658-0.388,5.123-1.498c4.992-3.781,10.285-7.132,15.795-10.03c4.147,6.693,11.556,11.162,19.992,11.162 c8.484,0,15.932-4.519,20.065-11.276c3.503,2.076,7.586,3.273,11.946,3.273s8.442-1.197,11.946-3.273 c4.133,6.757,11.581,11.276,20.065,11.276c8.436,0,15.845-4.469,19.993-11.162c5.51,2.897,10.803,6.249,15.794,10.03 c1.466,1.11,3.288,1.644,5.123,1.498c2.422-0.193,4.788-0.366,7.106-0.366c28.462,0,55.386,13.9,72.02,37.182 c1.292,1.809,3.32,2.951,5.537,3.119c26.166,1.978,48.657,17.603,59.759,40.732H38.16 C49.262,191.277,71.753,175.653,97.919,173.674z M375.863,438.499c-0.107-0.004-0.211-0.016-0.319-0.016h-16.005 c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h8.505v0.502c0,9.103-7.406,16.508-16.508,16.508H159.471 c-9.103,0-16.508-7.406-16.508-16.508v-0.502h136.551c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5H135.462 c-0.334,0-0.66,0.029-0.983,0.072C66.541,406.603,26.354,345.786,17.027,261.418h350.518c4.142,0,7.5-3.358,7.5-7.5 c0-4.142-3.358-7.5-7.5-7.5H15.713c-0.355-5.414-0.598-10.912-0.713-16.504c-0.001-0.043-0.003-0.174,0.146-0.326 c0.081-0.083,0.217-0.181,0.406-0.181h11.571c0.008,0,0.017,0.002,0.026,0.002c0.008,0,0.016-0.002,0.024-0.002h456.659 c0.008,0,0.016,0.002,0.024,0.002c0.008,0,0.017-0.002,0.026-0.002h11.487c0.199,0,0.337,0.099,0.418,0.181 c0.135,0.138,0.132,0.25,0.131,0.292c-0.133,5.587-0.407,11.099-0.807,16.539h-47.544c-4.142,0-7.5,3.358-7.5,7.5 c0,4.142,3.358,7.5,7.5,7.5h46.09C483.597,344.051,441.743,407.488,375.863,438.499z"></path>{" "}
    <path d="M415.559,246.418h-16.008c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h16.008c4.142,0,7.5-3.358,7.5-7.5 C423.059,249.776,419.701,246.418,415.559,246.418z"></path>{" "}
  </svg>
);

export const ChefSvg = (props) => (
  <svg
    width={props.size}
    style={props.style}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 728 754.88525"
  >
    <rect
      x="514.67011"
      y="302.6311"
      width="33"
      height="524"
      transform="translate(-458.65432 311.24592) rotate(-33.25976)"
      fill="#e6e6e6"
    />
    <path
      d="M335.58256,171.60615l63.84438,97.34271a8.5,8.5,0,0,1-14.21528,9.32341L311.81484,166.36508a60.62682,60.62682,0,0,0-29.14936,4.78729L362.63446,293.08a8.5,8.5,0,0,1-14.21528,9.3234l-79.969-121.92766A60.62685,60.62685,0,0,0,252.44516,205.304L325.842,317.2112a8.5,8.5,0,0,1-14.21528,9.3234l-63.84438-97.3427c-1.6398,27.14157,7.20944,59.3114,26.60329,88.881,36.04421,54.95614,94.83957,80.109,131.32307,56.18052s36.8396-87.87721.79539-142.83336C387.11022,201.85046,361.13005,180.91634,335.58256,171.60615Z"
      transform="translate(-236 -72.55738)"
      fill="#e6e6e6"
    />
    <rect x="256" y="204" width="33" height="524" fill="#e6e6e6" />
    <ellipse cx="272" cy="119" rx="79" ry="119" fill="#e6e6e6" />
    <ellipse cx="272" cy="119" rx="65" ry="97.91139" fill="#ccc" />
    <ellipse cx="364" cy="734" rx="364" ry="20.88525" fill="#e6e6e6" />
    <path
      d="M815.26782,806.25045a1162.796,1162.796,0,0,0-412.53564,0A15.04906,15.04906,0,0,1,385,791.45826V604.55738H833V791.45826A15.04906,15.04906,0,0,1,815.26782,806.25045Z"
      transform="translate(-236 -72.55738)"
      fill="#fed448"
    />
    <path
      d="M792,466.55738a92.85808,92.85808,0,0,0-30.39526,5.0863,179.055,179.055,0,0,0-324.4441-1.63928,93.00486,93.00486,0,1,0,12.16987,174.74988,179.02647,179.02647,0,0,0,300.7481-2.16382A93.00664,93.00664,0,1,0,792,466.55738Z"
      transform="translate(-236 -72.55738)"
      fill="#fed448"
    />
    <path
      d="M421,546.55738h-2A178.40222,178.40222,0,0,1,436.24707,469.572l1.80762.85644A176.41047,176.41047,0,0,0,421,546.55738Z"
      transform="translate(-236 -72.55738)"
      fill="#3f3d56"
    />
    <path
      d="M779,546.55738h-2a176.52632,176.52632,0,0,0-16.29395-74.501l1.81641-.83789A178.51046,178.51046,0,0,1,779,546.55738Z"
      transform="translate(-236 -72.55738)"
      fill="#3f3d56"
    />
    <path
      d="M385.24121,691.52808l-.48242-1.94141c.56445-.13964,57.40332-14.09961,140.70019-21.02636,76.88086-6.39258,192.68653-7.93457,307.78516,21.02734l-.48828,1.93945C717.93945,662.63746,602.38672,664.17261,525.667,670.55054,442.519,677.46167,385.8042,691.38843,385.24121,691.52808Z"
      transform="translate(-236 -72.55738)"
      fill="#3f3d56"
    />
    <path
      d="M385.24121,718.52808l-.48242-1.94141c.56445-.13964,57.40332-14.09961,140.70019-21.02636,76.88086-6.39258,192.68653-7.93457,307.78516,21.02734l-.48828,1.93945C717.93945,689.63746,602.38672,691.17456,525.667,697.55054,442.519,704.46167,385.8042,718.38843,385.24121,718.52808Z"
      transform="translate(-236 -72.55738)"
      fill="#3f3d56"
    />
    <path
      d="M385.24121,745.52808l-.48242-1.94141c.56445-.13964,57.40332-14.09961,140.70019-21.02636,76.88086-6.39258,192.68653-7.93457,307.78516,21.02734l-.48828,1.93945C717.93945,716.63746,602.38672,718.17456,525.667,724.55054,442.519,731.46167,385.8042,745.38843,385.24121,745.52808Z"
      transform="translate(-236 -72.55738)"
      fill="#3f3d56"
    />
    <path
      d="M753.26693,598.71334,729.03658,590.475l23.26113-118.72871-15.992-1.45382c-15.594,11.96435-36.35984,16.65481-62.99891,13.08438l42.64542,64.45274-21.745,15.34942-69.368-83.20523A20.866,20.866,0,0,1,620,466.61227v0a20.866,20.866,0,0,1,15.0905-20.05076L709.16769,425.224l86.74466,9.69214c13.11467,19.99417,13.62744,33.89954-6.33645,37.911Z"
      transform="translate(-236 -72.55738)"
      fill="#2f2e41"
    />
    <path
      d="M728.46691,644.90106h0a15.95869,15.95869,0,0,1-13.86555-21.711l12.046-30.97551c6.11869-11.59112,14.5164-10.14011,24.43261,0l4.84611,14.21526a9.17534,9.17534,0,0,1-.53485,7.176L743.64973,636.306A15.95871,15.95871,0,0,1,728.46691,644.90106Z"
      transform="translate(-236 -72.55738)"
      fill="#2f2e41"
    />
    <path
      d="M697.15218,604.33834h0a15.95869,15.95869,0,0,1-13.86555-21.711l12.046-30.97551c6.11869-11.59113,14.51641-10.14012,24.43261,0l4.84611,14.21525a9.17537,9.17537,0,0,1-.53485,7.176L712.335,595.74331A15.9587,15.9587,0,0,1,697.15218,604.33834Z"
      transform="translate(-236 -72.55738)"
      fill="#2f2e41"
    />
    <circle cx="476.55994" cy="212.13062" r="27.13799" fill="#ffb9b9" />
    <polygon
      points="518.721 250.415 481.406 269.799 473.652 234.907 499.336 218.915 518.721 250.415"
      fill="#ffb9b9"
    />
    <path
      d="M799.7892,439.76224c-37.23393-11.24605-71.01788-17.07317-95.46758-8.23832,8.42738-23.70818-7.12737-59.91146-24.23035-96.9214,7.37949-9.64677,19.14576-13.38347,32.46867-15.02282,14.5769,10.5844,24.74122,3.79091,32.46867-12.59978,16.85358-.67652,33.095,5.29186,48.94531,15.50743C781.58355,362.17339,783.814,401.25293,799.7892,439.76224Z"
      transform="translate(-236 -72.55738)"
      fill="#3f3d56"
    />
    <path
      d="M703.837,437.33921c-5.87952,3.4656-11.3058,9.30325-16.47664,16.47664-8.73817-5.349-16.42816-11.439-22.48592-18.68294a40.01122,40.01122,0,0,1-7.33032-37.42892l16.56053-53.82173a23.60967,23.60967,0,0,1,7.67755-11.38054l2.18592-1.776,21.80731,41.19159-21.80731,40.707C686.73356,420.03892,694.88267,428.6031,703.837,437.33921Z"
      transform="translate(-236 -72.55738)"
      fill="#3f3d56"
    />
    <path
      d="M711.343,478.37478h0a14.00455,14.00455,0,0,1-19.66674-10.71872L688.072,442.98155l12.59979-6.7845,15.9909,20.93355A14.00455,14.00455,0,0,1,711.343,478.37478Z"
      transform="translate(-236 -72.55738)"
      fill="#ffb9b9"
    />
    <path
      d="M739.94024,283.50047l-4.63369.13763-12.853-18.20724c-16.46951,1.70257-29.96494,8.858-41.38524,19.81828l-1.15795-7.71966a29.10153,29.10153,0,0,1,22.90286-32.81892h.00006a29.10153,29.10153,0,0,1,34.57213,23.6573Z"
      transform="translate(-236 -72.55738)"
      fill="#2f2e41"
    />
    <path
      d="M687.82806,453.82563v0a14.00456,14.00456,0,0,1,10.71872-19.66675l24.67452-3.60414,6.7845,12.59978L709.07224,459.1454A14.00455,14.00455,0,0,1,687.82806,453.82563Z"
      transform="translate(-236 -72.55738)"
      fill="#ffb9b9"
    />
    <path
      d="M804.49034,431.38118c-23.4754,1.82279-49.10633,9.14326-75.93837,19.527a37.12074,37.12074,0,0,0-8.23832-21.80731c24.37008-6.41874,46.48406-13.95144,60.09127-25.68417L772.1666,341.387l17.93046-20.35349,3.09274,1.6136a20.65228,20.65228,0,0,1,10.4691,13.14326c7.57071,29.449,10.93351,57.66486,8.62195,84.21782A10.47079,10.47079,0,0,1,804.49034,431.38118Z"
      transform="translate(-236 -72.55738)"
      fill="#3f3d56"
    />
    <path
      d="M331.88594,800.6692q-32.74851,20.483-65.49722-.01716a4.441,4.441,0,0,1-2.10125-4.0963l6.81241-88.56136h55.10049l7.78288,88.5302A4.44,4.44,0,0,1,331.88594,800.6692Z"
      transform="translate(-236 -72.55738)"
      fill="#3f3d56"
    />
    <ellipse
      cx="62.39599"
      cy="636.43883"
      rx="27.80438"
      ry="10.01827"
      fill="#3f3d56"
    />
    <path
      d="M320.18941,705.61437q-21.73251,15.28772-42.07674,0V689.58514h42.07674Z"
      transform="translate(-236 -72.55738)"
      fill="#fed448"
    />
    <ellipse
      cx="63.15104"
      cy="617.02776"
      rx="21.03837"
      ry="8.01462"
      fill="#fed448"
    />
    <ellipse
      cx="64.15287"
      cy="616.02594"
      rx="2.00365"
      ry="1.00183"
      fill="#e6e6e6"
    />
    <ellipse
      cx="73.61397"
      cy="616.02594"
      rx="2.00365"
      ry="1.00183"
      fill="#e6e6e6"
    />
    <ellipse
      cx="68.88342"
      cy="618.39121"
      rx="2.00365"
      ry="1.00183"
      fill="#e6e6e6"
    />
    <ellipse
      cx="49.96121"
      cy="618.39121"
      rx="2.00365"
      ry="1.00183"
      fill="#e6e6e6"
    />
    <ellipse
      cx="54.69176"
      cy="616.02594"
      rx="2.00365"
      ry="1.00183"
      fill="#e6e6e6"
    />
    <ellipse
      cx="59.42232"
      cy="619.57385"
      rx="2.00365"
      ry="1.00183"
      fill="#e6e6e6"
    />
    <path
      d="M936.88594,800.6692q-32.74851,20.483-65.49722-.01716a4.441,4.441,0,0,1-2.10125-4.0963l6.81241-88.56136h55.10049l7.78288,88.5302A4.44,4.44,0,0,1,936.88594,800.6692Z"
      transform="translate(-236 -72.55738)"
      fill="#3f3d56"
    />
    <ellipse
      cx="667.39599"
      cy="636.43883"
      rx="27.80438"
      ry="10.01827"
      fill="#3f3d56"
    />
    <path
      d="M925.18941,705.61437q-21.73251,15.28772-42.07674,0V689.58514h42.07674Z"
      transform="translate(-236 -72.55738)"
      fill="#fed448"
    />
    <ellipse
      cx="668.15104"
      cy="617.02776"
      rx="21.03837"
      ry="8.01462"
      fill="#fed448"
    />
    <ellipse
      cx="669.15287"
      cy="616.02594"
      rx="2.00365"
      ry="1.00183"
      fill="#e6e6e6"
    />
    <ellipse
      cx="678.61397"
      cy="616.02594"
      rx="2.00365"
      ry="1.00183"
      fill="#e6e6e6"
    />
    <ellipse
      cx="673.88342"
      cy="618.39121"
      rx="2.00365"
      ry="1.00183"
      fill="#e6e6e6"
    />
    <ellipse
      cx="654.96121"
      cy="618.39121"
      rx="2.00365"
      ry="1.00183"
      fill="#e6e6e6"
    />
    <ellipse
      cx="659.69176"
      cy="616.02594"
      rx="2.00365"
      ry="1.00183"
      fill="#e6e6e6"
    />
    <ellipse
      cx="664.42232"
      cy="619.57385"
      rx="2.00365"
      ry="1.00183"
      fill="#e6e6e6"
    />
  </svg>
);

export const MerchantSvg = (props) => (
  <svg
    width={props.size}
    style={props.style}
    viewBox="0 0 222 111"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        x1="49.9931686%"
        y1="99.9666971%"
        x2="49.9931686%"
        y2="0.0148473559%"
        id="linearGradient-merchant-1"
      >
        <stop stopColor="#808080" stopOpacity="0.25" offset="0%"></stop>
        <stop stopColor="#808080" stopOpacity="0.12" offset="54%"></stop>
        <stop stopColor="#808080" stopOpacity="0.1" offset="100%"></stop>
      </linearGradient>
      <linearGradient
        x1="50.1906447%"
        y1="100.031988%"
        x2="50.1906447%"
        y2="0.0189831196%"
        id="linearGradient-merchant-2"
      >
        <stop stopColor="#808080" stopOpacity="0.25" offset="0%"></stop>
        <stop stopColor="#808080" stopOpacity="0.12" offset="54%"></stop>
        <stop stopColor="#808080" stopOpacity="0.1" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g
      id="website"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="09---Merchant" transform="translate(-124.000000, -279.000000)">
        <g id="merchant" transform="translate(75.000000, 128.000000)">
          <g transform="translate(49.000000, 151.000000)">
            <ellipse
              id="Oval"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
              cx="115.603413"
              cy="80.3286089"
              rx="105.987212"
              ry="30.2830034"
            ></ellipse>
            <path
              d="M193.619822,37.9984042 C193.619822,37.9984042 197.892222,42.2708047 195.481022,48.6112054 C193.069821,54.9516061 199.617022,65.4962073 199.617022,65.4962073 L199.416822,65.4632073 C190.641021,63.9232071 186.280621,53.878006 191.160221,46.4222052 C192.973021,43.6480048 194.462422,40.3964045 193.619822,37.9984042 Z"
              id="Path"
              fill="#FED448"
              fillRule="nonzero"
            ></path>
            <path
              d="M193.619822,37.9984042 C193.619822,37.9984042 196.039822,43.2366048 193.619822,47.5090053 C191.199821,51.7814058 193.206221,63.7736071 199.614822,65.4962073"
              id="Path"
              stroke="#535461"
              strokeWidth="0.550000012"
            ></path>
            <path
              d="M186.010021,55.2794061 C186.010021,55.2794061 190.885221,54.5028061 191.329621,58.8720065 C191.774021,63.241207 200.706022,63.8462071 200.706022,63.8462071 L200.538822,63.9584071 C193.164421,68.7984076 186.115621,67.0384074 187.178221,60.6144067 C187.576421,58.2252065 187.539021,55.8250062 186.010021,55.2794061 Z"
              id="Path"
              fill="#FED448"
              fillRule="nonzero"
            ></path>
            <path
              d="M186.010021,55.2794061 C186.010021,55.2794061 190.885221,54.5028061 191.329621,58.8720065 C191.774021,63.241207 200.706022,63.8462071 200.706022,63.8462071 L200.538822,63.9584071 C193.164421,68.7984076 186.115621,67.0384074 187.178221,60.6144067 C187.576421,58.2252065 187.539021,55.8250062 186.010021,55.2794061 Z"
              id="Path"
              fill="#F5F5F5"
              fillRule="nonzero"
              opacity="0.2"
            ></path>
            <path
              d="M186.010021,55.2794061 C186.010021,55.2794061 189.794021,56.1110062 189.483821,59.5518066 C189.173621,62.992607 195.104822,67.1176075 200.703822,63.8484071"
              id="Path"
              stroke="#535461"
              strokeWidth="0.550000012"
            ></path>
            <polygon
              id="Path"
              fill="#F5F5F5"
              fillRule="nonzero"
              points="176.74142 83.0346092 166.210018 82.2558091 27.7508031 82.2558091 27.7508031 61.9740069 176.74142 61.9740069"
            ></polygon>
            <path
              d="M26.3164029,10.0958011 L17.2216019,10.0958011 L17.2216019,4.74100053 C17.2216019,2.67545533 18.8960571,1.00100011 20.9616023,1.00100011 L22.5764025,1.00100011 C24.6419477,1.00100011 26.3164029,2.67545533 26.3164029,4.74100053 L26.3164029,10.0958011 Z"
              id="Path"
              fill="#EDEDF4"
              fillRule="nonzero"
            ></path>
            <path
              d="M182.33162,52.2236058 L182.33162,83.1666092 L172.176419,83.0346092 C172.176419,82.8146092 172.191819,82.5946092 172.191819,82.3878092 C172.191819,71.3310672 163.228559,62.3678069 152.171817,62.3678069 C141.115075,62.3678069 132.151815,71.3310672 132.151815,82.3878092 C132.151815,82.4318092 132.151815,82.4758092 132.151815,82.5176092 L122.016414,82.3856092 L69.4848077,82.3856092 C69.484159,81.6505701 69.44303,80.9161246 69.3616077,80.1856089 C69.3242077,79.8336089 69.2780077,79.4882088 69.2186077,79.1450088 C69.0771797,78.2625917 68.8757797,77.3908385 68.6158076,76.5358085 C68.5102076,76.1838085 68.3958076,75.8384084 68.2682076,75.4952084 C67.9399835,74.6018523 67.5488707,73.7328762 67.0978075,72.8948081 C66.9086074,72.5406081 66.7062074,72.195208 66.4950074,71.854208 C65.9272155,70.9373067 65.286405,70.0676879 64.5788072,69.2538077 C64.2664071,68.8944743 63.9430071,68.5476076 63.6086071,68.2132076 C55.7929198,60.4100686 43.1344912,60.4100686 35.3188039,68.2132076 C34.9829372,68.5490743 34.6595372,68.895941 34.3486038,69.2538077 C33.641006,70.0676879 33.0001955,70.9373067 32.4324036,71.854208 C32.2124036,72.195208 32.0188036,72.5406081 31.8296035,72.8948081 C31.3785403,73.7328762 30.9874275,74.6018523 30.6592034,75.4952084 C30.5338034,75.8384084 30.4172034,76.1838085 30.3116034,76.5358085 C30.0520192,77.387959 29.8506222,78.2567591 29.7088033,79.1362088 C29.6494033,79.4794088 29.6032033,79.8248089 29.5658033,80.1768089 C29.484381,80.9073246 29.443252,81.6417701 29.4426033,82.3768092 L9.42260105,82.3768092 L9.42260105,14.0008016 L150.616417,14.0008016 L164.623818,44.5434049 L182.03242,52.0938058 L182.33162,52.2236058 Z"
              id="Path"
              fill="#FED448"
              fillRule="nonzero"
            ></path>
            <path
              d="M12.5400014,7.49980006 L145.112016,7.49980006 C148.149583,7.49980006 150.612017,9.96223498 150.612017,12.9998001 L150.612017,14.0008016 L9.42040105,14.0008016 L9.42040105,10.6172012 C9.42040105,9.79003389 9.74914227,8.99677733 10.3342441,8.41208807 C10.919346,7.82739882 11.7128343,7.49921709 12.5400014,7.49980006 Z"
              id="Path"
              fill="#F5F5F5"
              fillRule="nonzero"
            ></path>
            <path
              d="M118.888013,7.49980083 L86.6448096,7.49980083 L86.6448096,6.2854007 C86.6448096,4.67617295 87.2840729,3.13285497 88.4219687,1.99495912 C89.5598646,0.85706326 91.1031825,0.217800024 92.7124103,0.217800024 L111.346412,0.217800024 L118.888013,7.49980083 Z"
              id="Path"
              fill="#EDEDF4"
              fillRule="nonzero"
            ></path>
            <rect
              id="Rectangle"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
              x="6.56040073"
              y="72.243608"
              width="18.200602"
              height="12.4806014"
              rx="2.42000027"
            ></rect>
            <polygon
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
              points="121.877814 82.2558091 106.796812 82.2558091 106.796812 13.8710015 136.437415 13.8710015 136.437415 61.1930068"
            ></polygon>
            <rect
              id="Rectangle"
              fill="#F5F5F5"
              fillRule="nonzero"
              x="6.3008007"
              y="72.7650081"
              width="18.200602"
              height="12.4806014"
              rx="2.42000027"
            ></rect>
            <rect
              id="Rectangle"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
              x="176.87122"
              y="71.724408"
              width="9.8802011"
              height="14.5618016"
              rx="3.04260034"
            ></rect>
            <rect
              id="Rectangle"
              fill="#F5F5F5"
              fillRule="nonzero"
              x="177.39042"
              y="71.984008"
              width="9.8802011"
              height="14.5618016"
              rx="3.04260034"
            ></rect>
            <rect
              id="Rectangle"
              fill="#1A2246"
              fillRule="nonzero"
              x="28.1402031"
              y="21.0210023"
              width="59.5430066"
              height="32.2410036"
            ></rect>
            <rect
              id="Rectangle"
              fill="#F5F5F5"
              fillRule="nonzero"
              x="56.3530063"
              y="23.7512026"
              width="31.4622035"
              height="27.8212031"
            ></rect>
            <polygon
              id="Path"
              fill="#FFFFFF"
              fillRule="nonzero"
              points="56.3530063 45.9822051 78.9734088 29.2116032 82.0952091 29.9926033 56.3530063 48.5826054"
            ></polygon>
            <polygon
              id="Path"
              fill="#FFFFFF"
              fillRule="nonzero"
              points="56.3530063 39.2216044 68.5740076 26.0920029 74.2940083 27.392203 56.3530063 44.2926049"
            ></polygon>
            <rect
              id="Rectangle"
              fill="#F5F5F5"
              fillRule="nonzero"
              x="111.086812"
              y="18.9420021"
              width="21.8416024"
              height="30.1620034"
              rx="3.52000039"
            ></rect>
            <rect
              id="Rectangle"
              fill="#1A2246"
              fillRule="nonzero"
              x="128.768214"
              y="51.7022057"
              width="2.86000032"
              height="6.24140069"
            ></rect>
            <path
              d="M141.768016,23.2298026 L141.768016,44.767805 C141.768016,45.4384996 142.311721,45.9822051 142.982416,45.9822051 L156.237417,45.9822051 C156.677115,45.9819654 157.082338,45.7440691 157.296842,45.3602437 C157.511346,44.9764184 157.501621,44.5066247 157.271417,44.1320049 L144.016416,22.5940025 C143.731631,22.1316398 143.174506,21.9145383 142.651967,22.0623014 C142.129427,22.2100646 141.768497,22.6867728 141.768016,23.2298026 L141.768016,23.2298026 Z"
              id="Path"
              fill="#F5F5F5"
              fillRule="nonzero"
            ></path>
            <polygon
              id="Path"
              fill="#FFFFFF"
              fillRule="nonzero"
              points="118.107013 18.9420021 111.086812 25.1812028 111.086812 28.4328032 121.096813 18.9420021"
            ></polygon>
            <polygon
              id="Path"
              fill="#FFFFFF"
              fillRule="nonzero"
              points="111.086812 32.1992036 111.086812 35.972204 127.727614 18.9420021 124.476014 18.9420021"
            ></polygon>
            <polygon
              id="Path"
              fill="#FFFFFF"
              fillRule="nonzero"
              points="146.168016 26.0920029 141.768016 32.1992036 141.768016 34.5422038 147.609016 28.4328032"
            ></polygon>
            <polygon
              id="Path"
              fill="#FFFFFF"
              fillRule="nonzero"
              points="149.611017 32.1992036 141.768016 38.8982043 141.768016 40.7836045 151.368817 34.5422038"
            ></polygon>
            <circle
              id="Oval"
              fill="#1A2246"
              fillRule="nonzero"
              cx="49.4626055"
              cy="82.3856092"
              r="14.0404016"
            ></circle>
            <circle
              id="Oval"
              fill="#FFFFFF"
              fillRule="nonzero"
              cx="49.4626055"
              cy="82.3856092"
              r="7.80120087"
            ></circle>
            <circle
              id="Oval"
              fill="#1A2246"
              fillRule="nonzero"
              cx="49.3328055"
              cy="82.2558091"
              r="2.08120023"
            ></circle>
            <circle
              id="Oval"
              fill="#1A2246"
              fillRule="nonzero"
              cx="152.169617"
              cy="82.3856092"
              r="14.0404016"
            ></circle>
            <circle
              id="Oval"
              fill="#FFFFFF"
              fillRule="nonzero"
              cx="152.169617"
              cy="82.3856092"
              r="7.80120087"
            ></circle>
            <circle
              id="Oval"
              fill="#1A2246"
              fillRule="nonzero"
              cx="152.299417"
              cy="82.2558091"
              r="2.08120023"
            ></circle>
            <rect
              id="Rectangle"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
              x="9.29060103"
              y="60.9334068"
              width="97.5062108"
              height="1.04060012"
            ></rect>
            <polyline
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
              points="180.51002 61.9740069 135.918215 61.9740069 136.437415 61.1930068 136.437415 60.9334068 180.51002 60.9334068"
            ></polyline>
            <polyline
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
              points="180.51002 57.5542064 136.437415 57.5542064 136.437415 56.5136063 180.51002 56.5136063"
            ></polyline>
            <polyline
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
              points="180.51002 53.1322059 136.437415 53.1322059 136.437415 52.0938058 180.21082 52.0938058"
            ></polyline>
            <path
              d="M40.3084045,64.5744072 C39.696094,64.8902188 39.1005619,65.2375514 38.5242043,65.6150073 L9.29060103,65.6150073 L9.29060103,64.5744072 L40.3084045,64.5744072 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M106.796812,64.5744072 L106.796812,65.6150073 L60.4032067,65.6150073 C59.8268491,65.2375514 59.231317,64.8902188 58.6190065,64.5744072 L106.796812,64.5744072 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M35.3188039,68.2154076 C34.9829372,68.5512743 34.6595372,68.898141 34.3486038,69.2560077 L9.29060103,69.2560077 L9.29060103,68.2154076 L35.3188039,68.2154076 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M106.796812,68.2154076 L106.796812,69.2560077 L64.5788072,69.2560077 C64.2664071,68.8966743 63.9430071,68.5498076 63.6086071,68.2154076 L106.796812,68.2154076 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M32.4324036,71.854208 C32.2124036,72.195208 32.0188036,72.5406081 31.8296035,72.8948081 L9.29060103,72.8948081 L9.29060103,71.854208 L32.4324036,71.854208 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M106.796812,71.854208 L106.796812,72.8948081 L67.0978075,72.8948081 C66.9086074,72.5406081 66.7062074,72.195208 66.4950074,71.854208 L106.796812,71.854208 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M30.6592034,75.4952084 C30.5338034,75.8384084 30.4172034,76.1838085 30.3116034,76.5358085 L24.8908028,76.5358085 L24.8908028,75.4952084 L30.6592034,75.4952084 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M106.796812,75.4952084 L106.796812,76.5358085 L68.6158076,76.5358085 C68.5102076,76.1838085 68.3958076,75.8384084 68.2682076,75.4952084 L106.796812,75.4952084 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M29.7066033,79.1362088 C29.6472033,79.4794088 29.6010033,79.8248089 29.5636033,80.1768089 L24.8908028,80.1768089 L24.8908028,79.1362088 L29.7066033,79.1362088 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M106.796812,79.1362088 L106.796812,80.1768089 L69.3616077,80.1768089 C69.3242077,79.8248089 69.2780077,79.4794088 69.2186077,79.1362088 L106.796812,79.1362088 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M85.2148095,48.8158054 L83.6550093,48.8158054 L83.6550093,45.075805 L84.3150094,43.7756049 C84.3396331,43.7264912 84.3898687,43.6954817 84.4448094,43.6954817 C84.4997501,43.6954817 84.5499856,43.7264912 84.5746094,43.7756049 L85.2346095,45.075805 L85.2148095,48.8158054 Z"
              id="Path"
              fill="#FE5858"
              fillRule="nonzero"
            ></path>
            <rect
              id="Rectangle"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
              x="83.6550093"
              y="45.080205"
              width="1.55980017"
              height="1"
            ></rect>
            <path
              d="M87.5556097,48.8158054 L85.9958096,48.8158054 L85.9958096,45.075805 L86.6558096,43.7756049 C86.6804334,43.7264912 86.7306689,43.6954817 86.7856096,43.6954817 C86.8405504,43.6954817 86.8907859,43.7264912 86.9154097,43.7756049 L87.5754097,45.075805 L87.5556097,48.8158054 Z"
              id="Path"
              fill="#F1C413"
              fillRule="nonzero"
            ></path>
            <rect
              id="Rectangle"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
              x="85.9958096"
              y="45.080205"
              width="1.55980017"
              height="1"
            ></rect>
            <path
              d="M48.1536053,43.8856049 C48.1452356,43.8517856 48.1342011,43.8186822 48.1206053,43.7866049 C48.2108054,42.8538048 48.4748054,39.7650044 48.0942053,39.0258043 C47.7972053,38.4494043 46.9942052,38.4538043 46.0460051,38.6518043 C46.0460051,38.5528043 46.0592051,38.4538043 46.0592051,38.3526043 L46.0592051,35.1956039 C46.0278529,33.2009524 44.3864861,31.6088168 42.3918047,31.6382035 L41.7978046,31.6382035 C39.8031232,31.6088168 38.1617565,33.2009524 38.1304042,35.1956039 L38.1304042,38.3526043 C38.1304042,38.4450043 38.1304042,38.5374043 38.1414042,38.6298043 C37.1140041,38.7002043 36.139404,39.3426044 36.366004,41.6504046 L36.366004,44.2750049 L36.5728041,44.2750049 C36.6436973,44.3229495 36.7171385,44.3670142 36.7928041,44.4070049 L37.2768041,48.8664054 L38.8564043,48.8664054 L38.8366043,49.0864055 L45.018605,49.0864055 C45.5246051,49.1238055 46.0284051,49.1502055 46.4222052,49.1480055 C46.6768099,49.1607233 46.9319834,49.1400135 47.1812052,49.0864055 C47.8588053,48.8664054 47.8588053,47.5464053 47.8588053,47.5464053 L48.0788053,44.2618049 C48.1599609,44.1544438 48.1875185,44.0158452 48.1536053,43.8856049 L48.1536053,43.8856049 Z M39.2348044,44.690805 L39.2568044,44.690805 L39.2568044,44.732605 L39.2348044,44.715005 L39.2348044,44.690805 Z M45.159405,45.240805 L45.271605,46.8996052 L45.159405,46.8996052 L45.159405,45.240805 Z M38.8564043,46.6796052 L39.2348044,44.748005 L39.2590044,44.748005 L39.2590044,44.748005 L39.0764043,46.7038052 L38.8564043,46.6796052 Z"
              id="Shape"
              fill="url(#linearGradient-merchant-1)"
              fillRule="nonzero"
            ></path>
            <rect
              id="Rectangle"
              fill="#965D7B"
              fillRule="nonzero"
              x="38.2888043"
              y="31.6932035"
              width="7.61200085"
              height="10.1662011"
              rx="3.22080036"
            ></rect>
            <path
              d="M40.3018045,39.0346043 C40.3018045,39.0346043 36.163604,37.0546041 36.5970041,41.6042046 L36.5970041,44.1958049 L39.4108044,44.1958049 L38.9708043,48.9588054 L45.031805,48.9588054 L45.031805,44.1958049 C45.031805,44.1958049 47.4122053,44.4158049 47.8456053,43.9758049 C47.8456053,43.9758049 48.2856054,39.8618044 47.8456053,38.9972043 C47.4056053,38.1326042 45.8854051,38.5924043 44.3696049,39.0236043 C42.8538048,39.4548044 40.3018045,39.0346043 40.3018045,39.0346043 Z"
              id="Path"
              fill="#FC6681"
              fillRule="nonzero"
            ></path>
            <path
              d="M36.9842041,44.1958049 L37.4616042,48.7454054 L42.2246047,48.7454054 C42.2246047,48.7454054 44.1738049,47.4474053 43.0914048,47.0140052 C42.0090047,46.5806052 41.3600046,46.7940052 41.3600046,46.7940052 L38.9796043,46.5740052 L39.4306044,44.1958049 L36.9842041,44.1958049 Z"
              id="Path"
              fill="#F7C4A7"
              fillRule="nonzero"
            ></path>
            <path
              d="M47.7488053,43.9758049 L47.5288053,47.4430053 C47.5288053,47.4430053 47.5288053,48.7410054 46.8688052,48.9588054 C46.2088051,49.1766055 42.7548047,48.7388054 42.7548047,48.7388054 C42.7548047,48.7388054 41.4568046,48.7388054 41.6724046,47.6564053 C41.8880047,46.5740052 42.9704048,46.3584051 43.4038048,46.3584051 C43.8372049,46.3584051 44.4862049,46.7984052 44.4862049,46.7984052 L45.146205,46.7984052 L44.976805,44.1958049 L47.7488053,43.9758049 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M47.8588053,43.9758049 L47.6388053,47.4430053 C47.6388053,47.4430053 47.6388053,48.7410054 46.9788052,48.9588054 C46.3188051,49.1766055 42.8648048,48.7388054 42.8648048,48.7388054 C42.8648048,48.7388054 41.5668046,48.7388054 41.7824046,47.6564053 C41.9980047,46.5740052 43.0804048,46.3584051 43.5138048,46.3584051 C43.9472049,46.3584051 44.596205,46.7984052 44.596205,46.7984052 L45.256205,46.7984052 L45.084605,44.1958049 L47.8588053,43.9758049 Z"
              id="Path"
              fill="#F7C4A7"
              fillRule="nonzero"
            ></path>
            <path
              d="M36.6564041,44.0902049 C36.6564041,44.0902049 37.5364042,44.970205 39.3624044,44.666605 C39.5582044,44.635805 36.9842041,43.7096049 36.6564041,44.0902049 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M44.814005,44.959205 C44.814005,44.959205 48.1844054,44.904205 47.9138053,43.8174049 C47.6432053,42.7306047 45.031805,43.3290048 45.031805,43.3290048 L44.814005,44.959205 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M36.6564041,44.0352049 C36.6564041,44.0352049 37.7432042,45.122005 39.9718044,44.4752049 C42.2004047,43.8284049 36.9842041,43.6546048 36.6564041,44.0352049 Z"
              id="Path"
              fill="#FC6681"
              fillRule="nonzero"
            ></path>
            <path
              d="M44.759005,44.906405 C44.759005,44.906405 48.1294053,44.851405 47.8588053,43.7646049 C47.5882053,42.6778047 44.976805,43.2762048 44.976805,43.2762048 L44.759005,44.906405 Z"
              id="Path"
              fill="#FC6681"
              fillRule="nonzero"
            ></path>
            <path
              d="M40.0598044,36.025004 C40.0598044,36.025004 40.7198045,38.4054043 40.2798045,39.0566043 C39.8398044,39.7078044 41.6438046,41.0520046 42.4248047,41.0366046 C42.8890048,41.0366046 44.5324049,39.8794044 44.3938049,39.0566043 C44.2816049,38.3812043 43.3114048,36.458404 43.5270048,35.593804 L40.0598044,36.025004 Z"
              id="Path"
              fill="#F7C4A7"
              fillRule="nonzero"
            ></path>
            <path
              d="M42.1168047,39.0060043 C42.8448874,39.0050529 43.5480896,38.7409614 44.0968049,38.2624043 C43.7866049,37.4132042 43.3664048,36.302204 43.5160048,35.701604 L40.0532044,36.141604 C40.0532044,36.141604 40.4382045,37.5518042 40.4184045,38.4978043 C40.9208488,38.8335114 41.5125458,39.0105606 42.1168047,39.0060043 L42.1168047,39.0060043 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <circle
              id="Oval"
              fill="#F7C4A7"
              fillRule="nonzero"
              cx="42.1168047"
              cy="35.866604"
              r="3.03160034"
            ></circle>
            <path
              d="M40.2710045,37.2020041 C40.1962045,36.9160041 40.0796045,36.6432041 40.0202044,36.355004 C39.8204783,35.2621942 40.4186096,34.1800365 41.4502046,33.7678038 C41.5979915,33.7053332 41.7593419,33.6818503 41.9188047,33.6996037 C42.5612047,33.8030038 42.6558047,34.7996039 43.2652048,35.0350039 C43.3862048,35.0812039 43.5182048,35.0900039 43.6414048,35.1318039 C43.9676896,35.2773239 44.2104081,35.5629227 44.3014049,35.908404 C44.4281203,36.2748654 44.4760983,36.6639374 44.4422049,37.0502041 C44.4092049,37.4176042 44.3036049,37.7762042 44.2750049,38.1502042 C44.2229749,38.5196087 44.3265418,38.8940427 44.5610049,39.1842044 C44.6910506,39.3087769 44.8394447,39.4126528 45.001005,39.4922044 C45.113205,39.5538044 45.254005,39.6154044 45.359605,39.5450044 C45.4070105,39.5077294 45.4422412,39.4571811 45.460805,39.3998044 C45.6192051,39.0104043 45.5422051,38.5726043 45.5048051,38.1546042 C45.4621814,37.5126411 45.4688008,36.8683559 45.5246051,36.227404 C45.5576051,35.708204 45.5906051,35.1692039 45.401405,34.6874039 C45.2606182,34.366545 45.0705963,34.0696357 44.838205,33.8074038 C44.6403956,33.545117 44.4105434,33.3086131 44.1540049,33.1034037 C43.6650802,32.7681555 43.0835078,32.5942992 42.4908047,32.6062036 C41.9023985,32.6175864 41.316858,32.691332 40.7440045,32.8262036 C40.3238045,32.9120037 39.8640044,33.0198037 39.6110044,33.3608037 C39.4879385,33.5482518 39.4013565,33.7572428 39.3558044,33.9768038 L39.1820044,34.6104038 C38.9677243,35.2809321 38.8383817,35.9756865 38.7970043,36.6784041 C38.7970043,37.1910041 38.8762043,38.2998043 39.4570044,38.5220043 C40.2116045,38.8146043 40.3964045,37.6948042 40.2710045,37.2020041 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M40.2710045,37.0942041 C40.1962045,36.8082041 40.0796045,36.5354041 40.0202044,36.247204 C39.8204783,35.1543941 40.4186096,34.0722365 41.4502046,33.6600037 C41.5979915,33.5975332 41.7593419,33.5740503 41.9188047,33.5918037 C42.5612047,33.6952037 42.6558047,34.6918039 43.2652048,34.9272039 C43.3862048,34.9734039 43.5182048,34.9822039 43.6414048,35.0240039 C43.9676896,35.1695239 44.2104081,35.4551226 44.3014049,35.800604 C44.4281203,36.1670654 44.4760983,36.5561373 44.4422049,36.9424041 C44.4092049,37.3098041 44.3036049,37.6684042 44.2750049,38.0424042 C44.2229749,38.4118087 44.3265418,38.7862427 44.5610049,39.0764043 C44.6910506,39.2009769 44.8394447,39.3048528 45.001005,39.3844044 C45.113205,39.4460044 45.254005,39.5076044 45.359605,39.4372044 C45.4070105,39.3999294 45.4422412,39.349381 45.460805,39.2920044 C45.6192051,38.9026043 45.5422051,38.4648043 45.5048051,38.0468042 C45.4621814,37.4048411 45.4688008,36.7605559 45.5246051,36.119604 C45.5576051,35.600404 45.5906051,35.0614039 45.401405,34.5796038 C45.2606182,34.258745 45.0705963,33.9618357 44.838205,33.6996037 C44.6403956,33.437317 44.4105434,33.200813 44.1540049,32.9956037 C43.6650802,32.6603555 43.0835078,32.4864992 42.4908047,32.4984036 C41.9023985,32.5097864 41.316858,32.583532 40.7440045,32.7184036 C40.3238045,32.8042036 39.8640044,32.9120037 39.6110044,33.2530037 C39.4879385,33.4404518 39.4013565,33.6494428 39.3558044,33.8690038 L39.1820044,34.5026038 C38.9677243,35.173132 38.8383817,35.8678865 38.7970043,36.5706041 C38.7970043,37.0832041 38.8762043,38.1920042 39.4570044,38.4142043 C40.2116045,38.6958043 40.3964045,37.5958042 40.2710045,37.0942041 Z"
              id="Path"
              fill="#965D7B"
              fillRule="nonzero"
            ></path>
            <path
              d="M28.0126031,31.2928035 C28.0126031,31.2928035 30.6130034,36.7532041 37.5034042,31.2928035"
              id="Path"
              fill="#FED448"
              fillRule="nonzero"
            ></path>
            <path
              d="M37.3736042,31.2928035 C37.3736042,31.2928035 39.9740044,36.7532041 46.8644052,31.2928035"
              id="Path"
              fill="#FED448"
              fillRule="nonzero"
            ></path>
            <path
              d="M46.7324052,31.2928035 C46.7324052,31.2928035 49.3328055,36.7532041 56.2232062,31.2928035"
              id="Path"
              fill="#FED448"
              fillRule="nonzero"
            ></path>
            <path
              d="M56.0934062,31.2928035 C56.0934062,31.2928035 58.6938065,36.7532041 65.5842073,31.2928035"
              id="Path"
              fill="#FED448"
              fillRule="nonzero"
            ></path>
            <path
              d="M65.4544073,31.2928035 C65.4544073,31.2928035 68.0548076,36.7532041 74.9452083,31.2928035"
              id="Path"
              fill="#FED448"
              fillRule="nonzero"
            ></path>
            <path
              d="M74.8154083,31.2928035 C74.8154083,31.2928035 77.4158086,36.7532041 84.3062094,31.2928035"
              id="Path"
              fill="#FED448"
              fillRule="nonzero"
            ></path>
            <path
              d="M84.1764094,31.2928035 C84.1764094,31.2928035 86.7768096,36.7532041 93.6672104,31.2928035"
              id="Path"
              fill="#FED448"
              fillRule="nonzero"
            ></path>
            <path
              d="M93.5352104,31.2928035 C93.5352104,31.2928035 96.1356107,35.1934039 97.9550109,31.5524035"
              id="Path"
              fill="#FED448"
              fillRule="nonzero"
            ></path>
            <path
              d="M28.0126031,31.2928035 C28.0126031,31.2928035 30.6130034,36.7532041 37.5034042,31.2928035"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M37.3736042,31.2928035 C37.3736042,31.2928035 39.9740044,36.7532041 46.8644052,31.2928035"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M46.7324052,31.2928035 C46.7324052,31.2928035 49.3328055,36.7532041 56.2232062,31.2928035"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M56.0934062,31.2928035 C56.0934062,31.2928035 58.6938065,36.7532041 65.5842073,31.2928035"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M65.4544073,31.2928035 C65.4544073,31.2928035 68.0548076,36.7532041 74.9452083,31.2928035"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M74.8154083,31.2928035 C74.8154083,31.2928035 77.4158086,36.7532041 84.3062094,31.2928035"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M84.1764094,31.2928035 C84.1764094,31.2928035 86.7768096,36.7532041 93.6672104,31.2928035"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M93.5352104,31.2928035 C93.5352104,31.2928035 96.1356107,35.1934039 97.9550109,31.5524035"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <polygon
              id="Path"
              fill="#FED448"
              fillRule="nonzero"
              points="97.8252109 31.4226035 18.7814021 31.4226035 24.5014027 18.9420021 91.8456102 18.9420021"
            ></polygon>
            <polygon
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
              points="97.8252109 31.4226035 18.7814021 31.4226035 24.5014027 18.9420021 91.8456102 18.9420021"
            ></polygon>
            <path
              d="M18.6516021,31.2928035 C18.6516021,31.2928035 21.2520024,36.7532041 28.1424031,31.2928035"
              id="Path"
              fill="#FED448"
              fillRule="nonzero"
            ></path>
            <path
              d="M18.6516021,31.2928035 C18.6516021,31.2928035 21.2520024,36.7532041 28.1424031,31.2928035"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <rect
              id="Rectangle"
              fill="#EDEDF4"
              fillRule="nonzero"
              x="26.3208029"
              y="53.2642059"
              width="63.9650071"
              height="4.67940052"
            ></rect>
            <rect
              id="Rectangle"
              fill="#EDEDF4"
              fillRule="nonzero"
              x="21.6414024"
              y="48.5826054"
              width="73.0642081"
              height="6.24140069"
            ></rect>
            <rect
              id="Rectangle"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
              x="26.3208029"
              y="54.8240061"
              width="63.9650071"
              height="1"
            ></rect>
            <path
              d="M204.646223,64.6778072 C204.646223,64.6778072 201.579422,64.0640071 200.763222,63.247807 C199.947022,62.4316069 196.266422,60.9994068 195.857222,62.0224069 C195.448022,63.045407 190.337421,66.5192074 193.813422,67.1330075 C197.289422,67.7468075 201.990822,67.9514075 203.011623,67.5422075 C204.032423,67.1330075 204.646223,64.6778072 204.646223,64.6778072 Z"
              id="Path"
              fill="#A8A8A8"
              fillRule="nonzero"
            ></path>
            <path
              d="M193.811222,66.7524074 C197.287222,67.3662075 201.988622,67.5708075 203.009423,67.1616075 C203.788223,66.8492074 204.329423,65.3554073 204.549423,64.6580072 L204.650623,64.6800072 C204.650623,64.6800072 204.036823,67.1330075 203.016023,67.5400075 C201.995222,67.9470075 197.296022,67.7446075 193.817822,67.1308075 C192.814621,66.9548074 192.528621,66.5390074 192.636421,66.0110073 C192.715621,66.3564074 193.065421,66.6204074 193.811222,66.7524074 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.2"
            ></path>
            <path
              d="M213.151424,82.0534091 C213.151424,82.0534091 216.057624,72.182008 212.605824,64.9176072 C211.138372,61.8794851 210.696035,58.4473205 211.345223,55.1364061 C211.665284,53.5668855 212.128487,52.0299935 212.729024,50.5450056"
              id="Path"
              stroke="#535461"
              strokeWidth="0.550000012"
            ></path>
            <path
              d="M210.581823,45.9558051 C210.581823,47.1658052 212.781824,50.6726056 212.781824,50.6726056 C212.781824,50.6726056 214.981824,47.1636052 214.981824,45.9558051 C214.874339,44.8266413 213.925992,43.9642803 212.791724,43.9642803 C211.657456,43.9642803 210.709108,44.8266413 210.601623,45.9558051 L210.581823,45.9558051 Z"
              id="Path"
              fill="#FED448"
              fillRule="nonzero"
            ></path>
            <path
              d="M206.960623,52.6548058 C207.620623,53.671206 211.360623,55.4246062 211.360623,55.4246062 C211.360623,55.4246062 211.292423,51.2886057 210.634623,50.2744056 C210.24753,49.5352917 209.475641,49.0787532 208.641466,49.0955393 C207.80729,49.1123253 207.054393,49.599547 206.697347,50.3536352 C206.340301,51.1077234 206.440556,51.9988957 206.956223,52.6548058 L206.960623,52.6548058 Z"
              id="Path"
              fill="#FED448"
              fillRule="nonzero"
            ></path>
            <path
              d="M207.119023,64.1058071 C208.199223,64.6514072 212.317624,64.2752071 212.317624,64.2752071 C212.317624,64.2752071 210.170423,60.7398067 209.090223,60.1942067 C208.383597,59.7576432 207.491337,59.7562693 206.78337,60.1906547 C206.075403,60.6250401 205.672437,61.4211234 205.741539,62.2488508 C205.810641,63.0765781 206.34003,63.7948245 207.110223,64.1058071 L207.119023,64.1058071 Z"
              id="Path"
              fill="#FED448"
              fillRule="nonzero"
            ></path>
            <path
              d="M209.189223,72.7430081 C210.161623,73.4624082 214.284424,73.7880082 214.284424,73.7880082 C214.284424,73.7880082 212.766424,69.9402078 211.794024,69.2208077 C210.822822,68.6396147 209.56912,68.8901418 208.895865,69.7999465 C208.222609,70.7097511 208.349512,71.9819258 209.189223,72.7408081 L209.189223,72.7430081 Z"
              id="Path"
              fill="#FED448"
              fillRule="nonzero"
            ></path>
            <path
              d="M215.956424,55.6600062 C215.089624,56.5026063 211.046023,57.3760064 211.046023,57.3760064 C211.046023,57.3760064 212.036024,53.3610059 212.902824,52.5184058 C213.444988,51.8836734 214.299683,51.6104628 215.109496,51.813024 C215.919309,52.0155852 216.54472,52.65902 216.724198,53.4742594 C216.903676,54.2894988 216.6063,55.1360889 215.956424,55.6600062 Z"
              id="Path"
              fill="#FED448"
              fillRule="nonzero"
            ></path>
            <path
              d="M218.255424,65.7910073 C217.175224,66.3366074 213.056824,65.9604073 213.056824,65.9604073 C213.056824,65.9604073 215.204024,62.4250069 216.284224,61.8794069 C217.343873,61.4515499 218.55467,61.9062315 219.070772,62.9258186 C219.586873,63.9454056 219.236416,65.1903732 218.264224,65.7910073 L218.255424,65.7910073 Z"
              id="Path"
              fill="#FED448"
              fillRule="nonzero"
            ></path>
            <path
              d="M219.133224,75.9440084 C218.160824,76.6634085 214.038024,76.9890086 214.038024,76.9890086 C214.038024,76.9890086 215.556024,73.1412081 216.528424,72.421808 C217.499625,71.840615 218.753327,72.0911422 219.426583,73.0009468 C220.099838,73.9107515 219.972936,75.1829261 219.133224,75.9418084 L219.133224,75.9440084 Z"
              id="Path"
              fill="#FED448"
              fillRule="nonzero"
            ></path>
            <path
              d="M219.476424,81.094209 C219.476424,81.094209 214.163424,80.0316089 212.746624,78.6148087 C211.329823,77.1980086 204.954223,74.7186083 204.245823,76.4896085 C203.537423,78.2606087 194.682422,84.2820094 200.703822,85.3446095 C206.725223,86.4072096 214.871824,86.7614096 216.640624,86.0530096 C218.409424,85.3446095 219.476424,81.094209 219.476424,81.094209 Z"
              id="Path"
              fill="#A8A8A8"
              fillRule="nonzero"
            ></path>
            <path
              d="M200.703822,84.6758094 C206.725223,85.7384095 214.871824,86.0926096 216.640624,85.3842095 C217.989224,84.8452094 218.926424,82.2536091 219.296024,81.045809 L219.474224,81.083209 C219.474224,81.083209 218.411624,85.3336095 216.640624,86.0420096 C214.869624,86.7504096 206.723023,86.3962096 200.703822,85.3336095 C198.965822,85.0278094 198.468622,84.3062094 198.655622,83.3954093 C198.796422,84.0004093 199.410222,84.4558094 200.703822,84.6758094 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.2"
            ></path>
            <path
              d="M0.169400019,63.208207 C0.169400019,63.208207 0.0484000054,64.3962072 0.772200086,64.9924072 C0.772200086,64.9924072 3.01400033,67.9448075 4.12940046,69.6124077 C4.06560045,70.0656078 4.02160045,70.3406078 4.02160045,70.3406078 L4.02160045,70.3406078 L4.02160045,70.4022078 L4.05020045,70.4022078 L4.02160045,70.5870078 L4.05240045,70.5870078 C3.41660038,72.8640081 3.17240035,76.1838085 3.17240035,76.1838085 L3.17240035,76.3114085 C3.17240035,76.3818085 3.17240035,76.4214085 3.17240035,76.4214085 C3.17240035,76.4214085 3.43200038,80.2186089 3.44080038,83.1622092 C3.44080038,84.5944094 3.36820037,85.7868095 3.17240035,86.1718096 C2.92380032,86.6602096 2.84020032,89.0582099 2.84240032,91.7796102 C2.84240032,95.7264106 3.02720034,100.463011 3.17240035,101.035011 C3.20278402,101.14091 3.26223086,101.236177 3.34400037,101.310011 C3.12400035,102.190011 2.7038003,103.424211 2.08780023,103.650812 C1.65377978,103.811001 1.35352765,104.21019 1.32000015,104.671612 C1.32000015,104.671612 1.32000015,104.671612 1.32000015,104.684812 C1.32000015,104.698012 1.32000015,104.733212 1.32000015,104.759612 L1.32000015,104.777212 C1.32000015,104.799212 1.32000015,104.821212 1.32000015,104.843212 L1.32000015,104.865212 C1.32000015,104.887212 1.32000015,104.907012 1.33540015,104.929012 L1.33540015,104.951012 C1.33540015,104.970812 1.34860015,104.992812 1.35740015,105.012612 L1.35740015,105.032412 C1.35740015,105.054412 1.37720015,105.074212 1.38820015,105.094012 L1.38820015,105.109412 C1.41892701,105.161366 1.45586548,105.209386 1.49820017,105.252412 L1.49820017,105.252412 L1.55760017,105.305212 L1.58180018,105.322812 L1.63680018,105.360212 L1.66980019,105.380012 L1.72700019,105.410812 L1.7666002,105.428412 L1.8282002,105.452612 L1.87220021,105.468012 L1.94040022,105.487812 L1.98880022,105.501012 L2.06580023,105.516412 L2.11640024,105.516412 L2.20880025,105.516412 L2.25500025,105.516412 L2.40460027,105.516412 C3.97100044,105.516412 4.81360053,105.160012 5.29540059,104.447212 L6.2590007,104.209612 L6.2590007,104.183212 L6.2590007,104.183212 L6.2590007,104.154612 L6.2590007,104.134812 L6.2590007,104.115012 L6.2590007,104.086412 L6.2590007,104.049012 L6.2590007,104.002812 L6.2590007,103.983012 L6.2590007,103.936812 L6.2590007,103.936812 L6.2810007,103.822412 L6.2810007,103.815812 L6.2920007,103.752012 L6.2920007,103.752012 C6.3030007,103.683812 6.3162007,103.611212 6.3294007,103.532012 L6.3294007,103.518811 C6.3426007,103.439611 6.35360071,103.356011 6.36680071,103.268011 L6.36680071,103.268011 C6.38000071,103.180011 6.39100071,103.089811 6.40200071,102.995211 L6.40200071,102.984211 C6.40200071,102.891811 6.42180071,102.797211 6.43060071,102.700411 L6.43060071,102.685011 L6.43060071,102.590411 L6.43060071,102.579411 C6.43060071,102.517811 6.43500071,102.456211 6.44380072,102.394611 L6.44380072,102.381411 C6.44380072,102.352078 6.44380072,102.322745 6.44380072,102.293411 L6.44380072,102.264811 C6.44380072,102.207611 6.44380072,102.150411 6.44380072,102.093211 L6.53840073,102.093211 L7.38100082,88.7766099 L10.3906012,76.8966085 L11.8338013,86.8692096 C11.8338013,87.1970097 11.8338013,87.8614098 11.8338013,88.7062099 C11.8338013,91.5464102 11.8888013,96.7802108 12.3244014,97.4688108 C12.5114014,97.7658109 12.5840014,98.3290109 12.5906014,98.964811 C12.5643668,99.9375259 12.475449,100.907538 12.3244014,101.868811 L12.3596014,101.868811 C12.3376014,102.020611 12.3244014,102.108611 12.3244014,102.108611 L12.4344014,102.108611 C12.3552014,102.887411 12.3332014,103.732212 12.3266014,104.134812 L12.3266014,104.134812 L12.3266014,104.189812 C12.3266014,104.304212 12.3266014,104.372412 12.3266014,104.372412 C12.3266014,104.372412 14.3748016,104.610012 14.7356016,104.610012 C16.7552019,104.610012 19.3116021,105.560412 20.1542022,104.966412 L20.2268022,104.909212 L20.2422022,104.896012 L20.2862023,104.854212 L20.2972023,104.841012 L20.3302023,104.799212 L20.3302023,104.788212 C20.3393603,104.774172 20.3474498,104.759464 20.3544023,104.744212 L20.3544023,104.744212 C20.3601974,104.729245 20.3646157,104.713781 20.3676023,104.698012 L20.3676023,104.698012 C20.3692498,104.68192 20.3692498,104.665703 20.3676023,104.649612 L20.3676023,104.649612 C20.3693081,104.632788 20.3693081,104.615835 20.3676023,104.599012 L20.3676023,104.599012 C20.2510022,104.178812 19.0586021,103.811412 18.222602,103.444011 C17.5010019,103.127211 16.8872019,101.915011 16.5572018,101.140611 C16.6707751,101.010448 16.715694,100.83404 16.6782019,100.665411 C16.7013762,100.561508 16.6945088,100.453157 16.6584019,100.353011 C16.2184018,99.033011 16.0776018,87.9010098 16.0578018,86.1872096 L17.1402019,78.4740087 C17.2473101,78.0135557 17.2887871,77.5402729 17.2634019,77.0682086 C17.2788019,75.3082084 16.9224019,72.292008 16.7024019,70.6310078 L17.0192019,70.6310078 L16.9796019,70.3934078 L17.0192019,70.3934078 L16.5374018,67.5334075 L16.5374018,63.8044071 L17.1402019,57.2638064 L17.861802,57.7390064 C17.916802,57.7390064 18.020202,57.6598064 18.154402,57.5190064 C19.6944022,58.1944065 21.6744024,59.0590066 22.7986025,59.5122066 C24.8468028,60.3438067 24.9656028,59.5122066 24.9656028,59.5122066 L28.9388032,51.7836058 C28.9388032,51.7836058 35.923804,48.9236054 33.6358037,47.7400053 C31.3478035,46.5564052 28.0962031,48.9280054 27.6144031,50.1182056 C27.132603,51.3084057 24.3628027,55.1122061 23.7600026,55.8250062 C23.1572026,56.5378063 22.7964025,56.0626062 22.1936025,55.4686062 C21.6829176,55.0203958 21.1458928,54.603118 20.5854023,54.219006 L20.6294023,54.159606 C20.3853195,54.0495854 20.1688605,53.8864896 19.9958022,53.682206 C19.0410021,52.6064058 16.9862019,50.4438056 15.8158018,50.3558056 C14.3572016,50.2458056 12.4828014,48.7960054 12.2320014,48.5958054 C12.2038601,48.2456185 12.2082791,47.8935755 12.2452014,47.5442053 L12.2562014,47.5442053 C12.2562014,47.5046053 12.2562014,47.4628053 12.2694014,47.4232053 C13.978014,47.0670975 15.2050716,45.5649149 15.2130017,43.8196049 C15.2130017,43.7272049 15.2130017,43.6348048 15.2020017,43.5424048 C15.2234831,43.5491604 15.2465203,43.5491604 15.2680017,43.5424048 C15.4220017,43.4984048 15.5056017,42.0376047 15.5056017,41.8374046 C15.5140283,41.7013914 15.5444917,41.5676499 15.5958017,41.4414046 C15.6464017,41.3314046 15.7300017,41.2368046 15.7784018,41.1246046 C15.816979,41.0275828 15.8313265,40.9226201 15.8202018,40.8188045 C15.8181506,40.583147 15.7592859,40.3514614 15.6486017,40.1434045 C15.3118862,39.3029782 14.8792902,38.5042258 14.3594016,37.7630042 C14.2860282,37.6508872 14.1853367,37.5592806 14.0668016,37.4968042 C13.9311932,37.4536504 13.7883464,37.4379447 13.6466015,37.4506042 C12.9866014,37.4506042 12.3706014,37.1338041 11.7436013,36.9248041 C11.1166012,36.7158041 10.3752012,36.6190041 9.83400109,36.9930041 C9.29280103,37.3670042 9.08820101,38.1084042 8.51400095,38.4054043 C8.35560093,38.4846043 8.17960091,38.5264043 8.02340089,38.6122043 C7.8579313,38.7613827 7.72014345,38.9386449 7.61640085,39.1358043 C7.28121389,39.5064259 7.01920273,39.9371394 6.84420076,40.4052045 C6.75978709,40.7273351 6.72419074,41.0603093 6.73860075,41.3930046 C6.73860075,41.5030046 6.73860075,41.6130046 6.73860075,41.7252046 C6.73860075,42.3852047 6.80900076,43.1420048 7.34800082,43.5314048 C7.47058004,43.6197202 7.57637859,43.729244 7.66040085,43.8548049 C7.75914463,44.0153594 7.80955398,44.2009574 7.80560087,44.3894049 C7.83200087,44.756805 7.97720089,45.124205 8.00360089,45.4894051 C8.00059664,45.6294347 8.03720158,45.7674659 8.1092009,45.8876051 C8.14849524,45.9457732 8.20933775,45.9858968 8.27828013,45.9991073 C8.34722251,46.0123179 8.4185875,45.9975274 8.47660094,45.9580051 L8.49860094,45.8656051 C8.53820095,45.9228051 8.57780095,45.9800051 8.61960096,46.0350051 C8.48100094,46.8226052 8.26320092,47.6740053 7.91560088,48.2350054 L7.83640087,48.2350054 C7.26322746,48.2394666 6.70569988,48.4224895 6.24140069,48.7586054 C4.88840054,49.7200055 2.10320023,50.4944056 2.10320023,50.4944056 C1.89547931,50.6935862 1.7613275,50.9572372 1.72260019,51.2424057 C1.20630808,52.4223976 0.791214907,53.6441258 0.481800054,54.8944061 L0.481800054,54.8944061 C0.250800028,55.7876062 0.105600012,56.5356063 0.127600014,56.8062063 L0.127600014,56.8546063 L0.145200016,56.8546063 L0.145200016,56.8546063 L0.125400014,56.9602063 L0.552200061,57.0636063 C0.220000024,58.8434065 -0.255200028,62.0334069 0.169400019,63.208207 Z M2.80940031,62.614207 C3.12370994,61.8279198 3.39760103,61.0260724 3.6300004,60.2118067 C3.89620043,61.0170068 4.15580046,61.6528068 4.37580049,61.9014069 C4.59580051,62.1500069 4.66840052,62.781407 4.67500052,63.6350071 C4.68160052,64.4886072 4.59580051,65.5028073 4.4990005,66.4818074 C3.83415061,65.2406245 3.27200714,63.9471059 2.81820031,62.614207 L2.80940031,62.614207 Z"
              id="Shape"
              fill="url(#linearGradient-merchant-2)"
              fillRule="nonzero"
            ></path>
            <path
              d="M16.4450018,99.9724111 C16.4450018,99.9724111 17.2656019,102.434211 18.319402,102.902811 C19.3732022,103.371411 21.0144023,103.840012 20.1938022,104.425212 C19.3732022,105.010412 16.8938019,104.073212 14.9138017,104.073212 C14.5618016,104.073212 12.5708014,103.837812 12.5708014,103.837812 C12.5708014,103.837812 12.5708014,100.674211 13.0394014,100.097811 C13.5080015,99.5214111 16.4450018,99.9724111 16.4450018,99.9724111 Z"
              id="Path"
              fill="#59495D"
              fillRule="nonzero"
            ></path>
            <path
              d="M3.90720043,99.9724111 C3.90720043,99.9724111 3.43860038,102.784011 2.50140028,103.136011 C1.56420017,103.488011 1.32880015,105.010412 2.85340032,105.010412 C4.37800049,105.010412 5.19640058,104.658412 5.66500063,103.956612 L6.60220073,103.721212 C6.60220073,103.721212 7.1874008,101.026211 6.60220073,100.322211 L3.90720043,99.9724111 Z"
              id="Path"
              fill="#59495D"
              fillRule="nonzero"
            ></path>
            <path
              d="M16.4450018,99.9724111 C16.4450018,99.9724111 17.2656019,102.434211 18.319402,102.902811 C19.3732022,103.371411 21.0144023,103.840012 20.1938022,104.425212 C19.3732022,105.010412 16.8938019,104.073212 14.9138017,104.073212 C14.5618016,104.073212 12.5708014,103.837812 12.5708014,103.837812 C12.5708014,103.837812 12.5708014,100.674211 13.0394014,100.097811 C13.5080015,99.5214111 16.4450018,99.9724111 16.4450018,99.9724111 Z"
              id="Path"
              fill="#59495D"
              fillRule="nonzero"
            ></path>
            <path
              d="M3.90720043,99.9724111 C3.90720043,99.9724111 3.43860038,102.784011 2.50140028,103.136011 C1.56420017,103.488011 1.32880015,105.010412 2.85340032,105.010412 C4.37800049,105.010412 5.19640058,104.658412 5.66500063,103.956612 L6.60220073,103.721212 C6.60220073,103.721212 7.1874008,101.026211 6.60220073,100.322211 L3.90720043,99.9724111 Z"
              id="Path"
              fill="#59495D"
              fillRule="nonzero"
            ></path>
            <path
              d="M19.3754022,53.567806 C19.3754022,53.567806 21.6018024,55.0902061 22.1870025,55.6776062 C22.7722025,56.2650062 23.1242026,56.7314063 23.7094026,56.0296062 C24.2946027,55.3278061 26.989603,51.5768057 27.449403,50.4042056 C27.9092031,49.2316055 31.0816035,46.8842052 33.3080037,48.0612053 C35.5344039,49.2382055 28.7386032,52.0454058 28.7386032,52.0454058 L24.8820028,59.6618066 C24.8820028,59.6618066 24.7654028,60.4824067 22.7722025,59.6618066 C20.7790023,58.8412065 16.0930018,56.7358063 16.0930018,56.7358063 L19.3754022,53.567806 Z"
              id="Path"
              fill="#F0B9BB"
              fillRule="nonzero"
            ></path>
            <path
              d="M16.6804019,69.6234077 C16.6804019,69.6234077 17.734202,76.8834085 17.2656019,78.2958087 L16.2118018,85.9122095 C16.2118018,85.9122095 16.3284018,98.685411 16.7970019,100.091211 C17.2656019,101.497011 12.5774014,101.615811 12.5774014,101.615811 C12.5774014,101.615811 13.1626015,97.9836109 12.5774014,97.0464108 C11.9922013,96.1092107 12.1088013,86.6162096 12.1088013,86.6162096 L10.6964012,76.7712085 L7.76600086,88.4884098 L6.95640077,101.615811 C6.95640077,101.615811 3.79280042,101.499211 3.5574004,100.562011 C3.32200037,99.6248111 2.97220033,87.3202097 3.5574004,86.1476096 C4.14260046,84.9750094 3.5574004,76.3048085 3.5574004,76.3048085 C3.5574004,76.3048085 4.02600045,69.6256077 5.4318006,68.8050076 C6.83760076,67.9844076 16.6804019,69.6234077 16.6804019,69.6234077 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M16.6804019,69.3880077 C16.6804019,69.3880077 17.734202,76.6480085 17.2656019,78.0604087 L16.2118018,85.6768095 C16.2118018,85.6768095 16.3284018,98.4500109 16.7970019,99.8558111 C17.2656019,101.261611 12.5774014,101.378211 12.5774014,101.378211 C12.5774014,101.378211 13.1626015,97.7460109 12.5774014,96.8088108 C11.9922013,95.8716106 12.1088013,86.3786096 12.1088013,86.3786096 L10.6964012,76.5358085 L7.76600086,88.2530098 L6.95640077,101.378211 C6.95640077,101.378211 3.79280042,101.261611 3.5574004,100.324411 C3.32200037,99.387211 2.97220033,87.0826097 3.5574004,85.9100095 C4.14260046,84.7374094 3.5574004,76.0672084 3.5574004,76.0672084 C3.5574004,76.0672084 4.02600045,69.3880077 5.4318006,68.5674076 C6.83760076,67.7468075 16.6804019,69.3880077 16.6804019,69.3880077 Z"
              id="Path"
              fill="#524D64"
              fillRule="nonzero"
            ></path>
            <path
              d="M9.06180101,44.4290049 C9.06180101,44.4290049 8.82640098,50.0544056 6.83540076,48.9984054 L8.59540095,54.278406 L12.5796014,54.043006 L14.9226017,50.8794057 L13.1626015,49.8256055 C13.1626015,49.8256055 11.8734013,50.2942056 12.8106014,45.9580051 L9.06180101,44.4290049 Z"
              id="Path"
              fill="#F0B9BB"
              fillRule="nonzero"
            ></path>
            <path
              d="M12.4564014,49.1150055 C12.4564014,49.1150055 14.4474016,50.7562056 15.9764018,50.8750057 C17.1182019,50.9630057 19.1180021,53.0948059 20.0464022,54.155206 C20.2141872,54.3559772 20.4246259,54.5168125 20.6624023,54.6260061 C20.6624023,54.6260061 18.319402,57.9062064 17.967402,57.9062064 L17.2634019,57.4376064 L16.6782019,63.8836071 L16.6782019,67.7512075 L17.1468019,70.5628078 C17.1468019,70.5628078 9.76360108,70.6794079 9.06180101,70.0942078 C8.36000093,69.5090077 4.37360049,70.5628078 4.37360049,70.5628078 C4.37360049,70.5628078 5.54620062,62.946407 4.72560052,62.0092069 C3.90500043,61.0720068 2.49920028,54.5094061 2.49920028,54.5094061 C2.49920028,54.5094061 1.56200017,51.8144058 2.49920028,50.9894057 C2.49920028,50.9894057 5.20740058,50.2282056 6.52520072,49.2800055 C6.97510201,48.9491134 7.51774463,48.7682325 8.0762009,48.7630054 L8.16200091,48.7630054 C8.16200091,48.7630054 8.24120092,50.5230056 9.99900111,50.8728057 C11.7568013,51.2226057 12.8700014,50.5758056 12.4564014,49.1150055 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M12.4564014,48.8818054 C12.4564014,48.8818054 14.4474016,50.5230056 15.9764018,50.6418056 C17.1182019,50.7298056 19.1180021,52.8616059 20.0464022,53.922006 C20.2141872,54.1227771 20.4246259,54.2836125 20.6624023,54.392806 C20.6624023,54.392806 18.319402,57.6730064 17.967402,57.6730064 L17.2634019,57.2044064 L16.6782019,63.6504071 L16.6782019,67.5158075 L17.1468019,70.3274078 C17.1468019,70.3274078 9.76360108,70.4440078 9.06180101,69.8588078 C8.36000093,69.2736077 4.37360049,70.3274078 4.37360049,70.3274078 C4.37360049,70.3274078 5.54620062,62.711007 4.72560052,61.7738069 C3.90500043,60.8366068 2.49920028,54.274006 2.49920028,54.274006 C2.49920028,54.274006 1.56200017,51.5790057 2.49920028,50.7540056 C2.49920028,50.7540056 5.20740058,49.9928056 6.52520072,49.0446054 C6.97510201,48.7137134 7.51774463,48.5328325 8.0762009,48.5276054 L8.16200091,48.5276054 C8.16200091,48.5276054 8.24120092,50.2876056 9.99900111,50.6374056 C11.7568013,50.9872057 12.8700014,50.3558056 12.4564014,48.8818054 Z"
              id="Path"
              fill="#E2E8F0"
              fillRule="nonzero"
            ></path>
            <path
              d="M4.4924005,57.5520064 C4.4924005,57.5520064 0.972400108,57.0834063 0.624800069,57.0834063 C0.277200031,57.0834063 1.7974002,51.3414057 2.61580029,50.7562056 C3.43420038,50.1710056 4.4902005,52.8660059 4.4902005,52.8660059 L4.4924005,57.5520064 Z"
              id="Path"
              fill="#E2E8F0"
              fillRule="nonzero"
            ></path>
            <g
              id="Group"
              opacity="0.1"
              transform="translate(2.420000, 48.840005)"
              fill="#000000"
              fillRule="nonzero"
            >
              <path
                d="M10.4588012,0.415800046 C10.6018012,1.46300016 9.85600109,2.00200022 8.63720096,1.94480022 C9.75480108,1.88320021 10.3620012,1.24080014 10.0408011,0.0968000108 C10.0364011,0.099000011 10.1992011,0.228800025 10.4588012,0.415800046 Z"
                id="Path"
              ></path>
              <path
                d="M15.1976017,8.41940094 L15.7322017,8.77580097 C15.6831814,8.82972983 15.6198611,8.8686375 15.5496017,8.88800099 L15.1778017,8.63940096 L15.1976017,8.41940094 Z"
                id="Path"
              ></path>
              <path
                d="M0.081400009,5.49120061 C0.081400009,5.49120061 1.8414002,12.0538013 2.6598003,12.9910014 C3.42760038,13.8710015 2.45080027,20.5898023 2.32320026,21.4544024 L1.95800022,21.5468024 C1.95800022,21.5468024 3.13060035,13.9304015 2.31000026,12.9932014 C1.48940017,12.0560013 0.081400009,5.49120061 0.081400009,5.49120061 Z"
                id="Path"
              ></path>
              <path
                d="M6.99380078,21.0760023 C7.48440083,21.4852024 11.2134012,21.5512024 13.4332015,21.5534024 C11.2816013,21.5534024 7.1588008,21.5050024 6.64400074,21.0760023 C6.43833126,20.9512248 6.20008632,20.890706 5.95980066,20.9022023 C6.43500071,20.8758023 6.81780076,20.9286023 6.99380078,21.0760023 Z"
                id="Path"
              ></path>
            </g>
            <path
              d="M1.21220013,56.0296062 C1.21220013,56.0296062 0.0396000044,61.6550068 0.62700007,63.289607 C0.62700007,63.289607 0.510400057,64.4622072 1.21220013,65.0496072 C1.21220013,65.0496072 5.07980056,70.2064078 5.07980056,70.6750079 C5.07980056,71.1436079 6.25240069,73.3700082 8.24340092,71.4956079 C8.24340092,71.4956079 9.18060102,70.2064078 7.07080079,69.1526077 C4.96100055,68.0988076 3.20320036,62.706607 3.20320036,62.706607 C3.20320036,62.706607 4.96320055,58.3704065 4.25700047,56.9646063 C3.55080039,55.5588062 1.21220013,56.0296062 1.21220013,56.0296062 Z"
              id="Path"
              fill="#F0B9BB"
              fillRule="nonzero"
            ></path>
            <polygon
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
              points="4.90160054 58.1966065 0.565400063 57.1428063 0.919600102 55.2090061 2.79180031 54.9164061 5.25360058 55.7348062"
            ></polygon>
            <polygon
              id="Path"
              fill="#E2E8F0"
              fillRule="nonzero"
              points="4.90160054 58.0800065 0.565400063 57.0240063 0.919600102 55.0902061 2.79180031 54.7976061 5.25360058 55.6182062"
            ></polygon>
            <path
              d="M9.06180101,44.5456049 L12.8018014,46.0680051 C12.6690377,46.6604295 12.5691517,47.2597454 12.5026014,47.8632053 C11.1164289,48.1572325 9.6857604,47.6187997 8.83740098,46.4838052 C8.94918937,45.8425591 9.02411237,45.1954301 9.06180101,44.5456049 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <circle
              id="Oval"
              fill="#F0B9BB"
              fillRule="nonzero"
              cx="11.7568013"
              cy="44.1936049"
              r="3.6322004"
            ></circle>
            <path
              d="M15.6750017,42.2444047 C15.68265,42.1108593 15.7116161,41.9793977 15.7608018,41.8550046 C15.8114018,41.7472046 15.8928018,41.6526046 15.9368018,41.5426046 C16.0490018,41.2698046 15.9368018,40.9640046 15.8114018,40.6934045 C15.4836559,39.8662388 15.0621713,39.0793692 14.5552016,38.3482043 C14.4842972,38.2383133 14.3866446,38.1482307 14.2714016,38.0864042 C14.1394916,38.043665 14.0003203,38.0279521 13.8622015,38.0402042 C13.2176015,38.0402042 12.6214014,37.7278042 12.0120013,37.5232042 C11.4026013,37.3186041 10.6920012,37.2218041 10.1530011,37.5892042 C9.61400107,37.9566042 9.42920105,38.6892043 8.85940098,38.9818043 C8.70540097,39.0610043 8.53380095,39.1006043 8.38200093,39.1864044 C8.17905325,39.3189907 8.00413914,39.4901674 7.86720087,39.6902044 C7.22273819,40.3261845 6.90845777,41.2243606 7.01580078,42.1234047 C7.01580078,42.7834048 7.08400079,43.5182048 7.60760085,43.9032049 C7.72698066,43.9906209 7.82979391,44.0986493 7.91120088,44.2222049 C8.00700663,44.3805901 8.0558361,44.5629377 8.05200089,44.748005 C8.0784009,45.111005 8.21920091,45.4718051 8.24560092,45.8348051 C8.24252469,45.9731629 8.27835046,46.1096057 8.34900093,46.2286051 C8.38664274,46.286198 8.4459448,46.3261519 8.51345902,46.3394062 C8.58097325,46.3526605 8.65097903,46.3380923 8.70760097,46.2990051 L9.07500101,44.787605 C9.1248694,44.4856304 9.24135503,44.1985497 9.41600105,43.9472049 C9.68880108,43.6128048 10.1750011,43.4456048 10.3202011,43.0364048 C10.4236012,42.7438047 10.3334011,42.3654047 10.5622012,42.1564047 C10.6605735,42.0807542 10.7762684,42.0308467 10.8988012,42.0112047 C11.9523482,41.7601756 13.0460025,41.7264901 14.1130016,41.9122047 C14.2277957,41.9257631 14.3390046,41.9608424 14.4408016,42.0156047 C14.6147542,42.1531826 14.7372211,42.3454091 14.7884016,42.5612047 C14.8654017,42.7812048 15.1492017,44.0110049 15.4484017,43.9274049 C15.5936017,43.8790049 15.6750017,42.4358047 15.6750017,42.2444047 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M15.6750017,42.1256047 C15.68265,41.9920593 15.7116161,41.8605977 15.7608018,41.7362046 C15.8114018,41.6284046 15.8928018,41.5338046 15.9368018,41.4238046 C16.0490018,41.1510046 15.9368018,40.8452045 15.8114018,40.5746045 C15.4836559,39.7474388 15.0621713,38.9605692 14.5552016,38.2294042 C14.4842972,38.1195133 14.3866446,38.0294307 14.2714016,37.9676042 C14.1394916,37.924865 14.0003203,37.9091521 13.8622015,37.9214042 C13.2176015,37.9214042 12.6214014,37.6090042 12.0120013,37.4044042 C11.4026013,37.1998041 10.6920012,37.1030041 10.1530011,37.4704042 C9.61400107,37.8378042 9.42920105,38.5704043 8.85940098,38.8630043 C8.70540097,38.9422043 8.53380095,38.9818043 8.38200093,39.0676043 C8.17905325,39.2001907 8.00413914,39.3713673 7.86720087,39.5714044 C7.22533138,40.2053908 6.91126912,41.0996973 7.01580078,41.9958047 C7.01580078,42.6558047 7.08400079,43.3906048 7.60760085,43.7756049 C7.72698066,43.8630208 7.82979391,43.9710493 7.91120088,44.0946049 C8.0114157,44.2569535 8.06189296,44.445096 8.05640089,44.635805 C8.0828009,44.998805 8.22360091,45.359605 8.25000092,45.7226051 C8.24692469,45.8609629 8.28275046,45.9974057 8.35340093,46.1164051 C8.39280499,46.1735305 8.45377406,46.2121452 8.52226054,46.2233521 C8.59074702,46.2345589 8.66084408,46.2173915 8.71640097,46.1758051 L9.08380101,44.664405 C9.1336694,44.3624304 9.25015503,44.0753497 9.42480105,43.8240049 C9.69760108,43.4896048 10.1838011,43.3224048 10.3290011,42.9132048 C10.4324012,42.6206047 10.3422011,42.2422047 10.5710012,42.0332047 C10.6693735,41.9575542 10.7850684,41.9076466 10.9076012,41.8880047 C11.9611482,41.6369755 13.0548025,41.6032901 14.1218016,41.7890046 C14.2365957,41.802563 14.3478046,41.8376424 14.4496016,41.8924047 C14.6235542,42.0299825 14.7460211,42.2222091 14.7972016,42.4380047 C14.8742017,42.6580047 15.1580017,43.8878049 15.4572017,43.8042049 C15.5936017,43.7558049 15.6750017,42.3236047 15.6750017,42.1256047 Z"
              id="Path"
              fill="#575168"
              fillRule="nonzero"
            ></path>
            <ellipse
              id="Oval"
              fill="#F0B9BB"
              fillRule="nonzero"
              cx="9.35440104"
              cy="44.0176049"
              rx="1"
              ry="1"
            ></ellipse>
            <path
              d="M14.9226017,103.840012 C16.8872019,103.840012 19.3754022,104.777212 20.2026022,104.192012 C20.2817084,104.140868 20.3473542,104.071449 20.3940023,103.989612 C20.4622023,104.128212 20.4160023,104.273412 20.2026022,104.429612 C19.3820022,105.014812 16.9026019,104.077612 14.9226017,104.077612 C14.5706016,104.077612 12.5796014,103.842212 12.5796014,103.842212 C12.5796014,103.842212 12.5796014,103.754212 12.5796014,103.609012 C12.6258014,103.611212 14.5750016,103.840012 14.9226017,103.840012 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <path
              d="M2.85120032,104.777212 C4.37360049,104.777212 5.19420058,104.425212 5.66280063,103.723412 L6.60000073,103.488011 C6.74411569,102.800454 6.83094677,102.102126 6.85960076,101.400211 C6.84898768,102.181221 6.76204075,102.959322 6.60000073,103.723412 L5.66280063,103.958812 C5.19420058,104.662812 4.37360049,105.012612 2.85120032,105.012612 C2.00200022,105.012612 1.69840019,104.537412 1.75120019,104.057812 C1.8150002,104.445012 2.14280024,104.777212 2.85120032,104.777212 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
            ></path>
            <rect
              id="Rectangle"
              fill="#524D64"
              fillRule="nonzero"
              transform="translate(7.130627, 71.551102) rotate(160.920000) translate(-7.130627, -71.551102) "
              x="5.02082702"
              y="70.7305023"
              width="4.21960047"
              height="1.64120018"
            ></rect>
            <rect
              id="Rectangle"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.1"
              transform="translate(7.130627, 71.551102) rotate(160.920000) translate(-7.130627, -71.551102) "
              x="5.02082702"
              y="70.7305023"
              width="4.21960047"
              height="1.64120018"
            ></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const BikeSvg = (props) => (
  <svg
    width={props.width}
    height={props.height}
    style={props.style}
    viewBox="0 0 1057 809"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <g id="bike" clipPath="url(#clip0)">
      <g id="cloud-small">
        <path
          id="Vector"
          opacity="0.1"
          d="M1048.39 140.669C1044.72 132.153 1039.77 124.254 1033.69 117.248L829.765 115.238L997.665 91.6562C986.819 87.3379 975.271 85.0477 963.598 84.8994C947.536 72.0607 927.759 64.7499 907.209 64.0546C886.658 63.3593 866.433 69.3167 849.54 81.0404C836.038 74.0971 821.07 70.4883 805.888 70.5159C760.576 70.5159 722.822 101.9 714.353 143.514L1048.39 140.669Z"
          fill="#FED448"
        />
        <path
          id="Vector_2"
          opacity="0.1"
          d="M1055.56 175.572C1055.57 164.286 1053.41 153.103 1049.21 142.63L695.774 179.729C692.142 186.321 689.363 193.348 687.505 200.641L796.96 216.954L685 228.85C688.368 275.961 728.754 313.162 778.089 313.162C802.924 313.162 825.492 303.735 842.212 288.363C858.984 304.027 881.77 313.66 906.871 313.66C944.117 313.66 976.262 292.453 991.231 261.792C1021.26 252.26 1044.59 228.327 1052.58 198.385L914.168 176.919H1055.55C1055.55 176.47 1055.56 176.021 1055.56 175.572Z"
          fill="#FED448"
        />
      </g>
      <g id="cloud">
        <path
          id="Vector_3"
          opacity="0.1"
          d="M1035.84 218.55C1025.39 194.277 1011.26 171.76 993.95 151.79L412.65 146.06L891.25 78.84C860.331 66.5309 827.416 60.0027 794.14 59.58C748.357 22.9833 691.983 2.144 633.404 0.162065C574.825 -1.81987 517.172 15.1615 469.02 48.58C430.534 28.788 387.867 18.5011 344.59 18.58C215.43 18.58 107.81 108.04 83.67 226.66L1035.84 218.55Z"
          fill="#FED448"
        />
        <path
          id="Vector_4"
          opacity="0.1"
          d="M1056.28 318.04C1056.31 285.869 1050.16 253.992 1038.17 224.14L30.71 329.89C20.3578 348.68 12.4376 368.711 7.14 389.5L319.14 436L0 469.91C9.6 604.2 124.72 710.24 265.35 710.24C336.14 710.24 400.47 683.37 448.13 639.55C495.94 684.2 560.89 711.66 632.44 711.66C738.61 711.66 830.24 651.21 872.91 563.81C958.52 536.64 1025.02 468.42 1047.78 383.07L653.24 321.88H1056.24C1056.26 320.6 1056.28 319.32 1056.28 318.04Z"
          fill="#FED448"
        />
      </g>
      <g id="flower-2">
        <path
          id="Vector_5"
          opacity="0.1"
          d="M814.82 742.35C829.08 742.35 840.64 740.761 840.64 738.8C840.64 736.839 829.08 735.25 814.82 735.25C800.56 735.25 789 736.839 789 738.8C789 740.761 800.56 742.35 814.82 742.35Z"
          fill="#FED448"
        />
        <path
          id="Vector_6"
          opacity="0.1"
          d="M913.73 752.38C927.99 752.38 939.55 750.791 939.55 748.83C939.55 746.869 927.99 745.28 913.73 745.28C899.47 745.28 887.91 746.869 887.91 748.83C887.91 750.791 899.47 752.38 913.73 752.38Z"
          fill="#FED448"
        />
        <path
          id="Vector_7"
          opacity="0.1"
          d="M1030.24 738.8C1044.5 738.8 1056.06 737.211 1056.06 735.25C1056.06 733.289 1044.5 731.7 1030.24 731.7C1015.98 731.7 1004.42 733.289 1004.42 735.25C1004.42 737.211 1015.98 738.8 1030.24 738.8Z"
          fill="#FED448"
        />
        <path
          id="Vector_8"
          opacity="0.1"
          d="M874.14 779.91C884.28 779.91 892.5 778.782 892.5 777.39C892.5 775.998 884.28 774.87 874.14 774.87C864 774.87 855.78 775.998 855.78 777.39C855.78 778.782 864 779.91 874.14 779.91Z"
          fill="#FED448"
        />
        <path
          id="Vector_9"
          opacity="0.1"
          d="M976.81 777.39C986.95 777.39 995.17 776.262 995.17 774.87C995.17 773.478 986.95 772.35 976.81 772.35C966.67 772.35 958.45 773.478 958.45 774.87C958.45 776.262 966.67 777.39 976.81 777.39Z"
          fill="#FED448"
        />
        <path
          id="Vector_10"
          d="M914.29 748.03C914.29 748.03 878.07 629.31 919.95 581.76C951.29 546.18 986.85 550.44 1002.78 554.84C1006.9 555.938 1010.74 557.919 1014.02 560.646C1017.3 563.372 1019.95 566.779 1021.78 570.63C1027.35 582.63 1026.34 602.14 987.03 624.9C921.21 663.01 917.12 715.28 917.12 715.28L914.29 748.03Z"
          fill="#FED448"
        />
        <path
          id="Vector_11"
          d="M997.11 571.68C997.11 571.68 890.35 605.06 914.29 748.03"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_12"
          d="M934.76 583.65C934.76 583.65 949.46 593.55 944.76 608.44"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_13"
          d="M986.4 592.45C986.4 592.45 977.4 583.31 966.48 588.35"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_14"
          d="M944.2 638.45C944.2 638.45 928.42 630.45 924.34 640.45"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_15"
          d="M905.15 655.13C905.15 655.13 917 654.19 917.22 659.86"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_16"
          d="M912.85 748.98C912.85 748.98 955.27 662.69 966.92 664.58C972.45 665.48 975 670.92 976.16 676.39C977.598 683.48 976.79 690.841 973.85 697.45C967.85 711.2 951.63 737.45 912.85 748.98Z"
          fill="#FED448"
        />
        <path
          id="Vector_17"
          d="M966.57 680.96C966.57 680.96 922.05 745.52 913.45 748.35"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_18"
          d="M970.67 691.03H960.28"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_19"
          d="M958.22 714.65L941.94 715.35"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_20"
          d="M948.31 695.76L950.08 704.24"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_21"
          d="M930.99 721.58L931.31 729.29"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_22"
          d="M914.08 748.98C914.08 748.98 871.66 662.69 860.01 664.58C854.48 665.48 851.93 670.92 850.77 676.39C849.344 683.461 850.155 690.801 853.09 697.39C859.1 711.2 875.27 737.45 914.08 748.98Z"
          fill="#FED448"
        />
        <path
          id="Vector_23"
          d="M860.33 680.96C860.33 680.96 904.85 745.52 913.45 748.35"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_24"
          d="M856.24 691.03H866.63"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_25"
          d="M868.68 714.65L884.97 715.35"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_26"
          d="M878.6 695.76L876.83 704.24"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_27"
          d="M895.92 721.58L895.6 729.29"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_28"
          d="M986.91 769.13C988.067 768.19 988.911 766.92 989.33 765.49C989.516 764.772 989.449 764.011 989.142 763.336C988.834 762.661 988.304 762.111 987.64 761.78C986.09 761.18 984.43 762.26 983.18 763.34C981.93 764.42 980.48 765.67 978.84 765.44C979.677 764.669 980.301 763.695 980.652 762.613C981.002 761.53 981.067 760.375 980.84 759.26C980.771 758.797 980.578 758.361 980.28 758C979.42 757.08 977.86 757.48 976.83 758.2C973.55 760.5 972.64 764.95 972.62 768.96C972.44 767.49 972.42 766.005 972.56 764.53C972.56 763.05 972.14 761.4 970.89 760.61C970.116 760.185 969.242 759.978 968.36 760.01C966.88 760.01 965.25 760.1 964.24 761.18C962.99 762.52 963.31 764.76 964.4 766.24C965.616 767.61 967.057 768.764 968.66 769.65C969.862 770.383 970.887 771.373 971.66 772.55C971.75 772.716 971.823 772.89 971.88 773.07H981.11C983.215 772.029 985.167 770.703 986.91 769.13V769.13Z"
          fill="#FED448"
        />
        <path
          id="Vector_29"
          d="M825.28 734.38C826.438 733.441 827.282 732.171 827.7 730.74C827.884 730.02 827.817 729.259 827.51 728.582C827.203 727.906 826.674 727.355 826.01 727.02C824.46 726.43 822.81 727.51 821.55 728.59C820.29 729.67 818.86 730.91 817.21 730.68C818.05 729.911 818.675 728.937 819.026 727.854C819.376 726.771 819.44 725.615 819.21 724.5C819.135 724.04 818.938 723.608 818.64 723.25C817.78 722.33 816.22 722.72 815.19 723.45C811.91 725.75 811 730.2 810.98 734.21C810.8 732.737 810.78 731.248 810.92 729.77C810.92 728.29 810.51 726.65 809.26 725.86C808.483 725.435 807.605 725.228 806.72 725.26C805.25 725.2 803.61 725.35 802.6 726.43C801.35 727.77 801.68 730.01 802.76 731.43C803.974 732.809 805.419 733.966 807.03 734.85C808.235 735.579 809.261 736.57 810.03 737.75C810.12 737.917 810.197 738.091 810.26 738.27H819.49C821.587 737.242 823.535 735.933 825.28 734.38V734.38Z"
          fill="#FED448"
        />
        <path
          id="Vector_30"
          d="M879.15 769.13C880.307 768.19 881.151 766.92 881.57 765.49C881.756 764.772 881.689 764.011 881.382 763.336C881.074 762.661 880.544 762.111 879.88 761.78C878.33 761.18 876.67 762.26 875.42 763.34C874.17 764.42 872.72 765.67 871.08 765.44C871.917 764.669 872.541 763.695 872.892 762.613C873.242 761.53 873.307 760.375 873.08 759.26C873.011 758.797 872.818 758.361 872.52 758C871.66 757.08 870.1 757.48 869.07 758.2C865.79 760.5 864.88 764.95 864.86 768.96C864.68 767.49 864.66 766.005 864.8 764.53C864.8 763.05 864.39 761.4 863.14 760.61C862.362 760.186 861.485 759.979 860.6 760.01C859.13 760.01 857.49 760.1 856.48 761.18C855.23 762.52 855.55 764.76 856.64 766.24C857.856 767.61 859.297 768.764 860.9 769.65C862.102 770.383 863.127 771.373 863.9 772.55C863.99 772.716 864.063 772.89 864.12 773.07H873.35C875.455 772.029 877.407 770.703 879.15 769.13V769.13Z"
          fill="#FED448"
        />
        <path
          id="Vector_31"
          d="M1031.92 698.88C1031.92 698.88 1035.38 703.41 1030.32 710.24C1025.26 717.07 1021.1 722.84 1022.78 727.1C1022.78 727.1 1030.41 714.41 1036.62 714.23C1042.83 714.05 1038.75 706.51 1031.92 698.88Z"
          fill="#FED448"
        />
        <path
          id="Vector_32"
          opacity="0.1"
          d="M1031.92 698.88C1032.22 699.318 1032.46 699.796 1032.63 700.3C1038.69 707.42 1041.91 714.06 1036.09 714.23C1030.66 714.39 1024.16 724.09 1022.6 726.54C1022.65 726.73 1022.71 726.91 1022.78 727.1C1022.78 727.1 1030.41 714.41 1036.62 714.23C1042.83 714.05 1038.75 706.51 1031.92 698.88Z"
          fill="black"
        />
        <path
          id="Vector_33"
          d="M1038.35 704.65C1038.35 706.24 1038.17 707.53 1037.95 707.53C1037.73 707.53 1037.55 706.24 1037.55 704.65C1037.55 703.06 1037.78 703.81 1038 703.81C1038.22 703.81 1038.35 703.06 1038.35 704.65Z"
          fill="#FFD037"
        />
        <path
          id="Vector_34"
          d="M1040.56 706.55C1039.16 707.31 1037.94 707.77 1037.84 707.55C1037.74 707.33 1038.78 706.55 1040.18 705.82C1041.58 705.09 1041.02 705.61 1041.13 705.82C1041.24 706.03 1041.96 705.79 1040.56 706.55Z"
          fill="#FFD037"
        />
        <path
          id="Vector_35"
          d="M1013.64 698.88C1013.64 698.88 1010.18 703.41 1015.24 710.24C1020.3 717.07 1024.47 722.84 1022.78 727.1C1022.78 727.1 1015.15 714.41 1008.94 714.23C1002.73 714.05 1006.85 706.51 1013.64 698.88Z"
          fill="#FED448"
        />
        <path
          id="Vector_36"
          opacity="0.1"
          d="M1013.64 698.88C1013.34 699.317 1013.1 699.796 1012.94 700.3C1006.88 707.42 1003.65 714.06 1009.47 714.23C1014.9 714.39 1021.41 724.09 1022.97 726.54C1022.91 726.73 1022.85 726.91 1022.78 727.1C1022.78 727.1 1015.15 714.41 1008.94 714.23C1002.73 714.05 1006.85 706.51 1013.64 698.88Z"
          fill="black"
        />
        <path
          id="Vector_37"
          d="M1007.21 704.65C1007.21 706.24 1007.39 707.53 1007.61 707.53C1007.83 707.53 1008.01 706.24 1008.01 704.65C1008.01 703.06 1007.79 703.81 1007.57 703.81C1007.35 703.81 1007.21 703.06 1007.21 704.65Z"
          fill="#FFD037"
        />
        <path
          id="Vector_38"
          d="M1005 706.55C1006.4 707.31 1007.62 707.77 1007.73 707.55C1007.84 707.33 1006.78 706.55 1005.39 705.82C1004 705.09 1004.54 705.61 1004.39 705.82C1004.24 706.03 1003.61 705.79 1005 706.55Z"
          fill="#FFD037"
        />
        <path
          id="Vector_39"
          d="M1008.31 726.5C1008.31 726.5 1017.99 726.21 1020.9 724.13C1023.81 722.05 1035.78 719.57 1036.51 722.9C1037.24 726.23 1051.04 739.46 1040.12 739.55C1029.2 739.64 1014.75 737.85 1011.84 736.08C1008.93 734.31 1008.31 726.5 1008.31 726.5Z"
          fill="#A8A8A8"
        />
        <path
          id="Vector_40"
          opacity="0.2"
          d="M1040.32 738.39C1029.4 738.48 1014.94 736.69 1012.03 734.92C1009.81 733.57 1008.93 728.73 1008.64 726.49H1008.31C1008.31 726.49 1008.93 734.3 1011.84 736.07C1014.75 737.84 1029.2 739.63 1040.12 739.54C1043.28 739.54 1044.36 738.39 1044.3 736.73C1043.85 737.75 1042.66 738.37 1040.32 738.39Z"
          fill="black"
        />
      </g>
      <g id="flower-1">
        <path
          id="Vector_41"
          opacity="0.1"
          d="M28.11 742.35C42.37 742.35 53.93 740.761 53.93 738.8C53.93 736.839 42.37 735.25 28.11 735.25C13.85 735.25 2.28998 736.839 2.28998 738.8C2.28998 740.761 13.85 742.35 28.11 742.35Z"
          fill="#FED448"
        />
        <path
          id="Vector_42"
          opacity="0.1"
          d="M127.02 752.38C141.28 752.38 152.84 750.791 152.84 748.83C152.84 746.869 141.28 745.28 127.02 745.28C112.76 745.28 101.2 746.869 101.2 748.83C101.2 750.791 112.76 752.38 127.02 752.38Z"
          fill="#FED448"
        />
        <path
          id="Vector_43"
          opacity="0.1"
          d="M243.53 738.8C257.79 738.8 269.35 737.211 269.35 735.25C269.35 733.289 257.79 731.7 243.53 731.7C229.27 731.7 217.71 733.289 217.71 735.25C217.71 737.211 229.27 738.8 243.53 738.8Z"
          fill="#FED448"
        />
        <path
          id="Vector_44"
          opacity="0.1"
          d="M87.43 779.91C97.57 779.91 105.79 778.782 105.79 777.39C105.79 775.998 97.57 774.87 87.43 774.87C77.2901 774.87 69.07 775.998 69.07 777.39C69.07 778.782 77.2901 779.91 87.43 779.91Z"
          fill="#FED448"
        />
        <path
          id="Vector_45"
          opacity="0.1"
          d="M190.1 777.39C200.24 777.39 208.46 776.262 208.46 774.87C208.46 773.478 200.24 772.35 190.1 772.35C179.96 772.35 171.74 773.478 171.74 774.87C171.74 776.262 179.96 777.39 190.1 777.39Z"
          fill="#FED448"
        />
        <path
          id="Vector_46"
          d="M127.58 748.03C127.58 748.03 91.36 629.31 133.24 581.76C164.58 546.18 200.14 550.44 216.07 554.84C220.192 555.938 224.026 557.919 227.306 560.646C230.587 563.372 233.236 566.779 235.07 570.63C240.64 582.63 239.63 602.14 200.32 624.9C134.5 663.01 130.41 715.28 130.41 715.28L127.58 748.03Z"
          fill="#FED448"
        />
        <path
          id="Vector_47"
          d="M210.4 571.68C210.4 571.68 103.64 605.06 127.58 748.03"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_48"
          d="M148.05 583.65C148.05 583.65 162.75 593.55 158.05 608.44"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_49"
          d="M199.69 592.45C199.69 592.45 190.69 583.31 179.77 588.35"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_50"
          d="M157.49 638.45C157.49 638.45 141.71 630.45 137.63 640.45"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_51"
          d="M118.44 655.13C118.44 655.13 130.29 654.19 130.51 659.86"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_52"
          d="M126.14 748.98C126.14 748.98 168.56 662.69 180.21 664.58C185.74 665.48 188.29 670.92 189.45 676.39C190.888 683.48 190.08 690.841 187.14 697.45C181.14 711.2 164.92 737.45 126.14 748.98Z"
          fill="#FED448"
        />
        <path
          id="Vector_53"
          d="M179.86 680.96C179.86 680.96 135.34 745.52 126.74 748.35"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_54"
          d="M183.96 691.03H173.57"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_55"
          d="M171.51 714.65L155.23 715.35"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_56"
          d="M161.6 695.76L163.37 704.24"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_57"
          d="M144.28 721.58L144.6 729.29"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_58"
          d="M127.37 748.98C127.37 748.98 84.95 662.69 73.3 664.58C67.77 665.48 65.22 670.92 64.06 676.39C62.6337 683.461 63.4445 690.801 66.38 697.39C72.39 711.2 88.56 737.45 127.37 748.98Z"
          fill="#FED448"
        />
        <path
          id="Vector_59"
          d="M73.62 680.96C73.62 680.96 118.14 745.52 126.74 748.35"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_60"
          d="M69.53 691.03H79.92"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_61"
          d="M81.97 714.65L98.26 715.35"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_62"
          d="M91.89 695.76L90.12 704.24"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_63"
          d="M109.21 721.58L108.89 729.29"
          stroke="#565987"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_64"
          d="M200.2 769.13C201.357 768.19 202.201 766.92 202.62 765.49C202.806 764.772 202.739 764.011 202.432 763.336C202.124 762.661 201.594 762.111 200.93 761.78C199.38 761.18 197.72 762.26 196.47 763.34C195.22 764.42 193.77 765.67 192.13 765.44C192.967 764.669 193.591 763.695 193.941 762.613C194.292 761.53 194.357 760.375 194.13 759.26C194.061 758.797 193.868 758.361 193.57 758C192.71 757.08 191.15 757.48 190.12 758.2C186.84 760.5 185.93 764.95 185.91 768.96C185.73 767.49 185.71 766.005 185.85 764.53C185.85 763.05 185.43 761.4 184.18 760.61C183.406 760.185 182.532 759.978 181.65 760.01C180.17 760.01 178.54 760.1 177.53 761.18C176.28 762.52 176.6 764.76 177.69 766.24C178.906 767.61 180.347 768.764 181.95 769.65C183.152 770.383 184.177 771.373 184.95 772.55C185.04 772.716 185.113 772.89 185.17 773.07H194.4C196.505 772.029 198.457 770.703 200.2 769.13V769.13Z"
          fill="#FED448"
        />
        <path
          id="Vector_65"
          d="M38.57 734.38C39.7276 733.441 40.5717 732.171 40.99 730.74C41.1745 730.02 41.1075 729.259 40.8001 728.582C40.4928 727.906 39.9635 727.355 39.3 727.02C37.75 726.43 36.1 727.51 34.84 728.59C33.58 729.67 32.15 730.91 30.5 730.68C31.3396 729.911 31.9652 728.937 32.3158 727.854C32.6663 726.771 32.7298 725.615 32.5 724.5C32.4251 724.04 32.2282 723.608 31.93 723.25C31.07 722.33 29.51 722.72 28.48 723.45C25.2 725.75 24.29 730.2 24.27 734.21C24.0899 732.737 24.0698 731.248 24.21 729.77C24.21 728.29 23.8 726.65 22.55 725.86C21.7728 725.435 20.8953 725.228 20.01 725.26C18.54 725.2 16.9 725.35 15.89 726.43C14.64 727.77 14.97 730.01 16.05 731.43C17.2644 732.809 18.7092 733.966 20.32 734.85C21.5253 735.579 22.5507 736.57 23.32 737.75C23.4105 737.917 23.4874 738.091 23.55 738.27H32.78C34.8775 737.242 36.8253 735.933 38.57 734.38V734.38Z"
          fill="#FED448"
        />
        <path
          id="Vector_66"
          d="M92.44 769.13C93.5967 768.19 94.4406 766.92 94.86 765.49C95.0457 764.772 94.9793 764.011 94.6717 763.336C94.364 762.661 93.834 762.111 93.17 761.78C91.62 761.18 89.96 762.26 88.71 763.34C87.46 764.42 86.01 765.67 84.37 765.44C85.2071 764.669 85.8311 763.695 86.1815 762.613C86.5319 761.53 86.5968 760.375 86.37 759.26C86.3011 758.797 86.1075 758.361 85.81 758C84.95 757.08 83.39 757.48 82.36 758.2C79.08 760.5 78.17 764.95 78.15 768.96C77.9699 767.49 77.9497 766.005 78.09 764.53C78.09 763.05 77.68 761.4 76.43 760.61C75.6524 760.186 74.7751 759.979 73.89 760.01C72.42 760.01 70.78 760.1 69.77 761.18C68.52 762.52 68.84 764.76 69.93 766.24C71.1459 767.61 72.5865 768.764 74.19 769.65C75.3924 770.383 76.417 771.373 77.19 772.55C77.2795 772.716 77.3532 772.89 77.41 773.07H86.64C88.745 772.029 90.6966 770.703 92.44 769.13V769.13Z"
          fill="#FED448"
        />
        <path
          id="Vector_67"
          d="M245.21 698.88C245.21 698.88 248.67 703.41 243.61 710.24C238.55 717.07 234.39 722.84 236.07 727.1C236.07 727.1 243.7 714.41 249.91 714.23C256.12 714.05 252.04 706.51 245.21 698.88Z"
          fill="#FED448"
        />
        <path
          id="Vector_68"
          opacity="0.1"
          d="M245.21 698.88C245.511 699.318 245.75 699.796 245.92 700.3C251.98 707.42 255.2 714.06 249.38 714.23C243.95 714.39 237.45 724.09 235.89 726.54C235.94 726.73 236 726.91 236.07 727.1C236.07 727.1 243.7 714.41 249.91 714.23C256.12 714.05 252.04 706.51 245.21 698.88Z"
          fill="black"
        />
        <path
          id="Vector_69"
          d="M251.64 704.65C251.64 706.24 251.46 707.53 251.24 707.53C251.02 707.53 250.84 706.24 250.84 704.65C250.84 703.06 251.07 703.81 251.29 703.81C251.51 703.81 251.64 703.06 251.64 704.65Z"
          fill="#FFD037"
        />
        <path
          id="Vector_70"
          d="M253.85 706.55C252.45 707.31 251.23 707.77 251.13 707.55C251.03 707.33 252.07 706.55 253.47 705.82C254.87 705.09 254.31 705.61 254.42 705.82C254.53 706.03 255.25 705.79 253.85 706.55Z"
          fill="#FFD037"
        />
        <path
          id="Vector_71"
          d="M226.93 698.88C226.93 698.88 223.47 703.41 228.53 710.24C233.59 717.07 237.76 722.84 236.07 727.1C236.07 727.1 228.44 714.41 222.23 714.23C216.02 714.05 220.14 706.51 226.93 698.88Z"
          fill="#FED448"
        />
        <path
          id="Vector_72"
          opacity="0.1"
          d="M226.93 698.88C226.63 699.317 226.394 699.796 226.23 700.3C220.17 707.42 216.94 714.06 222.76 714.23C228.19 714.39 234.7 724.09 236.26 726.54C236.2 726.73 236.14 726.91 236.07 727.1C236.07 727.1 228.44 714.41 222.23 714.23C216.02 714.05 220.14 706.51 226.93 698.88Z"
          fill="black"
        />
        <path
          id="Vector_73"
          d="M220.5 704.65C220.5 706.24 220.68 707.53 220.9 707.53C221.12 707.53 221.3 706.24 221.3 704.65C221.3 703.06 221.08 703.81 220.86 703.81C220.64 703.81 220.5 703.06 220.5 704.65Z"
          fill="#FFD037"
        />
        <path
          id="Vector_74"
          d="M218.29 706.55C219.69 707.31 220.91 707.77 221.02 707.55C221.13 707.33 220.07 706.55 218.68 705.82C217.29 705.09 217.83 705.61 217.68 705.82C217.53 706.03 216.9 705.79 218.29 706.55Z"
          fill="#FFD037"
        />
        <path
          id="Vector_75"
          d="M221.6 726.5C221.6 726.5 231.28 726.21 234.19 724.13C237.1 722.05 249.07 719.57 249.8 722.9C250.53 726.23 264.33 739.46 253.41 739.55C242.49 739.64 228.04 737.85 225.13 736.08C222.22 734.31 221.6 726.5 221.6 726.5Z"
          fill="#A8A8A8"
        />
        <path
          id="Vector_76"
          opacity="0.2"
          d="M253.61 738.39C242.69 738.48 228.23 736.69 225.32 734.92C223.1 733.57 222.22 728.73 221.93 726.49H221.6C221.6 726.49 222.22 734.3 225.13 736.07C228.04 737.84 242.49 739.63 253.41 739.54C256.57 739.54 257.65 738.39 257.59 736.73C257.14 737.75 255.95 738.37 253.61 738.39Z"
          fill="black"
        />
      </g>
      <path
        id="shadow"
        opacity="0.1"
        d="M612.39 808.9C794.324 808.9 941.81 802.211 941.81 793.96C941.81 785.709 794.324 779.02 612.39 779.02C430.456 779.02 282.97 785.709 282.97 793.96C282.97 802.211 430.456 808.9 612.39 808.9Z"
        fill="#FED448"
      />
      <g id="girl-1">
        <path
          id="Vector_77"
          d="M578.83 347.29C578.83 347.29 599.83 387.02 601.46 392.69C601.884 394.264 602.8 395.662 604.073 396.68C605.346 397.698 606.911 398.283 608.54 398.35C608.54 398.35 629.46 403.35 634.46 404.02C639.46 404.69 682.8 408.35 682.8 408.35C682.8 408.35 693.8 408.69 695.13 404.69C696.35 401.03 717.6 381.8 729.9 398.58C731.034 400.132 731.786 401.93 732.095 403.827C732.405 405.725 732.262 407.668 731.68 409.5C729.42 416.7 724.78 428.13 719.8 421.02C712.8 411.02 704.66 413.83 704.66 419.16C704.66 424.49 693.46 422.51 689.8 423.26C687.8 423.67 680.92 425.5 674.97 427.1C668.064 428.967 660.989 430.142 653.85 430.61C642.04 431.38 624.63 432.02 618.46 429.69C611.01 426.86 598.02 426.21 592.46 426.06C590.618 426.015 588.84 425.377 587.39 424.24C579.672 418.199 573.145 410.776 568.14 402.35C559.47 387.35 541.64 356.29 542.84 347.29C544.04 338.29 578.83 347.29 578.83 347.29Z"
          fill="#EFB7B9"
        />
        <path
          id="Vector_78"
          opacity="0.05"
          d="M578.83 347.29C578.83 347.29 599.83 387.02 601.46 392.69C601.884 394.264 602.8 395.662 604.073 396.68C605.346 397.698 606.911 398.283 608.54 398.35C608.54 398.35 629.46 403.35 634.46 404.02C639.46 404.69 682.8 408.35 682.8 408.35C682.8 408.35 693.8 408.69 695.13 404.69C696.35 401.03 717.6 381.8 729.9 398.58C731.034 400.132 731.786 401.93 732.095 403.827C732.405 405.725 732.262 407.668 731.68 409.5C729.42 416.7 724.78 428.13 719.8 421.02C712.8 411.02 704.66 413.83 704.66 419.16C704.66 424.49 693.46 422.51 689.8 423.26C687.8 423.67 680.92 425.5 674.97 427.1C668.064 428.967 660.989 430.142 653.85 430.61C642.04 431.38 624.63 432.02 618.46 429.69C611.01 426.86 598.02 426.21 592.46 426.06C590.618 426.015 588.84 425.377 587.39 424.24C579.672 418.199 573.145 410.776 568.14 402.35C559.47 387.35 541.64 356.29 542.84 347.29C544.04 338.29 578.83 347.29 578.83 347.29Z"
          fill="black"
        />
      </g>
      <g id="right-wheel">
        <path
          id="Vector_79"
          d="M901.55 719.45C901.513 740.699 893.279 761.114 878.563 776.443C863.846 791.771 843.783 800.83 822.554 801.732C801.324 802.634 780.565 795.311 764.601 781.286C748.637 767.262 738.7 747.619 736.86 726.45C736.74 725.11 736.65 723.77 736.61 722.45V722.38C736.57 721.387 736.55 720.387 736.55 719.38C736.55 697.5 745.242 676.516 760.714 661.044C776.186 645.572 797.17 636.88 819.05 636.88C840.93 636.88 861.915 645.572 877.386 661.044C892.858 676.516 901.55 697.5 901.55 719.38V719.45Z"
          fill="#65617D"
        />
        <path
          id="Vector_80"
          d="M819.05 764.4C843.903 764.4 864.05 744.253 864.05 719.4C864.05 694.547 843.903 674.4 819.05 674.4C794.197 674.4 774.05 694.547 774.05 719.4C774.05 744.253 794.197 764.4 819.05 764.4Z"
          fill="#DCE0ED"
        />
        <path
          id="Vector_81"
          d="M819.05 746.4C833.962 746.4 846.05 734.312 846.05 719.4C846.05 704.489 833.962 692.4 819.05 692.4C804.138 692.4 792.05 704.489 792.05 719.4C792.05 734.312 804.138 746.4 819.05 746.4Z"
          fill="#65617D"
        />
        <rect
          id="Vector_82"
          x="815"
          y="745"
          width="5"
          height="30"
          fill="#65617D"
        />
      </g>
      <g id="bike-2">
        <path
          id="Vector_83"
          d="M602.39 562.73L403.73 566.73V537.45C405.51 513.88 429.73 505.61 451.73 503.02C468.93 501.067 486.344 502.374 503.06 506.87C545.21 518.03 572.06 520.19 585.29 520.4C588.194 520.444 590.994 521.488 593.217 523.358C595.44 525.227 596.949 527.806 597.49 530.66C598.12 534.01 598.74 537.66 599.32 541.26C599.76 544.08 600.18 546.86 600.56 549.45C601.66 556.91 602.39 562.73 602.39 562.73Z"
          fill="#65617D"
        />
        <path
          id="Vector_84"
          d="M760.88 724.73H348.19C345.004 724.762 341.878 723.857 339.202 722.127C336.527 720.397 334.418 717.919 333.14 715C330.03 707.57 334.38 702.83 339.02 700.05C348.516 694.422 355.714 685.616 359.34 675.19C363.74 662.19 368.04 641.85 369.73 610.07C371.47 577.2 383.37 560.95 396.23 553.07C412.84 542.91 431.05 546.72 431.05 546.72L598.38 548.06C601.359 549.411 604.114 551.208 606.55 553.39C621.46 567.27 599.72 585.39 599.72 585.39C553.05 634.72 588.38 684.72 588.38 684.72H674C689.997 684.803 705.641 680.014 718.85 670.99C730.42 662.99 734.85 655.26 736.63 650.58C737.95 647 739.29 643.43 740.89 639.97C763.35 591.26 736.26 512.02 724.57 482.39C721.67 475.02 719.72 470.72 719.72 470.72L746.57 468.72L763.57 467.43H763.74C801.16 531.97 815.07 598.29 819.74 647.43C820.18 652.06 820.54 656.55 820.83 660.86C821.36 669.054 820.202 677.271 817.428 684.999C814.653 692.728 810.322 699.805 804.703 705.793C799.083 711.78 792.294 716.55 784.756 719.807C777.218 723.065 769.092 724.74 760.88 724.73V724.73Z"
          fill="#FED448"
        />
        <path
          id="Vector_85"
          opacity="0.1"
          d="M600.57 549.45H403.73V541.26H599.33C599.77 544.03 600.19 546.81 600.57 549.45Z"
          fill="black"
        />
        <path
          id="Vector_86"
          opacity="0.1"
          d="M606.56 553.45H397.82C397.277 553.452 396.74 553.343 396.24 553.13C412.85 542.97 431.06 546.78 431.06 546.78L598.39 548.12C601.369 549.471 604.124 551.268 606.56 553.45Z"
          fill="black"
        />
        <path
          id="Vector_87"
          d="M608.3 543.21H324.78C322.521 543.21 320.69 545.041 320.69 547.3V547.31C320.69 549.569 322.521 551.4 324.78 551.4H608.3C610.559 551.4 612.39 549.569 612.39 547.31V547.3C612.39 545.041 610.559 543.21 608.3 543.21Z"
          fill="#DCE0ED"
        />
        <path
          id="Vector_88"
          opacity="0.1"
          d="M819.74 647.45C810.23 657.79 803.23 661.86 803.56 650.95C804.56 617.95 746.56 468.75 746.56 468.75L763.71 467.45C801.14 531.94 815.06 598.26 819.74 647.45Z"
          fill="black"
        />
        <path
          id="Vector_89"
          opacity="0.1"
          d="M901.05 710.36C891.2 712.72 879.05 715.12 864.05 717.36C858.47 718.18 852.47 718.967 846.05 719.72C830.72 721.54 812.99 723.13 792.51 724.35C786.71 724.697 780.687 725.013 774.44 725.3C762.74 725.833 750.217 726.24 736.87 726.52L736.62 722.52V722.45C755.27 714.92 784.62 694.83 789.34 642.5C801.127 637.958 813.798 636.181 826.38 637.308C838.961 638.434 851.116 642.432 861.908 648.995C872.701 655.559 881.843 664.511 888.63 675.164C895.418 685.817 899.671 697.885 901.06 710.44L901.05 710.36Z"
          fill="black"
        />
        <path
          id="Vector_90"
          d="M721.06 724.73C721.06 724.73 815.76 714.45 783.14 570.16C783.14 570.16 829.93 613.06 859.04 636.9C888.15 660.74 940.04 693.61 940.04 693.61C940.04 693.61 909.06 722.56 721.06 724.73Z"
          fill="#FED448"
        />
        <path
          id="Vector_91"
          opacity="0.1"
          d="M721.06 724.73C721.06 724.73 815.76 714.45 783.14 570.16C783.14 570.16 829.93 613.06 859.04 636.9C888.15 660.74 940.04 693.61 940.04 693.61C940.04 693.61 909.06 722.56 721.06 724.73Z"
          fill="white"
        />
      </g>
      <g id="left-wheel">
        <path
          id="Vector_92"
          d="M468.06 801.9C513.623 801.9 550.56 764.964 550.56 719.4C550.56 673.837 513.623 636.9 468.06 636.9C422.496 636.9 385.56 673.837 385.56 719.4C385.56 764.964 422.496 801.9 468.06 801.9Z"
          fill="#65617D"
        />
        <path
          id="Vector_93"
          d="M468.06 764.4C492.913 764.4 513.06 744.253 513.06 719.4C513.06 694.547 492.913 674.4 468.06 674.4C443.207 674.4 423.06 694.547 423.06 719.4C423.06 744.253 443.207 764.4 468.06 764.4Z"
          fill="#DCE0ED"
        />
        <path
          id="Vector_94"
          d="M468.06 746.4C482.972 746.4 495.06 734.312 495.06 719.4C495.06 704.488 482.972 692.4 468.06 692.4C453.148 692.4 441.06 704.488 441.06 719.4C441.06 734.312 453.148 746.4 468.06 746.4Z"
          fill="#65617D"
        />
        <rect
          id="Vector_95"
          x="464.275"
          y="742.043"
          width="5"
          height="30"
          fill="#65617D"
        />
      </g>
      <g id="bike-1">
        <path
          id="Vector_96"
          opacity="0.1"
          d="M560.56 694.62C560.56 641.35 518.25 598.16 466.06 598.16C413.87 598.16 371.56 641.35 371.56 694.62C371.56 696.873 371.637 699.103 371.79 701.31H560.33C560.483 699.103 560.56 696.873 560.56 694.62Z"
          fill="black"
        />
        <path
          id="Vector_97"
          d="M557.06 692.96C557.06 641.66 516.32 600.07 466.06 600.07C415.8 600.07 375.06 641.66 375.06 692.96C375.06 695.13 375.14 697.27 375.28 699.4H556.84C556.98 697.27 557.06 695.13 557.06 692.96Z"
          fill="#FED448"
        />
        <path
          id="Vector_98"
          opacity="0.1"
          d="M557.06 692.96C557.06 694.45 557.06 695.96 556.95 697.4C556.95 698.07 556.88 698.73 556.84 699.4H375.28C375.28 698.73 375.2 698.07 375.17 697.4C375.1 695.93 375.06 694.4 375.06 692.96C375.06 641.66 415.8 600.07 466.06 600.07C516.32 600.07 557.06 641.66 557.06 692.96Z"
          fill="white"
        />
        <path
          id="Vector_99"
          opacity="0.1"
          d="M556.95 697.45C556.95 698.12 556.88 698.78 556.84 699.45H375.28C375.28 698.78 375.2 698.12 375.17 697.45H556.95Z"
          fill="black"
        />
        <path
          id="Vector_100"
          opacity="0.1"
          d="M569.06 701.4H345.92C340.027 701.4 335.25 706.175 335.25 712.065C335.25 717.955 340.027 722.73 345.92 722.73H569.06C574.953 722.73 579.73 717.955 579.73 712.065C579.73 706.175 574.953 701.4 569.06 701.4Z"
          fill="black"
        />
        <path
          id="Vector_101"
          d="M569.06 699.4H345.92C340.027 699.4 335.25 704.175 335.25 710.065C335.25 715.955 340.027 720.73 345.92 720.73H569.06C574.953 720.73 579.73 715.955 579.73 710.065C579.73 704.175 574.953 699.4 569.06 699.4Z"
          fill="#DCE0ED"
        />
        <path
          id="Vector_102"
          opacity="0.1"
          d="M803.464 560.284C809.493 557.558 808.817 543.044 801.955 527.867C795.092 512.689 784.642 502.595 778.613 505.321C772.584 508.047 773.26 522.56 780.122 537.738C786.985 552.916 797.435 563.01 803.464 560.284Z"
          fill="black"
        />
        <path
          id="Vector_103"
          d="M804.463 559.281C810.492 556.555 809.816 542.041 802.954 526.864C796.091 511.686 785.641 501.592 779.612 504.318C773.583 507.044 774.259 521.557 781.122 536.735C787.984 551.912 798.435 562.007 804.463 559.281Z"
          fill="#DCE0ED"
        />
        <path
          id="Vector_104"
          opacity="0.1"
          d="M763.56 467.45V483.12H733.06C730.22 483.123 727.384 482.895 724.58 482.44C721.68 475.07 719.73 470.77 719.73 470.77L746.58 468.77L763.56 467.45Z"
          fill="black"
        />
        <path
          id="Vector_105"
          d="M763.56 481.08H733.06C706.27 481.08 684.56 461.08 684.56 436.31V432.16C684.56 407.44 706.27 387.4 733.06 387.4L763.56 390.17V481.08Z"
          fill="#FED448"
        />
        <path
          id="Vector_106"
          d="M713.31 413.9C713.31 413.9 731.56 423.65 721.06 440.15C721.06 440.15 708.18 461.27 687.93 459.27L680.56 413.9C680.56 413.9 704.81 411.65 713.31 413.9Z"
          fill="#FED448"
        />
        <path
          id="Vector_107"
          opacity="0.1"
          d="M706.3 413.02C709.201 413.13 712.04 413.89 714.609 415.243C717.177 416.597 719.409 418.509 721.14 420.84C724.39 425.34 726.33 431.9 721.08 440.15C721.08 440.15 708.2 461.27 687.95 459.27L680.58 413.9C680.58 413.9 695.75 412.45 706.3 413.02Z"
          fill="black"
        />
        <path
          id="Vector_108"
          opacity="0.1"
          d="M762.56 390.17H768.44C773.378 390.17 778.114 392.132 781.606 395.624C785.098 399.116 787.06 403.852 787.06 408.79V462.47C787.06 467.408 785.098 472.144 781.606 475.636C778.114 479.128 773.378 481.09 768.44 481.09H762.56V390.17Z"
          fill="black"
        />
        <path
          id="Vector_109"
          d="M763.56 390.17H769.44C774.378 390.17 779.114 392.132 782.606 395.624C786.098 399.116 788.06 403.852 788.06 408.79V462.47C788.06 467.408 786.098 472.144 782.606 475.636C779.114 479.128 774.378 481.09 769.44 481.09H763.56V390.17Z"
          fill="#DCE0ED"
        />
      </g>
      <g id="girl-0">
        <path
          id="Vector_110"
          d="M547.02 506.93C547.02 506.93 551.73 508.65 558.02 511.05C568.02 514.9 582.12 520.52 587.02 523.6C591.92 526.68 610.19 531.74 623.87 535.3C634.012 537.927 644.454 539.215 654.93 539.13C665.57 539.03 678.46 538.93 682.02 538.93C682.643 538.925 683.265 538.972 683.88 539.07C687.62 539.69 687.47 542.2 687.38 542.8V542.93C665.38 556.26 638.71 615.93 637.05 625.93C635.8 633.43 624.81 654.22 619.39 664.16C617.57 667.49 616.39 669.6 616.39 669.6L623.06 677.26L642.39 685.93L660.72 693.93C660.72 693.93 680.06 694.93 680.39 693.93C680.72 692.93 680.72 682.6 680.72 682.6C678.366 681.081 676.133 679.382 674.04 677.52C669.605 673.658 665.485 669.448 661.72 664.93C651.06 652.26 672.39 627.93 672.39 627.93L713.39 574.6C713.39 574.6 716.72 568.6 732.72 544.6C748.72 520.6 732.72 507.6 732.72 507.6L704.56 495.91C655.72 477.63 596.81 462.98 596.81 462.98L595.97 462.87L583.48 461.31L547.02 506.93Z"
          fill="#EFB7B9"
        />
        <path
          id="Vector_111"
          d="M672.85 685.93C672.85 685.93 676.35 690.06 673.73 690.43C671.11 690.8 664.23 689.31 664.23 689.31L620.6 666.31C620.6 666.31 615.85 662.93 614.73 669.56C613.61 676.19 612.85 675.56 612.85 675.56C612.85 675.56 607.1 687.93 612.85 690.49C618.6 693.05 653.14 703.18 653.14 703.18C653.14 703.18 703.27 714.56 708.02 701.43C712.77 688.3 699.52 690.56 699.52 690.56C699.52 690.56 683.02 686.56 677.39 678.56C677.35 678.56 669.23 680.81 672.85 685.93Z"
          fill="#444053"
        />
        <path
          id="Vector_112"
          opacity="0.05"
          d="M732.68 507.6L704.52 495.91C655.68 477.63 596.77 462.98 596.77 462.98L595.93 462.87L583.44 461.31L547.02 506.93C547.02 506.93 551.73 508.65 558.02 511.05C568.02 514.9 582.12 520.52 587.02 523.6C591.92 526.68 610.19 531.74 623.87 535.3C634.012 537.927 644.454 539.215 654.93 539.13C665.57 539.03 678.46 538.93 682.02 538.93C682.643 538.925 683.265 538.972 683.88 539.07C687.62 539.69 687.47 542.2 687.38 542.8V542.93C665.38 556.26 638.71 615.93 637.05 625.93C635.8 633.43 624.81 654.22 619.39 664.16L618.66 665.5C617.21 665.26 615.4 665.78 614.76 669.56C613.63 676.18 612.88 675.56 612.88 675.56C612.88 675.56 607.13 687.93 612.88 690.49C618.63 693.05 653.14 703.18 653.14 703.18C653.14 703.18 703.27 714.56 708.02 701.43C712.77 688.3 699.52 690.56 699.52 690.56C699.52 690.56 683.02 686.56 677.39 678.56C676.891 678.706 676.403 678.886 675.93 679.1C675.34 678.62 674.71 678.1 674.04 677.52C669.605 673.658 665.485 669.448 661.72 664.93C651.06 652.26 672.39 627.93 672.39 627.93L713.39 574.6C713.39 574.6 716.72 568.6 732.72 544.6C748.72 520.6 732.68 507.6 732.68 507.6Z"
          fill="black"
        />
        <path
          id="Vector_113"
          d="M513.44 283.91L514.96 285.83L515.81 286.9L521.11 293.57C521.11 293.57 533.76 297.63 544.85 300.26C556.4 302.99 566.25 304.18 558.42 297.65C553.56 293.6 553.24 286.82 555.01 279.55C556.501 273.956 558.635 268.553 561.37 263.45C561.763 262.69 562.153 261.95 562.54 261.23C565.024 256.636 567.775 252.192 570.78 247.92C563.67 242.996 556.296 238.466 548.69 234.35C539.53 229.61 532.01 227.54 536.78 236.92C539.84 242.92 538.84 249.66 535.98 256.11C535.76 256.62 535.52 257.11 535.27 257.64C532.703 262.638 529.532 267.303 525.83 271.53C522.037 275.981 517.894 280.12 513.44 283.91V283.91Z"
          fill="#EFB7B9"
        />
        <path
          id="Vector_114"
          d="M576.78 436.24L583.56 442.43L590.11 467.63H579.18L567.11 451.93L576.78 436.24Z"
          fill="#444053"
        />
        <path
          id="Vector_115"
          opacity="0.1"
          d="M567.11 451.93L574.41 461.42L579.18 467.63H590.11L588.99 463.32L584.22 444.96L583.56 442.43L576.78 436.24L567.52 451.26L567.11 451.93Z"
          fill="black"
        />
        <path
          id="Vector_116"
          opacity="0.1"
          d="M567.11 451.93L574.41 461.42L579.18 467.63H590.11L588.99 463.32L584.22 444.96L583.56 442.43L576.78 436.24L567.52 451.26L567.11 451.93Z"
          fill="black"
        />
        <path
          id="Vector_117"
          d="M530.78 518.24C530.78 518.24 535.49 519.96 541.78 522.36C551.78 526.21 565.88 531.83 570.78 534.91C575.68 537.99 593.95 543.05 607.63 546.61C617.771 549.24 628.213 550.531 638.69 550.45C649.33 550.35 662.22 550.25 665.78 550.25C666.403 550.245 667.025 550.292 667.64 550.39C671.38 551.01 671.23 553.52 671.14 554.12V554.25C649.14 567.58 622.47 627.25 620.81 637.25C619.56 644.75 608.57 665.54 603.15 675.48C601.33 678.81 600.15 680.92 600.15 680.92L606.82 688.58L626.14 697.24L644.47 705.24C644.47 705.24 663.81 706.24 664.14 705.24C664.47 704.24 664.47 693.91 664.47 693.91C662.116 692.391 659.883 690.692 657.79 688.83C653.355 684.968 649.235 680.758 645.47 676.24C634.81 663.57 656.14 639.24 656.14 639.24L697.14 585.91C697.14 585.91 700.47 579.91 716.47 555.91C732.47 531.91 716.47 518.91 716.47 518.91L690.81 504.24C650.81 479.91 594.47 465.91 594.47 465.91L593.63 465.8L581.14 464.24L530.78 518.24Z"
          fill="#EFB7B9"
        />
        <path
          id="Vector_118"
          opacity="0.1"
          d="M600.14 680.91L606.81 688.57L626.14 697.24L644.47 705.24C644.47 705.24 663.81 706.24 664.14 705.24C664.47 704.24 664.47 693.91 664.47 693.91C662.116 692.391 659.883 690.692 657.79 688.83C655.72 689.94 653.37 692.02 655.64 695.24C655.64 695.24 659.14 699.36 656.52 699.74C653.9 700.12 647.02 698.62 647.02 698.62L603.39 675.62L603.14 675.45C601.3 678.8 600.14 680.91 600.14 680.91Z"
          fill="black"
        />
        <path
          id="Vector_119"
          d="M656.61 697.24C656.61 697.24 660.11 701.36 657.48 701.74C654.85 702.12 647.98 700.61 647.98 700.61L604.36 677.61C604.36 677.61 599.61 674.24 598.48 680.86C597.35 687.48 596.61 686.86 596.61 686.86C596.61 686.86 590.86 699.24 596.61 701.8C602.36 704.36 636.86 714.45 636.86 714.45C636.86 714.45 686.98 725.82 691.73 712.7C696.48 699.58 683.23 701.82 683.23 701.82C683.23 701.82 666.73 697.82 661.11 689.82C661.14 689.86 652.98 692.11 656.61 697.24Z"
          fill="#444053"
        />
        <path
          id="Vector_120"
          opacity="0.1"
          d="M533.44 253.57C539.22 257.57 548.04 263.9 555.57 263.9C557.512 263.9 559.452 263.746 561.37 263.44C564.155 258.058 567.299 252.87 570.78 247.91C570.78 247.91 526.78 217.24 536.78 236.91C540.08 243.45 536.83 246.66 533.44 253.57Z"
          fill="black"
        />
        <path
          id="Vector_121"
          d="M519.57 225.9C519.565 231.904 521.064 237.813 523.931 243.089C526.797 248.364 530.94 252.837 535.98 256.1C537.111 256.838 538.287 257.506 539.5 258.1C546.507 261.596 554.463 262.711 562.162 261.277C569.86 259.843 576.881 255.938 582.16 250.154C587.439 244.37 590.688 237.023 591.415 229.226C592.141 221.429 590.306 213.608 586.186 206.948C582.067 200.288 575.888 195.153 568.587 192.322C561.286 189.49 553.261 189.116 545.729 191.257C538.196 193.398 531.567 197.936 526.846 204.184C522.126 210.432 519.571 218.049 519.57 225.88V225.9Z"
          fill="#EFB7B9"
        />
        <path
          id="Vector_122"
          opacity="0.1"
          d="M530.78 518.24C530.78 518.24 535.49 519.96 541.78 522.36C545.73 518.88 549.78 515.52 551.47 514.91C555.14 513.57 567.14 506.57 566.81 504.57C566.48 502.57 571.81 494.91 576.47 493.57C581.13 492.23 578.47 485.24 578.47 485.24C578.47 485.24 587.47 481.91 589.71 477.24C591.95 472.57 598.81 466.57 596.47 466.91C595.455 466.745 594.487 466.367 593.63 465.8L581.14 464.24L530.78 518.24Z"
          fill="black"
        />
        <path
          id="Vector_123"
          d="M503.44 506.24C503.44 506.24 518.78 518.91 519.49 524.57C520.2 530.23 530.44 529.91 530.44 529.91C530.44 529.91 545.78 515.24 549.44 513.91C553.1 512.58 565.11 505.57 564.78 503.57C564.45 501.57 569.78 493.91 574.44 492.57C579.1 491.23 576.44 484.24 576.44 484.24C576.44 484.24 585.44 480.91 587.68 476.24C589.92 471.57 596.78 465.57 594.44 465.91C593.78 466 591.67 464.91 588.99 463.32C585.7 461.32 581.53 458.61 578.13 456.32C574.53 453.88 571.78 451.94 571.78 451.94C571.78 451.94 570.21 451.66 567.52 451.27C553.01 449.17 505.75 443.81 494.78 461.27C493.318 463.577 492.221 466.097 491.53 468.74C486.62 487.34 503.44 506.24 503.44 506.24Z"
          fill="#444053"
        />
        <path
          id="Vector_124"
          opacity="0.1"
          d="M519.48 465.82C519.48 465.82 503.82 474.66 497.98 474.66C492.14 474.66 519.48 465.82 519.48 465.82Z"
          fill="black"
        />
        <path
          id="Vector_125"
          opacity="0.1"
          d="M529.94 472.57C529.94 472.57 506.62 480.41 506.62 486.57C506.62 492.73 504.44 470.07 529.94 472.57Z"
          fill="black"
        />
        <path
          id="Vector_126"
          opacity="0.1"
          d="M585.77 437.26L585.44 437.71C585.59 437.594 585.705 437.438 585.77 437.26V437.26Z"
          fill="black"
        />
        <path
          id="Vector_127"
          opacity="0.1"
          d="M513.44 283.91L514.96 285.83L515.81 286.9L521.11 293.57C521.11 293.57 533.76 297.63 544.85 300.26C556.4 302.99 566.25 304.18 558.42 297.65C553.56 293.6 553.24 286.82 555.01 279.55L554.66 279.1C554.66 279.1 555.01 285.84 551.02 285.97C545.64 286.14 545.57 284.33 540.61 282.24C534.22 279.54 527.67 275.03 525.83 271.52C522.037 275.974 517.894 280.117 513.44 283.91Z"
          fill="black"
        />
        <path
          id="Vector_128"
          opacity="0.1"
          d="M491.53 468.71C494.258 469.876 497.33 469.948 500.11 468.91C510.44 465.57 526.78 457.53 534.44 461.05C540.58 463.87 565.31 463.79 574.44 461.42C576.71 460.83 578.01 460.1 577.81 459.24C577.681 458.249 577.801 457.242 578.16 456.31C579.22 452.92 582.1 448.21 584.25 444.96L583.59 442.43L576.81 436.24L567.55 451.24C553.04 449.14 505.78 443.78 494.81 461.24C493.337 463.546 492.231 466.065 491.53 468.71Z"
          fill="black"
        />
        <path
          id="Vector_129"
          d="M484.78 460.91C484.78 460.91 488.78 470.24 499.11 466.91C509.44 463.58 525.78 455.53 533.44 459.05C541.1 462.57 577.78 461.57 576.78 457.24C575.78 452.91 585.78 439.24 585.78 439.24C585.78 439.24 580.32 438.24 576.94 420.41C576.44 417.81 575.99 414.85 575.61 411.49C574.784 404.609 574.59 397.667 575.03 390.75C576.38 371.45 583.14 363.57 583.14 363.57C583.14 363.57 592.47 352.91 584.47 338.24C580.28 330.55 563.37 309.24 563.14 299.74C562.93 291.12 554.69 281.1 554.69 281.1C554.69 281.1 555.04 287.84 551.05 287.97C545.67 288.14 545.6 286.33 540.64 284.24C533.35 281.16 525.86 275.73 525.37 272.1C525.37 272.1 494.81 270.57 488.14 301.57C481.47 332.57 483.81 349.57 484.81 353.24C485.81 356.91 494.47 404.24 487.47 424.24C480.47 444.24 484.78 460.91 484.78 460.91Z"
          fill="#A36468"
        />
        <path
          id="Vector_130"
          opacity="0.1"
          d="M534.61 406.45C540.122 415.748 547.496 423.807 556.27 430.12C562.121 430.169 567.964 430.559 573.77 431.29C573.27 428.69 572.77 425.73 572.44 422.37C571.614 415.489 571.42 408.547 571.86 401.63C570.9 401.149 570.054 400.468 569.378 399.633C568.702 398.798 568.212 397.829 567.94 396.79C566.27 391.12 551.4 364.12 551.4 364.12C551.4 364.12 516.61 355.12 515.4 364.12C514.19 373.12 525.94 391.45 534.61 406.45Z"
          fill="black"
        />
        <path
          id="Vector_131"
          d="M546.14 347.29C546.14 347.29 567.14 387.02 568.77 392.69C569.194 394.264 570.11 395.662 571.383 396.68C572.656 397.698 574.221 398.283 575.85 398.35C575.85 398.35 596.77 403.35 601.77 404.02C606.77 404.69 650.14 408.35 650.14 408.35C650.14 408.35 661.14 408.69 662.47 404.69C663.69 401.03 684.94 381.8 697.24 398.58C698.374 400.132 699.126 401.93 699.435 403.827C699.745 405.725 699.602 407.668 699.02 409.5C696.76 416.7 692.12 428.13 687.14 421.02C680.14 411.02 672 413.83 672 419.16C672 424.49 660.8 422.51 657.14 423.26C655.14 423.67 648.26 425.5 642.31 427.1C635.387 428.97 628.296 430.146 621.14 430.61C609.33 431.38 591.92 432.02 585.75 429.69C578.31 426.86 565.32 426.21 559.75 426.06C557.908 426.015 556.13 425.377 554.68 424.24C546.966 418.198 540.442 410.775 535.44 402.35C526.77 387.35 508.94 356.29 510.14 347.29C511.34 338.29 546.14 347.29 546.14 347.29Z"
          fill="#EFB7B9"
        />
        <path
          id="Vector_132"
          opacity="0.1"
          d="M539.14 292.24C539.14 292.24 550.39 310.91 555.6 324.24C560.81 337.57 567.14 360.91 567.14 360.91L535.8 357.24L533.14 352.91C533.14 352.91 510.76 366.91 513.43 372.91C516.1 378.91 507.43 363.91 508.1 346.91C508.77 329.91 505.69 299.57 508.1 292.24C510.51 284.91 531.77 286.57 539.14 292.24Z"
          fill="black"
        />
        <path
          id="Vector_133"
          d="M508.14 344.91C507.47 361.91 516.14 376.91 513.47 370.91C510.8 364.91 533.18 350.91 533.18 350.91L535.81 355.24L567.14 358.91C567.14 358.91 560.81 335.57 555.6 322.24C552.47 314.699 548.89 307.352 544.88 300.24C541.67 294.41 539.14 290.24 539.14 290.24C534.83 286.91 525.68 284.96 518.38 285.42C517.242 285.485 516.11 285.622 514.99 285.83C511.99 286.42 509.57 287.56 508.5 289.36C508.336 289.639 508.202 289.934 508.1 290.24C505.7 297.57 508.78 327.91 508.14 344.91Z"
          fill="#A36468"
        />
        <path
          id="Vector_134"
          opacity="0.1"
          d="M494.14 391.45C494.14 391.45 507.39 409.7 511.39 410.2C511.36 410.24 494.36 406.45 494.14 391.45Z"
          fill="black"
        />
        <path
          id="Vector_135"
          opacity="0.1"
          d="M494.14 417.45C494.14 417.45 519.14 442.7 527.14 442.95C535.14 443.2 494.14 417.45 494.14 417.45Z"
          fill="black"
        />
        <path
          id="Vector_136"
          opacity="0.1"
          d="M494.14 427.99C494.14 427.99 510.14 446.74 511.14 446.74C512.14 446.74 493.86 440.24 494.14 427.99Z"
          fill="black"
        />
        <path
          id="Vector_137"
          opacity="0.1"
          d="M508.47 289.36C511.042 288.977 513.526 288.144 515.81 286.9C516.67 286.45 517.52 285.95 518.35 285.42C521.629 283.226 524.684 280.713 527.47 277.92C532.07 273.45 536.66 268.57 538.56 262.44C538.987 261.027 539.302 259.583 539.5 258.12C540.64 250.43 539.68 241.94 545.18 236.71C546.213 235.735 547.399 234.934 548.69 234.34C556.49 230.63 567.8 233.03 573.62 226.34C577.32 222.1 577.23 216.21 580.07 211.6C581.31 209.6 583.59 207.87 585.61 206.03C582.668 201.552 578.764 197.786 574.182 195.009C569.599 192.232 564.455 190.512 559.124 189.976C553.792 189.44 548.409 190.1 543.365 191.91C538.322 193.719 533.746 196.631 529.971 200.434C526.196 204.237 523.318 208.834 521.546 213.891C519.775 218.948 519.154 224.337 519.73 229.664C520.305 234.991 522.063 240.122 524.874 244.684C527.686 249.245 531.48 253.121 535.98 256.03C535.76 256.54 535.52 257.03 535.27 257.56C528.4 271.56 513.44 283.84 513.44 283.84L514.96 285.76C511.93 286.45 509.54 287.56 508.47 289.36Z"
          fill="black"
        />
        <path
          id="Vector_138"
          opacity="0.1"
          d="M671.14 554.11L679.55 550.04V548.45C679.55 547.84 672.84 549.19 667.64 550.34C671.38 551 671.23 553.51 671.14 554.11Z"
          fill="black"
        />
      </g>
      <path
        id="bike-0"
        d="M678.45 462.15C689.639 462.15 698.71 451.114 698.71 437.5C698.71 423.886 689.639 412.85 678.45 412.85C667.261 412.85 658.19 423.886 658.19 437.5C658.19 451.114 667.261 462.15 678.45 462.15Z"
        fill="#FED448"
      />
      <g id="hair">
        <path
          id="Vector_139"
          d="M571.62 225.36C564.85 233.12 550.62 228.6 543.17 235.71C536.63 241.94 539.23 252.81 536.56 261.44C534.66 267.57 530.07 272.44 525.47 276.92C518.77 283.44 510.2 290.06 501.04 288.19C495.61 287.08 490.29 283.02 485.04 284.89C482.43 285.83 480.56 288.09 478.61 290.08C471.986 296.83 463.377 301.284 454.04 302.79C452.194 303.206 450.269 303.117 448.47 302.53C445.67 301.39 444.16 298.33 441.61 296.7C436.61 293.5 430.19 296.78 425 299.64C410.485 307.499 394.463 312.176 378 313.361C361.537 314.546 345.01 312.21 329.52 306.51L337.61 302.51C335.89 299 331.24 298.23 328.28 295.66C322.18 290.37 325.77 279.79 332.22 274.94C338.67 270.09 347.02 268.4 353.7 263.87C355.06 262.95 356.44 261.73 356.57 260.1C356.548 258.903 356.168 257.74 355.48 256.76C351.92 250.49 347.98 243.76 348.78 236.59C350 225.59 362.01 218.83 373.04 218.06C384.07 217.29 394.99 220.61 406.04 220.8C410.04 220.87 414.23 220.48 417.66 218.41C422.45 215.53 424.86 210.04 427.77 205.27C432.964 196.801 440.407 189.939 449.27 185.45C459.27 180.4 470.59 178.63 480.99 174.45C491.61 170.19 501.27 163.45 512.38 160.74C528.51 156.74 545.79 161.97 559.72 171.01C566.43 175.36 587.86 189.32 587.72 198.25C587.61 203.55 580.72 206.42 578.11 210.58C575.23 215.23 575.32 221.12 571.62 225.36Z"
          fill="#965D7B"
        />
        <g id="Group" opacity="0.1">
          <path
            id="Vector_140"
            opacity="0.1"
            d="M354.5 251.75C355.184 252.732 355.563 253.894 355.59 255.09C355.55 255.512 355.431 255.922 355.24 256.3C352.3 251.12 349.24 245.63 348.75 239.85C350.05 243.98 352.34 247.95 354.5 251.75Z"
            fill="black"
          />
          <path
            id="Vector_141"
            opacity="0.1"
            d="M327.3 290.65C330.25 293.22 334.9 293.99 336.63 297.5L333.77 298.92C331.843 298.014 330.011 296.918 328.3 295.65C327.216 294.684 326.369 293.479 325.828 292.131C325.287 290.783 325.065 289.328 325.18 287.88C325.69 288.939 326.411 289.881 327.3 290.65V290.65Z"
            fill="black"
          />
          <path
            id="Vector_142"
            opacity="0.1"
            d="M424.02 294.64C429.21 291.78 435.64 288.5 440.63 291.7C443.17 293.33 444.69 296.39 447.49 297.53C449.286 298.117 451.207 298.207 453.05 297.79C462.389 296.284 471.002 291.83 477.63 285.08C479.57 283.08 481.44 280.83 484.06 279.89C489.28 278.02 494.6 282.08 500.06 283.19C509.22 285.06 517.78 278.44 524.49 271.92C529.09 267.45 533.67 262.57 535.57 256.44C538.25 247.81 535.65 236.94 542.19 230.71C549.66 223.6 563.86 228.12 570.64 220.36C574.33 216.12 574.25 210.23 577.09 205.62C579.49 201.73 585.71 198.97 586.59 194.28C587.277 195.504 587.658 196.877 587.7 198.28C587.59 203.58 580.7 206.45 578.09 210.61C575.25 215.22 575.33 221.11 571.64 225.35C564.86 233.11 550.64 228.59 543.19 235.7C536.65 241.93 539.25 252.8 536.57 261.43C534.67 267.56 530.09 272.43 525.49 276.91C518.78 283.43 510.22 290.05 501.06 288.18C495.62 287.07 490.3 283.01 485.06 284.88C482.44 285.82 480.57 288.08 478.63 290.07C472.002 296.82 463.389 301.274 454.05 302.78C452.207 303.197 450.286 303.107 448.49 302.52C445.69 301.38 444.17 298.32 441.63 296.69C436.63 293.49 430.21 296.77 425.02 299.63C410.505 307.489 394.483 312.166 378.02 313.351C361.557 314.536 345.03 312.2 329.54 306.5L335.13 303.73C349.815 308.142 365.227 309.61 380.482 308.05C395.736 306.49 410.532 301.933 424.02 294.64V294.64Z"
            fill="black"
          />
        </g>
      </g>
      <g id="box">
        <path
          id="Vector_143"
          d="M483.45 405.42L450.88 437.54L343.81 435.67L373.25 405.42H483.45Z"
          fill="#DDA2A6"
        />
        <path
          id="Vector_144"
          d="M483.45 515.3V405.42L450.88 437.54V545.06L483.45 515.3Z"
          fill="#B77B7F"
        />
        <path
          id="Vector_145"
          d="M343.81 435.67V545.06H450.88V437.54L343.81 435.67Z"
          fill="#DDA2A6"
        />
        <path
          id="Vector_146"
          opacity="0.3"
          d="M343.81 435.67V545.06H450.88V437.54L343.81 435.67Z"
          fill="white"
        />
        <path
          id="Vector_147"
          d="M442.18 467.65L362.55 453.98L352.17 506.26L434.15 521.32L442.18 467.65Z"
          fill="#DCE0ED"
        />
        <path
          id="Vector_148"
          d="M426.45 479.86L372.92 471.45L371.58 478.43L425.11 487.51L426.45 479.86Z"
          fill="#FED448"
        />
        <path
          id="Vector_149"
          d="M411.73 494.79L381.28 490.37L379.94 498.12L411.73 502.58V494.79Z"
          fill="#FED448"
        />
        <path
          id="Vector_150"
          d="M470.28 463.09L468.83 419.83L460.46 428.09L461.92 471.45L470.28 463.09Z"
          fill="#65617D"
        />
        <path
          id="Vector_151"
          d="M362.48 416.49L465.37 417.88L468.83 419.83L460.46 428.09L457.57 426.39L355.66 423.5L362.48 416.49Z"
          fill="#65617D"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="1056.29" height="808.9" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const WalletSvg = (props) => (
  <svg
    width={props.size}
    style={props.style}
    viewBox="0 0 328 208"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        x1="0%"
        y1="30.5415598%"
        x2="100%"
        y2="69.4584402%"
        id={"linearGradient-1" + props.id}
      >
        <stop stopColor="#FFEB75" offset="0%"></stop>
        <stop stopColor="#FECF34" offset="100%"></stop>
      </linearGradient>
      <rect
        id={"path-2" + props.id}
        x="0.498442368"
        y="0.497512438"
        width="319.003115"
        height="199.004975"
        rx="6"
      ></rect>
      <filter
        x="-2.2%"
        y="-2.5%"
        width="104.4%"
        height="107.0%"
        filterUnits="objectBoundingBox"
        id={"filter-4" + props.id}
      >
        <feOffset
          dx="0"
          dy="2"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="2"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="100%"
        id={"linearGradient-5" + props.id}
      >
        <stop stopColor="#FFFFFF" stopOpacity="0.19921875" offset="0%"></stop>
        <stop
          stopColor="#FFFFFF"
          stopOpacity="0.639204545"
          offset="100%"
        ></stop>
      </linearGradient>
      <text
        id={"text-6" + props.id}
        fontFamily="OpenSans-Bold, Open Sans"
        fontSize="16"
        fontWeight="bold"
        fill="#FED448"
      >
        <tspan x="12.4610592" y="79.1343284">
          {props.title}
        </tspan>
      </text>
      <filter
        x="-1.9%"
        y="-9.1%"
        width="103.7%"
        height="118.2%"
        filterUnits="objectBoundingBox"
        id={"filter-7" + props.id}
      >
        <feGaussianBlur
          stdDeviation="1.5"
          in="SourceAlpha"
          result="shadowBlurInner1"
        ></feGaussianBlur>
        <feOffset
          dx="0"
          dy="1"
          in="shadowBlurInner1"
          result="shadowOffsetInner1"
        ></feOffset>
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner1"
        ></feComposite>
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
          type="matrix"
          in="shadowInnerInner1"
        ></feColorMatrix>
      </filter>
      <filter
        x="-1.9%"
        y="-9.1%"
        width="103.7%"
        height="118.2%"
        filterUnits="objectBoundingBox"
        id={"filter-8" + props.id}
      >
        <feGaussianBlur
          stdDeviation="1.5"
          in="SourceAlpha"
          result="shadowBlurInner1"
        ></feGaussianBlur>
        <feOffset
          dx="0"
          dy="1"
          in="shadowBlurInner1"
          result="shadowOffsetInner1"
        ></feOffset>
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner1"
        ></feComposite>
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
          type="matrix"
          in="shadowInnerInner1"
        ></feColorMatrix>
      </filter>
    </defs>
    <g
      id={"website" + props.id}
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id={"13---Merchant-Wallet" + props.id}
        transform="translate(-506.000000, -243.000000)"
      >
        <g
          id={"Admin-credit-card" + props.id}
          transform="translate(510.000000, 245.000000)"
        >
          <g id={"card" + props.id}>
            <mask id={"mask-3" + props.id} fill="white">
              <use href={"#path-2" + props.id}></use>
            </mask>
            <g id={"Mask" + props.id}>
              <use
                fill="black"
                fillOpacity="1"
                filter={"url(#filter-4" + props.id + ")"}
                href={"#path-2" + props.id}
              ></use>
              <use
                fill={"url(#linearGradient-1" + props.id + ")"}
                fillRule="evenodd"
                href={"#path-2" + props.id}
              ></use>
            </g>
            <line
              x1="0.498442368"
              y1="199.502488"
              x2="319.501558"
              y2="0.497512438"
              id={"Line-2" + props.id}
              strokeOpacity="0.19921875"
              stroke="#FFFFFF"
              strokeWidth="20"
              strokeLinecap="square"
              strokeLinejoin="bevel"
              mask={"url(#mask-3" + props.id + ")"}
            ></line>
            <line
              x1="-7.47663551"
              y1="164.676617"
              x2="288.598131"
              y2="-19.4029851"
              id={"Line-2" + props.id}
              stroke={"url(#linearGradient-5" + props.id + ")"}
              strokeWidth="20"
              strokeLinecap="square"
              strokeLinejoin="bevel"
              mask={"url(#mask-3" + props.id + ")"}
            ></line>
          </g>
          <g
            id={"logo/primaryBlack" + props.id}
            transform="translate(12.461059, 12.437811)"
          >
            <g id={"logo" + props.id}>
              <path
                d="M16.9924662,20.6952806 C17.782545,20.8535966 18.447373,21.3928684 18.7745262,22.1407892 C18.9983254,22.6143411 19.0467068,23.154015 18.9108014,23.6608819 C18.8653763,23.8349112 18.8688706,23.9343566 19.0750305,23.9840792 C19.6344384,24.0884259 20.1299061,24.4149778 20.4518688,24.8915232 C20.7738315,25.3680685 20.895763,25.9553452 20.7907,26.5234864 C20.7592519,26.7436867 20.8361251,26.8005126 21.0073426,26.8573385 C21.7809481,27.0939796 22.3852367,27.7107845 22.6147939,28.4980841 C22.844351,29.2853838 22.6682917,30.1372534 22.1464633,30.7641188 C21.0981927,32.0498046 19.9695547,33.2964227 18.8059743,34.4862149 C17.3404653,35.9737865 15.4518735,36.955333 13.4073808,37.2919934 C10.632958,37.78922 8.06120082,37.2919934 5.78994788,35.5445972 C3.86462423,34.0458142 2.83382482,32.000082 2.44596471,29.6098428 C2.30483268,28.8238748 2.24162003,28.0254999 2.257276,27.2267068 C2.28545233,25.645004 1.82068101,24.0947733 0.929466588,22.7978387 C0.597090878,22.3286107 0.325786617,21.8176793 0.122298235,21.277746 C-0.11836942,20.5535751 0.00805737565,19.7553397 0.460163734,19.1445258 C0.912270093,18.5337119 1.63180696,18.1890162 2.38306847,18.2233541 C2.97691712,18.2750576 3.53260476,18.5423353 3.94848588,18.9762972 C4.73850314,19.7590536 5.40973403,20.6567563 5.9402,21.6400111 C5.99610776,21.7323531 6.05201553,21.8282468 6.11491176,21.9170373 C6.57265659,22.598948 7.02690717,22.701945 7.75370812,22.3219218 C8.63941024,21.8215901 9.46094661,21.2120198 10.1996728,20.5070448 C12.4010411,18.550103 14.4416745,16.4262352 16.4508598,14.2704028 C17.2092588,13.3635191 18.5029636,13.1498773 19.5048214,13.766073 C20.1389751,14.1522056 20.5652159,14.811259 20.662515,15.5560983 C20.7598141,16.3009376 20.5175443,17.050211 20.0044971,17.591166 C19.0925016,18.5465514 18.1595408,19.4770754 17.2335685,20.4324608 L16.9924662,20.6952806 Z M19.3510751,32.344589 L19.0575593,32.2273856 C18.1684008,31.9003702 17.564012,31.0569182 17.5305785,30.0964145 C17.5305785,29.8016302 17.4537053,29.645359 17.1497068,29.6524622 C17.1001826,29.6506679 17.0509865,29.6435244 17.0029489,29.6311525 C15.7939004,29.369446 14.9869466,28.2056822 15.1510042,26.9603354 C15.1824523,26.7543416 15.1195561,26.6726544 14.9273732,26.6300349 C14.075748,26.4310348 13.3981391,25.7767552 13.158941,24.922488 C12.919743,24.0682207 13.1568591,23.1493332 13.7777698,22.524364 C15.5458528,20.7130386 17.3244186,18.9159197 19.0959959,17.1116976 C19.210725,16.9995389 19.3192145,16.8809677 19.4209598,16.7565357 C19.8843958,16.1615395 19.8059246,15.3013841 19.2427538,14.8031456 C18.6033087,14.2490931 17.7821634,14.3165739 17.1462126,14.9913814 C16.1328843,16.0568669 15.1405215,17.1223524 14.1062279,18.1878379 C12.5408105,19.7647565 10.9614161,21.3416751 9.15489647,22.6238094 C8.64225142,22.9743123 8.09108798,23.2627633 7.51260588,23.483301 C7.247044,23.5898496 7.21909012,23.6715368 7.26102094,23.9165985 C7.43581179,24.8311118 7.25008628,25.778816 6.74387412,26.5554509 C6.62226669,26.8006046 6.3281878,26.8991807 6.08695788,26.7756513 C5.85492649,26.6365904 5.76799619,26.3389638 5.88778647,26.0937406 C5.9506827,25.9374693 6.04153282,25.791853 6.11141753,25.6391334 C6.54754017,24.7885349 6.41798634,23.7520749 5.78645365,23.0393487 C5.40165418,22.5588303 5.05132826,22.0508242 4.73818306,21.519256 C4.2978345,20.8032007 3.76156479,20.1529341 3.14481176,19.5871756 C2.75489472,19.1925216 2.15536708,19.1071225 1.67373871,19.3776301 C1.07971871,19.732792 0.800179882,20.2619831 1.009834,20.8835163 C1.20453542,21.3636541 1.45185763,21.8199573 1.74711765,22.2437862 C2.34414309,23.098332 2.77034275,24.0636775 3.00154812,25.0850809 C3.12621232,25.9520531 3.19391743,26.8265033 3.20421376,27.7026237 C3.25129062,29.2343148 3.59814843,30.7411209 4.22453047,32.1350435 C4.85349282,33.5308295 7.0793207,34.6957604 8.8019787,33.3532486 C9.26373675,32.9661962 9.68736827,32.5344182 10.0668919,32.0640111 C10.3569134,31.730159 10.6294638,31.6165072 10.8880372,31.8189495 C11.1466106,32.0213917 11.1221509,32.3019696 10.8496006,32.660683 C10.6748888,32.8879866 10.5001771,33.125945 10.3079941,33.3354905 C9.50781423,34.1807757 8.60280729,34.8413767 7.40079035,34.9479253 C7.21210165,34.9479253 7.02690717,34.9940963 6.80327612,35.0225093 C10.4477635,37.5761229 16.1678267,36.7201829 19.3510751,32.344589 Z M15.4829566,25.7350271 C15.6881371,25.6579241 15.8858281,25.5616167 16.0734823,25.447346 C16.4583463,25.1531406 16.8280595,24.8389989 17.1811549,24.5061671 C17.4278921,24.3030547 17.6434156,24.0636417 17.8206,23.7958434 C18.1874238,23.185517 18.0236289,22.3904356 17.4467168,21.9809664 C16.9414194,21.5803952 16.2328505,21.5803952 15.7275531,21.9809664 C15.2488428,22.4213671 14.8015807,22.9008356 14.3648013,23.4016138 C13.9892282,23.7846603 13.9080328,24.3739448 14.1656299,24.8471225 C14.3970269,25.3786939 14.9111501,25.7252232 15.4829566,25.7350271 Z M19.9171412,26.1860826 L19.8437622,26.1470148 C19.860697,25.6854084 19.5950169,25.2612568 19.1763633,25.0815293 C18.7611755,24.865448 18.2586849,24.9257829 17.9044616,25.2342489 C17.4746707,25.5894107 17.0623509,25.9445726 16.63256,26.2997344 C16.3211269,26.5416899 16.1352828,26.9148204 16.1277983,27.3131757 C16.1203137,27.711531 16.2920061,28.0916016 16.5941234,28.3454666 C17.0413855,28.732593 17.7437268,28.7965222 18.0791734,28.4591184 C18.5753548,27.9618918 19.0750305,27.4646653 19.5362695,26.9354741 C19.6945137,26.703431 19.822535,26.4515402 19.9171412,26.1860826 Z M20.2665647,27.7594496 C20.1783028,27.7819587 20.0952155,27.8217717 20.0219682,27.876653 C19.6096485,28.2779859 19.2008229,28.6828704 18.8094686,29.1090646 C18.4535308,29.4915964 18.3724186,30.0601778 18.6068029,30.529712 C18.8254424,31.0274525 19.3109678,31.3485742 19.8472565,31.3501358 C20.0878672,31.3302931 20.3180393,31.2416376 20.5111612,31.0944193 C20.8233806,30.8059875 21.1109408,30.4911303 21.3707431,30.1532404 C21.7451449,29.7444769 21.8365204,29.1450042 21.6013626,28.640251 C21.3748219,28.0974143 20.846598,27.7488519 20.2665647,27.7594496 Z"
                id={"Shape" + props.id}
                fill="#161616"
                fillRule="nonzero"
              ></path>
              <path
                d="M1.00633976,9.44375339 C1.11695004,9.49166052 1.22044487,9.55501627 1.31383247,9.63198916 C2.89322682,11.2231142 4.46679745,12.8177909 6.03454435,14.4160192 C6.14253008,14.5072348 6.20999421,14.6386746 6.22181757,14.780882 C6.23364093,14.9230893 6.18883482,15.0641725 6.09744059,15.1725139 C5.99435569,15.2754789 5.85336293,15.3295375 5.70905494,15.3214263 C5.56474695,15.3133151 5.43047818,15.2437847 5.33919153,15.1298945 C3.78425682,13.5529759 2.23281635,11.9796089 0.698847059,10.3920355 C0.574129698,10.2446192 0.499396548,10.0603218 0.485698706,9.86639598 C0.461239059,9.62133431 0.698847059,9.447305 1.00633976,9.44375339 Z"
                id={"Path" + props.id}
                fill="#161616"
                fillRule="nonzero"
              ></path>
              <path
                d="M9.23526388,9.12765935 C9.26198738,9.40444005 9.07746193,9.65656419 8.80896717,9.71012477 C8.5643707,9.74208933 8.35821082,9.57871489 8.27434917,9.25551761 C8.09963741,8.57005525 7.92492564,7.88104128 7.76768506,7.19557892 C7.41360255,5.76072508 7.06417902,4.32823898 6.71941447,2.89812063 C6.68689705,2.77301216 6.67160969,2.64392388 6.67398941,2.51454584 C6.66758267,2.30165867 6.81678171,2.11664661 7.02341294,2.0812484 C7.22953486,2.01148154 7.45446706,2.10902868 7.54754823,2.30855197 C7.59119654,2.39724268 7.62630235,2.49001674 7.65237529,2.58557821 C8.1741811,4.69523956 8.69365741,6.8049009 9.21080423,8.91456224 C9.2177927,9.0033527 9.22827541,9.09214316 9.23526388,9.12765935 Z"
                id={"Path" + props.id}
                fill="#161616"
                fillRule="nonzero"
              ></path>
              <path
                d="M15.0985907,8.83997825 C15.0985907,7.73897654 15.0985907,6.63797483 15.0985907,5.54052474 C15.099151,5.34596208 15.1686129,5.15810873 15.2942679,5.01133359 C15.4116445,4.91368768 15.5707112,4.88553685 15.71365,4.93711344 C15.8565887,4.98869003 15.9625865,5.11248404 15.9931149,5.2634985 C16.0165501,5.37068815 16.0259493,5.48055509 16.0210688,5.5902474 C16.0210688,7.77094111 16.0210688,9.95045095 16.0210688,12.1287769 C16.0210688,12.4839388 15.8358743,12.7254488 15.5423586,12.7290385 C15.2488428,12.732552 15.0531656,12.4874904 15.0531656,12.1074672 C15.0531656,11.0159365 15.0531656,9.92677349 15.0531656,8.83997825 L15.0985907,8.83997825 Z"
                id={"Path" + props.id}
                fill="#161616"
                fillRule="nonzero"
              ></path>
              <path
                d="M8.90331153,13.49615 C9.04308094,13.49615 9.10248294,13.4748403 9.1583907,13.4748403 C9.77687035,13.4748403 10.2346152,13.25464 10.4023385,12.5975905 C10.4387147,12.5069845 10.4856388,12.421134 10.5421079,12.341874 C10.6748888,12.6153486 10.7936928,12.8497555 10.8915314,13.0877139 C10.9423736,13.2532853 11.0913265,13.3675487 11.2619203,13.3718434 C11.5309765,13.3931531 11.8000326,13.4535306 12.1529503,13.5103565 C11.9293193,13.7341084 11.7546075,13.9258958 11.5659188,14.0963735 C11.3937559,14.2199841 11.3213975,14.4435082 11.3877128,14.6468744 C11.4506091,14.8954877 11.4680802,15.1547558 11.5135053,15.4530918 C11.2514376,15.311027 11.0208181,15.2009268 10.8146582,15.069517 C10.6531469,14.9463942 10.4310688,14.9463942 10.2695575,15.069517 C10.0668919,15.2009268 9.84326082,15.3003722 9.54275659,15.4566434 C9.59517012,15.144101 9.623124,14.9132458 9.67553753,14.6859422 C9.75077573,14.4538966 9.66862949,14.1990921 9.47287188,14.0573057 C9.28767741,13.9116894 9.12694259,13.7234536 8.90331153,13.49615 Z"
                id={"Path" + props.id}
                fill="#161616"
                fillRule="nonzero"
              ></path>
              <path
                d="M3.92402623,5.73941537 C4.27344976,6.3041227 4.71721765,6.3609486 5.26231835,6.15495473 C4.89190694,6.57918842 4.9134121,7.22400904 5.31123765,7.62177314 C4.80344068,7.40484672 4.21768701,7.63359532 3.98342823,8.14030943 C4.00960608,7.86045229 3.92091032,7.58203088 3.73831507,7.37088423 C3.55571983,7.15973759 3.29543806,7.03461381 3.01901929,7.02510124 C3.27501398,6.90608221 3.51087702,6.74665748 3.71786635,6.55273599 C3.83070984,6.29520506 3.90039067,6.02030744 3.92402623,5.73941537 L3.92402623,5.73941537 Z"
                id={"Path" + props.id}
                fill="#161616"
                fillRule="nonzero"
              ></path>
              <path
                d="M11.5309765,5.07171111 C11.9208877,5.45419985 12.5387593,5.45419985 12.9286706,5.07171111 C12.8452762,5.34017311 12.8097753,5.62162741 12.8238435,5.90278982 C12.8867398,6.12654178 13.1313362,6.29701946 13.3444846,6.54563275 C12.7574531,6.51721981 12.296214,6.66283616 12.1319849,7.32343719 C12.0525415,6.76845141 11.5508419,6.38007707 11.0033469,6.44973906 C11.4785629,6.09812883 11.7476191,5.70034757 11.5309765,5.07171111 Z"
                id={"Path" + props.id}
                fill="#161616"
                fillRule="nonzero"
              ></path>
              <line
                x1="46.1239059"
                y1="0"
                x2="46.1239059"
                y2="39.7781263"
                id={"Path" + props.id}
                stroke="#161616"
                strokeWidth="1.20000005"
              ></line>
              <path
                d="M62.8717756,21.1108199 C62.8199003,21.5825239 62.7942351,22.0568259 62.7949025,22.5314673 C62.7949025,27.0065065 64.6328702,28.6686639 66.886652,28.6686639 C68.4571278,28.698849 70.0199439,28.4389157 71.4990426,27.9015143 L71.57941,28.0790953 C70.0768176,28.6358479 68.4856358,28.9043964 66.886652,28.8711062 C63.7418402,28.8711062 61.0303136,27.1840874 61.0303136,22.5314673 C61.0303136,18.2695252 63.6754497,15.8828376 67.0963061,15.8828376 C69.6086613,15.8828376 72.2258435,17.303485 72.1210165,21.0966134 L62.8717756,21.1108199 Z M62.8962353,20.9083777 L70.3599219,20.9083777 C70.3075083,17.4029303 68.728114,16.0994863 67.0963061,16.0994863 C65.0486842,16.0994863 63.3365089,17.8397793 62.8962353,20.9083777 Z"
                id={"Shape" + props.id}
                fill="#161616"
                fillRule="nonzero"
              ></path>
              <path
                d="M81.6567846,26.9674387 L81.6567846,26.6122768 C81.1396377,27.532146 80.1542634,28.8853126 77.5894947,28.8853126 C74.5564985,28.8853126 74.0393516,26.9958516 73.882111,25.9729855 C73.6235376,24.2575538 74.2315346,22.9789712 78.8579021,22.673532 C79.7880336,22.6000713 80.7220365,22.5917645 81.6532903,22.6486707 L81.6532903,18.3867286 C81.6532903,18.3867286 81.9398176,16.0852798 78.931281,16.0852798 C77.4624809,16.1383595 76.018484,16.4859751 74.6822909,17.1081459 L74.5809581,16.930565 C76.0367045,16.1964227 77.6454896,15.8308777 79.2702219,15.8650795 C83.0265248,15.8650795 83.4633042,17.498824 83.4633042,18.3689705 L83.4633042,26.9674387 C83.4633042,28.6331477 84.6548384,28.5798734 84.6548384,28.5798734 L85.4585126,28.5798734 L85.4585126,28.7858673 L84.6548384,28.7858673 C81.5030382,28.7858673 81.6567846,26.9674387 81.6567846,26.9674387 Z M81.6567846,25.9445726 L81.6567846,22.8511129 C80.7170115,22.7687128 79.7716699,22.7770371 78.8334424,22.8759743 C76.0869735,23.1849651 75.5418728,24.1048342 75.6886307,25.9729855 C75.7899635,27.2231552 76.1778236,28.6828704 77.994826,28.6828704 C79.9725632,28.6828704 81.5799114,26.9674387 81.6567846,25.9445726 L81.6567846,25.9445726 Z"
                id={"Shape" + props.id}
                fill="#161616"
                fillRule="nonzero"
              ></path>
              <path
                d="M94.4561684,16.8914972 C93.914562,16.4830611 92.4365004,16.074625 91.1925527,16.0994863 C89.1449308,16.1243476 88.5509108,17.4029303 88.5509108,18.3760737 C88.5509108,21.7536628 95.8888049,20.6526611 95.8888049,25.3336942 C95.8888049,28.1181631 92.9885896,28.8853126 90.8640946,28.8853126 C89.815824,28.8853126 88.0127986,28.7077317 86.8981375,27.7345883 L87.0553781,27.5818687 C87.7542252,28.2460213 89.3615734,28.6828704 90.5775673,28.6828704 C92.5727756,28.6828704 94.1032507,27.5072847 94.1032507,25.6639947 C94.1032507,21.5973916 86.7653566,22.748116 86.7653566,18.7347872 C86.7653566,16.1527606 89.7983528,15.8934924 91.1191737,15.8934924 C92.8033952,15.8934924 93.9704697,16.3019286 94.5924436,16.7103647 L94.4561684,16.8914972 Z"
                id={"Path" + props.id}
                fill="#161616"
                fillRule="nonzero"
              ></path>
              <path
                d="M98.1111386,15.9822829 L99.9351294,15.9822829 L103.950006,26.6371382 L107.915963,18.5287933 C107.915963,18.5287933 108.744097,16.9696328 107.811136,16.1278993 L107.971871,15.9822829 C107.971871,15.9822829 108.981705,16.6499872 108.17803,18.5394482 L103.188262,28.7858673 L101.011354,33.3639035 C100.106347,35.3563614 98.9916859,35.3315001 97.6953246,34.9976479 L97.6953246,34.8058605 C99.379546,35.2640193 100.18322,34.7028636 100.780734,33.3852132 L102.957643,28.807177 L102.929689,28.807177 L98.1111386,15.9822829 Z"
                id={"Path" + props.id}
                fill="#161616"
                fillRule="nonzero"
              ></path>
              <path
                d="M119.408503,18.5820676 C118.866896,16.8062584 117.661385,16.0959347 116.480333,16.0959347 C114.097265,16.0994863 112.164953,18.4684158 112.164953,22.5456737 C112.164953,27.020713 114.006415,28.6828704 116.260197,28.6828704 C117.66222,28.7106191 119.055265,28.4496641 120.35544,27.9157208 L120.432314,28.0933017 C119.110109,28.6465241 117.689724,28.9161619 116.260197,28.8853126 C113.097914,28.8853126 110.403858,27.1982939 110.403858,22.5456737 C110.403858,18.2837316 113.048994,15.8970441 116.466357,15.8970441 C118.307819,15.8970441 120.226154,16.689055 121.054287,18.5820676 L119.408503,18.5820676 Z"
                id={"Path" + props.id}
                fill="#161616"
                fillRule="nonzero"
              ></path>
              <path
                d="M131.536993,26.9674387 L131.536993,18.9372294 C131.536993,17.8397793 131.407707,16.0959347 129.125971,16.0959347 C126.844235,16.0959347 124.953854,18.5287933 124.953854,19.704379 L124.953854,28.7858673 L123.140346,28.7858673 L123.140346,9.62843754 L124.953854,9.62843754 L124.953854,18.9123681 C125.422082,17.6870597 127.025936,15.8970441 129.146936,15.8970441 C132.903239,15.8970441 133.340019,17.5592015 133.340019,18.9656424 L133.340019,26.9674387 C133.340019,28.6331477 134.531553,28.5798734 134.531553,28.5798734 L135.335227,28.5798734 L135.335227,28.7858673 L133.755833,28.7858673 C131.383247,28.7858673 131.536993,26.9674387 131.536993,26.9674387 Z"
                id={"Path" + props.id}
                fill="#161616"
                fillRule="nonzero"
              ></path>
              <path
                d="M144.982811,26.9674387 L144.982811,26.6122768 C144.465664,27.532146 143.48029,28.8853126 140.915521,28.8853126 C137.882525,28.8853126 137.365378,26.9958516 137.211631,25.9729855 C136.949564,24.2575538 137.561055,22.9789712 142.183928,22.673532 C143.11406,22.6000713 144.048063,22.5917645 144.979317,22.6486707 L144.979317,18.3867286 C144.979317,18.3867286 145.265844,16.0852798 142.260801,16.0852798 C140.794618,16.144315 139.35429,16.4967324 138.022294,17.1223524 L137.920961,16.9447715 C139.376939,16.2112951 140.985562,15.8457869 142.610225,15.879286 C146.366528,15.879286 146.803307,17.5130304 146.803307,18.383177 L146.803307,26.9674387 C146.803307,28.6331477 147.998336,28.5798734 147.998336,28.5798734 L148.798516,28.5798734 L148.798516,28.7858673 L147.998336,28.7858673 C144.829064,28.7858673 144.982811,26.9674387 144.982811,26.9674387 Z M144.982811,25.9445726 L144.982811,22.8511129 C144.043038,22.7687128 143.097696,22.7770371 142.159469,22.8759743 C139.413,23.1849651 138.867899,24.1048342 139.014657,25.9729855 C139.11599,27.2231552 139.507344,28.6828704 141.320852,28.6828704 C143.298589,28.6828704 144.905938,26.9674387 144.982811,25.9445726 L144.982811,25.9445726 Z"
                id={"Shape" + props.id}
                fill="#161616"
                fillRule="nonzero"
              ></path>
              <path
                d="M160.245631,18.8875068 L155.685653,28.7858673 L155.42708,28.7858673 L150.601541,15.9822829 L152.415049,15.9822829 L156.381006,26.5696574 L160.11285,18.5678611 L159.158923,15.9822829 L160.972431,15.9822829 L164.927906,26.5838639 L168.687703,18.5536546 C168.687703,18.5536546 169.515837,16.9944942 168.582876,16.1527606 L168.736622,15.9964894 C168.736622,15.9964894 169.749951,16.6641936 168.946276,18.5536546 L164.229059,28.7858673 L163.970485,28.7858673 L160.245631,18.8875068 Z"
                id={"Path" + props.id}
                fill="#161616"
                fillRule="nonzero"
              ></path>
            </g>
          </g>
          <g id={"Admin-Wallet" + props.id} fill="#FED448" fillOpacity="1">
            <use
              filter={"url(#filter-7" + props.id + ")"}
              href={"#text-6" + props.id}
            ></use>
            <use
              filter={"url(#filter-8" + props.id + ")"}
              href={"#text-6" + props.id}
            ></use>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const BlankDetailSvg = (props) => (
  <svg
    width={props.size}
    style={props.style}
    viewBox="0 0 974 805"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="website"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="17---Admin-Message"
        transform="translate(-398.000000, -201.000000)"
      >
        <g id="blankdetail" transform="translate(398.000000, 201.000000)">
          <path
            d="M974.000042,768.75 L974.000042,773.75 C974.000042,779.127008 971.720955,784.252255 967.741426,787.868278 C963.761898,791.484301 958.443107,793.256474 953.09,792.75 C913.94,789.03 874.97,782.11 835.69,783.32 C763.27,785.53 690.25,815.15 620.15,796.85 C600.38,791.69 580.83,782.72 560.49,784.65 C542.24,786.38 526,796.7 508.32,801.54 C454.55,816.3 399.8,779 344.06,780.51 C307.32,781.51 272.14,799.4 235.44,797.41 C214.17,796.27 193.91,788.49 173.16,783.7 C121.5,771.76 68.3,778.43 15.07,782.57 C11.1874768,782.867615 7.35640879,781.534792 4.49696716,778.891659 C1.63752554,776.248525 0,772.533905 0,768.64 L0,764.36 C0,756.628014 6.2680135,750.36 14,750.36 L954.92,749.6 C959.990025,749.607948 964.849089,751.630319 968.427572,755.221931 C972.006055,758.813542 974.010619,763.67998 974.000042,768.75 Z"
            id="Path"
            fill="#3F3D56"
            fillRule="nonzero"
          ></path>
          <path
            d="M974.000042,768.75 L974.000042,773.75 C974.000042,779.127008 971.720955,784.252255 967.741426,787.868278 C963.761898,791.484301 958.443107,793.256474 953.09,792.75 C913.94,789.03 874.97,782.11 835.69,783.32 C763.27,785.53 690.25,815.15 620.15,796.85 C600.38,791.69 580.83,782.72 560.49,784.65 C542.24,786.38 526,796.7 508.32,801.54 C454.55,816.3 399.8,779 344.06,780.51 C307.32,781.51 272.14,799.4 235.44,797.41 C214.17,796.27 193.91,788.49 173.16,783.7 C121.5,771.76 68.3,778.43 15.07,782.57 C11.1874768,782.867615 7.35640879,781.534792 4.49696716,778.891659 C1.63752554,776.248525 0,772.533905 0,768.64 L0,764.36 C0,756.628014 6.2680135,750.36 14,750.36 L954.92,749.6 C959.990025,749.607948 964.849089,751.630319 968.427572,755.221931 C972.006055,758.813542 974.010619,763.67998 974.000042,768.75 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.1"
          ></path>
          <path
            d="M974.000042,759.61 L974.000042,764.61 C974.000042,765.304755 973.962079,765.998993 973.89,766.69 C972.780935,777.095988 963.50852,784.674404 953.09,783.69 C913.94,779.96 874.97,773.04 835.69,774.25 C763.27,776.47 690.25,806.09 620.15,787.78 C600.38,782.62 580.83,773.65 560.49,775.58 C542.24,777.31 526,787.63 508.32,792.48 C454.55,807.2 399.8,769.9 344.06,771.4 C307.32,772.4 272.14,790.29 235.44,788.31 C214.17,787.16 193.91,779.39 173.16,774.59 C121.51,762.66 68.3,769.33 15.07,773.47 C7.89778753,774.023672 1.47322365,769.051769 0.21,761.97 C0.0661038762,761.157992 -0.000176117089,760.334649 -0.000176117089,759.51 L-0.000176117089,755.23 C-0.000176117089,747.498014 6.2680135,741.23 14,741.23 L249.83,741.04 L731.64,740.64 L954.92,740.46 C959.990025,740.467948 964.849089,742.490319 968.427572,746.081931 C972.006055,749.673542 974.010619,754.53998 974.000042,759.61 L974.000042,759.61 Z"
            id="Path"
            fill="#3F3D56"
            fillRule="nonzero"
          ></path>
          <path
            d="M743.59,743.51 C743.59,745.72 739.23,747.84 731.19,749.83 C699,757.78 608,763.51 500.59,763.51 C394.92,763.51 305.01,757.96 271.59,750.2 C262.59,748.11 257.59,745.86 257.59,743.51 C257.59,742.69 258.19,741.88 259.37,741.08 L741.18,740.68 C742.77,741.61 743.59,742.51 743.59,743.51 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.1"
          ></path>
          <g
            id="Group"
            opacity="0.5"
            transform="translate(552.000000, 0.000000)"
            fillRule="nonzero"
          >
            <rect
              id="Rectangle"
              fill="#36334A"
              x="0"
              y="0"
              width="402"
              height="121"
              rx="19.03"
            ></rect>
            <rect
              id="Rectangle"
              fill="#FED448"
              x="49"
              y="26"
              width="93"
              height="21"
            ></rect>
            <rect
              id="Rectangle"
              fill="#FED448"
              opacity="0.3"
              x="49"
              y="60"
              width="285"
              height="11"
            ></rect>
            <rect
              id="Rectangle"
              fill="#FED448"
              opacity="0.3"
              x="49"
              y="84"
              width="114"
              height="11"
            ></rect>
          </g>
          <g
            id="Group"
            opacity="0.5"
            transform="translate(48.000000, 98.000000)"
            fillRule="nonzero"
          >
            <rect
              id="Rectangle"
              fill="#36334A"
              x="0"
              y="0.51"
              width="402"
              height="121"
              rx="19.03"
            ></rect>
            <rect
              id="Rectangle"
              fill="#36334A"
              x="49"
              y="26.51"
              width="93"
              height="21"
            ></rect>
            <rect
              id="Rectangle"
              fill="#36334A"
              x="49"
              y="60.51"
              width="285"
              height="11"
            ></rect>
            <rect
              id="Rectangle"
              fill="#36334A"
              x="49"
              y="84.51"
              width="114"
              height="11"
            ></rect>
            <rect
              id="Rectangle"
              fill="#36334A"
              x="0"
              y="0.51"
              width="402"
              height="121"
              rx="19.03"
            ></rect>
            <rect
              id="Rectangle"
              fill="#FED448"
              x="49"
              y="26.51"
              width="93"
              height="21"
            ></rect>
            <rect
              id="Rectangle"
              fill="#FED448"
              opacity="0.3"
              x="49"
              y="60.51"
              width="285"
              height="11"
            ></rect>
            <rect
              id="Rectangle"
              fill="#FED448"
              opacity="0.3"
              x="49"
              y="84.51"
              width="114"
              height="11"
            ></rect>
          </g>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            fillRule="nonzero"
            x="667.58"
            y="211.54"
            width="10.31"
            height="85.02"
            rx="2.29"
          ></rect>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            fillRule="nonzero"
            x="324.76"
            y="144.93"
            width="5.79"
            height="27.99"
            rx="1.5"
          ></rect>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            fillRule="nonzero"
            x="324.55"
            y="196.17"
            width="6.52"
            height="48.72"
            rx="1.69"
          ></rect>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            fillRule="nonzero"
            x="324.65"
            y="261.94"
            width="6.21"
            height="49.14"
            rx="1.61"
          ></rect>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            fillRule="nonzero"
            x="328.04"
            y="52.43"
            width="345.1"
            height="701.37"
            rx="35.69"
          ></rect>
          <rect
            id="Rectangle"
            fill="#E6E8EC"
            fillRule="nonzero"
            x="467.3"
            y="73.38"
            width="48.19"
            height="9.79"
            rx="2.54"
          ></rect>
          <circle
            id="Oval"
            fill="#E6E8EC"
            fillRule="nonzero"
            cx="528.33"
            cy="78.27"
            r="5.55"
          ></circle>
          <path
            d="M651.83,98.11 L651.83,708.11 C651.824479,723.24422 639.554221,735.51 624.42,735.51 L376.76,735.51 C361.625779,735.51 349.355521,723.24422 349.35,708.11 L349.35,98.11 C349.35,82.971875 361.621875,70.7 376.76,70.7 L413.82,70.7 L413.82,75.51 C413.825518,87.9727804 423.92722,98.0744818 436.39,98.08 L562.39,98.08 C574.835536,98.052429 584.910031,87.9555667 584.91,75.51 L584.91,70.75 L624.42,70.75 C639.53862,70.7499748 651.802421,82.9914049 651.83,98.11 L651.83,98.11 Z"
            id="Path"
            fill="#36334A"
            fillRule="nonzero"
          ></path>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            fillRule="nonzero"
            x="358"
            y="129"
            width="31"
            height="4"
          ></rect>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            fillRule="nonzero"
            x="358"
            y="136"
            width="31"
            height="4"
          ></rect>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            fillRule="nonzero"
            x="358"
            y="143"
            width="31"
            height="4"
          ></rect>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            fillRule="nonzero"
            x="358"
            y="129"
            width="31"
            height="4"
          ></rect>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            fillRule="nonzero"
            x="358"
            y="136"
            width="31"
            height="4"
          ></rect>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            fillRule="nonzero"
            x="358"
            y="143"
            width="31"
            height="4"
          ></rect>
          <path
            d="M637.66,139 L636.75,139 L636.4,138.71 C637.54953,137.339815 638.179733,135.608526 638.18,133.82 C638.15785,129.711089 634.808984,126.398104 630.700073,126.420105 C626.591162,126.442325 623.278144,129.791159 623.300106,133.900071 C623.322287,138.008982 626.671089,141.322032 630.78,141.3 C632.563293,141.287347 634.287359,140.658486 635.66,139.52 L636,139.81 L636,140.73 L641.74,146.48 L643.46,144.76 L637.66,139 Z M630.78,139.000039 C628.683085,139.008096 626.788139,137.751176 625.980068,135.816198 C625.171997,133.881219 625.610226,131.649936 627.090109,130.164317 C628.569992,128.678698 630.799563,128.231841 632.737653,129.03242 C634.675743,129.833 635.940088,131.723069 635.940088,133.82 C635.948,135.19279 635.407571,136.511958 634.438724,137.484559 C633.469878,138.457161 632.152811,139.002689 630.78,139.000039 L630.78,139.000039 Z"
            id="Shape"
            fill="#3F3D56"
            fillRule="nonzero"
          ></path>
          <rect
            id="Rectangle"
            fill="#FED448"
            fillRule="nonzero"
            x="358"
            y="200"
            width="93"
            height="21"
          ></rect>
          <rect
            id="Rectangle"
            fill="#FED448"
            fillRule="nonzero"
            opacity="0.3"
            x="358"
            y="234"
            width="285"
            height="11"
          ></rect>
          <rect
            id="Rectangle"
            fill="#FED448"
            fillRule="nonzero"
            opacity="0.3"
            x="358"
            y="258"
            width="114"
            height="11"
          ></rect>
          <rect
            id="Rectangle"
            fill="#FED448"
            fillRule="nonzero"
            x="358"
            y="444"
            width="93"
            height="21"
          ></rect>
          <rect
            id="Rectangle"
            fill="#FED448"
            fillRule="nonzero"
            opacity="0.3"
            x="358"
            y="478"
            width="285"
            height="11"
          ></rect>
          <rect
            id="Rectangle"
            fill="#FED448"
            fillRule="nonzero"
            opacity="0.3"
            x="358"
            y="502"
            width="114"
            height="11"
          ></rect>
          <rect
            id="Rectangle"
            fill="#FED448"
            fillRule="nonzero"
            x="358"
            y="566"
            width="93"
            height="21"
          ></rect>
          <rect
            id="Rectangle"
            fill="#FED448"
            fillRule="nonzero"
            opacity="0.3"
            x="358"
            y="600"
            width="285"
            height="11"
          ></rect>
          <rect
            id="Rectangle"
            fill="#FED448"
            fillRule="nonzero"
            opacity="0.3"
            x="358"
            y="624"
            width="114"
            height="11"
          ></rect>
          <circle
            id="Oval"
            fill="#FED448"
            fillRule="nonzero"
            cx="592"
            cy="676"
            r="34"
          ></circle>
          <path
            d="M609.33,673.32 L609.33,689.75 C609.33,690.440356 608.770356,691 608.08,691 L574.58,691 C573.889644,691 573.33,690.440356 573.33,689.75 L573.33,663.58 C573.33,662.889644 573.889644,662.33 574.58,662.33 L597.89,662.33"
            id="Path"
            stroke="#FFFFFF"
            strokeLinecap="round"
          ></path>
          <line
            x1="579.67"
            y1="672"
            x2="602.33"
            y2="672"
            id="Path"
            stroke="#FFFFFF"
            strokeLinecap="round"
          ></line>
          <line
            x1="580"
            y1="676.67"
            x2="602.67"
            y2="676.67"
            id="Path"
            stroke="#FFFFFF"
            strokeLinecap="round"
          ></line>
          <line
            x1="580.33"
            y1="681.33"
            x2="603"
            y2="681.33"
            id="Path"
            stroke="#FFFFFF"
            strokeLinecap="round"
          ></line>
          <line
            x1="605"
            y1="661"
            x2="605"
            y2="672.33"
            id="Path"
            stroke="#FF00FF"
          ></line>
          <line
            x1="610.67"
            y1="666.67"
            x2="599.33"
            y2="666.67"
            id="Path"
            stroke="#FF00FF"
          ></line>
          <line
            x1="605"
            y1="661"
            x2="605"
            y2="672.33"
            id="Path"
            stroke="#FFFFFF"
            strokeLinecap="round"
          ></line>
          <line
            x1="610.67"
            y1="666.67"
            x2="599.33"
            y2="666.67"
            id="Path"
            stroke="#FFFFFF"
            strokeLinecap="round"
          ></line>
          <path
            d="M888.6,745.17 C891.6,739.66 888.2,732.9 884.31,727.99 C880.42,723.08 875.7,717.99 875.8,711.7 C875.95,702.7 885.5,697.39 893.13,692.61 C898.795553,689.07341 904.019107,684.873753 908.69,680.1 C910.647539,678.264577 912.265702,676.097999 913.47,673.7 C915.05,670.18 915.01,666.18 914.91,662.33 C914.57,649.49 913.933333,636.66 913,623.84"
            id="Path"
            stroke="#3F3D56"
            strokeWidth="4"
          ></path>
          <path
            d="M927.51,623.14 C927.293914,618.362714 924.654297,614.026201 920.51,611.64 L917.37,617.86 L917.47,610.33 C915.968003,609.889797 914.403635,609.700586 912.84,609.77 C905.127992,610.152444 899.181668,616.706643 899.549295,624.419371 C899.916923,632.132099 906.459685,638.091004 914.173105,637.738195 C921.886526,637.385386 927.85799,630.854084 927.52,623.14 L927.51,623.14 Z"
            id="Path"
            fill="#57B894"
            fillRule="nonzero"
          ></path>
          <path
            d="M902.48,718.13 C899.445933,724.010638 892.708872,726.963899 886.328252,725.210287 C879.947632,723.456675 875.666157,717.475144 876.063641,710.869883 C876.461126,704.264622 881.429008,698.839689 887.973876,697.863894 C894.518743,696.888099 900.853033,700.627955 903.16,706.83 L894.39,713.96 L904.04,711.73 C904.036441,713.957046 903.501638,716.151111 902.48,718.13 L902.48,718.13 Z"
            id="Path"
            fill="#57B894"
            fillRule="nonzero"
          ></path>
          <path
            d="M895.55,690.88 C888.322215,691.390531 881.89918,686.301733 880.742964,679.148784 C879.586748,671.995835 884.079451,665.142596 891.1,663.35 L891.02,669.13 L894.2,662.84 L894.2,662.84 C897.919097,662.65811 901.557439,663.965278 904.310428,666.472431 C907.063417,668.979584 908.704226,672.48015 908.87,676.2 C908.952156,677.819487 908.749067,679.440812 908.27,680.99 C906.542017,686.640694 901.452269,690.598054 895.55,690.88 Z"
            id="Path"
            fill="#57B894"
            fillRule="nonzero"
          ></path>
          <path
            d="M929.62,668.21 C923.714222,668.427067 918.30819,664.912317 916.110148,659.426522 C913.912105,653.940728 915.395509,647.665526 919.817222,643.744584 C924.238935,639.823642 930.646525,639.10153 935.83,641.94 L933.35,648.74 L938.45,643.84 C941.185674,646.334871 942.821676,649.811826 943,653.51 C943.06658,654.810054 942.948743,656.112986 942.65,657.38 C941.232016,663.50677 935.902757,667.936231 929.62,668.21 Z"
            id="Path"
            fill="#57B894"
            fillRule="nonzero"
          ></path>
          <path
            d="M925.62,626.88 C922.38,627.23 919.23,628.24 915.98,628.44 C912.73,628.64 909.16,627.87 907.1,625.34 C906,623.98 905.44,622.26 904.51,620.77 C903.621794,619.385781 902.405885,618.242002 900.97,617.44 C898.659785,622.269131 899.305643,627.992905 902.633885,632.185804 C905.962128,636.378703 911.390015,638.306596 916.617413,637.152514 C921.844811,635.998433 925.956461,631.964444 927.21,626.76 C926.683333,626.78 926.153333,626.82 925.62,626.88 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.1"
          ></path>
          <path
            d="M929.62,668.21 C924.695996,668.45984 920.003564,666.101217 917.26634,662.000506 C914.529115,657.899795 914.150664,652.661589 916.27,648.21 C917.383601,648.958692 918.341308,649.916399 919.09,651.03 C920.09,652.54 920.7,654.29 921.87,655.67 C924.06,658.24 927.79,659.08 931.18,658.93 C934.57,658.78 937.84,657.81 941.18,657.5 C941.65,657.5 942.12,657.43 942.6,657.42 C941.171681,663.513766 935.872158,667.919147 929.62,668.21 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.1"
          ></path>
          <path
            d="M895.55,690.88 C890.673349,691.126904 886.020379,688.815129 883.271438,684.779537 C880.522497,680.743944 880.07479,675.567653 882.09,671.12 C883.254371,671.880447 884.270881,672.846131 885.09,673.97 C886.18,675.51 886.86,677.29 888.14,678.71 C890.51,681.34 894.49,682.27 898.07,682.19 C901.65,682.11 904.9,681.26 908.35,680.99 C906.61217,686.667375 901.482174,690.631099 895.55,690.88 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.1"
          ></path>
          <path
            d="M902.48,718.13 C899.31817,725.196483 891.026483,728.36183 883.96,725.2 C876.893517,722.038169 873.72817,713.746483 876.89,706.68 C878.0484,707.4375 879.086618,708.364481 879.97,709.43 C881.31,711.05 882.19,712.9 883.73,714.43 C886.6,717.25 891.23,718.43 895.36,718.52 C897.738966,718.531269 900.116497,718.401039 902.48,718.13 L902.48,718.13 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.1"
          ></path>
          <path
            d="M867.43,738.82 C867.43,738.82 878.51,738.48 881.85,736.1 C885.19,733.72 898.85,730.89 899.71,734.7 C900.57,738.51 916.36,753.7 903.86,753.76 C891.36,753.82 874.8,751.82 871.46,749.76 C868.12,747.7 867.43,738.82 867.43,738.82 Z"
            id="Path"
            fill="#656380"
            fillRule="nonzero"
          ></path>
          <path
            d="M904.08,752.44 C891.57,752.54 875.02,750.49 871.69,748.44 C869.15,746.89 868.14,741.35 867.8,738.79 L867.43,738.79 C867.43,738.79 868.13,747.73 871.43,749.79 C874.73,751.85 891.32,753.86 903.83,753.79 C907.44,753.79 908.68,752.48 908.61,750.58 C908.14,751.7 906.77,752.41 904.08,752.44 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.2"
          ></path>
          <path
            d="M642.000095,331.03 L642.000095,413.97 C642.000095,424.46341 633.49341,432.97 623,432.97 L349.35,432.97 L349.35,311.97 L623,311.97 C628.049526,311.97 632.891366,313.979989 636.456287,317.556168 C640.021208,321.132346 642.015946,325.980499 642.000095,331.03 L642.000095,331.03 Z"
            id="Path"
            fill="#3F3D56"
            fillRule="nonzero"
          ></path>
          <rect
            id="Rectangle"
            fill="#F2F2F2"
            fillRule="nonzero"
            x="208"
            y="295"
            width="402"
            height="121"
            rx="19.03"
          ></rect>
          <rect
            id="Rectangle"
            fill="#F2F2F2"
            fillRule="nonzero"
            x="208"
            y="295"
            width="402"
            height="121"
            rx="19.03"
          ></rect>
          <rect
            id="Rectangle"
            fill="#FED448"
            fillRule="nonzero"
            x="257"
            y="321"
            width="93"
            height="21"
          ></rect>
          <rect
            id="Rectangle"
            fill="#FED448"
            fillRule="nonzero"
            opacity="0.3"
            x="257"
            y="355"
            width="285"
            height="11"
          ></rect>
          <rect
            id="Rectangle"
            fill="#FED448"
            fillRule="nonzero"
            opacity="0.3"
            x="257"
            y="379"
            width="114"
            height="11"
          ></rect>
          <circle
            id="Oval"
            fill="#3F3D56"
            fillRule="nonzero"
            cx="92.34"
            cy="246.84"
            r="35.75"
          ></circle>
          <path
            d="M71.6,524.94 C75.29,550.83 70.79,577.23 63.78,602.42 C62.47,607.11 61.06,611.84 58.61,616.05 C56.16,620.26 52.75,623.88 49.87,627.84 C43.87,636.1 40.35,645.84 37.06,655.48 C27.9895799,682.154429 20.371738,709.300919 14.24,736.8 C13.8705188,737.92716 13.8705188,739.14284 14.24,740.27 C15.11,742.27 17.75,742.53 19.92,742.520269 L47.98,742.37 C48.98,740.45 47.13,738.37 45.98,736.53 C41.98,730.31 45.82,722.23 49.35,715.72 C57.9293504,699.909087 64.5706312,683.121218 69.13,665.72 C71.05,658.39 72.61,650.9 75.73,643.99 C79.5,635.61 85.41,628.4 90.21,620.56 C95.79,611.45 99.86,601.56 103.9,591.63 C109.54,577.85 115.23,563.9 117.45,549.18 C119.54,535.36 118.51,521.28 117.15,507.37 C117.278241,506.53055 116.994849,505.680658 116.388466,505.086165 C115.782083,504.491671 114.926747,504.225163 114.09,504.37 L76.44,502.43 C68.68,502.03 66.84,500.33 68.02,507.95 C68.84,513.64 70.78,519.18 71.6,524.94 Z"
            id="Path"
            fill="#3F3D56"
            fillRule="nonzero"
          ></path>
          <path
            d="M71.6,524.94 C75.29,550.83 70.79,577.23 63.78,602.42 C62.47,607.11 61.06,611.84 58.61,616.05 C56.16,620.26 52.75,623.88 49.87,627.84 C43.87,636.1 40.35,645.84 37.06,655.48 C27.9895799,682.154429 20.371738,709.300919 14.24,736.8 C13.8705188,737.92716 13.8705188,739.14284 14.24,740.27 C15.11,742.27 17.75,742.53 19.92,742.520269 L47.98,742.37 C48.98,740.45 47.13,738.37 45.98,736.53 C41.98,730.31 45.82,722.23 49.35,715.72 C57.9293504,699.909087 64.5706312,683.121218 69.13,665.72 C71.05,658.39 72.61,650.9 75.73,643.99 C79.5,635.61 85.41,628.4 90.21,620.56 C95.79,611.45 99.86,601.56 103.9,591.63 C109.54,577.85 115.23,563.9 117.45,549.18 C119.54,535.36 118.51,521.28 117.15,507.37 C117.278241,506.53055 116.994849,505.680658 116.388466,505.086165 C115.782083,504.491671 114.926747,504.225163 114.09,504.37 L76.44,502.43 C68.68,502.03 66.84,500.33 68.02,507.95 C68.84,513.64 70.78,519.18 71.6,524.94 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.1"
          ></path>
          <path
            d="M79,461.99 C71.35,472.99 63.33,485.65 65.87,498.82 C67.8,508.82 75.42,516.57 82.61,523.82 C111.35,552.68 139.61,584.74 149.39,624.29 C151.91,634.51 153.13,645 155.3,655.29 C159.24,673.99 166.3,691.87 173.3,709.64 L192.02,757.02 C203.938882,757.312867 214.768277,750.119911 219.12,739.02 C216.66,738.83 213.45,736.45 212.01,734.45 C204.01,723.38 202.37,709.14 200.32,695.64 C198.05,680.72 195.02,665.92 191.98,651.13 L178.58,585.71 C177.03,578.16 175.48,570.6 173.46,563.17 C165.64,534.34 150.82,507.17 148.53,477.36 C148.19,472.98 147.98,468.17 145.01,464.92 C141.89,461.49 136.77,460.92 132.14,460.65 C113.41,459.41 97.25,457.58 79,461.99 Z"
            id="Path"
            fill="#3F3D56"
            fillRule="nonzero"
          ></path>
          <path
            d="M28.47,736.13 C26.4304947,735.645747 24.3456663,735.377602 22.25,735.33 C18.1776046,735.474258 14.4119333,737.531293 12.09,740.88 C10.9217234,742.752113 10.0039041,744.769298 9.36,746.88 L6.65,754.66 C5.85,756.94 5.07,759.57 6.26,761.66 C7.13887676,762.973386 8.41412767,763.971865 9.9,764.51 C16.46,767.43 23.85,767.59 31,768.29 C37.94,768.97 44.82,770.19 51.67,771.48 C54.03,771.92 56.38,772.37 58.77,772.61 C64.11,773.15 69.49,772.61 74.83,772.13 L80.34,771.6 C82.1843926,771.520455 84.0086572,771.183875 85.76,770.6 C87.5279362,770.000295 88.973338,768.703047 89.76,767.01 C91.12,763.64 88.2,759.65 84.63,759.01 C83.18,758.72 81.68,758.85 80.21,758.66 C78.5439205,758.374365 76.9186915,757.887468 75.37,757.21 C68.32,754.44 61.2,751.64 55,747.28 C53.28,746.07 51.48,744.38 51.67,742.28 C51.8487725,741.380552 52.1481422,740.509353 52.56,739.69 C53.4006731,737.54419 53.4291202,735.165299 52.64,733 C52.3,732.08 51.64,731.11 50.71,731 C48.07,730.68 48.39,734.53 48,736 C47.47,738 46.51,738.18 44.63,738 C39.23,737.42 33.83,737.15 28.47,736.13 Z"
            id="Path"
            fill="#F2F2F2"
            fillRule="nonzero"
          ></path>
          <path
            d="M186.34,762.96 C186.388202,766.867405 187.731753,770.648341 190.16,773.71 C190.902393,774.623334 191.829278,775.369613 192.88,775.9 C194.446421,776.543597 196.141065,776.814055 197.83,776.69 C202.590224,776.586437 207.293843,775.634877 211.72,773.88 C213.279306,773.173816 214.882652,772.569221 216.52,772.07 C218.58065,771.648461 220.664216,771.347947 222.76,771.17 C231.03,769.98 238.29,765.1 246.28,762.63 C248.667284,762.038478 251.007111,761.269678 253.28,760.33 C256.44,758.84 259,756.33 261.51,753.9 C262.987419,752.589357 264.261395,751.065979 265.29,749.38 C266.76,746.64 266.85,743.38 266.91,740.28 C266.963933,739.79679 266.880761,739.308156 266.67,738.87 C266.441651,738.554447 266.13004,738.308621 265.77,738.16 C263.34,736.96 260.46,737.56 257.77,738.03 C248.05,739.76 238.1,739.44 228.23,739.12 C226.304713,739.384644 224.442004,738.321997 223.69,736.53 L219.94,730.53 C218.87,728.81 217.17,726.84 215.23,727.43 C213.68,727.9 213.05,729.8 213.11,731.43 C213.17,733.06 213.67,734.68 213.36,736.27 C212.913145,738.038862 211.75506,739.544373 210.16,740.43 C208.584761,741.286536 206.903666,741.932077 205.16,742.35 C199.64,743.91 193.22,745.68 188.95,749.74 C185.86,752.66 186.15,759.11 186.34,762.96 Z"
            id="Path"
            fill="#F2F2F2"
            fillRule="nonzero"
          ></path>
          <path
            d="M184.4,366.26 C186.553381,364.614552 188.401392,362.604078 189.86,360.32 C191.116693,357.742895 191.905615,354.963047 192.19,352.11 L193.76,342.19 C194.63,336.72 195.65,330.93 199.3,326.76 C202.95,322.59 210.22,321.1 213.93,325.22 C215.55,327.01 216.19,329.47 216.59,331.86 C218.900878,346.294688 214.555518,360.999797 204.77,371.86 C200.28,376.78 194.77,380.69 190.02,385.34 C185.88,389.34 182.29,393.93 178.47,398.28 C169.23219,408.787903 158.651293,418.034 147,425.78 C147.14,418.34 148.09,410.36 147,402.97 C146.19,397.63 144,394.75 149.17,391.26 C161.17,383.1 173.28,375.72 184.4,366.26 Z"
            id="Path"
            fill="#FBBEBE"
            fillRule="nonzero"
          ></path>
          <path
            d="M83.56,293.08 C83.17,298.4 80.96,303.84 76.56,306.91 C89.02,311.27 101.31,316.076667 113.43,321.33 C111.09,319.08 110.38,315.63 110.27,312.39 C109.96,303.92 112.89,295.59 117.17,288.29 C117.850878,287.364023 118.243902,286.257991 118.3,285.11 C118.16,282.75 115.36,281.66 113.06,281.11 C105.212995,279.206454 97.2044411,278.044678 89.14,277.64 C85.69,277.53 81.6,276.44 82.38,280.83 C83.12,284.93 83.87,288.93 83.56,293.08 Z"
            id="Path"
            fill="#FBBEBE"
            fillRule="nonzero"
          ></path>
          <circle
            id="Oval"
            fill="#FBBEBE"
            fillRule="nonzero"
            cx="107.66"
            cy="266.7"
            r="29.23"
          ></circle>
          <path
            d="M136.6,345.65 C135.579482,343.455151 134.336296,341.370888 132.89,339.43 C127.59,331.82 122.15,324.22 115.35,317.92 C110.198998,313.326278 104.624051,309.231288 98.7,305.69 C95.5035831,303.498916 91.989158,301.812532 88.28,300.69 C86.0789949,300.202224 83.8413242,299.897847 81.59,299.78 L74,299.16 C73.3344729,299.07176 72.6590407,299.092023 72,299.22 C69.94,299.74 69,302.3 69.44,304.37 C69.88,306.44 71.44,308.12 72.82,309.69 C73.16,325.18 66.27,340.46 65.34,355.93 C63.71,382.93 80.22,408.14 81.54,435.21 C81.6760834,436.433247 81.5464638,437.671455 81.16,438.84 C80.94,439.4 80.61,439.91 80.36,440.46 C79.58,442.16 79.61,444.09 79.47,445.96 C78.9251605,452.629368 76.0048015,458.881704 71.24,463.58 C72.4783281,465.117154 74.0703209,466.331735 75.88,467.12 C79.07,468.51 82.88,468.63 86.27,469.6 C95.11,472.18 104.17,474.78 113.36,474.23 C114.501716,471.745532 115.20864,469.083572 115.45,466.36 C116.75,465.55 118.25,467.28 118.45,468.8 C118.65,470.32 118.36,472.09 119.45,473.19 C120.54,474.29 121.92,474.12 123.25,473.95 C128.86,473.24 134.25,471.35 139.75,470.08 C145.25,468.81 151.13,468.2 156.48,470.02 C157.56,468.65 157.1,466.62 156.22,465.12 C155.34,463.62 154.09,462.3 153.59,460.63 C153.33839,459.667837 153.230555,458.673735 153.27,457.68 C153.27,449.13 155.03,440.49 153.36,432.1 C152.87,429.64 152.09,427.24 151.59,424.77 C150.59,419.98 150.74,415.04 150.87,410.15 C151,405.26 150.41,399.97 150.31,395.01 C150.306901,392.960248 150.173298,390.912773 149.91,388.88 C149.57,386.75 148.91,384.67 148.73,382.52 C148.19,377.06 150.39,371.64 150.06,366.16 C149.51,357.84 139.84,353.32 136.6,345.65 Z"
            id="Path"
            fill="#FF6584"
            fillRule="nonzero"
          ></path>
          <path
            d="M70.63,341.73 C63.55,360.51 60.09,380.43 56.63,400.21 L48.63,446.67 C46.36,459.8 44.08,473.01 44.17,486.33 C44.17,490.07 44.41,493.88 43.43,497.49 C42.15,502.23 38.97,506.18 36.56,510.49 C31.6699516,519.291522 30.0410624,529.535818 31.96,539.42 C32.78,543.57 35.02,548.28 39.23,548.76 C42.69,549.14 45.68,546.39 47.7,543.55 C52.34,537.04 54.64,529.18 56.7,521.44 C63.3316388,496.145464 67.9691921,470.369762 70.57,444.35 C70.8172081,441.056308 71.2815507,437.782526 71.96,434.55 C72.8431679,431.217378 73.9729501,427.955048 75.34,424.79 C78.4,417.203333 81.4633333,409.616667 84.53,402.03 C91.6,384.5 98.71,366.89 108.42,350.67 C98.82,347.91 88.83,344.67 79.23,341.94 C76.46,341.12 73.49,341.61 70.63,341.73 Z"
            id="Path"
            fill="#FBBEBE"
            fillRule="nonzero"
          ></path>
          <path
            d="M87.27,355.97 C80.55,354.52 73.6,354.97 66.74,354.8 C65.7657817,354.870846 64.7954622,354.617719 63.98,354.08 C62.59,352.89 63.18,350.66 63.88,348.97 L67.2,340.97 C67.7449168,339.316259 68.6539041,337.805837 69.86,336.55 C71.55,335.05 73.93,334.68 76.17,334.41 C83.46,333.57 90.96,333.29 98.03,335.26 C105.1,337.23 111.75,341.71 114.91,348.34 C116.23,351.1 116.84,354.58 115.09,357.09 C112.49,360.82 106.66,364.99 102.31,362.95 C97.1,360.51 93.11,357.24 87.27,355.97 Z"
            id="Path"
            fill="#FF6584"
            fillRule="nonzero"
          ></path>
          <path
            d="M123,221.3 C117.23165,221.239069 111.57185,222.869564 106.72,225.99 C97.3589989,217.119734 83.9462073,213.978619 71.62,217.77 C69.8316447,207.549536 60.6663202,200.292687 50.308121,200.895847 C39.9499219,201.499007 31.6888215,209.7706 31.0988097,220.129557 C30.508798,230.488513 37.7772747,239.644619 48,241.42 C43.8660553,253.833028 46.8429912,267.512756 55.7613786,277.085379 C64.679766,286.658002 78.1148949,290.594297 90.7890461,287.34797 C103.463197,284.101642 113.351679,274.191292 116.57,261.51 C118.679358,261.941761 120.826907,262.159531 122.98,262.16 C137.08,262.16 148.52,253.01 148.52,241.73 C148.52,230.45 137.08,221.3 123,221.3 Z"
            id="Path"
            fill="#3F3D56"
            fillRule="nonzero"
          ></path>
          <path
            d="M128.09,251.94 C125.936592,251.945837 123.788401,251.728002 121.68,251.29 C120.678491,254.947542 119.098544,258.421401 117,261.58 C118.977388,261.96105 120.986238,262.155238 123,262.16 C136.18,262.16 147,254.16 148.39,243.92 C143.7,248.8 136.35,251.94 128.09,251.94 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.1"
          ></path>
          <path
            d="M87.23,277.51 C75.8870197,277.493621 65.2229074,272.102692 58.4841717,262.978388 C51.745436,253.854085 49.7294698,242.076085 53.05,231.23 C43.2829008,229.511617 36.1604692,221.02711 36.16,211.11 C36.157954,209.88248 36.268416,208.657356 36.49,207.45 C31.4093106,212.938977 29.7342243,220.765545 32.1231875,227.85322 C34.5121508,234.940894 40.5832329,240.156548 47.95,241.45 C42.2184467,260.269438 52.7690764,280.183308 71.558979,286.010957 C90.3488817,291.838606 110.316408,281.389877 116.24,262.63 C109.534051,271.976434 98.7332837,277.516434 87.23,277.51 L87.23,277.51 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.1"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const ChatBotSvg = (props) => (
  <svg
    width={props.size}
    style={props.style}
    viewBox="0 0 845 495"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="chatbot"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Custom-Preset"
        transform="translate(-382.000000, -537.000000)"
        fillRule="nonzero"
      >
        <g id="chatbot" transform="translate(382.000000, 537.000000)">
          <path
            d="M47.59202,463.05798 C46.571435,463.078853 45.5843791,463.426131 44.77556,464.0489 C42.37511,457.70516 38.65904,453.62848 34.48423,453.62848 C30.30942,453.62848 26.59336,457.70516 24.19291,464.0489 C23.3840892,463.426134 22.3970344,463.078857 21.37645,463.05798 C16.63351,463.05798 12.78859,471.07926 12.78859,480.97398 L56.17988,480.97398 C56.17988,471.07924 52.33496,463.05798 47.59202,463.05798 Z"
            id="Path"
            fill="#FED448"
          ></path>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            x="0"
            y="479.97356"
            width="220"
            height="2"
          ></rect>
          <path
            d="M829.59202,421.03198 C828.571435,421.052853 827.584379,421.400131 826.77556,422.0229 C824.37511,415.67916 820.65904,411.60248 816.48423,411.60248 C812.30942,411.60248 808.59336,415.67916 806.19291,422.0229 C805.384089,421.400134 804.397034,421.052857 803.37645,421.03198 C798.63351,421.03198 794.78859,429.05326 794.78859,438.94798 L838.17988,438.94798 C838.17988,429.05324 834.33496,421.03198 829.59202,421.03198 Z"
            id="Path"
            fill="#FED448"
          ></path>
          <path
            d="M736.22875,91.8533 L526.73903,91.8533 L526.73903,87.53554 L431.74824,87.53554 L431.74824,91.8533 L221.39497,91.8533 C217.636745,91.8532973 214.032447,93.3462451 211.374981,96.0037111 C208.717515,98.6611772 207.22457,102.265475 207.22457,106.0237 L207.22457,392.87954 C207.22457,400.70565 213.56886,407.05 221.39497,407.05 L736.22875,407.05 C744.05486,407.05 750.39915,400.70565 750.39915,392.87954 L750.39915,106.0237 C750.39915,102.265475 748.906205,98.6611772 746.248739,96.0037111 C743.591273,93.3462451 739.986975,91.8532973 736.22875,91.8533 Z"
            id="Path"
            fill="#3F3D56"
          ></path>
          <rect
            id="Rectangle"
            fill="#000000"
            opacity="0.2"
            x="226.22703"
            y="116.89232"
            width="505.16998"
            height="284.98004"
          ></rect>
          <circle
            id="Oval"
            fill="#FED448"
            cx="478.38008"
            cy="103.94303"
            r="5.18132"
          ></circle>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            x="111.50024"
            y="436.948"
            width="732.99951"
            height="2"
          ></rect>
          <path
            d="M547.83237,223.36563 L547.83237,202.28177 C547.832375,195.420902 545.106908,188.841035 540.255542,183.989668 C535.404175,179.138302 528.824308,176.412835 521.96344,176.41284 L500.87958,176.41284 C500.87958,173.56684 491.73364,171.23505 480.112,171.01406 L480.112,145.58817 C487.67974,144.634724 493.20243,137.962362 492.724769,130.349768 C492.247109,122.737174 485.93369,116.807482 478.306125,116.807482 C470.67856,116.807482 464.365141,122.737174 463.887481,130.349768 C463.40982,137.962362 468.93251,144.634724 476.50025,145.58817 L476.50025,171.01406 C464.87861,171.23506 455.73267,173.5668 455.73267,176.41284 L431.03705,176.41284 C424.176182,176.412835 417.596315,179.138302 412.744948,183.989668 C407.893582,188.841035 405.168115,195.420902 405.16812,202.28177 L405.16812,223.36563 C402.17603,223.36563 399.75049,233.4721 399.75049,245.93909 C399.75049,258.40608 402.17603,268.51255 405.16812,268.51255 L405.16812,293.20816 C405.168115,300.069028 407.893582,306.648895 412.744948,311.500262 C417.596315,316.351628 424.176182,319.07709 431.03705,319.07709 L521.96344,319.07709 C528.824308,319.07709 535.404175,316.351628 540.255542,311.500262 C545.106908,306.648895 547.832375,300.069028 547.83237,293.20816 L547.83237,268.51255 C550.82446,268.51255 553.25,258.40607 553.25,245.93909 C553.25,233.47211 550.82446,223.36563 547.83237,223.36563 Z"
            id="Path"
            fill="#FED448"
          ></path>
          <path
            d="M436.21643,184.53924 L516.78412,184.53924 C529.443486,184.53924 539.70593,194.801684 539.70593,207.46105 L539.70593,288.0288 C539.70593,294.108042 537.290961,299.938294 532.992287,304.236967 C528.693614,308.535641 522.863362,310.95061 516.78412,310.95061 L436.21637,310.95061 C423.557004,310.95061 413.29456,300.688166 413.29456,288.0288 L413.29456,207.46111 C413.29456,194.801713 423.557033,184.53924 436.21643,184.53924 L436.21643,184.53924 Z"
            id="Path"
            fill="#3F3D56"
          ></path>
          <path
            d="M447.60622,244.58468 C438.634187,244.574573 431.363437,237.303823 431.35333,228.33179 C431.35333,227.83311 431.75759,227.42885 432.25627,227.42885 C432.75495,227.42885 433.15921,227.83311 433.15921,228.33179 C433.15921,236.310648 439.627352,242.77879 447.60621,242.77879 C455.585068,242.77879 462.05321,236.310648 462.05321,228.33179 C462.05321,227.83311 462.45747,227.42885 462.95615,227.42885 C463.45483,227.42885 463.85909,227.83311 463.85909,228.33179 C463.848983,237.303816 456.578246,244.574562 447.60622,244.58468 Z"
            id="Path"
            fill="#FED448"
          ></path>
          <path
            d="M476.50025,275.28458 C469.521989,275.276754 463.866941,269.621711 463.85911,262.64345 C463.85911,262.14477 464.26337,261.74051 464.76205,261.74051 C465.26073,261.74051 465.66499,262.14477 465.66499,262.64345 C465.66499,268.627599 470.516101,273.47871 476.50025,273.47871 C482.484399,273.47871 487.33551,268.627599 487.33551,262.64345 C487.33551,262.144773 487.739768,261.74051 488.238445,261.74051 C488.737122,261.74051 489.14138,262.144773 489.14138,262.64345 C489.133554,269.621709 483.478509,275.276754 476.50025,275.28458 L476.50025,275.28458 Z"
            id="Path"
            fill="#FED448"
          ></path>
          <path
            d="M505.39427,244.58468 C496.422237,244.574573 489.151487,237.303823 489.14138,228.33179 C489.14138,227.83311 489.54564,227.42885 490.04432,227.42885 C490.543,227.42885 490.94726,227.83311 490.94726,228.33179 C490.94726,236.310648 497.415402,242.77879 505.39426,242.77879 C513.373118,242.77879 519.84126,236.310648 519.84126,228.33179 C519.84126,227.83311 520.24552,227.42885 520.7442,227.42885 C521.24288,227.42885 521.64714,227.83311 521.64714,228.33179 C521.636879,237.303752 514.366232,244.574408 505.39427,244.58468 L505.39427,244.58468 Z"
            id="Path"
            fill="#FED448"
          ></path>
          <circle
            id="Oval"
            fill="#FED448"
            cx="447.60622"
            cy="229.23473"
            r="8.12644"
          ></circle>
          <circle
            id="Oval"
            fill="#FED448"
            cx="505.39427"
            cy="229.23473"
            r="8.12644"
          ></circle>
          <ellipse
            id="Oval"
            fill="#FED448"
            cx="476.50024"
            cy="267.15814"
            rx="7.22351"
            ry="3.61175"
          ></ellipse>
          <path
            d="M764.58346,396.68735 L715.28135,396.68735 L715.28135,393.13516 C715.281355,392.948362 715.207152,392.769213 715.075065,392.637128 C714.942978,392.505043 714.763828,392.43085 714.57703,392.43085 L697.67345,392.43085 C697.486652,392.43085 697.307502,392.505043 697.175415,392.637128 C697.043328,392.769213 696.969125,392.948362 696.96913,393.13516 L696.96913,396.68735 L686.40439,396.68735 L686.40439,393.13516 C686.404395,392.948364 686.330193,392.769217 686.198108,392.637132 C686.066023,392.505047 685.886876,392.43085 685.70008,392.43085 L668.79649,392.43085 C668.609693,392.43085 668.430544,392.505043 668.298459,392.637129 C668.166373,392.769214 668.092172,392.948363 668.09218,393.13516 L668.09218,396.68735 L657.52744,396.68735 L657.52744,393.13516 C657.527445,392.948362 657.453242,392.769213 657.321155,392.637128 C657.189068,392.505043 657.009918,392.43085 656.82312,392.43085 L639.91954,392.43085 C639.732742,392.43085 639.553592,392.505043 639.421505,392.637128 C639.289418,392.769213 639.215215,392.948362 639.21522,393.13516 L639.21522,396.68735 L628.65048,396.68735 L628.65048,393.13516 C628.650488,392.948363 628.576287,392.769214 628.444201,392.637129 C628.312116,392.505043 628.132967,392.43085 627.94617,392.43085 L611.04259,392.43085 C610.855792,392.43085 610.676642,392.505043 610.544555,392.637128 C610.412468,392.769213 610.338265,392.948362 610.33827,393.13516 L610.33827,396.68735 L599.77353,396.68735 L599.77353,393.13516 C599.773535,392.948362 599.699332,392.769213 599.567245,392.637128 C599.435158,392.505043 599.256008,392.43085 599.06921,392.43085 L582.16563,392.43085 C581.978833,392.43085 581.799684,392.505043 581.667599,392.637129 C581.535513,392.769214 581.461312,392.948363 581.46132,393.13516 L581.46132,396.68735 L570.89658,396.68735 L570.89658,393.13516 C570.896585,392.948362 570.822382,392.769213 570.690295,392.637128 C570.558208,392.505043 570.379058,392.43085 570.19226,392.43085 L553.28868,392.43085 C553.101882,392.43085 552.922732,392.505043 552.790645,392.637128 C552.658558,392.769213 552.584355,392.948362 552.58436,393.13516 L552.58436,396.68735 L542.01962,396.68735 L542.01962,393.13516 C542.019628,392.948363 541.945427,392.769214 541.813341,392.637129 C541.681256,392.505043 541.502107,392.43085 541.31531,392.43085 L408.90388,392.43085 C408.717082,392.43085 408.537932,392.505043 408.405845,392.637128 C408.273758,392.769213 408.199555,392.948362 408.19956,393.13516 L408.19956,396.68735 L397.63488,396.68735 L397.63488,393.13516 C397.634888,392.948363 397.560687,392.769214 397.428601,392.637129 C397.296516,392.505043 397.117367,392.43085 396.93057,392.43085 L380.02695,392.43085 C379.840154,392.43085 379.661007,392.505047 379.528922,392.637132 C379.396837,392.769217 379.322635,392.948364 379.32264,393.13516 L379.32264,396.68735 L368.75788,396.68735 L368.75788,393.13516 C368.757885,392.948362 368.683682,392.769213 368.551595,392.637128 C368.419508,392.505043 368.240358,392.43085 368.05356,392.43085 L351.15,392.43085 C350.963202,392.43085 350.784052,392.505043 350.651965,392.637128 C350.519878,392.769213 350.445675,392.948362 350.44568,393.13516 L350.44568,396.68735 L339.88095,396.68735 L339.88095,393.13516 C339.880955,392.948362 339.806752,392.769213 339.674665,392.637128 C339.542578,392.505043 339.363428,392.43085 339.17663,392.43085 L322.27305,392.43085 C322.086252,392.43085 321.907102,392.505043 321.775015,392.637128 C321.642928,392.769213 321.568725,392.948362 321.56873,393.13516 L321.56873,396.68735 L311.00399,396.68735 L311.00399,393.13516 C311.003995,392.948364 310.929793,392.769217 310.797708,392.637132 C310.665623,392.505047 310.486476,392.43085 310.29968,392.43085 L293.39609,392.43085 C293.209293,392.43085 293.030144,392.505043 292.898059,392.637129 C292.765973,392.769214 292.691772,392.948363 292.69178,393.13516 L292.69178,396.68735 L282.12704,396.68735 L282.12704,393.13516 C282.127045,392.948362 282.052842,392.769213 281.920755,392.637128 C281.788668,392.505043 281.609518,392.43085 281.42272,392.43085 L264.51914,392.43085 C264.332342,392.43085 264.153192,392.505043 264.021105,392.637128 C263.889018,392.769213 263.814815,392.948362 263.81482,393.13516 L263.81482,396.68735 L253.25008,396.68735 L253.25008,393.13516 C253.250088,392.948363 253.175887,392.769214 253.043801,392.637129 C252.911716,392.505043 252.732567,392.43085 252.54577,392.43085 L235.64219,392.43085 C235.455392,392.43085 235.276242,392.505043 235.144155,392.637128 C235.012068,392.769213 234.937865,392.948362 234.93787,393.13516 L234.93787,396.68735 L202.53934,396.68735 C198.056222,396.68735 193.756722,398.468264 190.586683,401.638311 C187.416644,404.808358 185.63575,409.107862 185.63575,413.59098 L185.63575,421.23438 C185.63575,430.569955 193.203765,438.13792 202.53934,438.13792 L764.58346,438.13792 C773.919034,438.13792 781.48704,430.569954 781.48704,421.23438 L781.48704,413.59098 C781.48704,409.107864 779.706148,404.808361 776.536111,401.638315 C773.366074,398.468268 769.066576,396.687353 764.58346,396.68735 L764.58346,396.68735 Z"
            id="Path"
            fill="#3F3D56"
          ></path>
          <rect
            id="Rectangle"
            fill="#FED448"
            x="303.50024"
            y="317.948"
            width="337"
            height="2"
          ></rect>
          <path
            d="M327.50025,316.94798 L244.50025,316.94798 C247.15644,285.670939 247.15644,254.225021 244.50025,222.94798 L327.50025,222.94798 C322.93042,255.14243 322.66315,286.5261 327.50025,316.94798 Z"
            id="Path"
            fill="#D0CDE1"
          ></path>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            x="256.50024"
            y="241.948"
            width="60"
            height="4"
          ></rect>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            x="256.50024"
            y="254.948"
            width="60"
            height="4"
          ></rect>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            x="256.50024"
            y="267.948"
            width="60"
            height="4"
          ></rect>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            x="256.50024"
            y="280.948"
            width="60"
            height="4"
          ></rect>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            x="256.50024"
            y="293.948"
            width="60"
            height="4"
          ></rect>
          <path
            d="M106.94424,3.20737 C106.94424,3.20737 93.90308,-1.45019 85.51949,17.18003 C77.1359,35.81025 64.09473,56.30349 64.09473,56.30349 L71.54682,58.16649 C71.54682,58.16649 73.40982,45.12534 78.0674,43.26232 L76.2044,60.02951 C76.2044,60.02951 132.09505,79.59124 157.24585,58.16651 L156.31434,51.64593 C156.31434,51.64593 160.04034,52.57744 160.04034,58.16651 L162.83488,55.37198 C162.83488,55.37198 160.04035,49.78291 151.65675,42.33082 C146.15412,37.4396 144.26318,28.1341 143.61337,22.31615 C143.126544,17.4580935 141.182863,12.8605818 138.03724,9.12658 C132.46588,2.66973 122.31417,-4.19297 106.94424,3.20737 Z"
            id="Path"
            fill="#2F2E41"
          ></path>
          <polygon
            id="Path"
            fill="#FFB9B9"
            points="69.335 414.136 73.335 437.136 89.335 434.136 92.335 414.136"
          ></polygon>
          <path
            d="M92.33488,427.13622 L70.33488,429.13622 L71.33488,447.13622 L70.33488,470.13622 C70.33488,470.13622 57.33488,496.13622 76.33488,494.13622 C95.33488,492.13622 93.33488,482.13622 93.33488,482.13622 L98.33488,476.13622 L95.33488,461.13622 L92.33488,427.13622 Z"
            id="Path"
            fill="#2F2E41"
          ></path>
          <polygon
            id="Path"
            fill="#FFB9B9"
            points="159.335 414.136 155.335 437.136 139.335 434.136 136.335 414.136"
          ></polygon>
          <path
            d="M136.33488,427.13622 L158.33488,429.13622 L157.33488,447.13622 L158.33488,470.13622 C158.33488,470.13622 171.33488,496.13622 152.33488,494.13622 C133.33488,492.13622 135.33488,482.13622 135.33488,482.13622 L130.33488,476.13622 L133.33488,461.13622 L136.33488,427.13622 Z"
            id="Path"
            fill="#2F2E41"
          ></path>
          <circle
            id="Oval"
            fill="#FFB9B9"
            cx="113.33489"
            cy="42.13622"
            r="23"
          ></circle>
          <path
            d="M98.33488,54.13622 L101.33488,90.13622 L129.33488,89.13622 C129.33488,89.13622 121.33488,66.13622 126.33488,57.13622 L98.33488,54.13622 Z"
            id="Path"
            fill="#FFB9B9"
          ></path>
          <path
            d="M114.33488,83.13622 L125.8526,75.95251 L138.33488,82.13622 L158.33488,91.13622 L151.33488,176.13622 C151.33488,176.13622 167.33488,229.13622 164.33488,255.13622 C161.33488,281.13622 197.33488,411.13622 168.33488,417.13622 C139.33488,423.13622 118.33488,429.13622 117.33488,419.13622 C116.33488,409.13622 114.33488,256.13622 114.33488,256.13622 C114.33488,256.13622 111.33488,418.13622 99.33488,420.13622 C87.33488,422.13622 35.33488,430.13622 39.33488,418.13622 C43.33488,406.13622 70.33488,196.13622 83.33488,184.13622 L85.33488,174.13622 L68.33488,93.13622 L100.25899,77.22555 L114.33488,83.13622 Z"
            id="Path"
            fill="#2F2E41"
          ></path>
          <path
            d="M54.33488,207.13622 L53.33488,248.13622 C53.33488,248.13622 43.70888,288.61479 60.02188,288.37551 C76.33488,288.13622 64.33488,248.13622 64.33488,248.13622 L71.33488,208.13622 L54.33488,207.13622 Z"
            id="Path"
            fill="#FFB9B9"
          ></path>
          <path
            d="M205.54804,164.10516 L233.65148,193.97482 C233.65148,193.97482 267.83163,217.70015 255.522,228.40732 C243.21237,239.11449 225.45865,201.31498 225.45865,201.31498 L193.55365,176.19384 L205.54804,164.10516 Z"
            id="Path"
            fill="#FFB9B9"
          ></path>
          <polygon
            id="Path"
            fill="#D0CDE1"
            points="83.835 181.636 152.325 179.536 151.435 174.886 151.435 174.866 85.235 173.666"
          ></polygon>
          <circle
            id="Oval"
            fill="#2F2E41"
            cx="97.83489"
            cy="177.63622"
            r="6"
          ></circle>
          <path
            d="M76.33488,94.13622 L69.83488,92.63622 C69.83488,92.63622 61.33488,96.13622 59.33488,107.13622 C57.33488,118.13622 31.33488,204.13622 44.33488,209.13622 C57.33488,214.13622 76.33488,216.13622 76.33488,214.13622 C76.33488,212.13622 84.33488,137.13622 84.33488,137.13622 L76.33488,94.13622 Z"
            id="Path"
            fill="#2F2E41"
          ></path>
          <path
            d="M137.50025,97.94798 L158.33489,91.1362 C158.33489,91.1362 168.33489,91.1362 168.33489,102.1362 C168.33489,106.67402 187.50025,143.94798 187.50025,143.94798 C187.50025,143.94798 233.54989,176.77304 226.50025,177.94798 C214.50025,179.94798 207.50025,200.94798 207.50025,200.94798 L162.50025,160.94798 L137.50025,97.94798 Z"
            id="Path"
            fill="#2F2E41"
          ></path>
          <path
            d="M85.28358,43.84907 C85.28358,43.84907 92.73567,33.60245 99.25625,31.73942 C105.77683,29.87639 106.70833,20.56129 106.70833,20.56129 C106.70833,20.56129 123.47553,39.19151 133.72215,40.12298 C143.96877,41.05445 134.65366,17.76672 134.65366,17.76672 L116.02344,13.10917 L98.32474,14.97217 L84.35207,24.28728 L85.28358,43.84907 Z"
            id="Path"
            fill="#2F2E41"
          ></path>
          <ellipse
            id="Oval"
            fill="#FFB9B9"
            cx="90.83489"
            cy="38.63622"
            rx="3"
            ry="4.5"
          ></ellipse>
        </g>
      </g>
    </g>
  </svg>
);

export const OrdersSvg = (props) => (
  <svg
    width={props.size}
    style={props.style}
    viewBox="0 0 886 558"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="orders" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="waiting"
        transform="translate(-255.000000, -434.000000)"
        fillRule="nonzero"
      >
        <g id="orders" transform="translate(255.000000, 434.000000)">
          <path
            d="M681.59125,421.11103 C718.01703,330.04364 706.99808,228.35687 660.01866,150.25937 L168.2454,218.35103 L639.5213,120.13416 C440.89839,-127.5505 54.30791,36.73567 91.5733,349.45516 L681.59125,421.11103 Z"
            id="Path"
            fill="#E6E6E6"
          ></path>
          <rect
            id="Rectangle"
            fill="#FED448"
            x="76.75322"
            y="320.44454"
            width="626.52594"
            height="195.09542"
          ></rect>
          <path
            d="M251.48503,296.65242 C257.10631,301.01773 259.16185,302.42697 260.35893,302.24811 C318.3585,319.1379 267.51331,338.93145 239.33271,305.33265 L251.48503,296.65242 Z"
            id="Path"
            fill="#FFB8B8"
          ></path>
          <polygon
            id="Path"
            fill="#FFB8B8"
            points="60.099 475.093 60.099 514.747 88.649 513.161 80.719 471.921"
          ></polygon>
          <polygon
            id="Path"
            fill="#FFB8B8"
            points="218.713 475.093 218.713 514.747 190.162 513.161 198.093 471.921"
          ></polygon>
          <path
            d="M131.47511,270.48108 L174.30093,268.89494 C273.09463,372.46607 235.73287,348.84348 232.98817,490.95476 L180.6455,475.09337 L191.7485,376.75259 C191.75414,376.74883 194.6773,374.80005 192.2475,374.75513 C177.05102,379.97742 165.9632,315.31837 133.06121,322.82377 C95.62048,321.03277 89.52521,376.57414 74.37397,376.75259 L85.47703,475.09337 L33.13433,490.95476 C27.27383,334.78889 -1.44867,370.06696 91.82157,268.89494 L131.47511,270.48108 Z"
            id="Path"
            fill="#2F2E41"
          ></path>
          <path
            d="M68.02944,502.05775 C68.02944,502.05775 61.68488,489.36862 53.75417,495.71319 C45.82346,502.05776 26.78976,521.09145 26.78976,521.09145 C26.78976,521.09145 -19.20835,541.7113 9.3422,554.40045 C37.89275,567.0896 61.68488,536.95289 61.68488,536.95289 C88.87888,531.28224 104.5645,527.65179 90.14307,497.98889 C81.95546,501.53191 70.36875,505.63376 68.02944,502.05775 Z"
            id="Path"
            fill="#2F2E41"
          ></path>
          <path
            d="M210.78219,502.05775 C210.78219,502.05775 217.12675,489.36862 225.05746,495.71319 C232.98817,502.05776 252.02187,521.09145 252.02187,521.09145 C252.02187,521.09145 298.01998,541.7113 269.46943,554.40045 C240.91888,567.0896 217.12675,536.95289 217.12675,536.95289 C189.93275,531.28224 174.24713,527.65179 188.66856,497.98889 C196.85617,501.53191 208.44288,505.63376 210.78219,502.05775 Z"
            id="Path"
            fill="#2F2E41"
          ></path>
          <path
            d="M174.30093,91.24708 C171.94186,130.73258 118.05282,127.25627 117.20006,91.24676 C119.5589,51.76157 173.44794,55.23788 174.30093,91.24708 Z"
            id="Path"
            fill="#FFB8B8"
          ></path>
          <path
            d="M133.06125,111.86692 C146.93712,153.80467 114.17693,130.97233 160.02566,164.20959 L177.47321,129.31448 C177.47321,129.31448 164.78408,124.55605 166.37021,107.10848 L133.06125,111.86692 Z"
            id="Path"
            fill="#FFB8B8"
          ></path>
          <path
            d="M218.7129,135.65904 L171.43056,124.86677 C172.76043,153.37647 142.3354,147.63847 137.02656,133.29739 L91.82156,159.45117 C110.79544,230.11817 105.98678,233.03394 80.71856,278.41179 C71.0752,287.21779 85.49702,292.26485 98.05211,287.4462 C107.62811,281.53596 112.49125,276.28383 122.75211,277.62031 C171.23729,287.71591 211.60045,290.09884 217.9882,286.15397 C220.27396,282.88264 217.92203,136.22692 218.7129,135.65904 Z"
            id="Path"
            fill="#575A89"
          ></path>
          <path
            d="M206.02376,138.83137 C207.6099,138.83137 215.78036,134.988978 215.78036,134.988978 C239.55136,134.58902 255.50328,294.48637 256.78029,299.03167 L240.91888,310.13467 L215.54061,245.10286 L206.02376,138.83137 Z"
            id="Path"
            fill="#575A89"
          ></path>
          <path
            d="M94.99385,324.40989 C95.80485,330.39605 97.18495,397.62047 121.26637,366.21844 C124.42581,343.30844 113.68416,336.46926 110.85527,321.23761 L94.99385,324.40989 Z"
            id="Path"
            fill="#FFB8B8"
          ></path>
          <path
            d="M101.33842,159.45117 L96.4785,156.75686 C83.44921,156.32874 87.5555,190.818 82.04307,216.0758 C77.53966,245.50046 78.82192,277.94563 84.10543,321.32313 C84.56748,337.2409 113.07793,327.21302 117.19983,325.99604 C117.19983,325.99604 107.68298,260.96423 112.44141,249.86124 C117.19983,238.75825 101.33842,159.45117 101.33842,159.45117 Z"
            id="Path"
            fill="#575A89"
          ></path>
          <path
            d="M173.05303,63.56973 C168.648334,56.416966 161.753668,51.1461459 153.69603,48.77173 L147.77782,53.50628 L150.07872,47.98396 C148.143774,47.6887753 146.18542,47.5755903 144.22935,47.64589 L138.90447,54.4922 L141.10836,47.8804 C118.25928,50.3338 104.74065,76.56363 116.6028,94.92124 C118.43264,89.29801 120.65349,84.02153 122.48333,78.39824 C123.921421,78.5942848 125.378977,78.601385 126.81891,78.41936 L129.04519,73.22483 L129.66705,78.19966 C136.56722,77.59844 146.80188,76.27866 153.34352,75.06935 L152.70746,71.25297 L156.51312,74.42438 C158.51735,73.96295 159.70728,73.54461 159.60895,73.22483 C164.47408,81.06802 169.29468,86.07763 174.15969,93.92077 C176.00652,82.85772 179.26675,73.66177 173.05303,63.56973 Z"
            id="Path"
            fill="#2F2E41"
          ></path>
          <rect
            id="Rectangle"
            fill="#FFFFFF"
            x="527.41215"
            y="343.97895"
            width="138.36733"
            height="65.63579"
          ></rect>
          <rect
            id="Rectangle"
            fill="#E6E6E6"
            x="553.57776"
            y="357.72699"
            width="86.0361"
            height="7.8701"
          ></rect>
          <rect
            id="Rectangle"
            fill="#E6E6E6"
            x="553.57776"
            y="372.8618"
            width="86.0361"
            height="7.8701"
          ></rect>
          <rect
            id="Rectangle"
            fill="#E6E6E6"
            x="553.57776"
            y="387.9966"
            width="86.0361"
            height="7.8701"
          ></rect>
          <polygon
            id="Path"
            fill="#FFFFFF"
            points="406.916 359.57 402.415 351.775 397.915 343.979 393.414 351.775 388.913 359.57 393.749 359.57 393.749 382.144 402.08 382.144 402.08 359.57"
          ></polygon>
          <circle
            id="Oval"
            fill="#3F3D56"
            cx="711.88818"
            cy="483.13309"
            r="37.06013"
          ></circle>
          <circle
            id="Oval"
            fill="#E6E6E6"
            cx="718.62639"
            cy="483.13309"
            r="16.42438"
          ></circle>
          <polygon
            id="Path"
            fill="#3F3D56"
            points="688.515 509.033 769.374 542.724 766.847 550.726 720.311 545.461 641.558 510.507 685.356 515.561"
          ></polygon>
          <path
            d="M759.98962,541.20611 L860.55438,211.31922 L885.04454,167.82831 L885.13054,167.40861 C885.20954,167.0249 887.00754,157.93445 882.5848,151.35129 C880.330885,148.04337 876.803308,145.821258 872.8464,145.21682 C859.33009,142.68259 829.09247,141.43398 827.8122,141.38196 L827.57078,141.37209 L827.33143,141.40478 C826.50519,141.51747 807.18055,144.34226 802.81207,161.21698 L781.78767,199.48068 L781.705,199.75294 L686.52779,512.65837 L691.76569,514.25162 L786.86019,201.61843 L807.95492,163.22579 L808.04047,162.87293 C811.12947,150.17443 825.89729,147.20364 827.86147,146.86372 C830.95047,146.99553 859.37032,148.26018 871.83707,150.59783 C874.339964,150.939047 876.585447,152.3132 878.02829,154.38663 C880.75417,158.42281 880.07187,164.36542 879.83169,165.92763 L855.49169,209.15226 L855.4045,209.43747 L754.75254,539.60957 L759.98962,541.20611 Z"
            id="Path"
            fill="#3F3D56"
          ></path>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            transform="translate(810.522018, 240.369900) rotate(-79.762140) translate(-810.522018, -240.369900) "
            x="807.784633"
            y="203.46721"
            width="5.47477"
            height="73.80538"
          ></rect>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            transform="translate(796.637884, 285.963656) rotate(-78.464690) translate(-796.637884, -285.963656) "
            x="793.900514"
            y="249.164341"
            width="5.47474"
            height="73.59863"
          ></rect>
          <rect
            id="Rectangle"
            fill="#3F3D56"
            transform="translate(771.424877, 368.759572) rotate(-74.032140) translate(-771.424877, -368.759572) "
            x="768.687562"
            y="332.144777"
            width="5.47463"
            height="73.22959"
          ></rect>
          <polygon
            id="Path"
            fill="#3F3D56"
            points="784.589 511.372 786.585 506.273 718.249 479.515 714.893 443.181 778.675 467.004 799.338 496.902 803.843 493.79 782.201 462.476 708.64 435 713.108 483.382"
          ></polygon>
          <circle
            id="Oval"
            fill="#3F3D56"
            cx="808.32876"
            cy="518.50867"
            r="37.06013"
          ></circle>
          <circle
            id="Oval"
            fill="#E6E6E6"
            cx="818.01493"
            cy="520.19322"
            r="16.42438"
          ></circle>
        </g>
      </g>
    </g>
  </svg>
);

export const ShieldIcon = (props) => (
  <svg
    width={props.size}
    style={props.style}
    viewBox="0 0 60 70"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs></defs>
    <title>shield_1</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="icon">
        <g id="shield-icon">
          <g id="shield">
            <path
              className="shield-icon shield"
              d="M30,3.09,57,9.58v41a5.8,5.8,0,0,1-3.35,5.24L30,66.7,6.35,55.79A5.8,5.8,0,0,1,3,50.55v-41L30,3.09M30,0,0,7.21V50.55a8.76,8.76,0,0,0,5.1,8L30,70,54.9,58.51a8.76,8.76,0,0,0,5.1-8V7.21L30,0Z"
            />
          </g>
          <g id="icon-2" data-name="icon">
            <path
              className="shield-icon"
              d="M36,34.44a2.6,2.6,0,0,1,1.88,1.47A2.16,2.16,0,0,1,38,37.45c0,.18,0,.28.18.33A2.22,2.22,0,0,1,40,40.37c0,.22.05.28.23.33a2.46,2.46,0,0,1,1.2,4c-1.12,1.3-2.3,2.57-3.53,3.78a10.52,10.52,0,0,1-5.7,2.86,10,10,0,0,1-8-1.78,9.17,9.17,0,0,1-3.55-6,12.23,12.23,0,0,1-.2-2.42A7.43,7.43,0,0,0,19,36.58,6.9,6.9,0,0,1,18.13,35a2.36,2.36,0,0,1,2.39-3.1,2.62,2.62,0,0,1,1.65.76,11.5,11.5,0,0,1,2.11,2.71l.18.28a1.16,1.16,0,0,0,1.74.41,13.09,13.09,0,0,0,2.59-1.84c2.32-2,4.48-4.15,6.6-6.34a2.58,2.58,0,0,1,3.23-.52,2.47,2.47,0,0,1,.53,3.89c-1,1-1.95,1.92-2.93,2.88Zm2.49,11.84-.31-.12A2.39,2.39,0,0,1,36.53,44c0-.3-.09-.45-.41-.45l-.15,0a2.45,2.45,0,0,1-2-2.71c0-.21,0-.3-.24-.34a2.43,2.43,0,0,1-1.43-.9,2.36,2.36,0,0,1,.22-3.27l5.62-5.51a3.73,3.73,0,0,0,.34-.35,1.44,1.44,0,0,0-.18-2,1.56,1.56,0,0,0-2.23.19C35,29.73,34,30.84,32.9,31.9a41,41,0,0,1-5.24,4.51,8.5,8.5,0,0,1-1.73.87c-.28.11-.31.19-.27.44a3.53,3.53,0,0,1-.54,2.68.51.51,0,1,1-.91-.47c.07-.16.16-.3.24-.46a2.29,2.29,0,0,0-.35-2.64A14,14,0,0,1,23,35.28a9.18,9.18,0,0,0-1.66-2,1.33,1.33,0,0,0-1.56-.22,1.24,1.24,0,0,0-.7,1.53A6.47,6.47,0,0,0,19.85,36a8,8,0,0,1,1.32,2.91,20.88,20.88,0,0,1,.22,2.63,11.56,11.56,0,0,0,1.07,4.51A3.34,3.34,0,0,0,27.3,47.3,10.37,10.37,0,0,0,28.64,46c.31-.34.59-.46.87-.25s.24.49-.05.85a6.33,6.33,0,0,1-.57.69,4.83,4.83,0,0,1-3.07,1.64c-.2,0-.39,0-.63.07C29,51.6,35.09,50.73,38.45,46.28Zm-4.09-6.72a3.41,3.41,0,0,0,.61-.29,13.51,13.51,0,0,0,1.18-.94,3.17,3.17,0,0,0,.68-.74,1.36,1.36,0,0,0-.4-1.85,1.49,1.49,0,0,0-1.81,0c-.51.45-1,.94-1.44,1.43A1.2,1.2,0,0,0,33,38.65,1.57,1.57,0,0,0,34.36,39.56Zm4.69.46L39,40a1.13,1.13,0,0,0-.7-1.09,1.25,1.25,0,0,0-1.35.16c-.45.35-.89.72-1.35,1.08a1.31,1.31,0,0,0,0,2.08,1.28,1.28,0,0,0,1.57.12c.52-.51,1-1,1.54-1.55A3.65,3.65,0,0,0,39.05,40Zm.36,1.6a.71.71,0,0,0-.26.12c-.44.41-.87.82-1.28,1.25a1.25,1.25,0,0,0-.22,1.45,1.44,1.44,0,0,0,1.31.83,1.33,1.33,0,0,0,.71-.26,8.31,8.31,0,0,0,.91-1,1.36,1.36,0,0,0,.24-1.53A1.51,1.51,0,0,0,39.41,41.62Z"
            />
            <path
              className="shield-icon"
              d="M19.06,23a1.49,1.49,0,0,1,.33.19l5,4.87a.52.52,0,0,1,.06.76.54.54,0,0,1-.8,0c-1.64-1.6-3.28-3.2-4.91-4.82a.85.85,0,0,1-.22-.53C18.49,23.18,18.72,23,19.06,23Z"
            />
            <path
              className="shield-icon"
              d="M27.76,22.68a.54.54,0,0,1-.45.59c-.26,0-.48-.13-.57-.46-.18-.7-.35-1.4-.53-2.1l-1.12-4.36a1.29,1.29,0,0,1,0-.39.42.42,0,0,1,.36-.44.45.45,0,0,1,.55.23,1,1,0,0,1,.11.28l1.65,6.44C27.74,22.55,27.75,22.64,27.76,22.68Z"
            />
            <path
              className="shield-icon"
              d="M34,22.39c0-1.12,0-2.24,0-3.36a.84.84,0,0,1,.21-.53.45.45,0,0,1,.75.25,1.23,1.23,0,0,1,0,.33q0,3.33,0,6.65c0,.37-.19.61-.5.61s-.52-.24-.52-.63V22.39Z"
            />
            <path
              className="shield-icon"
              d="M27.41,27.13l.27,0a1.18,1.18,0,0,0,1.31-.9,1.24,1.24,0,0,1,.15-.25c.14.27.27.51.38.75a.41.41,0,0,0,.39.29c.29,0,.57.08.94.14-.23.23-.42.42-.62.6a.51.51,0,0,0-.19.56,7.72,7.72,0,0,1,.14.82c-.28-.14-.52-.26-.75-.39a.5.5,0,0,0-.58,0c-.21.13-.45.23-.76.39.05-.32.08-.55.13-.78A.56.56,0,0,0,28,27.7,7.56,7.56,0,0,1,27.41,27.13Z"
            />
            <path
              className="shield-icon"
              d="M22.15,19.24a1,1,0,0,0,1.41.42,1.07,1.07,0,0,0,.05,1.49,1.09,1.09,0,0,0-1.4.53,1,1,0,0,0-1-1.14,2.86,2.86,0,0,0,.75-.48A2.36,2.36,0,0,0,22.15,19.24Z"
            />
            <path
              className="shield-icon"
              d="M30.18,18.56a1.08,1.08,0,0,0,1.49,0,2.34,2.34,0,0,0-.12.84c.07.23.33.41.55.66-.61,0-1.1.12-1.28.79A1.07,1.07,0,0,0,29.63,20,1.1,1.1,0,0,0,30.18,18.56Z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

class Fmb extends React.Component {
  constructor() {
    super();
    this.state = {
      moveMenu: false,
      menuButtonPosition: "top",
    };
    this.repositionFab = this.repositionFab.bind(this);

    this.stopMovingFab = this.stopMovingFab.bind(this);

    this.mouse = this.mouse.bind(this);
  }

  mouse(e) {
    let x = e.clientX;
    let y = e.clientY;
    document.getElementById("fmb").style.top = y + "px";
    document.getElementById("fmb").style.left = x + "px";
    document.getElementById("fmb").style.width = "40px";
    document.getElementById("fmb").style.height = "40px";

    const w = parseInt(window.innerWidth);
    const h = parseInt(window.innerHeight);
    const w_x = Math.round(((w - x) / w) * 100, 1);
    const h_y = Math.round(((h - y) / h) * 100, 1);

    if (h_y > 50) {
      this.setState({ ...this.state, menuButtonPosition: "bottom" });
    } else {
      this.setState({ ...this.state, menuButtonPosition: "top" });
    }

    if (w_x > 50) {
      this.$f7
        .$('.fab[class*="fab-right-"] .fab-label')
        .css({
          left: "100%",
          right: "unset",
          width: "max-content",
          marginLeft: "8px",
        });
    } else {
      this.$f7
        .$('.fab[class*="fab-right-"] .fab-label')
        .css({
          left: "unset",
          right: "100%",
          width: "max-content",
          marginRight: "8px",
        });
    }
  }

  repositionFab() {
    document
      .getElementById("fmbMoving")
      .addEventListener("mousemove", this.mouse);
    document.getElementById("fmbMoving").style.display = "block";
    this.setState({ ...this.state, moveMenu: !this.state.moveMenu });
  }

  stopMovingFab() {
    if (document.getElementById("fmbMoving").style.display == "block") {
      document
        .getElementById("fmbMoving")
        .removeEventListener("mousemove", this.mouse);
      document.getElementById("fmbMoving").style.display = "none";
      this.setState({ ...this.state, moveMenu: !this.state.moveMenu });
    }
  }

  render() {
    return (
      <div>
        <Fab
          position="right-bottom"
          slot="fixed"
          colorTheme="tint"
          id="fmb"
          onClick={this.stopMovingFab}
          style={
            localStorage.quickMenu === "true" &&
            parseInt(window.innerWidth) <= 800
              ? { display: "block" }
              : { display: "none" }
          }
        >
          <Icon f7="equal"></Icon>
          <Icon ios="f7:xmark" aurora="f7:xmark" md="material:close"></Icon>
          <FabButtons
            position={this.state.menuButtonPosition}
            style={{ left: "20px" }}
          >
            <Link
              className="fab-close fab-label-button"
              tabLink="#view-map"
              panelClose
              popupClose
              popoverClose
            >
              <i className="f7-icons">house</i>
              <span className="fab-label">I'm Hungry</span>
            </Link>

            <Link
              className="fab-close fab-label-button"
              tabLink="#view-account"
              onClick={() => this.props.account("profile")}
              panelClose
              popupClose
              popoverClose
            >
              <i className="f7-icons">person</i>
              <span className="fab-label">Profile</span>
            </Link>

            <Link
              className="fab-close fab-label-button"
              tabLink="#view-account"
              onClick={() => this.props.account("merchant")}
              panelClose
              popupClose
              popoverClose
            >
              <svg
                version="1.1"
                id="IconsRepoEditor"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 510.919 510.919"
                style={{ enableBackground: "new 0 0 510.919 510.919" }}
                width="20px"
                height="20px"
                fill="#000000"
                stroke="#000000"
                strokeWidth="12"
              >
                <g id="IconsRepo_bgCarrier"></g>{" "}
                <path d="M327.528,438.483h-16.004c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16.004c4.142,0,7.5-3.358,7.5-7.5 S331.67,438.483,327.528,438.483z"></path>{" "}
                <path d="M506.52,219.108c-2.918-2.988-6.982-4.702-11.15-4.702h-6.206c-5.548-14.372-14.763-26.99-26.903-36.729 c-12.89-10.341-28.234-16.743-44.567-18.628c-19.564-25.534-50.02-40.675-82.163-40.675c-1.882,0-3.688,0.084-5.479,0.203 c-6.067-4.388-12.504-8.228-19.2-11.481c-1.377-11.658-11.315-20.732-23.337-20.732c-4.359,0-8.442,1.197-11.946,3.273 c-4.133-6.757-11.581-11.276-20.065-11.276s-15.932,4.519-20.065,11.276c-3.503-2.076-7.586-3.273-11.946-3.273 c-12.022,0-21.959,9.074-23.336,20.732c-6.697,3.254-13.134,7.094-19.201,11.482c-1.792-0.119-3.598-0.203-5.479-0.203 c-17.687,0-34.858,4.593-49.99,12.971L67.664,36.201c-0.049-0.082-0.101-0.162-0.153-0.241 c-7.148-10.812-21.761-13.792-32.571-6.644c-10.812,7.148-13.792,21.759-6.644,32.571c0.044,0.066,0.089,0.132,0.135,0.197 l66.87,94.455c-0.674,0.826-1.338,1.661-1.988,2.51c-16.333,1.886-31.678,8.288-44.567,18.628 c-12.14,9.739-21.355,22.357-26.903,36.729h-6.291c-4.212,0-8.162,1.663-11.121,4.683c-2.941,3.002-4.514,6.955-4.429,11.131 c2.192,106.873,46.41,183.467,127.959,221.85v1.915c0,17.374,14.135,31.508,31.508,31.508h192.065 c17.374,0,31.508-14.135,31.508-31.508v-2.286c40.324-19.147,72.016-49.108,94.24-89.115 c20.835-37.506,32.464-83.271,33.63-132.349C511.014,226.064,509.453,222.112,506.52,219.108z M287.514,101.363 c4.69,0,8.506,3.815,8.506,8.505s-3.816,8.505-8.506,8.505s-8.505-3.815-8.505-8.505S282.824,101.363,287.514,101.363z M255.503,93.361c4.69,0,8.505,3.815,8.505,8.505s-3.815,8.505-8.505,8.505s-8.505-3.815-8.505-8.505 S250.813,93.361,255.503,93.361z M223.493,101.363c4.69,0,8.505,3.815,8.505,8.505s-3.815,8.505-8.505,8.505 s-8.505-3.815-8.505-8.505S218.803,101.363,223.493,101.363z M43.213,41.829c3.878-2.565,9.108-1.526,11.718,2.303l57.982,95.409 c-2.444,1.857-4.811,3.824-7.091,5.9L40.754,53.529C38.239,49.626,39.329,44.397,43.213,41.829z M97.919,173.674 c2.217-0.167,4.245-1.31,5.537-3.119c16.634-23.282,43.558-37.182,72.02-37.182c2.318,0,4.685,0.173,7.106,0.366 c1.837,0.146,3.658-0.388,5.123-1.498c4.992-3.781,10.285-7.132,15.795-10.03c4.147,6.693,11.556,11.162,19.992,11.162 c8.484,0,15.932-4.519,20.065-11.276c3.503,2.076,7.586,3.273,11.946,3.273s8.442-1.197,11.946-3.273 c4.133,6.757,11.581,11.276,20.065,11.276c8.436,0,15.845-4.469,19.993-11.162c5.51,2.897,10.803,6.249,15.794,10.03 c1.466,1.11,3.288,1.644,5.123,1.498c2.422-0.193,4.788-0.366,7.106-0.366c28.462,0,55.386,13.9,72.02,37.182 c1.292,1.809,3.32,2.951,5.537,3.119c26.166,1.978,48.657,17.603,59.759,40.732H38.16 C49.262,191.277,71.753,175.653,97.919,173.674z M375.863,438.499c-0.107-0.004-0.211-0.016-0.319-0.016h-16.005 c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h8.505v0.502c0,9.103-7.406,16.508-16.508,16.508H159.471 c-9.103,0-16.508-7.406-16.508-16.508v-0.502h136.551c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5H135.462 c-0.334,0-0.66,0.029-0.983,0.072C66.541,406.603,26.354,345.786,17.027,261.418h350.518c4.142,0,7.5-3.358,7.5-7.5 c0-4.142-3.358-7.5-7.5-7.5H15.713c-0.355-5.414-0.598-10.912-0.713-16.504c-0.001-0.043-0.003-0.174,0.146-0.326 c0.081-0.083,0.217-0.181,0.406-0.181h11.571c0.008,0,0.017,0.002,0.026,0.002c0.008,0,0.016-0.002,0.024-0.002h456.659 c0.008,0,0.016,0.002,0.024,0.002c0.008,0,0.017-0.002,0.026-0.002h11.487c0.199,0,0.337,0.099,0.418,0.181 c0.135,0.138,0.132,0.25,0.131,0.292c-0.133,5.587-0.407,11.099-0.807,16.539h-47.544c-4.142,0-7.5,3.358-7.5,7.5 c0,4.142,3.358,7.5,7.5,7.5h46.09C483.597,344.051,441.743,407.488,375.863,438.499z"></path>{" "}
                <path d="M415.559,246.418h-16.008c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h16.008c4.142,0,7.5-3.358,7.5-7.5 C423.059,249.776,419.701,246.418,415.559,246.418z"></path>{" "}
              </svg>

              <span className="fab-label">Merchant</span>
            </Link>

            <Link
              className="fab-close fab-label-button"
              tabLink="#view-account"
              onClick={() => this.props.account("delivery")}
              panelClose
              popupClose
              popoverClose
            >
              <i className="f7-icons">car_fill</i>
              <span className="fab-label">Delivery Agent</span>
            </Link>

            {!this.state.moveMenu ? (
              <Link
                className="fab-label-button"
                onClick={this.repositionFab}
                style={{ background: "#161616", color: "#fed448" }}
              >
                <i className="f7-icons">move</i>
                <span className="fab-label">Move Menu</span>
              </Link>
            ) : (
              <Link
                className="fab-close fab-label-button"
                onClick={this.stopMovingFab}
                panelClose
                style={{ background: "#161616", color: "#fed448" }}
              >
                <i className="f7-icons">pin_fill</i>
                <span className="fab-label">Pin Menu</span>
              </Link>
            )}
          </FabButtons>
        </Fab>
        <div
          id="fmbMoving"
          style={{
            width: "100vw",
            height: "100vh",
            display: "none",
            backgroundColor: "rgba(0,0,0,0.3)",
            position: "fixed",
            top: 0,
            zIndex: "100000",
          }}
        >
          &nbsp;
        </div>
      </div>
    );
  }
}

export default Fmb;

/* Emoticons Component */
export const Emoticons = (props) => {
  const { selected_rating } = props;

  let background = "";
  switch (selected_rating) {
    case 1:
      background = "shock-face";
      break;
    case 2:
      background = "sad-face";
      break;
    case 3:
      background = "flat-face";
      break;
    case 4:
      background = "smile-face";
      break;
    case 5:
      background = "happy-face";
      break;
    default:
      background = "flat-face";
  }

  let mouth = "";
  switch (selected_rating) {
    case 1:
      mouth = "shock";
      break;
    case 2:
      mouth = "sad";
      break;
    case 3:
      mouth = "flat";
      break;
    case 4:
      mouth = "smile";
      break;
    case 5:
      mouth = "happy";
      break;
    default:
      mouth = "smile";
  }

  return (
    <div className={"ratingApp ".concat(background)}>
      <div className="face">
        <div className="eye" />
        <div className="mouth">
          <div className={mouth} />
        </div>
        <div className="eye" />
      </div>
    </div>
  );
};

/* Emoji Component */
export const Emoji = (props) => {
  const { user_rating } = props;

  let mouth;
  switch (user_rating) {
    case 1: //angry
      mouth = (
        <div className="emoji-wrapper">
          <div className="emoji angry">
            <figure className="face">
              <span className="eyes">
                <span className="eye"></span>
                <span className="eye"></span>
              </span>
              <span className="mouth"></span>
            </figure>
          </div>
        </div>
      );
      break;
    case 2: //sad
      mouth = (
        <div className="emoji-wrapper">
          <div className="emoji sad">
            <figure className="face">
              <span className="eyes">
                <span className="eye"></span>
                <span className="eye"></span>
              </span>
              <span className="mouth tounge"></span>
            </figure>
          </div>
        </div>
      );
      break;
    case 3: //flat
      mouth = (
        <div className="emoji-wrapper">
          <div className="emoji speechless">
            <figure className="face">
              <span className="eyes">
                <span className="eye"></span>
                <span className="eye"></span>
              </span>
              <span className="mouth"></span>
            </figure>
          </div>
        </div>
      );
      break;
    case 4: //smile
      mouth = (
        <div className="emoji-wrapper">
          <div className="emoji smile">
            <figure className="face">
              <span className="eyes">
                <span className="eye"></span>
                <span className="eye"></span>
              </span>
              <span className="mouth"></span>
            </figure>
          </div>
        </div>
      );

      break;
    case 5: //happy
      mouth = (
        <div className="emoji-wrapper">
          <div className="emoji love">
            <figure className="face">
              <span className="eyes">
                <span className="heart-eye">
                  <span className="heart"></span>
                </span>
                <span className="heart-eye">
                  <span className="heart"></span>
                </span>
              </span>
              <span className="mouth tounge"></span>
            </figure>
          </div>
        </div>
      );
      break;
    default: //speechless
      mouth = (
        <div className="emoji-wrapper">
          <div className="emoji speechless">
            <figure className="face">
              <span className="eyes">
                <span className="eye"></span>
                <span className="eye"></span>
              </span>
              <span className="mouth"></span>
            </figure>
          </div>
        </div>
      );
  }

  return <div className="emoji">{mouth}</div>;
};

// No popular meal
export const NoPopMealSvg = (props) => (

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="891.38"
          height="573.886"
          data-name="Layer 1"
          viewBox="0 0 891.381 573.886"
          className="w-full h-full"
        >
          <path
            fill="#e6e6e6"
            d="M68.723 461.8l-6.294-24.823a322.324 322.324 0 00-34.197-12.269l-.794 11.536-3.222-12.71C9.804 419.42 0 417.608 0 417.608s13.243 50.36 41.02 88.86l32.365 5.685-25.144 3.625a130.406 130.406 0 0011.247 11.92c40.407 37.506 85.413 54.714 100.523 38.435s-5.396-59.88-45.803-97.387c-12.526-11.627-28.262-20.958-44.014-28.302z"
            className="no-1 no-pop-meal-1"
          ></path>
          <path
            fill="#e6e6e6"
            d="M128.579 434.843l7.443-24.503a322.325 322.325 0 00-22.932-28.179l-6.643 9.465 3.81-12.546c-10.21-10.972-17.665-17.591-17.665-17.591s-14.694 49.955-10.817 97.27l24.768 21.598-23.399-9.894a130.406 130.406 0 003.467 16.017c15.204 52.993 44.836 90.988 66.185 84.863s26.333-54.05 11.13-107.043c-4.713-16.429-13.36-32.55-23.049-46.979z"
            className="no-2 no-pop-meal-2"
          ></path>
          <path
            fill="#e6e6e6"
            d="M821.742 487.639l14.11-8.87a209.77 209.77 0 00.746-23.632l-7.302 1.819 7.224-4.541c-.338-9.748-1.18-16.182-1.18-16.182s-28.53 18.288-46.806 43.199l2.963 21.18-7.281-14.843a84.867 84.867 0 00-5.128 9.351c-15.13 32.533-16.77 63.848-3.663 69.944s35.997-15.337 51.127-47.87c4.69-10.085 7.316-21.698 8.708-32.922z"
            className="no-3 no-pop-meal-3"
          ></path>
          <path
            fill="#e6e6e6"
            d="M850.423 519.302l16.663-.3a209.77 209.77 0 0012.855-19.844l-7.19-2.217 8.53-.153c4.75-8.52 7.355-14.463 7.355-14.463s-33.876.908-62.398 12.787l-8.411 19.662 1.44-16.47a84.868 84.868 0 00-9.224 5.355c-29.769 20.029-47.36 45.988-39.29 57.98s38.743 5.48 68.511-14.55c9.228-6.209 17.479-14.793 24.472-23.682z"
            className="no-4 no-pop-meal-4"
          ></path>
          <path
            fill="#3f3d56"
            d="M2.029 571.273H890.029V573.514H2.029z"
            className="no-5 no-pop-meal-5"
          ></path>
          <path
            fill="#fff"
            d="M402.421 219.049H404.99399999999997V232.943H402.421z"
            className="no-6 no-pop-meal-6"
            transform="rotate(26.644 661.54 -178.122)"
          ></path>
          <path
            fill="#3f3d56"
            d="M394.196 531.16H394.963V535.302H394.196z"
            className="no-7 no-pop-meal-7"
            transform="rotate(-6.648 -1047.146 1778.38)"
          ></path>
          <path
            fill="#fff"
            d="M396.799 565.653H397.566V569.7950000000001H396.799z"
            className="no-8 no-pop-meal-8"
            transform="rotate(71.644 430.08 381.886)"
          ></path>
          <path
            fill="#fff"
            d="M395.063 546.129H395.83V550.2710000000001H395.063z"
            className="no-9 no-pop-meal-9"
            transform="rotate(-3.441 -2320.628 3029.99)"
          ></path>
          <path
            fill="#fff"
            d="M391.484 523.458H392.251V527.6H391.484z"
            className="no-10 no-pop-meal-10"
            transform="rotate(-3.441 -2324.207 3007.32)"
          ></path>
          <path
            fill="#ff6584"
            d="M444.389 538.698H445.156V542.84H444.389z"
            className="no-11 no-pop-meal-11"
            transform="rotate(68.004 485.361 347.466)"
          ></path>
          <path
            fill="#ff6584"
            d="M400.27 538.969H401.037V543.1110000000001H400.27z"
            className="no-12 no-pop-meal-12"
            transform="rotate(15 925.834 -122.516)"
          ></path>
          <path
            fill="#3f3d56"
            d="M286.479 70.608H288.897V83.666H286.479z"
            className="no-13 no-pop-meal-13"
          ></path>
          <path
            fill="#fff"
            d="M285.028 102.042H287.446V115.1H285.028z"
            className="no-14 no-pop-meal-14"
          ></path>
          <path
            fill="#fff"
            d="M437.469 532.657H438.19V536.5490000000001H437.469z"
            className="no-15 no-pop-meal-15"
            transform="rotate(45 552.277 269.626)"
          ></path>
          <path
            fill="#fff"
            d="M444.706 574.35H445.427V578.2420000000001H444.706z"
            className="no-16 no-pop-meal-16"
            transform="rotate(45 559.515 311.32)"
          ></path>
          <path
            fill="#ff6584"
            d="M439.711 557.734H440.432V561.6260000000001H439.711z"
            className="no-17 no-pop-meal-17"
            transform="rotate(15 965.252 -103.876)"
          ></path>
          <path
            fill="#ff6584"
            d="M440.731 542.851H441.452V546.743H440.731z"
            className="no-18 no-pop-meal-18"
            transform="rotate(45 555.54 279.82)"
          ></path>
          <path
            fill="#3f3d56"
            d="M277.806 384.67a3.307 3.307 0 00-4.677-4.676L167.613 485.51a3.307 3.307 0 104.676 4.677l104.838-104.838"
            className="no-19 no-pop-meal-19"
          ></path>
          <path
            fill="#f9a826"
            d="M288.591 371.353a49.71 49.71 0 1012.377 49.809 49.733 49.733 0 00-12.377-49.809zm-40.702 54.094a20.575 20.575 0 01-9.05-5.281 22.704 22.704 0 01-1.429-1.588 20.621 20.621 0 1110.479 6.87z"
            className="no-20 no-pop-meal-20"
          ></path>
          <path
            fill="#3f3d56"
            d="M175.926 94.945a11.093 11.093 0 00-22.186 0v467.539a11.093 11.093 0 1022.186 0V98.167"
            className="no-21 no-pop-meal-21"
          ></path>
          <path
            fill="#f9a826"
            d="M317.428 90.8a166.89 166.89 0 1019.35 78.05 166.805 166.805 0 00-19.35-78.05zM203.92 229.092a69.167 69.167 0 1135.167-60.24 68.827 68.827 0 01-35.167 60.24z"
            className="no-22 no-pop-meal-22"
          ></path>
          <path
            d="M169.444 325.054A166.842 166.842 0 012.686 163.41q-.086 2.708-.088 5.436a166.847 166.847 0 10333.693 0q0-2.732-.088-5.442a166.842 166.842 0 01-166.759 161.649z"
            className="no-23 no-pop-meal-23"
            opacity="0.2"
          ></path>
          <path
            d="M169.928 85.594a83.251 83.251 0 1083.256 83.257 83.349 83.349 0 00-83.256-83.257zm33.992 143.497a69.167 69.167 0 1135.167-60.24 68.827 68.827 0 01-35.167 60.24z"
            className="no-24 no-pop-meal-24"
            opacity="0.2"
          ></path>
          <path
            fill="#e6e6e6"
            d="M317.43 88.796v27.755a10.149 10.149 0 01-17.478 7.027v3.163a12.056 12.056 0 11-24.113 0v-2.636a10.143 10.143 0 01-16.926-7.554l-.484-29.5v-6.805a4.11 4.11 0 00-8.221 0v6.804l-.484 24.665a10.156 10.156 0 01-20.312 0L228.17 87.05V74.443a6.737 6.737 0 00-13.474 0V87.05l-.76 24.665a10.148 10.148 0 01-18.135 6.267 10.129 10.129 0 01-13.85 2.012v6.747a12.056 12.056 0 11-24.113 0v-20.83a10.152 10.152 0 01-19.413 4.164v16.666a12.056 12.056 0 11-24.113 0V87.05h-.067v39.69a12.056 12.056 0 11-24.113 0v-16.525a10.15 10.15 0 01-19.345-4.305v-18.86h-1.035v33.886a12.056 12.056 0 01-24.113 0v-15.026a10.156 10.156 0 11-20.312 0V83.554a166.905 166.905 0 01292.103 5.242z"
            className="no-25 no-pop-meal-25"
          ></path>
          <path
            d="M102.188 132.994a12.056 12.056 0 01-12.056-12.057v6.287a12.056 12.056 0 0024.113 0v-6.287a12.056 12.056 0 01-12.057 12.057z"
            className="no-26 no-pop-meal-26"
            opacity="0.2"
          ></path>
          <path
            d="M126.369 132.994a12.056 12.056 0 01-12.057-12.057v6.287a12.056 12.056 0 0024.113 0v-6.287a12.056 12.056 0 01-12.056 12.057z"
            className="no-27 no-pop-meal-27"
            opacity="0.2"
          ></path>
          <path
            d="M90.132 104.412a10.15 10.15 0 01-19.345-4.304v6.287a10.15 10.15 0 0019.345 4.304z"
            className="no-28 no-pop-meal-28"
            opacity="0.2"
          ></path>
          <path
            d="M114.245 81.247H114.313V87.534H114.245z"
            className="no-29 no-pop-meal-29"
            opacity="0.2"
          ></path>
          <path
            d="M45.64 100.108a10.156 10.156 0 01-20.312 0v6.287a10.156 10.156 0 0020.311 0z"
            className="no-30 no-pop-meal-30"
            opacity="0.2"
          ></path>
          <path
            d="M69.752 81.247H70.78699999999999V87.534H69.752z"
            className="no-31 no-pop-meal-31"
            opacity="0.2"
          ></path>
          <path
            d="M57.696 127.19a12.056 12.056 0 01-12.057-12.056v6.287a12.056 12.056 0 1024.113 0v-6.287a12.056 12.056 0 01-12.056 12.056z"
            className="no-32 no-pop-meal-32"
            opacity="0.2"
          ></path>
          <path
            d="M169.894 132.994a12.056 12.056 0 01-12.056-12.057v6.287a12.056 12.056 0 0024.113 0v-6.287a12.056 12.056 0 01-12.057 12.057z"
            className="no-33 no-pop-meal-33"
            opacity="0.2"
          ></path>
          <path
            d="M258.43 74.443a4.11 4.11 0 10-8.222 0v6.287a4.11 4.11 0 118.221 0z"
            className="no-34 no-pop-meal-34"
            opacity="0.2"
          ></path>
          <path
            d="M157.838 100.108a10.152 10.152 0 01-19.413 4.164v6.287a10.152 10.152 0 0019.413-4.164z"
            className="no-35 no-pop-meal-35"
            opacity="0.2"
          ></path>
          <path
            d="M239.568 116.067a10.155 10.155 0 01-10.156-10.156l-1.242-24.664v6.287l1.242 24.664a10.156 10.156 0 0020.312 0l.484-24.664v-6.287l-.484 24.664a10.155 10.155 0 01-10.156 10.156z"
            className="no-36 no-pop-meal-36"
            opacity="0.2"
          ></path>
          <path
            d="M307.274 120.903a10.123 10.123 0 01-7.322-3.129v3.163a12.056 12.056 0 01-24.113 0v-2.635a10.143 10.143 0 01-16.926-7.554l-.484-29.5v6.286l.484 29.5a10.143 10.143 0 0016.926 7.555v2.635a12.056 12.056 0 0024.113 0v-3.163a10.149 10.149 0 0017.478-7.026v-6.287a10.155 10.155 0 01-10.156 10.155z"
            className="no-37 no-pop-meal-37"
            opacity="0.2"
          ></path>
          <path
            d="M203.78 116.067a10.131 10.131 0 01-7.979-3.888 10.129 10.129 0 01-13.85 2.012v6.287a10.129 10.129 0 0013.85-2.012 10.148 10.148 0 0018.136-6.268l.76-24.664v-6.287l-.76 24.664a10.155 10.155 0 01-10.156 10.156z"
            className="no-38 no-pop-meal-38"
            opacity="0.2"
          ></path>
          <path
            d="M228.17 68.64a6.737 6.737 0 10-13.474 0v6.286a6.737 6.737 0 1113.474 0z"
            className="no-39 no-pop-meal-39"
            opacity="0.2"
          ></path>
          <path
            fill="#3f3d56"
            d="M113.103 69.882H115.521V82.94H113.103z"
            className="no-40 no-pop-meal-40"
          ></path>
          <path
            fill="#3f3d56"
            d="M158.805 62.87H161.223V75.928H158.805z"
            className="no-41 no-pop-meal-41"
          ></path>
          <path
            fill="#3f3d56"
            d="M100.771 114.133H103.18900000000001V127.191H100.771z"
            className="no-42 no-pop-meal-42"
          ></path>
          <path
            fill="#3f3d56"
            d="M349.889 248.005H352.307V261.063H349.889z"
            className="no-43 no-pop-meal-43"
            transform="rotate(34.679 528.057 -71.11)"
          ></path>
          <path
            fill="#3f3d56"
            d="M230.92 227.694H233.338V240.75199999999998H230.92z"
            className="no-44 no-pop-meal-44"
            transform="rotate(-51.648 -8.593 313.906)"
          ></path>
          <path
            fill="#3f3d56"
            d="M373.102 178.849H375.52V191.90699999999998H373.102z"
            className="no-45 no-pop-meal-45"
            transform="rotate(-51.648 133.59 265.061)"
          ></path>
          <path
            fill="#3f3d56"
            d="M204.321 241.235H206.739V254.293H204.321z"
            className="no-46 no-pop-meal-46"
            transform="rotate(-51.648 -35.192 327.448)"
          ></path>
          <path
            fill="#fff"
            d="M122.05 39.173H124.468V52.231H122.05z"
            className="no-47 no-pop-meal-47"
          ></path>
          <path
            fill="#fff"
            d="M55.795 106.395H58.213V119.453H55.795z"
            className="no-48 no-pop-meal-48"
          ></path>
          <path
            fill="#fff"
            d="M168.961 20.312H171.37900000000002V33.370000000000005H168.961z"
            className="no-49 no-pop-meal-49"
          ></path>
          <path
            fill="#fff"
            d="M333.446 223.341H335.86400000000003V236.399H333.446z"
            className="no-50 no-pop-meal-50"
            transform="rotate(26.644 592.487 -174.249)"
          ></path>
          <path
            fill="#fff"
            d="M322.323 271.702H324.741V284.76H322.323z"
            className="no-51 no-pop-meal-51"
            transform="rotate(26.644 581.364 -125.887)"
          ></path>
          <path
            fill="#fff"
            d="M297.175 245.104H299.593V258.16200000000003H297.175z"
            className="no-52 no-pop-meal-52"
            transform="rotate(-48.441 45.249 343.362)"
          ></path>
          <path
            fill="#fff"
            d="M249.297 188.521H251.715V201.57899999999998H249.297z"
            className="no-53 no-pop-meal-53"
            transform="rotate(-48.441 -2.63 286.78)"
          ></path>
          <path
            fill="#fff"
            d="M408.406 210.284H410.824V223.34199999999998H408.406z"
            className="no-54 no-pop-meal-54"
            transform="rotate(-48.441 156.48 308.542)"
          ></path>
          <path
            fill="#fff"
            d="M349.889 167.726H352.307V180.784H349.889z"
            className="no-55 no-pop-meal-55"
            transform="rotate(-48.441 97.963 265.984)"
          ></path>
          <path
            fill="#ff6584"
            d="M140.428 62.87H142.846V75.928H140.428z"
            className="no-56 no-pop-meal-56"
          ></path>
          <path
            fill="#ff6584"
            d="M428.234 228.661H430.652V241.719H428.234z"
            className="no-57 no-pop-meal-57"
            transform="rotate(23.004 742.07 -222.1)"
          ></path>
          <path
            fill="#ff6584"
            d="M249.297 242.202H251.715V255.26H249.297z"
            className="no-58 no-pop-meal-58"
            transform="rotate(-30 -122.25 456.543)"
          ></path>
          <path
            fill="#ff6584"
            d="M387.611 233.013H390.029V246.071H387.611z"
            className="no-59 no-pop-meal-59"
            transform="rotate(-30 16.063 447.354)"
          ></path>
          <path
            fill="#ff6584"
            d="M301.528 185.136H303.946V198.194H301.528z"
            className="no-60 no-pop-meal-60"
            transform="rotate(-30 -70.02 399.476)"
          ></path>
          <path
            fill="#ff6584"
            d="M404.054 182.718H406.472V195.77599999999998H404.054z"
            className="no-61 no-pop-meal-61"
            transform="rotate(-30 32.506 397.058)"
          ></path>
          <path
            fill="#ff6584"
            d="M271.06 172.078H273.478V185.136H271.06z"
            className="no-62 no-pop-meal-62"
            transform="rotate(-30 -100.488 386.419)"
          ></path>
          <path
            fill="#ff6584"
            d="M200.879 36.755H203.297V49.813H200.879z"
            className="no-63 no-pop-meal-63"
          ></path>
          <path
            fill="#ff6584"
            d="M61.599 58.517H64.017V71.575H61.599z"
            className="no-64 no-pop-meal-64"
          ></path>
          <path
            d="M220.392 439.352a49.736 49.736 0 01-1.078-69.223q-.59.552-1.165 1.127a49.737 49.737 0 1070.339 70.338q.576-.576 1.128-1.165a49.736 49.736 0 01-69.224-1.077z"
            className="no-65 no-pop-meal-65"
            opacity="0.2"
          ></path>
          <path
            d="M272.981 386.963a27.674 27.674 0 100 39.124 27.708 27.708 0 000-39.124zm-4.98 33.203a20.627 20.627 0 01-29.162 0 22.704 22.704 0 01-1.429-1.588 20.616 20.616 0 1130.59 1.588z"
            className="no-66 no-pop-meal-66"
            opacity="0.2"
          ></path>
          <path
            fill="#e6e6e6"
            d="M301.964 420.166l-5.85 5.85a3.025 3.025 0 01-5.165-2.202l-.667.667a3.594 3.594 0 01-5.083-5.083l.556-.556a3.024 3.024 0 01-1.976-5.16l6.117-6.32 1.434-1.434a1.225 1.225 0 00-1.733-1.733l-1.434 1.434-5.301 5.097a3.027 3.027 0 01-4.282-4.282l4.937-5.46 2.658-2.658a2.008 2.008 0 00-2.84-2.84l-2.658 2.657-5.359 5.04a34.695 34.695 0 00-7.645-3.365 3.017 3.017 0 01-.842-1.633l-1.422 1.422a3.594 3.594 0 01-5.083-5.082l4.39-4.391a3.026 3.026 0 01-4.969-3.214l-3.513 3.513a3.594 3.594 0 01-5.083-5.083l8.367-8.366-.015-.015-8.366 8.367a3.594 3.594 0 01-5.083-5.083l3.484-3.483a3.026 3.026 0 01-3.17-4.985l3.975-3.976-.218-.218-7.143 7.143a3.594 3.594 0 01-5.083-5.083l3.168-3.167a3.027 3.027 0 01-4.282-4.282l4.713-4.712a49.754 49.754 0 0160.466 62.676z"
            className="no-67 no-pop-meal-67"
          ></path>
          <path
            d="M247.278 384.112a3.594 3.594 0 010-5.082l-1.325 1.325a3.594 3.594 0 005.082 5.083l1.325-1.326a3.594 3.594 0 01-5.082 0z"
            className="no-68 no-pop-meal-68"
            opacity="0.2"
          ></path>
          <path
            d="M252.375 389.21a3.594 3.594 0 010-5.083l-1.325 1.325a3.594 3.594 0 105.082 5.083l1.325-1.326a3.594 3.594 0 01-5.082 0z"
            className="no-69 no-pop-meal-69"
            opacity="0.2"
          ></path>
          <path
            d="M250.761 375.546a3.026 3.026 0 01-3.17-4.984l-1.326 1.325a3.026 3.026 0 003.17 4.985z"
            className="no-70 no-pop-meal-70"
            opacity="0.2"
          ></path>
          <path
            d="M412.98 534.943H414.85400000000004V534.963H412.98z"
            className="no-71 no-pop-meal-71"
            opacity="0.2"
            transform="rotate(-45 145.623 641.393)"
          ></path>
          <path
            d="M242.29 365.26a3.027 3.027 0 11-4.282-4.28l-1.325 1.324a3.027 3.027 0 004.282 4.282z"
            className="no-72 no-pop-meal-72"
            opacity="0.2"
          ></path>
          <path
            d="M403.703 525.522H405.577V525.831H403.703z"
            className="no-73 no-pop-meal-73"
            opacity="0.2"
            transform="rotate(-45 136.347 632.116)"
          ></path>
          <path
            d="M239.123 373.51a3.594 3.594 0 010-5.082l-1.326 1.325a3.594 3.594 0 105.083 5.083l1.325-1.325a3.594 3.594 0 01-5.082 0z"
            className="no-74 no-pop-meal-74"
            opacity="0.2"
          ></path>
          <path
            d="M261.55 398.384a3.594 3.594 0 010-5.083l-1.326 1.325a3.594 3.594 0 105.083 5.083l1.325-1.325a3.594 3.594 0 01-5.083 0z"
            className="no-75 no-pop-meal-75"
            opacity="0.2"
          ></path>
          <path
            d="M292.553 404.704a1.225 1.225 0 00-1.733-1.733l-1.325 1.325a1.225 1.225 0 111.733 1.733z"
            className="no-76 no-pop-meal-76"
            opacity="0.2"
          ></path>
          <path
            d="M265.94 388.91a3.026 3.026 0 01-4.97-3.213l-1.325 1.325a3.026 3.026 0 004.97 3.214z"
            className="no-77 no-pop-meal-77"
            opacity="0.2"
          ></path>
          <path
            d="M279.804 409.503a3.027 3.027 0 010-4.282l4.937-5.46-1.326 1.324-4.936 5.461a3.027 3.027 0 104.281 4.282l5.3-5.097 1.326-1.325-5.3 5.097a3.027 3.027 0 01-4.282 0z"
            className="no-78 no-pop-meal-78"
            opacity="0.2"
          ></path>
          <path
            d="M293.056 424.794a3.018 3.018 0 01-.884-2.203l-.667.666a3.594 3.594 0 11-5.082-5.082l.555-.556a3.024 3.024 0 01-1.975-5.16l6.116-6.32-1.325 1.325-6.117 6.32a3.024 3.024 0 001.976 5.16l-.556.556a3.594 3.594 0 105.083 5.083l.667-.667a3.025 3.025 0 005.165 2.203l1.325-1.325a3.027 3.027 0 01-4.281 0z"
            className="no-79 no-pop-meal-79"
            opacity="0.2"
          ></path>
          <path
            d="M272.26 401.959a3.02 3.02 0 00-3.364-3.364 3.017 3.017 0 01-.842-1.633l-1.325 1.325a5.804 5.804 0 014.206 4.997 3.027 3.027 0 004.281 0l5.36-5.039 1.325-1.325-5.36 5.039a3.027 3.027 0 01-4.28 0z"
            className="no-80 no-pop-meal-80"
            opacity="0.2"
          ></path>
          <path
            d="M287.398 397.103a2.008 2.008 0 10-2.84-2.84l-1.325 1.325a2.008 2.008 0 112.84 2.84z"
            className="no-81 no-pop-meal-81"
            opacity="0.2"
          ></path>
          <path
            fill="#3f3d56"
            d="M415.246 531.332H415.967V535.224H415.246z"
            className="no-82 no-pop-meal-82"
            transform="rotate(45 530.054 268.301)"
          ></path>
          <path
            fill="#3f3d56"
            d="M426.357 539.487H427.07800000000003V543.379H426.357z"
            className="no-83 no-pop-meal-83"
            transform="rotate(45 541.166 276.456)"
          ></path>
          <path
            fill="#3f3d56"
            d="M437.357 533.487H438.07800000000003V537.379H437.357z"
            className="no-84 no-pop-meal-84"
            transform="rotate(45 552.166 270.456)"
          ></path>
          <path
            fill="#3f3d56"
            d="M403.319 538.06H404.04V541.952H403.319z"
            className="no-85 no-pop-meal-85"
            transform="rotate(45 518.127 275.03)"
          ></path>
          <path
            fill="#3f3d56"
            d="M428.6 552.943H429.321V556.835H428.6z"
            className="no-86 no-pop-meal-86"
            transform="rotate(79.679 447.045 383.424)"
          ></path>
          <path
            fill="#3f3d56"
            d="M444.6 545.943H445.321V549.835H444.6z"
            className="no-87 no-pop-meal-87"
            transform="rotate(79.679 463.045 376.424)"
          ></path>
          <path
            fill="#3f3d56"
            d="M407.804 523.584H408.525V527.476H407.804z"
            className="no-88 no-pop-meal-88"
            transform="rotate(-6.648 -1033.56 1770.68)"
          ></path>
          <path
            fill="#3f3d56"
            d="M399.343 520.832H400.064V524.724H399.343z"
            className="no-89 no-pop-meal-89"
            transform="rotate(-6.648 -1042.022 1767.928)"
          ></path>
          <path
            fill="#fff"
            d="M423.605 526.744H424.326V530.6360000000001H423.605z"
            className="no-90 no-pop-meal-90"
            transform="rotate(45 538.413 263.714)"
          ></path>
          <path
            fill="#fff"
            d="M444.605 540.744H445.326V544.6360000000001H444.605z"
            className="no-91 no-pop-meal-91"
            transform="rotate(45 559.413 277.714)"
          ></path>
          <path
            fill="#fff"
            d="M452.605 560.744H453.326V564.6360000000001H452.605z"
            className="no-92 no-pop-meal-92"
            transform="rotate(45 567.413 297.714)"
          ></path>
          <path
            fill="#fff"
            d="M395.469 526.948H396.19V530.84H395.469z"
            className="no-93 no-pop-meal-93"
            transform="rotate(45 510.278 263.918)"
          ></path>
          <path
            fill="#fff"
            d="M430.333 544.278H431.05400000000003V548.1700000000001H430.333z"
            className="no-94 no-pop-meal-94"
            transform="rotate(71.644 463.59 360.386)"
          ></path>
          <path
            fill="#fff"
            d="M417.794 552.127H418.515V556.019H417.794z"
            className="no-95 no-pop-meal-95"
            transform="rotate(71.644 451.051 368.235)"
          ></path>
          <path
            fill="#fff"
            d="M418.1 541.22H418.821V545.1120000000001H418.1z"
            className="no-96 no-pop-meal-96"
            transform="rotate(-3.441 -2297.614 3024.956)"
          ></path>
          <path
            fill="#fff"
            d="M419.935 519.201H420.656V523.0930000000001H419.935z"
            className="no-97 no-pop-meal-97"
            transform="rotate(-3.441 -2295.78 3002.937)"
          ></path>
          <path
            fill="#ff6584"
            d="M422.484 535.613H423.205V539.5050000000001H422.484z"
            className="no-98 no-pop-meal-98"
            transform="rotate(45 537.292 272.583)"
          ></path>
          <path
            fill="#ff6584"
            d="M446.484 569.613H447.205V573.5050000000001H446.484z"
            className="no-99 no-pop-meal-99"
            transform="rotate(45 561.292 306.583)"
          ></path>
          <path
            fill="#ff6584"
            d="M450.484 552.613H451.205V556.5050000000001H450.484z"
            className="no-100 no-pop-meal-100"
            transform="rotate(45 565.292 289.583)"
          ></path>
          <path
            fill="#ff6584"
            d="M408.62 530.516H409.341V534.408H408.62z"
            className="no-101 no-pop-meal-101"
            transform="rotate(15 934.16 -131.094)"
          ></path>
          <path
            fill="#ff6584"
            d="M431.658 529.497H432.379V533.389H431.658z"
            className="no-102 no-pop-meal-102"
            transform="rotate(15 957.2 -132.113)"
          ></path>
          <path
            fill="#ff6584"
            d="M427.988 520.322H428.709V524.214H427.988z"
            className="no-103 no-pop-meal-103"
            transform="rotate(15 953.53 -141.288)"
          ></path>
          <path
            fill="#ff6584"
            d="M406.785 518.08H407.50600000000003V521.9720000000001H406.785z"
            className="no-104 no-pop-meal-104"
            transform="rotate(45 521.593 255.049)"
          ></path>
          <path
            fill="#3f3d56"
            d="M775.38 206.93a8 8 0 10-16 0v358.647a8 8 0 0016 0V209.253"
            className="no-105 no-pop-meal-105"
          ></path>
          <path
            fill="#f9a826"
            d="M877.43 225.963a120.362 120.362 0 00-221.22 92.29h14.93c3 0 5.46 3.34 5.46 7.43h2.74c3.01 0 5.47 3.34 5.47 7.43 0 4.08-2.46 7.43-5.47 7.43h-2.74a10.087 10.087 0 01-.19 1.85h12.5c3.01 0 5.47 3.35 5.47 7.43 0 4.09-2.46 7.43-5.47 7.43h-11.94a120.34 120.34 0 00200.46-131.29zm-81.86 99.74a49.676 49.676 0 01-24.52 6.42 51.473 51.473 0 01-5.15-.26 49.849 49.849 0 1129.67-6.16z"
            className="no-106 no-pop-meal-106"
          ></path>
          <path
            d="M694.053 347.325a9.736 9.736 0 00.328-2.5c0-4.086-2.462-7.429-5.47-7.429h-5.116a5.24 5.24 0 01-4.455 3.143h-2.735a9.754 9.754 0 01-.196 1.857h12.502c2.362 0 4.381 2.065 5.142 4.929z"
            className="no-107 no-pop-meal-107"
            opacity="0.2"
          ></path>
          <path
            d="M679.34 325.682c2.362 0 4.38 2.065 5.142 4.928a9.73 9.73 0 00.327-2.5c0-4.085-2.461-7.428-5.47-7.428h-2.734c0-4.086-2.461-7.429-5.47-7.429H656.21a120.181 120.181 0 01-5.436-33.671c-.02.89-.045 1.777-.045 2.671a120.276 120.276 0 005.48 36h14.927c3.008 0 5.469 3.343 5.469 7.429z"
            className="no-108 no-pop-meal-108"
            opacity="0.2"
          ></path>
          <path
            d="M771.055 397.579a120.017 120.017 0 01-89.87-40.326h-4.219a120.323 120.323 0 00214.415-75c0-.752-.022-1.5-.035-2.248a120.323 120.323 0 01-120.291 117.574z"
            className="no-109 no-pop-meal-109"
            opacity="0.2"
          ></path>
          <path
            d="M771.05 222.383a59.87 59.87 0 1059.88 59.87 59.94 59.94 0 00-59.88-59.87zm24.52 103.32a49.676 49.676 0 01-24.52 6.42 51.473 51.473 0 01-5.15-.26 49.849 49.849 0 1129.67-6.16z"
            className="no-110 no-pop-meal-110"
            opacity="0.2"
          ></path>
          <path
            fill="#e6e6e6"
            d="M877.43 223.965v20.016a7.319 7.319 0 01-12.605 5.068v2.28a8.695 8.695 0 11-17.39 0v-1.9a7.315 7.315 0 01-12.206-5.448l-.35-21.275V217.8a2.965 2.965 0 10-5.928 0v4.907l-.35 17.788a7.324 7.324 0 01-14.647 0l-.897-17.788v-9.092a4.858 4.858 0 00-9.717 0v9.092l-.547 17.788a7.319 7.319 0 01-13.079 4.52 7.304 7.304 0 01-9.989 1.45v4.866a8.695 8.695 0 01-17.39 0v-15.022a7.321 7.321 0 01-13.999 3.003v12.019a8.695 8.695 0 01-17.39 0v-28.624h-.049v28.624a8.695 8.695 0 11-17.39 0v-11.918a7.32 7.32 0 01-13.95-3.104v-13.602h-.746v24.439a8.695 8.695 0 01-17.39 0v-10.837a7.324 7.324 0 01-14.648 0v-16.123a120.368 120.368 0 01210.657 3.78z"
            className="no-111 no-pop-meal-111"
          ></path>
          <path
            d="M722.203 255.84a8.694 8.694 0 01-8.695-8.695v4.534a8.695 8.695 0 0017.39 0v-4.534a8.694 8.694 0 01-8.695 8.694z"
            className="no-112 no-pop-meal-112"
            opacity="0.2"
          ></path>
          <path
            d="M739.641 255.84a8.694 8.694 0 01-8.695-8.695v4.534a8.695 8.695 0 0017.39 0v-4.534a8.694 8.694 0 01-8.695 8.694z"
            className="no-113 no-pop-meal-113"
            opacity="0.2"
          ></path>
          <path
            d="M713.508 235.227a7.32 7.32 0 01-13.95-3.104v4.534a7.32 7.32 0 0013.95 3.104z"
            className="no-114 no-pop-meal-114"
            opacity="0.2"
          ></path>
          <path
            d="M730.898 218.521H730.947V223.05499999999998H730.898z"
            className="no-115 no-pop-meal-115"
            opacity="0.2"
          ></path>
          <path
            d="M681.421 232.123a7.324 7.324 0 01-14.648 0v4.534a7.324 7.324 0 0014.648 0z"
            className="no-116 no-pop-meal-116"
            opacity="0.2"
          ></path>
          <path
            d="M698.811 218.521H699.557V223.05499999999998H698.811z"
            className="no-117 no-pop-meal-117"
            opacity="0.2"
          ></path>
          <path
            d="M690.116 251.654a8.694 8.694 0 01-8.695-8.695v4.534a8.695 8.695 0 0017.39 0v-4.534a8.694 8.694 0 01-8.695 8.695z"
            className="no-118 no-pop-meal-118"
            opacity="0.2"
          ></path>
          <path
            d="M771.03 255.84a8.694 8.694 0 01-8.694-8.695v4.534a8.695 8.695 0 1017.39 0v-4.534a8.694 8.694 0 01-8.696 8.694z"
            className="no-119 no-pop-meal-119"
            opacity="0.2"
          ></path>
          <path
            d="M834.88 213.614a2.965 2.965 0 10-5.93 0v4.534a2.965 2.965 0 115.93 0z"
            className="no-120 no-pop-meal-120"
            opacity="0.2"
          ></path>
          <path
            d="M762.336 232.123a7.321 7.321 0 01-14 3.003v4.534a7.321 7.321 0 0014-3.003z"
            className="no-121 no-pop-meal-121"
            opacity="0.2"
          ></path>
          <path
            d="M821.278 243.633a7.323 7.323 0 01-7.324-7.325l-.897-17.787v4.534l.897 17.787a7.324 7.324 0 0014.648 0l.349-17.787v-4.534l-.35 17.787a7.323 7.323 0 01-7.323 7.325z"
            className="no-122 no-pop-meal-122"
            opacity="0.2"
          ></path>
          <path
            d="M870.106 247.12a7.3 7.3 0 01-5.28-2.256v2.28a8.695 8.695 0 11-17.39 0v-1.9a7.315 7.315 0 01-12.208-5.448l-.348-21.275v4.534l.348 21.275a7.315 7.315 0 0012.207 5.448v1.9a8.695 8.695 0 0017.39 0v-2.28a7.319 7.319 0 0012.605-5.068v-4.534a7.323 7.323 0 01-7.324 7.324z"
            className="no-123 no-pop-meal-123"
            opacity="0.2"
          ></path>
          <path
            d="M795.469 243.633a7.306 7.306 0 01-5.755-2.805 7.304 7.304 0 01-9.989 1.451v4.534a7.304 7.304 0 009.99-1.45 7.319 7.319 0 0013.078-4.52l.548-17.788v-4.534l-.548 17.787a7.323 7.323 0 01-7.324 7.325z"
            className="no-124 no-pop-meal-124"
            opacity="0.2"
          ></path>
          <path
            d="M813.057 209.429a4.858 4.858 0 10-9.716 0v4.534a4.858 4.858 0 119.716 0z"
            className="no-125 no-pop-meal-125"
            opacity="0.2"
          ></path>
          <path
            fill="#3f3d56"
            d="M730.074 210.325H731.818V219.742H730.074z"
            className="no-126 no-pop-meal-126"
          ></path>
          <path
            fill="#3f3d56"
            d="M763.033 205.268H764.777V214.685H763.033z"
            className="no-127 no-pop-meal-127"
          ></path>
          <path
            fill="#3f3d56"
            d="M855.108 210.848H856.852V220.26500000000001H855.108z"
            className="no-128 no-pop-meal-128"
          ></path>
          <path
            fill="#3f3d56"
            d="M721.181 242.237H722.9250000000001V251.654H721.181z"
            className="no-129 no-pop-meal-129"
          ></path>
          <path
            fill="#3f3d56"
            d="M943.734 382.987H945.4780000000001V392.404H943.734z"
            className="no-130 no-pop-meal-130"
            transform="rotate(34.679 1121.57 62.054)"
          ></path>
          <path
            fill="#3f3d56"
            d="M857.937 368.339H859.681V377.756H857.937z"
            className="no-131 no-pop-meal-131"
            transform="rotate(-51.648 618.087 452.731)"
          ></path>
          <path
            fill="#3f3d56"
            d="M960.475 333.113H962.219V342.53H960.475z"
            className="no-132 no-pop-meal-132"
            transform="rotate(-51.648 720.625 417.505)"
          ></path>
          <path
            fill="#3f3d56"
            d="M838.755 378.104H840.499V387.52099999999996H838.755z"
            className="no-133 no-pop-meal-133"
            transform="rotate(-51.648 598.909 462.499)"
          ></path>
          <path
            fill="#fff"
            d="M736.527 188.178H738.2710000000001V197.595H736.527z"
            className="no-134 no-pop-meal-134"
          ></path>
          <path
            fill="#fff"
            d="M688.745 236.657H690.489V246.074H688.745z"
            className="no-135 no-pop-meal-135"
          ></path>
          <path
            fill="#fff"
            d="M770.357 174.576H772.101V183.993H770.357z"
            className="no-136 no-pop-meal-136"
          ></path>
          <path
            fill="#fff"
            d="M854.062 233.518H855.806V242.935H854.062z"
            className="no-137 no-pop-meal-137"
          ></path>
          <path
            fill="#fff"
            d="M931.876 365.2H933.62V374.61699999999996H931.876z"
            className="no-138 no-pop-meal-138"
            transform="rotate(26.644 1190.58 -34.21)"
          ></path>
          <path
            fill="#fff"
            d="M923.854 400.077H925.5980000000001V409.49399999999997H923.854z"
            className="no-139 no-pop-meal-139"
            transform="rotate(26.644 1182.559 .667)"
          ></path>
          <path
            fill="#fff"
            d="M1020.115 384.382H1021.859V393.799H1020.115z"
            className="no-140 no-pop-meal-140"
            transform="rotate(26.644 1278.82 -15.028)"
          ></path>
          <path
            fill="#fff"
            d="M905.718 380.894H907.462V390.311H905.718z"
            className="no-141 no-pop-meal-141"
            transform="rotate(-48.441 653.455 477.333)"
          ></path>
          <path
            fill="#fff"
            d="M871.19 340.088H872.9340000000001V349.505H871.19z"
            className="no-142 no-pop-meal-142"
            transform="rotate(-48.441 618.927 436.527)"
          ></path>
          <path
            fill="#fff"
            d="M985.935 355.783H987.679V365.2H985.935z"
            className="no-143 no-pop-meal-143"
            transform="rotate(-48.441 733.672 452.221)"
          ></path>
          <path
            fill="#fff"
            d="M943.734 325.091H945.4780000000001V334.508H943.734z"
            className="no-144 no-pop-meal-144"
            transform="rotate(-48.441 691.47 421.53)"
          ></path>
          <path
            fill="#ff6584"
            d="M749.78 205.268H751.524V214.685H749.78z"
            className="no-145 no-pop-meal-145"
          ></path>
          <path
            fill="#ff6584"
            d="M1000.235 369.036H1001.979V378.453H1000.235z"
            className="no-146 no-pop-meal-146"
            transform="rotate(23.004 1313.733 -83.546)"
          ></path>
          <path
            fill="#ff6584"
            d="M871.19 378.802H872.9340000000001V388.219H871.19z"
            className="no-147 no-pop-meal-147"
            transform="rotate(-30 499.305 591.322)"
          ></path>
          <path
            fill="#ff6584"
            d="M970.938 372.175H972.682V381.592H970.938z"
            className="no-148 no-pop-meal-148"
            transform="rotate(-30 599.054 584.695)"
          ></path>
          <path
            fill="#ff6584"
            d="M908.857 337.647H910.601V347.06399999999996H908.857z"
            className="no-149 no-pop-meal-149"
            transform="rotate(-30 536.972 550.167)"
          ></path>
          <path
            fill="#ff6584"
            d="M982.797 335.903H984.541V345.32H982.797z"
            className="no-150 no-pop-meal-150"
            transform="rotate(-30 610.912 548.423)"
          ></path>
          <path
            fill="#ff6584"
            d="M886.885 328.23H888.629V337.647H886.885z"
            className="no-151 no-pop-meal-151"
            transform="rotate(-30 515 540.75)"
          ></path>
          <path
            fill="#ff6584"
            d="M793.376 186.434H795.12V195.851H793.376z"
            className="no-152 no-pop-meal-152"
          ></path>
          <path
            fill="#ff6584"
            d="M692.93 202.129H694.674V211.546H692.93z"
            className="no-153 no-pop-meal-153"
          ></path>
          <circle
            cx="354.258"
            cy="504.177"
            r="42.012"
            fill="#2f2e41"
            className="no-154 no-pop-meal-154"
          ></circle>
          <path
            fill="#2f2e41"
            d="M522.191 692.702H534.9540000000001V715.569H522.191z"
            className="no-155 no-pop-meal-155"
            transform="rotate(169.739 458.767 617.961)"
          ></path>
          <path
            fill="#2f2e41"
            d="M497.073 697.249H509.83599999999996V720.116H497.073z"
            className="no-156 no-pop-meal-156"
            transform="rotate(169.739 433.649 622.508)"
          ></path>
          <ellipse
            cx="503.301"
            cy="722.762"
            fill="#2f2e41"
            className="no-157 no-pop-meal-157"
            rx="10.636"
            ry="3.989"
            transform="rotate(-40.261 210.124 853.35)"
          ></ellipse>
          <ellipse
            cx="527.896"
            cy="718.31"
            fill="#2f2e41"
            className="no-158 no-pop-meal-158"
            rx="10.636"
            ry="3.989"
            transform="rotate(-40.261 234.719 848.897)"
          ></ellipse>
          <circle
            cx="351.316"
            cy="493.901"
            r="14.359"
            fill="#fff"
            className="no-159 no-pop-meal-159"
          ></circle>
          <circle
            cx="345.415"
            cy="488.754"
            r="4.786"
            fill="#3f3d56"
            className="no-160 no-pop-meal-160"
          ></circle>
          <path
            fill="#cfcce0"
            d="M387.4 458.473c.631-15.554-12.774-28.728-29.941-29.425s-31.597 11.346-32.229 26.9 11.302 19.087 28.47 19.784 33.068-1.706 33.7-17.26z"
            className="no-161 no-pop-meal-161"
          ></path>
          <ellipse
            cx="469.311"
            cy="655.06"
            fill="#2f2e41"
            className="no-162 no-pop-meal-162"
            rx="6.594"
            ry="21.006"
            transform="rotate(-77.09 292.894 672.342)"
          ></ellipse>
          <ellipse
            cx="551.78"
            cy="668.775"
            fill="#2f2e41"
            className="no-163 no-pop-meal-163"
            rx="6.594"
            ry="21.006"
            transform="rotate(-77.09 375.363 686.056)"
          ></ellipse>
          <path
            fill="#fff"
            d="M365.796 520.734a9.572 9.572 0 11-18.838 3.41c-.942-5.202 3.08-7.043 8.282-7.984s9.615-.628 10.556 4.574z"
            className="no-164 no-pop-meal-164"
          ></path>
          <ellipse
            cx="740.583"
            cy="514.548"
            fill="#2f2e41"
            className="no-165 no-pop-meal-165"
            rx="21.534"
            ry="6.76"
            transform="rotate(-69.082 548.5 547.031)"
          ></ellipse>
          <circle
            cx="561.649"
            cy="512.284"
            r="43.067"
            fill="#2f2e41"
            className="no-166 no-pop-meal-166"
          ></circle>
          <path
            fill="#2f2e41"
            d="M542.023 546.083H555.107V569.525H542.023z"
            className="no-167 no-pop-meal-167"
          ></path>
          <path
            fill="#2f2e41"
            d="M568.191 546.083H581.275V569.525H568.191z"
            className="no-168 no-pop-meal-168"
          ></path>
          <ellipse
            cx="552.927"
            cy="569.798"
            fill="#2f2e41"
            className="no-169 no-pop-meal-169"
            rx="10.903"
            ry="4.089"
          ></ellipse>
          <ellipse
            cx="579.094"
            cy="569.252"
            fill="#2f2e41"
            className="no-170 no-pop-meal-170"
            rx="10.903"
            ry="4.089"
          ></ellipse>
          <circle
            cx="562.739"
            cy="501.381"
            r="14.719"
            fill="#fff"
            className="no-171 no-pop-meal-171"
          ></circle>
          <circle
            cx="562.739"
            cy="501.381"
            r="4.906"
            fill="#3f3d56"
            className="no-172 no-pop-meal-172"
          ></circle>
          <path
            fill="#cfcce0"
            d="M519.872 472.232c-3.477-15.574 7.639-31.31 24.829-35.149s33.944 5.676 37.422 21.25-7.915 21.317-25.105 25.155-33.668 4.318-37.146-11.256z"
            className="no-173 no-pop-meal-173"
          ></path>
          <circle
            cx="546.93"
            cy="388.533"
            r="43.067"
            fill="#2f2e41"
            className="no-174 no-pop-meal-174"
          ></circle>
          <path
            fill="#2f2e41"
            d="M527.304 422.333H540.3879999999999V445.77500000000003H527.304z"
            className="no-175 no-pop-meal-175"
          ></path>
          <path
            fill="#2f2e41"
            d="M553.472 422.333H566.5559999999999V445.77500000000003H553.472z"
            className="no-176 no-pop-meal-176"
          ></path>
          <ellipse
            cx="538.207"
            cy="446.047"
            fill="#2f2e41"
            className="no-177 no-pop-meal-177"
            rx="10.903"
            ry="4.089"
          ></ellipse>
          <ellipse
            cx="564.375"
            cy="445.502"
            fill="#2f2e41"
            className="no-178 no-pop-meal-178"
            rx="10.903"
            ry="4.089"
          ></ellipse>
          <circle
            cx="548.02"
            cy="377.63"
            r="14.719"
            fill="#fff"
            className="no-179 no-pop-meal-179"
          ></circle>
          <circle
            cx="548.02"
            cy="377.63"
            r="4.906"
            fill="#3f3d56"
            className="no-180 no-pop-meal-180"
          ></circle>
          <path
            fill="#cfcce0"
            d="M505.153 348.482c-3.477-15.574 7.639-31.31 24.829-35.149s33.944 5.675 37.421 21.249-7.915 21.318-25.105 25.156-33.667 4.318-37.145-11.256z"
            className="no-181 no-pop-meal-181"
          ></path>
          <ellipse
            cx="652.267"
            cy="527.087"
            fill="#2f2e41"
            className="no-182 no-pop-meal-182"
            rx="6.76"
            ry="21.534"
            transform="rotate(-64.626 450.017 569.438)"
          ></ellipse>
          <path
            fill="#fff"
            d="M525.775 404.07c0 4.215 10.854 12.539 22.897 12.539s23.335-11.867 23.335-16.082-11.292.817-23.335.817-22.897-1.489-22.897 2.726z"
            className="no-183 no-pop-meal-183"
          ></path>
          <circle
            cx="672.697"
            cy="441.69"
            r="6"
            fill="#f9a826"
            className="no-184 no-pop-meal-184"
          ></circle>
          <circle
            cx="689.04"
            cy="393.253"
            r="6"
            fill="#f9a826"
            className="no-185 no-pop-meal-185"
          ></circle>
          <circle
            cx="674.097"
            cy="368.495"
            r="6"
            fill="#f9a826"
            className="no-186 no-pop-meal-186"
          ></circle>
          <path
            fill="#2f2e41"
            d="M782.17 687.089H794.2829999999999V708.791H782.17z"
            className="no-187 no-pop-meal-187"
            transform="rotate(-105.453 650.972 677.217)"
          ></path>
          <ellipse
            cx="774.907"
            cy="699.004"
            fill="#2f2e41"
            className="no-188 no-pop-meal-188"
            rx="3.785"
            ry="10.094"
            transform="rotate(-15.453 113.698 1186.701)"
          ></ellipse>
          <ellipse
            cx="835.976"
            cy="654"
            fill="#2f2e41"
            className="no-189 no-pop-meal-189"
            rx="19.935"
            ry="6.258"
            transform="rotate(-82.281 668.315 662.784)"
          ></ellipse>
          <circle
            cx="678.227"
            cy="532.784"
            r="39.871"
            fill="#2f2e41"
            className="no-190 no-pop-meal-190"
          ></circle>
          <path
            fill="#2f2e41"
            d="M782.17 680.023H794.2829999999999V701.725H782.17z"
            className="no-191 no-pop-meal-191"
            transform="rotate(-105.453 650.972 670.151)"
          ></path>
          <ellipse
            cx="774.907"
            cy="691.938"
            fill="#2f2e41"
            className="no-192 no-pop-meal-192"
            rx="3.785"
            ry="10.094"
            transform="rotate(-15.452 113.709 1179.656)"
          ></ellipse>
          <circle
            cx="688.696"
            cy="509.944"
            r="13.627"
            fill="#fff"
            className="no-193 no-pop-meal-193"
          ></circle>
          <circle
            cx="693.054"
            cy="503.924"
            r="4.542"
            fill="#3f3d56"
            className="no-194 no-pop-meal-194"
          ></circle>
          <path
            fill="#cfcce0"
            d="M724.27 560.183c14.754-.738 26.055-14.539 25.24-30.825s-13.437-28.889-28.192-28.15-17.07 12.32-16.254 28.606 4.451 31.108 19.206 30.37z"
            className="no-195 no-pop-meal-195"
          ></path>
          <path
            fill="#fff"
            d="M661.932 515.915a9.084 9.084 0 01-1.466-18.11c5-.405 6.365 3.565 6.77 8.566s-.303 9.139-5.304 9.544z"
            className="no-196 no-pop-meal-196"
          ></path>
          <ellipse
            cx="821.011"
            cy="663.473"
            fill="#2f2e41"
            className="no-197 no-pop-meal-197"
            rx="19.935"
            ry="6.258"
            transform="rotate(-82.281 653.35 672.257)"
          ></ellipse>
          <circle
            cx="669.697"
            cy="480.69"
            r="6"
            fill="#f9a826"
            className="no-198 no-pop-meal-198"
          ></circle>
          <path
            fill="#f9a826"
            d="M634.733 342.67a7.454 7.454 0 00-7.437-8.417h-2.377a7.429 7.429 0 00.877-3.5 7.522 7.522 0 00-7.5-7.5h-25a7.5 7.5 0 000 15h2.376a7.43 7.43 0 00-.876 3.5 7.523 7.523 0 005.062 7.083 7.453 7.453 0 007.438 8.417h25a7.494 7.494 0 002.437-14.582z"
            className="no-199 no-pop-meal-199"
          ></path>
          <path
            fill="#3f3d56"
            d="M450.992 554.518H451.759V558.6600000000001H450.992z"
            className="no-200 no-pop-meal-200"
            transform="rotate(45 565.824 291.612)"
          ></path>
        </svg>
);

// No popular restaurant
export const NoPopRestoSvg = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="956.036"
      data-name="Layer 1"
      viewBox="0 0 956.036 759.564"
      className="w-full h-full"
    >
      <path
        fill="#f2f2f2"
        d="M951.457 451.296c15.666 116.589-5.666 233.304-114.169 278.753s-233.304-5.666-278.753-114.169 61.785-173.424 114.169-278.753C779.08 123.234 902.808 89.231 951.457 451.296z"
        className="no-pop-resto-1"
      ></path>
      <ellipse
        cx="756.122"
        cy="736.436"
        fill="#3f3d56"
        className="no-pop-resto-2"
        rx="170"
        ry="23.127"
      ></ellipse>
      <path
        fill="#2f2e41"
        d="M769.313 741.632H812.313V765.632H769.313z"
        className="no-pop-resto-3"
        transform="rotate(-15.452 471.039 1168.077)"
      ></path>
      <ellipse
        cx="764.421"
        cy="755.74"
        fill="#2f2e41"
        className="no-pop-resto-4"
        rx="7.5"
        ry="20"
        transform="rotate(-15.452 444.646 1170.186)"
      ></ellipse>
      <ellipse
        cx="885.422"
        cy="666.569"
        fill="#2f2e41"
        className="no-pop-resto-5"
        rx="39.5"
        ry="12.4"
        transform="rotate(-82.281 784.243 701.275)"
      ></ellipse>
      <circle
        cx="755.707"
        cy="670.299"
        r="79"
        fill="#2f2e41"
        className="no-pop-resto-6"
      ></circle>
      <path
        fill="#2f2e41"
        d="M769.313 727.632H812.313V751.632H769.313z"
        className="no-pop-resto-7"
        transform="rotate(-15.452 471.039 1154.077)"
      ></path>
      <ellipse
        cx="764.421"
        cy="741.74"
        fill="#2f2e41"
        className="no-pop-resto-8"
        rx="7.5"
        ry="20"
        transform="rotate(-15.452 444.646 1156.186)"
      ></ellipse>
      <circle
        cx="776.451"
        cy="625.043"
        r="27"
        fill="#fff"
        className="no-pop-resto-9"
      ></circle>
      <circle
        cx="785.086"
        cy="613.116"
        r="9"
        fill="#3f3d56"
        className="no-pop-resto-10"
      ></circle>
      <path
        fill="#f9a826"
        d="M846.937 724.588c29.234-1.464 51.625-28.808 50.01-61.077s-26.624-57.24-55.858-55.777-33.822 24.412-32.207 56.68 8.82 61.637 38.055 60.174z"
        className="no-pop-resto-11"
      ></path>
      <path
        fill="#fff"
        d="M723.42 636.874a18 18 0 01-2.904-35.883c9.909-.802 12.61 7.065 13.413 16.973s-.6 18.108-10.509 18.91z"
        className="no-pop-resto-12"
      ></path>
      <path
        fill="#f9a826"
        d="M675.597 506.71H801.726V570.871H675.597z"
        className="no-pop-resto-13"
      ></path>
      <ellipse
        cx="855.771"
        cy="685.34"
        fill="#2f2e41"
        className="no-pop-resto-14"
        rx="39.5"
        ry="12.4"
        transform="rotate(-82.281 754.59 720.046)"
      ></ellipse>
      <circle
        cx="567.843"
        cy="621.252"
        r="6.535"
        fill="#ff6584"
        className="no-pop-resto-15"
      ></circle>
      <path
        fill="#2f2e41"
        d="M842.891 356.264a.982.982 0 01-.302-.047c-264.407-83.618-497.444-72.684-646.38-48.786a1294.017 1294.017 0 00-60.404 11.16 1196.246 1196.246 0 00-15.596 3.379 1023.104 1023.104 0 00-18.532 4.306q-3.873.917-7.595 1.848a972.4 972.4 0 00-11.66 2.957 930.173 930.173 0 00-13.797 3.672.442.442 0 01-.051.015 926.363 926.363 0 00-15.323 4.326c-2.698.78-5.304 1.548-7.8 2.307-.278.077-.525.15-.776.227l-.536.163c-.31.095-.617.188-.924.276l-.02.005.001.001-.811.252c-.968.293-1.913.58-2.841.865-24.545 7.566-38.038 12.949-38.172 13.002a1 1 0 11-.744-1.857c.135-.053 13.694-5.463 38.328-13.057.932-.287 1.879-.573 2.85-.867l.753-.234c.026-.01.052-.018.079-.025.305-.087.61-.18.919-.274l.537-.163c.268-.081.531-.161.801-.235a593.8 593.8 0 017.798-2.307 932.235 932.235 0 0115.334-4.328c.016-.006.033-.01.049-.015a941.379 941.379 0 0113.845-3.685 993.766 993.766 0 0111.68-2.962q3.737-.93 7.61-1.853a1026.011 1026.011 0 0118.562-4.312c5.3-1.184 10.556-2.322 15.622-3.383a1295.424 1295.424 0 0160.497-11.179c149.15-23.931 382.52-34.884 647.3 48.855a1 1 0 01-.301 1.953z"
        className="no-pop-resto-16"
      ></path>
      <ellipse
        cx="350.928"
        cy="406.998"
        fill="#2f2e41"
        className="no-pop-resto-17"
        rx="39.5"
        ry="12.4"
        transform="rotate(-69.082 238.932 460.495)"
      ></ellipse>
      <circle
        cx="246.934"
        cy="300.025"
        r="13.685"
        fill="#f9a826"
        className="no-pop-resto-18"
      ></circle>
      <path
        fill="#3f3d56"
        d="M436.698 227.197a15.756 15.756 0 1115.755-15.756 15.773 15.773 0 01-15.755 15.756zm0-29.512a13.756 13.756 0 1013.755 13.756 13.77 13.77 0 00-13.755-13.756z"
        className="no-pop-resto-19"
      ></path>
      <path
        fill="#3f3d56"
        d="M546.698 407.197a15.756 15.756 0 1115.755-15.756 15.774 15.774 0 01-15.755 15.756zm0-29.512a13.756 13.756 0 1013.755 13.756 13.77 13.77 0 00-13.755-13.756z"
        className="no-pop-resto-20"
      ></path>
      <path
        fill="#3f3d56"
        d="M311.698 495.197a15.755 15.755 0 1115.755-15.756 15.774 15.774 0 01-15.755 15.756zm0-29.511a13.755 13.755 0 1013.755 13.755 13.77 13.77 0 00-13.755-13.755z"
        className="no-pop-resto-21"
      ></path>
      <ellipse
        cx="192.122"
        cy="736.436"
        fill="#3f3d56"
        className="no-pop-resto-22"
        rx="170"
        ry="23.127"
      ></ellipse>
      <circle
        cx="182.927"
        cy="623.436"
        r="79"
        fill="#2f2e41"
        className="no-pop-resto-23"
      ></circle>
      <path
        fill="#2f2e41"
        d="M146.927 685.436H170.927V728.436H146.927z"
        className="no-pop-resto-24"
      ></path>
      <path
        fill="#2f2e41"
        d="M194.927 685.436H218.927V728.436H194.927z"
        className="no-pop-resto-25"
      ></path>
      <ellipse
        cx="166.927"
        cy="728.936"
        fill="#2f2e41"
        className="no-pop-resto-26"
        rx="20"
        ry="7.5"
      ></ellipse>
      <ellipse
        cx="214.927"
        cy="727.936"
        fill="#2f2e41"
        className="no-pop-resto-27"
        rx="20"
        ry="7.5"
      ></ellipse>
      <circle
        cx="184.927"
        cy="603.436"
        r="27"
        fill="#fff"
        className="no-pop-resto-28"
      ></circle>
      <circle
        cx="184.927"
        cy="603.436"
        r="9"
        fill="#3f3d56"
        className="no-pop-resto-29"
      ></circle>
      <path
        fill="#f9a826"
        d="M106.294 549.969c-6.379-28.568 14.012-57.434 45.544-64.475s62.265 10.41 68.644 38.978-14.518 39.103-46.05 46.144-61.759 7.92-68.138-20.647z"
        className="no-pop-resto-30"
      ></path>
      <circle
        cx="155.927"
        cy="396.436"
        r="79"
        fill="#2f2e41"
        className="no-pop-resto-31"
      ></circle>
      <path
        fill="#2f2e41"
        d="M119.927 458.436H143.92700000000002V501.436H119.927z"
        className="no-pop-resto-32"
      ></path>
      <path
        fill="#2f2e41"
        d="M167.927 458.436H191.927V501.436H167.927z"
        className="no-pop-resto-33"
      ></path>
      <ellipse
        cx="139.927"
        cy="501.936"
        fill="#2f2e41"
        className="no-pop-resto-34"
        rx="20"
        ry="7.5"
      ></ellipse>
      <ellipse
        cx="187.927"
        cy="500.936"
        fill="#2f2e41"
        className="no-pop-resto-35"
        rx="20"
        ry="7.5"
      ></ellipse>
      <circle
        cx="157.927"
        cy="376.436"
        r="27"
        fill="#fff"
        className="no-pop-resto-36"
      ></circle>
      <circle
        cx="157.927"
        cy="376.436"
        r="9"
        fill="#3f3d56"
        className="no-pop-resto-37"
      ></circle>
      <path
        fill="#f9a826"
        d="M79.294 322.969c-6.379-28.568 14.012-57.434 45.544-64.475s62.265 10.41 68.644 38.977-14.518 39.104-46.05 46.145-61.759 7.92-68.138-20.647z"
        className="no-pop-resto-38"
      ></path>
      <ellipse
        cx="188.928"
        cy="429.998"
        fill="#2f2e41"
        className="no-pop-resto-39"
        rx="12.4"
        ry="39.5"
        transform="rotate(-64.626 72.428 491.32)"
      ></ellipse>
      <path
        fill="#fff"
        d="M117.122 424.936c0 7.732 19.909 23 42 23s42.805-21.768 42.805-29.5-20.713 1.5-42.805 1.5-42-2.732-42 5z"
        className="no-pop-resto-40"
      ></path>
      <circle
        cx="776.174"
        cy="189.47"
        r="79"
        fill="#2f2e41"
        className="no-pop-resto-41"
      ></circle>
      <path
        fill="#2f2e41"
        d="M924.644 316.073H948.644V359.073H924.644z"
        className="no-pop-resto-42"
        transform="rotate(-10.261 484.608 981.781)"
      ></path>
      <path
        fill="#2f2e41"
        d="M877.414 324.628H901.414V367.628H877.414z"
        className="no-pop-resto-43"
        transform="rotate(-10.261 437.398 990.34)"
      ></path>
      <ellipse
        cx="889.126"
        cy="372.603"
        fill="#2f2e41"
        className="no-pop-resto-44"
        rx="20"
        ry="7.5"
        transform="rotate(-40.261 732.353 503.885)"
      ></ellipse>
      <ellipse
        cx="935.374"
        cy="364.231"
        fill="#2f2e41"
        className="no-pop-resto-45"
        rx="20"
        ry="7.5"
        transform="rotate(-40.261 778.601 495.512)"
      ></ellipse>
      <circle
        cx="770.644"
        cy="170.146"
        r="27"
        fill="#fff"
        className="no-pop-resto-46"
      ></circle>
      <circle
        cx="759.547"
        cy="160.468"
        r="9"
        fill="#3f3d56"
        className="no-pop-resto-47"
      ></circle>
      <path
        fill="#f9a826"
        d="M838.494 103.527c1.188-29.247-24.018-54.02-56.3-55.331S722.779 69.53 721.59 98.778s21.252 35.892 53.534 37.203 62.181-3.207 63.37-32.454z"
        className="no-pop-resto-48"
      ></path>
      <ellipse
        cx="825.211"
        cy="245.296"
        fill="#2f2e41"
        className="no-pop-resto-49"
        rx="12.4"
        ry="39.5"
        transform="rotate(-77.09 720.153 286.74)"
      ></ellipse>
      <ellipse
        cx="980.285"
        cy="271.084"
        fill="#2f2e41"
        className="no-pop-resto-50"
        rx="12.4"
        ry="39.5"
        transform="rotate(-77.09 875.227 312.528)"
      ></ellipse>
      <path
        fill="#fff"
        d="M797.872 220.603a18 18 0 11-35.424 6.413c-1.771-9.782 5.792-13.244 15.574-15.015s18.08-1.18 19.85 8.602z"
        className="no-pop-resto-51"
      ></path>
      <path
        fill="#3f3d56"
        d="M749.208 146.814H751.208V261.623H749.208z"
        className="no-pop-resto-52"
        transform="rotate(-52.431 617.915 292.974)"
      ></path>
      <circle
        cx="539.726"
        cy="68"
        r="68"
        fill="#ff6584"
        className="no-pop-resto-53"
      ></circle>
      <circle
        cx="90.934"
        cy="713.025"
        r="13.685"
        fill="#f9a826"
        className="no-pop-resto-54"
      ></circle>
      <path
        fill="#ff6584"
        d="M278.726 697H314.726V733H278.726z"
        className="no-pop-resto-55"
      ></path>
      <circle
        cx="278.934"
        cy="721.025"
        r="13.685"
        fill="#f9a826"
        className="no-pop-resto-56"
      ></circle>
    </svg>
);